/*
*	MG2 Media JS Framework
*	@author  François Vandal
*	@version: 0.9.4
*	Last update: 6 september 2016
*/

(function ($, global, undefined) {
	var html = $('html');
	var lang = html.attr('lang');
	var defaultLang = html.attr('data-default-lang');

	var modules = {};
	var components = {};
	var pages = {};

	/* Modules */
	var createModule = function createModule(module) {
		return $.extend({
			init: $.noop,
			pageLoad: $.noop,
			pageChange: $.noop,
			pageEnter: $.noop,
			pageLeave: $.noop,
			pageStartChange: $.noop
		}, module);
	};

	var exportModule = function exportModule(key, module) {
		modules[key] = createModule(module);

		return modules[key];
	};

	/* Pages */
	var createPage = function createPage(page) {
		return $.extend({
			init: $.noop,
			pageLoad: $.noop,
			pageEnter: $.noop,
			pageLeave: $.noop
		}, page);
	};

	var exportPage = function exportPage(key, page) {
		pages[key] = createPage(page);

		return pages[key];
	};

	var checkForPage = function checkForPage(pageIdNum) {
		var currPage = $('.main-content .page[data-page-id-num=' + pageIdNum + ']').attr('data-page-id');

		if (pages[pageIdNum] !== undefined) {
			pages[pageIdNum].init('#page-' + currPage);
			pages[pageIdNum].pageLoad('#page-' + currPage);
		}
	};

	/* Components */
	var createComponent = function createComponent(component) {
		return $.extend({ init: $.noop }, component);
	};

	var exportComponent = function exportComponent(key, component) {
		components[key] = createPage(component);

		return pages[key];
	};

	var start = function start() {
		var lang = $('html').attr('lang');
		var defaultLang = $('html').attr('data-default-lang');

		var currPathname = location.pathname;
		var currentIdNum = $('.main-content .page').data('pageIdNum');

		if (currPathname !== '/' && currPathname.substring(0, 1) === '/') {
			currPathname = currPathname.substring(1);
		}

		if (lang !== defaultLang) {
			currPathname = currPathname.substring(lang.length);
		}

		currPathname = currPathname !== '/' ? currPathname : 'home';

		if (currPathname.substring(currPathname.length - 1) === '/') {
			currPathname = currPathname + 'home';
		}

		if (currPathname.substring(0, 1) === '/') {
			currPathname = currPathname.substring(1);
		}

		currPathname = currPathname.split('?')[0];
		if (currPathname.substring(currPathname.length - 1) === '/') {
			currPathname = currPathname.substring(0, currPathname.length - 1);
		}

		if (lang !== defaultLang) {
			if (currPathname.substring(0, lang.length) === lang) {
				currPathname = currPathname.substring(lang.length);
			}
		}

		if (currPathname.substring(0, 1) === '/') {
			currPathname = currPathname.substring(1);
		}

		currPathname = currPathname.split('/')[0];

		$.each(Fw.modules.models(), function () {
			this.init('body');
			this.pageLoad('body');
		});

		$('html').attr('data-curr-page', 'page-' + currPathname);
		checkForPage(currentIdNum);

		return Fw;
	};

	global.Fw = $.extend(global.Fw, {
		data: '',

		modules: {
			models: function models() {
				return modules;
			},

			export: exportModule
		},

		component: {
			models: function models() {
				return components;
			},

			export: exportComponent
		},

		page: {
			models: function models() {
				return pages;
			},

			export: exportPage,

			checkForPage: checkForPage
		},

		start: start
	});
})(jQuery, window);
(function ($, undefined) {

    'use strict';

    var faqQuestion;
    var faqAnswer;

    var toggleFaqAnswer = function toggleFaqAnswer() {
        var t = $(this);
        var questionCtn = t.closest('.faq-question-outer-ctn');
        var relatedAnswer = questionCtn.find(faqAnswer);

        if (questionCtn.hasClass('open')) {
            questionCtn.removeClass('open');
            relatedAnswer.slideUp(300);
        } else {
            questionCtn.addClass('open');
            relatedAnswer.slideDown(300);
        }
    };

    var init = function init() {
        faqQuestion = $('body:not(.is-logged-in) .faq-question-header-ctn');
        faqAnswer = $('.faq-answer-ctn');

        faqQuestion.click(toggleFaqAnswer);
    };

    init();
})(jQuery);
(function ($, undefined) {

    'use strict';

    var inputs;

    var init = function init() {
        inputs = $('.input-ctn');

        /* Animation on click of input to replace the 
        label on top of written input content */
        inputs.focusin(function () {
            $(this).addClass("focused");
        });
        inputs.focusout(function () {
            if ($(this).find("input").length !== 0 && $(this).find("input").val() === '') {
                $(this).removeClass("focused");
            }
            if ($(this).find("select").length !== 0 && $(this).find("select").val() === '') {
                $(this).removeClass("focused");
            }
            if ($(this).find("textarea").length !== 0 && $(this).find("textarea").val() === '') {
                $(this).removeClass("focused");
            }
        });
        inputs.each(function () {
            if ($(this).find("input").length !== 0 && $(this).find("input").val() !== '') {
                $(this).addClass("focused");
            }
            if ($(this).find("select").length !== 0 && $(this).find("select").val() !== '') {
                $(this).addClass("focused");
            }
            if ($(this).find("textarea").length !== 0 && $(this).find("textarea").val() !== '') {
                $(this).addClass("focused");
            }
        });
    };

    var formAnimate = Fw.component.export('formAnimate', {
        init: init
    });
})(jQuery);
(function ($, undefined) {

	'use strict';

	var doc = $(document);
	var transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend';
	var body;
	var items;
	var checkLabel;
	var checkboxItems;
	var checkboxItemsInner;
	var file;
	var fileInput;
	var formSwitch;
	var formCheck;
	var formFileBtn;
	var provinceSelects;

	var validateForm = function validateForm(ctn) {
		ctn.each(function () {
			var t = $(this);
			var toValidateItems = $('.form-input.required', t);
			var toValidateUpload = $('.file-upload.required', t);
			var toValidateCheck = $('.form-check-input:not(.radio).required', t);
			var toValidateRadio = $('.form-check-input.radio.required', t);
			var toValidateFriendlyUrl = $('.js-validate-friendlyUrl', t);
			var password = $('.js-password', t);
			var passwordConfirm = $('.js-password-confirm', t);
			var email = $('.js-email', t);
			var emailConfirm = $('.js-email-confirm', t);
			var btn = $('.js-form-btn', t);
			var isOk = true;
			var passwordOk = true;
			var checkOk = true;
			var termsOk = true;
			var friendlyUrlOk = true;
			var emailOk = true;
			var fieldsErrorMessage = $('.js-form-error-message.fields', t);
			var fieldsErrorCheckbox = $('.js-form-error-message.checkbox', t);
			var fieldsErrorTerms = $('.js-form-error-message.terms', t);
			var fieldsErrorPassword = $('.js-form-error-message.password', t);
			var fieldsErrorEmail = $('.js-form-error-message.email-check', t);

			toValidateItems.each(function () {
				var tChild = $(this);
				validateField(tChild);
				if (tChild.hasClass('error')) {
					isOk = false;
				}
			});

			toValidateUpload.each(function () {
				var tUpload = $(this);
				var input = $('.file-upload-input', tUpload);

				if (input.val() === '' || input[0].files === undefined) {
					tUpload.removeClass('success').addClass('error');
				}

				if (tUpload.hasClass('error')) {
					isOk = false;
				}
			});

			toValidateCheck.each(function () {
				var tCheck = $(this);
				var tCtn = tCheck.closest('.form-checkbox-ctn');

				if (!tCheck.is(':checked')) {
					tCtn.addClass('error');

					if (tCtn.attr('name') !== 'terms') {
						checkOk = false;
					}
				} else {
					tCtn.removeClass('error');
				}
				if (tCheck.attr('name') === 'terms' && tCtn.hasClass('error')) {
					termsOk = false;
				}

				if (tCtn.hasClass('error')) {
					termsOk = false;
				}
			});

			toValidateRadio.each(function () {
				var tRadio = $(this);
				var name = tRadio.attr('name');
				var tCtn = tRadio.closest('.form-checkbox-ctn');
				var tOuterCtn = tCtn.parent();

				if (!tRadio.is(':checked') && !$('.form-check-input[name=' + name + ']', tOuterCtn).is(':checked')) {
					tCtn.addClass('error');
					isOk = false;
				} else {
					tCtn.removeClass('error');
				}
			});

			if (toValidateFriendlyUrl.length !== 0) {
				if (toValidateFriendlyUrl.hasClass("error-friendlyUrl")) {
					friendlyUrlOk = false;
					toValidateFriendlyUrl.find("input").addClass("error");
				}
			}
			if (password.length !== 0 && passwordConfirm.length !== 0 && (password.val() !== passwordConfirm.val() || password.val().length === 0)) {
				if (password.val().length === 0) {
					password.removeClass('success').addClass('error');
					passwordOk = false;
				} else {
					password.addClass('success').removeClass('error');
					passwordOk = true;
				}

				if (password.val() !== passwordConfirm.val() || password.val().length === 0) {
					passwordConfirm.removeClass('success').addClass('error');
					passwordOk = false;
				} else {
					passwordConfirm.removeClass('error');
					passwordOk = true;

					if (password.val().length !== 0) {
						passwordConfirm.addClass('success');
					}
				}
			}
			if (email.length !== 0 && emailConfirm.length !== 0 && (email.val() !== emailConfirm.val() || email.val().length === 0)) {
				if (email.val().length === 0) {
					email.removeClass('success').addClass('error');
					emailOk = false;
				} else {
					email.addClass('success').removeClass('error');
					emailOk = true;
				}

				if (email.val() !== emailConfirm.val() || email.val().length === 0) {
					emailConfirm.removeClass('success').addClass('error');
					emailOk = false;
				} else {
					emailConfirm.removeClass('error');
					emailOk = true;

					if (email.val().length !== 0) {
						emailConfirm.addClass('success');
					}
				}
			}
			t.addClass('is-checked');

			if (!termsOk) {
				fieldsErrorTerms.slideDown(300);
			} else {
				fieldsErrorTerms.slideUp(300);
			}

			if (!checkOk) {
				fieldsErrorCheckbox.slideDown(300);
			} else {
				fieldsErrorCheckbox.slideUp(300);
			}

			if (password.length !== 0 && passwordConfirm.length !== 0) {
				if (password.length !== 0 && passwordOk) {
					ctn.addClass('has-password');
					password.add(passwordConfirm).removeClass('error');
					fieldsErrorPassword.slideUp(300);
				} else {
					ctn.removeClass('has-password');
					password.add(passwordConfirm).addClass('error');
					fieldsErrorPassword.slideDown(300);
				}
			}
			if (email.length !== 0 && emailConfirm.length !== 0) {
				if (email.length !== 0 && emailOk) {
					ctn.addClass('has-email');
					email.add(emailConfirm).removeClass('error');
					fieldsErrorEmail.slideUp(300);
				} else {
					ctn.removeClass('has-email');
					email.add(emailConfirm).addClass('error');
					fieldsErrorEmail.slideDown(300);
				}
			}

			if (!isOk) {
				fieldsErrorMessage.slideDown(300);
			} else {
				fieldsErrorMessage.slideUp(300);
			}

			if (!isOk || !passwordOk || !termsOk || !checkOk || !friendlyUrlOk || !emailOk) {
				btn.addClass('disabled');
				ctn.addClass('has-error');

				if (!passwordOk && password.hasClass('required')) {
					ctn.addClass('error-password');
				} else {
					ctn.removeClass('error-password');
				}
				$('html, body').animate({
					scrollTop: $(".error:eq(0)").offset().top - 90
				}, 2000);

				return false;
			} else {
				btn.removeClass('disabled');
				ctn.removeClass('has-error').removeClass('error-password');

				fieldsErrorTerms.slideUp(300);
				return true;
			}
		});
	};

	var validateField = function validateField(elt) {
		var tag = elt[0].tagName;
		var type = elt.attr('type');
		var val = elt.val() === null ? '' : elt.val();
		var attrClass = elt.attr('data-validator-apply-class-on');
		var classTarget = attrClass !== undefined ? elt.closest(attrClass) : elt;
		var targetCtn = classTarget.parent();
		var form = classTarget.closest('form');
		//Choises for validate are : "email", "url", "tel" or "default". By default, an input type email takes the email validation,
		//the input type tel takes the tel validation and if the validate value is "default", then it do a normal check if the input has char
		var validate = elt.attr('data-validate');
		var reEmail = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		var reUrl = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.‌​-]+(:[0-9]+)?|(?:www‌​.|[-;:&=\+\$,\w]+@)[‌​A-Za-z0-9.-]+)((?:\/‌​[\+~%\/.\w-_]*)?\??(‌​?:[-\+=&;%@.\w_]*)#?‌​(?:[\w]*))?)/;
		var numletter = /^[A-Za-z0-9]+$/;
		var reTel = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
		var errorEmail = $('.js-form-error-message.email');
		var emailValid = true;
		var urlValid = true;
		var numletterValid = true;
		var telValid = true;
		var inputValid = true;

		if (tag === 'INPUT' && (type === 'email' || validate === 'email') && validate !== 'default') {
			emailValid = reEmail.test(val);

			if (!emailValid && val !== '') {
				errorEmail.slideDown(300);
				form.addClass('error-email');
			}
		} else if (tag === 'INPUT' && validate === 'url' && validate !== 'default') {
			urlValid = reUrl.test(val);
		} else if (tag === 'INPUT' && validate === 'numletter' && validate !== 'default') {
			numletterValid = numletter.test(val);
		} else if (tag === 'INPUT' && (type === 'tel' || validate === 'tel') && validate !== 'default') {
			telValid = reTel.test(val);
		} else if (elt.hasClass('form-input-upload-input')) {
			if (classTarget.hasClass('required') && elt.val() !== '') {
				classTarget.removeClass('error').addClass('success');
				targetCtn.removeClass("error");
			} else {
				classTarget.addClass('error').removeClass('success');
				targetCtn.addClass("error");
			}
		} else {
			classTarget.addClass('success').removeClass('error');
			if (classTarget.hasClass('required') && $.trim(val).length === 0) {
				classTarget.removeClass('success').addClass('error');
				targetCtn.addClass("error");
				inputValid = false;
			} else if (!classTarget.hasClass('required') && val.length === 0) {
				classTarget.removeClass('success').removeClass('error');
				targetCtn.removeClass("error");
			}
		}

		if (emailValid && urlValid && telValid && inputValid && numletterValid) {
			classTarget.removeClass('error').addClass('success');
			targetCtn.removeClass('error');
		} else if (val.length === 0 && !classTarget.hasClass('required')) {
			classTarget.removeClass('error').removeClass('success');
			targetCtn.removeClass('error');
		} else {
			classTarget.addClass('error').removeClass('success');
			targetCtn.removeClass('error');
		}

		if (targetCtn.closest('.fake-ctn').length !== 0) {
			if (classTarget.hasClass('error')) {
				targetCtn.addClass('error');
			} else {
				targetCtn.removeClass('error');
			}
			if (classTarget.hasClass('success')) {
				targetCtn.addClass('success');
			} else {
				targetCtn.removeClass('success');
			}
		}
	};

	var formItemsBlur = function formItemsBlur(t) {
		var elt = t.target === undefined ? t : $(this);
		var ctn = elt.closest('.form-input');
		var form = ctn.closest('form');

		var errorEmail = $('.js-form-error-message.email', form);

		validateField(elt);

		// verifie si aucune erreur du meme type avant d'enlever le message d'erreur
		if (form.hasClass('error-email')) {
			var emailErrors = [];
			$('.form-input', form).each(function () {
				var t = $(this);
				if (t.attr('type') === 'email' && t.hasClass('error') && t.val() !== '') {
					emailErrors.push('error');
				}
			});

			if (emailErrors.length === 0) {
				errorEmail.slideUp(300);
				form.removeClass('error-email');
			}
		} else {
			errorEmail.slideUp(300);
		}

		if (form.hasClass('is-checked')) {
			validateForm(form);
		}
	};

	var formCheckChange = function formCheckChange() {
		var t = $(this);
		var ctn = t.closest('.form-checkbox-ctn');
		var form = ctn.closest('.js-form');

		if (form.hasClass('is-checked')) {
			validateForm(form);

			if (t.is(':checked')) {
				ctn.removeClass('error');
			}
		}
	};

	var checkLabelClick = function checkLabelClick() {
		var t = $(this);
		var ctn = t.closest('.register-checkbox');
		var input = $('.form-input-checkbox-input', ctn);

		if (input.hasClass('is-checked')) {
			input.removeClass('is-checked');
		} else {
			input.addClass('is-checked');
		}
	};

	var toggleCheckbox = function toggleCheckbox() {
		var t = $(this);
		var ctn = t.closest('.form-input-checkbox');
		var input = $('.form-input-checkbox-input', t);

		if (ctn.hasClass('checked')) {
			ctn.removeClass('checked');
			input.removeAttr('checked');
		} else {
			ctn.addClass('checked');
			input.attr('checked', 'checked');
		}
	};

	var fileInputChange = function fileInputChange(e) {
		var t = $(this);
		var label = t.closest('.file-ctn');
		var labelDefault = label.attr('data-default-value');
		var labelValue = $('.file-upload-title', label);
		var imageCtn = label.next().find(".file-image-inner");
		var imageEdited = label.next().find(".file-image-edited");
		var ctn = label;
		var form = ctn.closest('.js-form');

		if (t.val() !== '') {
			ctn.removeClass('error').addClass('success');
			label.addClass("focused");
			//            previewImage(t,imageCtn, imageEdited);
			labelValue.val(t.val().split('\\')[t.val().split('\\').length - 1]);
			if (t.hasClass("banner-pic")) {
				$(".default-images-ctn").find("input:checked").prop('checked', false);
				t.parent().find("input.form-input").addClass("required");
			}
		} else {
			ctn.addClass('error').removeClass('success');
			label.removeClass("focused");
			labelValue.val(labelDefault);
			if (t.hasClass("banner-pic")) {
				$(".default-images-ctn").find("input:eq(0)").prop('checked', true);
				t.parent().find("input").removeClass("required");
			}
		}

		if (form.hasClass('is-checked')) {
			validateForm(form);
		}
	};

	var formSwitchClick = function formSwitchClick() {
		var t = $(this);
		var elem = $(t).find('.checkbox');

		t.find('.form-checkbox-slider').toggleClass('active');
		if (elem.prop("checked")) {
			elem.removeAttr("checked");
		} else {
			elem.attr("checked", "checked");
		}
	};

	var openInputFile = function openInputFile() {
		var ctn = $(this).parent();
		var f = ctn.find("input[type = file]");
		f.trigger("click");
	};

	var limitChars = function limitChars(ed) {
		var max = parseInt(ed.getElement().maxLength);
		var _mem = "";
		if (!isNaN(max) && max > 0) {
			var allow = [0, 8, 9, 20, 27, 35, 36, 37, 38, 39, 40, 44, 46, 110, 144];
			ed.on("keydown", function (ev) {
				_mem = this.getContent().substring(0, max);
				if (allow.indexOf(ev.keyCode) !== -1 || ev.ctrlKey || ev.metaKey || this.contentWindow.getSelection().toString() !== "") {
					return true;
				}
				if (tinymce_getContentLength(this) + 1 > max) {
					ev.preventDefault();
					ev.stopPropagation();
					return false;
				}
			});
			ed.on("keyup change", function (ev) {
				var text = this.getContent();
				if (text.length > max) {
					this.setContent(text.substring(0, max));
					text = text.substring(0, max);
					//                    this.setSelectionRange(this.value.length,this.value.length);
				}
				tinymce_updateCharCounter(this, text.length);
			});
		}
	};
	var charCounter = function charCounter(ed) {
		if (!isNaN($('#' + ed.id).attr("maxlength"))) {
			$('#' + ed.id).prev().find('.mce-statusbar .mce-flow-layout').append('<div class="mce-char-count" style="text-align:right"></div>');
			tinymce_updateCharCounter(ed, tinymce_getContentLength(ed));
		}
	};
	function tinymce_updateCharCounter(el, len) {
		$('#' + el.id).prev().find('.mce-char-count').text(len + '/' + el.getElement().maxLength);
	}
	function tinymce_getContentLength(ed) {
		return ed.getContent().length;
	}

	var init = function init(page) {
		body = $('body');
		items = $('.form-input:not([type=file]).required');
		provinceSelects = $('.province-select,.other-province-select,.state-select');

		// Otherwise, other selects for provinces/states don't get blur events
		if (provinceSelects.hasClass('required')) {
			items = $.merge(items, provinceSelects);
		}

		checkLabel = $('.register-checkbox-label');
		checkboxItems = $('.form-input-checkbox');
		checkboxItemsInner = $('.form-input-checkbox-inner', checkboxItems);
		//		file = $('.file-upload');
		fileInput = $('.file-upload-input');
		formSwitch = $('.form-switch');
		formCheck = $('.form-check-input');
		formFileBtn = $(".file-ctn .file-btn");

		checkLabel.click(checkLabelClick);
		checkboxItemsInner.click(toggleCheckbox);
		fileInput.change(fileInputChange);
		formSwitch.click(formSwitchClick);
		formCheck.change(formCheckChange);
		formFileBtn.click(openInputFile);

		items.each(function () {
			if (!$(this).hasClass('no-blur')) {
				$(this).blur(formItemsBlur);
			}
		});
	};

	var form = Fw.component.export('form', {
		init: init,
		validateForm: validateForm,
		limitChars: limitChars,
		charCounter: charCounter,
		formItemsBlur: formItemsBlur
	});
})(jQuery);
(function ($, undefined) {

    'use strict';

    var item;
    var itemClone;
    var itemsAndButtonsCtn;
    var itemsCtn;
    var addNewItemBtn;
    var saveItemsBtn;
    var deleteItemBtn;
    var saveItemsSuccessMsg;
    var chooseBtn;
    var closeChoicePopupBtn;
    var saveIconChoiceBtn;
    var deleteChoiceBtn;
    var howItWorksItem;
    var textCtnClone;

    var changeCloneAttrValue = function changeCloneAttrValue(t, attr, itemNumber) {
        var attrInitVal = t.attr(attr);
        var attrInitValSplit = attrInitVal.split('clone');
        var newAttrVal = attrInitValSplit[0] + itemNumber + attrInitValSplit[1];
        t.attr(attr, newAttrVal);
    };

    var addNewItem = function addNewItem() {
        var t = $(this);
        var parent = t.closest(itemsAndButtonsCtn);
        var ctn = parent.find(itemsCtn);
        var itemCloneCopy = parent.find(itemClone).clone();
        var itemNumber = Math.floor(Math.random() * 100000);
        var localId = itemClone.data('local-id');

        ctn.append(itemCloneCopy);

        // change ids for labels
        itemCloneCopy.find('.item-text-to-modify').each(function () {
            changeCloneAttrValue($(this), 'ondblclick', itemNumber);
        });

        if (itemCloneCopy.find('.submit-icon-choice-btn').length !== 0) {
            itemCloneCopy.find('.submit-icon-choice-btn').each(function () {
                changeCloneAttrValue($(this), 'data-label', itemNumber);
            });
        }

        itemCloneCopy.attr('data-id', itemNumber);
        itemCloneCopy.hide().removeClass('clone').slideDown(300);

        // listeners for new item
        $('.delete-item-btn').click(removeItem);
        $('.choose-btn').click(showPopup);
        $('.choice-popup .popup-inner-close').click(hideChoicePopup);
        $('.submit-icon-choice-btn').click(saveIconChoice);
    };

    var saveItemsList = function saveItemsList() {
        saveItemsSuccessMsg.slideUp(300);

        var t = $(this);
        var ctn = t.closest(itemsAndButtonsCtn);
        var contents = ctn.find(itemsCtn).find('.item-ctn');
        var idsList = '';
        var localId = contents.first().data('local-id');
        var label = 'items-list-' + localId;

        contents.each(function () {
            if ($(this).data('id') !== ('' || undefined)) {
                idsList += $(this).data('id') + "~!~";
            }
        });

        // save all custom ids list in a label
        updateLabel(label, idsList, 'fr', function () {
            updateLabel(label, idsList, 'en', function () {
                saveItemsSuccessMsg.slideDown(300);

                setTimeout(function () {
                    saveItemsSuccessMsg.slideUp(300);
                }, 5000);
            });
        });
    };

    var removeItem = function removeItem() {
        var t = $(this);

        t.closest('.item-ctn').slideUp(300);
        setTimeout(function () {
            t.closest('.item-ctn').remove();
        }, 300);
    };

    var showPopup = function showPopup() {
        var t = $(this);
        var type = t.attr('data-type');
        var parent = t.closest('.choice-popup-parent');
        var popup = $('.' + type + '-choice-popup');
        var relatedPopup = parent.find(popup);

        relatedPopup.fadeIn(300);
        $('.overlay').addClass('active');
    };

    var hideChoicePopup = function hideChoicePopup() {
        var t = $(this);
        var parentPopup = t.closest('.choice-popup');

        parentPopup.fadeOut(300);
        $('.overlay').removeClass('active');
    };

    var saveIconChoice = function saveIconChoice() {
        var t = $(this);
        var parentPopup = t.closest('.icon-choice-popup');
        var iconChoiceInput = parentPopup.find('input:checked');

        if (iconChoiceInput.length !== 0) {
            $('.save-icon-error-msg').slideUp(300);

            var iconChoice = iconChoiceInput.val();
            var label = t.attr('data-label');

            // save choice in a label
            updateLabel(label, iconChoice, 'fr', function () {
                updateLabel(label, iconChoice, 'en', function () {
                    $('.save-icon-success-msg').slideDown(300);

                    setTimeout(function () {
                        $('.save-icon-success-msg').slideUp(300);

                        setTimeout(function () {
                            parentPopup.fadeOut(300);
                            $('.overlay').removeClass('active');
                        }, 600);
                    }, 3000);
                });
            });
        } else {
            $('.save-icon-error-msg').slideDown(300);

            setTimeout(function () {
                $('.save-icon-error-msg').slideUp(300);
            }, 5000);
        }
    };

    var deleteChoice = function deleteChoice() {
        var t = $(this);
        var label = t.attr('data-label');
        var parentCtn = t.closest('.delete-choice-ctn');
        var successMsg = parentCtn.find('.delete-choice-success-msg');

        updateLabel(label, '', 'fr', function () {
            updateLabel(label, '', 'en', function () {
                successMsg.slideDown(300);

                setTimeout(function () {
                    successMsg.slideUp(300);
                }, 3000);
            });
        });
    };

    var displayRelatedText = function displayRelatedText() {
        var t = $(this);
        var parent = t.closest('.how-it-works-item-ctn');
        var id = parent.attr('data-id');
        var allItemsCtn = t.closest('.all-how-it-works-items-inner-ctn');
        var relatedTextCtnHeight = parent.find('.how-it-works-text-ctn').height();
        var relatedTextNode = parent.find('.how-it-works-text').clone();
        var currPosition = t.offset().top;
        var textCtnCloneCopy = textCtnClone.clone();

        textCtnCloneCopy.html(relatedTextNode).hide().addClass('displayed').attr('data-id', id);

        if (allItemsCtn.find('.text-only-clone.displayed').length === 0) {
            insertText(t, allItemsCtn, textCtnCloneCopy);
        } else if (allItemsCtn.find('.text-only-clone.displayed').length > 0 && allItemsCtn.find('.text-only-clone.displayed').attr('data-id') !== id) {
            var previousHeader = allItemsCtn.find('.how-it-works-header-ctn.open');
            var previousHeaderPosition = previousHeader.offset().top;
            var textCtn = allItemsCtn.find('.text-only-clone.displayed');

            previousHeader.removeClass('open');

            // if the new text can't be displayed in the current text container
            if (previousHeaderPosition !== currPosition) {
                textCtn.removeAttr('style').slideUp(300);

                setTimeout(function () {
                    textCtn.remove();
                    insertText(t, allItemsCtn, textCtnCloneCopy);
                }, 300);
            } else {
                var previousText = textCtn.find('.how-it-works-text').fadeOut(300);
                relatedTextNode.hide();

                setTimeout(function () {
                    previousText.remove();
                    textCtn.css({ 'min-height': relatedTextCtnHeight, 'max-height': relatedTextCtnHeight });
                    textCtn.append(relatedTextNode).attr('data-id', id);
                    t.addClass('open');

                    setTimeout(function () {
                        relatedTextNode.fadeIn(300);
                    }, 300);
                }, 300);
            }
        } else {
            animateTextClose(allItemsCtn, t);
        }
    };

    var insertText = function insertText(t, allItemsCtn, textCtnCloneCopy) {
        $('.how-it-works-item-ctn', allItemsCtn).each(function () {
            if ($(this).offset().top > t.offset().top) {
                textCtnCloneCopy.insertBefore($(this));
                animateTextOpen(textCtnCloneCopy, t);
                return false;
            }
        });

        if (allItemsCtn.find('.text-only-clone.displayed').length === 0) {
            allItemsCtn.append(textCtnCloneCopy);
            animateTextOpen(textCtnCloneCopy, t);
        }
    };

    var animateTextOpen = function animateTextOpen(textCtn, textHeader) {
        textCtn.slideDown(300);
        textHeader.addClass('open');

        setTimeout(function () {
            var height = textCtn.height();
            textCtn.css({ 'min-height': height, 'max-height': height });
        }, 500);
    };

    var animateTextClose = function animateTextClose(allItemsCtn, textHeader) {
        textHeader.removeClass('open');

        var textCtn = allItemsCtn.find('.text-only-clone.displayed');
        textCtn.removeAttr('style').slideUp(300);

        setTimeout(function () {
            textCtn.remove();
        }, 300);
    };

    var init = function init() {
        item = $('.item-ctn');
        itemClone = $('.item-ctn.clone');
        itemsAndButtonsCtn = $('.items-and-buttons-ctn');
        itemsCtn = $('.all-items-ctn');
        addNewItemBtn = $('.add-new-item-btn');
        saveItemsBtn = $('.save-items-btn');
        deleteItemBtn = $('.delete-item-btn');
        saveItemsSuccessMsg = $('.save-items-success-msg');
        chooseBtn = $('.choose-btn');
        closeChoicePopupBtn = $('.choice-popup .popup-inner-close');
        saveIconChoiceBtn = $('.submit-icon-choice-btn');
        deleteChoiceBtn = $('.delete-choice-btn');
        howItWorksItem = $('.how-it-works-header-ctn');
        textCtnClone = $('.how-it-works-item-ctn.text-only-clone');

        addNewItemBtn.click(addNewItem);
        deleteItemBtn.click(removeItem);
        saveItemsBtn.click(saveItemsList);
        chooseBtn.click(showPopup);
        closeChoicePopupBtn.click(hideChoicePopup);
        saveIconChoiceBtn.click(saveIconChoice);
        deleteChoiceBtn.click(deleteChoice);
        howItWorksItem.click(displayRelatedText);

        $(window).resize(function () {
            $('.how-it-works').each(function () {
                if ($(this).find('.how-it-works-header-ctn.open').length > 0) {
                    animateTextClose($(this).find('.all-how-it-works-items-inner-ctn'), $(this).find('.how-it-works-header-ctn.open'));
                }
            });
        });
    };

    init();
})(jQuery);
(function ($, undefined) {
   /*
       * Mathilde Paccoud
       * Last update 25/03/2017
       * 
       * Purpose : allows to store a value inside a 'double-click label'
       * 
       * @param : lang - language in which to update a label (double-clic)
       * @param : key - unique key to store a value in
       * @param : val - value to store in the label
       * @param : callback - any function to be called once value is stored
       * @param : reset - true/false - deletes label if true
       * 
       * Call : var labels = Fw.component.models().labels;
       */
   'use strict';

   var save = function save(key, val, lang, callback, reset) {
      var ap = actionPath || "/action/";

      ajax(ap + "addSiteLabel?lang=" + lang + "&key=" + key + "&value=" + (reset ? '' : encodeURIComponent(val)), callback, true);
   };

   var init = function init(page) {
      var currPage = $(page);
   };

   var labels = Fw.component.export('labels', {
      init: init,
      save: save
   });
})(jQuery);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function ($, undefined) {

    'use strict';

    var session;
    var currPage;
    var header;
    var logForm;
    var logForgotForm;
    var logFormBtn;
    var logForgotBtn;
    var logForgotSendBtn;
    var logForgotCancelBtn;
    var panel1;
    var panel2;
    var logPopupClose;
    var dashboardLogout;

    var connectBtn;
    var openLoginCoreBtn;
    var connectWin;
    var loginFail;
    var responsiveMenu;

    var recaptchaKey = "6LcB2hUqAAAAAJKM4KosE-a9hR2_wtrYoUXDxLrs"; // Production
    var recaptchaReady = false;

    var renderCaptcha = function renderCaptcha() {
        logFormBtn = $(".login-form-ctn .login-btn");

        var $render = $(".account_login_recaptcha");
        if ($render.length && (typeof grecaptcha === "undefined" ? "undefined" : _typeof(grecaptcha)) === "object") {
            grecaptcha.ready(function () {
                // recaptcha initiated
                recaptchaReady = true;
                // Begin render in each element
                $render.each(function () {
                    var _ = this;
                    var loginForm = $(_).closest(".login-form-ctn");
                    var widgetId = grecaptcha.render(_, {
                        'sitekey': recaptchaKey,
                        'size': 'invisible',
                        'badge': 'bottomleft',
                        'callback': function callback(response) {
                            //loginForm.find('.account_login_recaptcha_token').val(response);
                            loginCheckUp(loginForm);
                        }
                    });
                    loginForm.attr("data-widget-id", widgetId);
                });
                // Click event on login button
                logFormBtn.on("click", loginRecaptcha);
            });
        } else {
            // API not found, bind regular click and submit form
            logFormBtn.on("click", function (e) {
                loginCheckUp($(this).closest(".login-form-ctn"));
            });
        }
    };

    var loginRecaptcha = function loginRecaptcha(e) {
        e.preventDefault();
        var loginForm = $(this).closest(".login-form-ctn");
        grecaptcha.execute(loginForm.attr("data-widget-id"));
    };

    var loginCheckUp = function loginCheckUp(logCtn) {
        formValidator.validateForm(logCtn);

        if (!logCtn.hasClass('has-error')) {
            console.log("submit " + logCtn.attr("data-widget-id"));
            var email = encodeURIComponent(logCtn.find('input[name="username"]').val());
            session.save("loginEmail", email, function (response) {
                if ($('.login-dashboard').length && header.hasClass('logo-only')) {
                    document.cookie = 'loginFromDashboard=true;max-age=' + 60 * 60 * 24 * 365;
                    session.save("logoutDashboard", true, function (response) {
                        logCtn.submit();
                    });
                } else {
                    logCtn.submit();
                }
            });
        } else if (recaptchaReady) {
            grecaptcha.reset(logCtn.attr("data-widget-id"));
        }
    };

    var loginForgot = function loginForgot(e, b) {
        var btn = b === undefined ? $(this) : b;
        var action = btn.attr("data-action");
        if (action === 'left') {
            panel1.css("left", "-50%");
            panel2.css("left", "-50%");
        } else {
            panel1.css("left", "0");
            panel2.css("left", "0%");
        }
    };

    var loginForgotSend = function loginForgotSend(event) {
        event.preventDefault();
        var btn = $(this);
        var panel = btn.closest(".login-forms-slide-2");
        formValidator.validateForm(panel);
        if (!panel.hasClass('has-error')) {
            var email = panel.find("input[name='email']").val();

            ajax("/action/forgotPassword?email=" + encodeURIComponent(email), function () {
                logForgotForm.fadeOut("fast", function () {
                    panel.find(".forgot-pwd-success").slideDown();
                    window.setTimeout(function () {
                        reset(event);
                    }, 4000);
                });
            }, true);
        }
    };

    var resetForgotPwd = function resetForgotPwd() {
        panel2.each(function () {
            $(this).find(".forgot-pwd-success").slideUp("fast", function () {
                logForgotForm.fadeIn();
                logForgotForm.find("input[name='email']").val("");
                logForgotForm.find(".input-ctn").removeClass("focused");
            });
        });
    };

    var reset = function reset(event) {
        loginForgot(event, logForgotCancelBtn);
        resetForgotPwd();
    };

    var reinit = function reinit() {
        connectWin.slideUp();
        $(".overlay").removeClass("active");
        header.removeClass("site-header-connect");
        $(".open-login-btn", header).removeClass("active");
    };

    var openLoginWindow = function openLoginWindow(e, b) {
        var btn = b === undefined ? $(this) : b;
        responsiveMenu = $(".site-header-menu-toggle-ham").is(":visible");
        if (!responsiveMenu) {
            toggleOverlay();
            if (btn.hasClass("active")) {
                if (window.pageYOffset === 0) {
                    header.removeClass("site-header-scroll");
                }
                header.removeClass("site-header-connect");
                btn.removeClass("active");
                connectWin.slideUp();
                session.save("loginEmail", null, function () {});
                // window.setTimeout(function() {
                //     login.reset();
                // }, 500);
            } else {
                header.addClass("site-header-scroll");
                header.addClass("site-header-connect");
                var t = header.outerHeight();
                connectWin.css("top", t + "px");
                connectWin.slideDown();
                btn.addClass("active");
            }
        } else {
            // $("#loginWindowResp").css("position", "absolute");
            $('body').css('position', 'fixed');
            openWindow("loginWindowResp", true);
        }
    };

    var closeLoginWindow = function closeLoginWindow() {
        $('body').removeAttr('style');
        closeWindow("loginWindowResp");
        session.save("loginEmail", null, function () {});
        window.setTimeout(function () {
            reset();
        }, 500);
    };

    var toggleOverlay = function toggleOverlay() {
        var active = $(".overlay").hasClass("active");
        if (active) {
            $(".overlay").removeClass("active");
        } else {
            $(".overlay").addClass("active");
        }
    };

    var init = function init(page, event) {
        currPage = $(page);
        renderCaptcha();
        session = Fw.component.models().session;

        header = $(".site-header");
        panel1 = $(".login-forms-slide-1");
        panel2 = $(".login-forms-slide-2");
        /*Listeners linked to login form*/

        /* Toggles connection window */
        connectWin = $("#loginWindow", header);
        connectBtn = $(".open-login-btn", header);
        connectBtn.on("click", openLoginWindow);

        /*Handling cases : 
         * login failed, open window again ; 
         * login successfull : delete the session variable
         * */
        var logged = false;
        loginFail = $("#loginFail", header).val() !== '';
        if ($(".is-signed-in", page).length !== 0 && loginFail) {
            session.save("loginEmail", null, function () {});
            logged = true;
        }
        if (loginFail && !logged && !header.hasClass('logo-only')) {
            openLoginWindow(event, connectBtn);
        }

        openLoginCoreBtn = $(".login-core-btn", page);
        openLoginCoreBtn.on("click", function () {
            openLoginWindow(event, connectBtn);
        });

        logForm = $(".login-form-ctn", page);
        logForgotForm = $(".forgot-pwd-input-ctn", page);

        logForgotBtn = $(".form-forgot-pwd", page);
        logForgotBtn.on("click", loginForgot);

        logForgotSendBtn = $(".get-pwd-btn", page);
        logForgotSendBtn.on("click", loginForgotSend);

        logForgotCancelBtn = $(".get-pwd-cancel-btn", page);
        logForgotCancelBtn.on("click", loginForgot);

        logPopupClose = $("#loginWindowResp .popup-inner-close", page);
        logPopupClose.on("click", closeLoginWindow);

        dashboardLogout = $('.dashboard-logout', page);
        dashboardLogout.on('click', function () {
            document.cookie = 'loginFromDashboard=false;max-age=1';
        });
    };

    var login = Fw.component.export('login', {
        init: init,
        reset: reset,
        reinit: reinit
    });
})(jQuery);
(function ($, undefined) {

    'use strict';

    var createProfileBtn;
    var previewProfileBtn;
    var selectTypeProfile;
    var autocomplete;
    var friendlyUrlInput;
    var defaultBanner;
    var boxThemeInfoBtn;
    var boxThemeSaveIconBtn;
    var boxThemeIcon;
    var addressInput;
    var cityInput;
    var cpInput;
    var provInput;
    var countryInput;
    var deleteProfilePicBtn;
    var profileNameInput;

    var checkForm = function checkForm(event) {
        event.preventDefault();

        var createForm = $(".create-profile-form");
        formValidator.validateForm(createForm);

        if (!createForm.hasClass('has-error')) {
            createProfileBtn.addClass('disabled');
            createForm.submit();
        }
    };

    var toggleItems = function toggleItems() {
        var t = $(this);
        var val = t.val();

        /* If room - display extra fields */
        if (val === '2') {
            $(".activate-room").slideDown();
            $(".activate-room").find("input").addClass("required");
            $(".hide-room").slideUp();
            activateGlgAutocomplete();
            setTimeout(function () {
                addressInput.removeAttr("placeholder");
            }, 100);
        } else {
            $(".activate-room").slideUp();
            $(".hide-room").slideDown();
            $(".activate-room").find("input").removeClass("required");
        }
    };

    var activateGlgAutocomplete = function activateGlgAutocomplete() {
        var request = {
            //			componentRestrictions: {country: 'ca'}
        };

        // Using getAddressInput() instead of addressInput directly fixes a 
        // potential race condition where an external script would use
        // this method before init was called by the header.
        autocomplete = new google.maps.places.Autocomplete(getAddressInput()[0], request);

        google.maps.event.addListener(autocomplete, 'place_changed', function () {
            addressSearch();
        });
    };

    var addressSearch = function addressSearch(addr) {
        var coorUrl = addr !== undefined ? addr : addressInput.val();
        var geocoder = new google.maps.Geocoder();
        var cp, street, city, province, country;

        geocoder.geocode({ 'address': coorUrl }, function (results, status) {
            var strNbr = "";
            for (var i = 0; i < results[0].address_components.length; i++) {
                var component = results[0].address_components[i];
                if (component.types[0] === "postal_code") {
                    cp = component.short_name;
                }
                if (component.types[0] === "street_number") {
                    strNbr = component.short_name;
                }
                if (component.types[0] === "locality" || !city && component.types[0] === "administrative_area_level_3") {
                    city = component.short_name;
                }
                if (component.types[0] === "administrative_area_level_1") {
                    province = component.short_name;
                }
                if (component.types[0] === "country") {
                    country = component.short_name;
                }
                if (component.types[0] === "route") {
                    street = component.short_name;
                }
            }
            street = strNbr + " " + street;

            if (street === ' undefined') {
                street = '-';
            }

            if (cp === '') {
                geocoder.geocode({ 'location': results[0].geometry.location }, function (results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {
                        for (var i = 0; i < results[0].address_components.length; ++i) {
                            var component = results[0].address_components[i];
                            if (component.types[0] === "postal_code") {
                                cp = component.long_name;
                            }
                            if (component.types[0] === "street_number") {
                                strNbr = component.short_name;
                            }
                            if (component.types[0] === "locality" || !city && component.types[0] === "administrative_area_level_3") {
                                city = component.short_name;
                            }
                            if (component.types[0] === "administrative_area_level_1") {
                                province = component.short_name;
                            }
                            if (component.types[0] === "country") {
                                country = component.short_name;
                            }
                            if (component.types[0] === "route") {
                                street = component.short_name;
                            }
                        }
                        street = strNbr + " " + street;
                        var placeLat = results[0].geometry.location.lat();
                        var placeLng = results[0].geometry.location.lng();

                        $("input[name=lat]").val(placeLat);
                        $("input[name=hiddenLat]").val(placeLat);
                        $("input[name=lng]").val(placeLng);
                        $("input[name=hiddenLng]").val(placeLng);
                        addressInput.val(street);
                        checkVal(addressInput);
                        cityInput.val(city);
                        checkVal(cityInput);
                        cpInput.val(cp);
                        checkVal(cpInput);
                        provInput.val(province);
                        checkVal(provInput);
                        countryInput.val(country);
                        checkVal(countryInput);

                        createMap(placeLat, placeLng);

                        $(".activate-room .input-ctn").each(function () {
                            if ($(this).find("input").length !== 0 && $(this).find("input").val() !== '') {
                                $(this).addClass("focused");
                            }
                        });
                    }
                });
            } else if (cp !== '' && cp !== undefined) {
                if (status === google.maps.GeocoderStatus.OK) {
                    var placeLat = results[0].geometry.location.lat();
                    var placeLng = results[0].geometry.location.lng();

                    $("input[name=lat]").val(placeLat);
                    $("input[name=hiddenLat]").val(placeLat);
                    $("input[name=lng]").val(placeLng);
                    $("input[name=hiddenLng]").val(placeLng);
                    addressInput.val(street);
                    checkVal(addressInput);
                    cityInput.val(city);
                    checkVal(cityInput);
                    // this if doesn't replace the postal code if you search another location.
                    // if (cpInput.val() === '') { // otherwise google cuts some of the provided postal codes
                    cpInput.val(cp);
                    checkVal(cpInput);
                    // }
                    provInput.val(province);
                    checkVal(provInput);
                    countryInput.val(country);
                    checkVal(countryInput);

                    createMap(placeLat, placeLng);

                    $(".activate-room .input-ctn").each(function () {
                        if ($(this).find("input").length !== 0 && $(this).find("input").val() !== '') {
                            $(this).addClass("focused");
                        }
                    });
                }
            }
        });
    };
    var checkVal = function checkVal(input) {
        input.val().length > 0 ? input.removeClass('error').closest('.input-ctn').addClass('focused') : input.closest('.input-ctn').removeClass('focused');
    };
    var createMap = function createMap(lat, lng) {
        if ($('#map-ctn').length > 0) {
            var myLatlng = new google.maps.LatLng(lat, lng);
            var mapOptions = {
                zoom: 18,
                center: myLatlng,
                scrollwheel: false,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };

            var map = new google.maps.Map(document.getElementById('map-ctn'), mapOptions);
            // document.getElementById('map-ctn').className = "activated";
            $('#map-ctn').addClass('activated');

            var marker = new google.maps.Marker({
                position: myLatlng,
                map: map,
                title: name,
                icon: '/static/assets/img/pin.png'
            });
        }
    };

    var checkValidFriendlyUrl = function checkValidFriendlyUrl() {
        var t = $(this);
        var val = t.val().trim();
        if (val === '') {
            t.parent().removeClass("error-friendlyUrl");
            t.parent().removeClass("success-friendlyUrl");
        } else {
            val = encodeURIComponent(val);
            t.val(val);
            ajax('/action/epProfiles?friendlyUrl=' + val, function (response) {
                if (response.indexOf("success") !== -1) {
                    t.parent().addClass("success-friendlyUrl");
                    t.parent().removeClass("error-friendlyUrl");
                } else {
                    t.parent().addClass("error-friendlyUrl");
                    t.parent().removeClass("success-friendlyUrl");
                }
            }, true);
        }
    };

    var updateFileInput = function updateFileInput() {
        var file = $(".banner-pic");
        var placeholder = file.parent().find("input.form-input");
        var customBannerImgCtn = $('.edit-profile-img-ctn-banner').closest('.edit-profile-img');

        placeholder.val("");
        placeholder.removeClass("required");
        customBannerImgCtn.slideUp(300, function () {
            $(this).remove();
        });
        file.parent().removeClass("focused");
        file.wrap('<form>').closest('form').get(0).reset();
        file.unwrap();
    };

    var checkAddress = function checkAddress() {
        var street = addressInput.val();
        var city = cityInput.val();
        var cp = cpInput.val();
        var province = provInput.val();
        var country = countryInput.val();

        if (street !== '' && street !== undefined) {
            addressSearch(street + " " + city + " " + cp + " " + province + " " + country);
        }
    };

    var createForm = function createForm(e) {
        $("input[name=preview]").val("false");
        $("input[name=pageSuccess]").val($(this).parent().attr("data-create-page"));
        $(".create-profile-form").removeAttr("target");
        checkForm(e);
    };

    var previewForm = function previewForm(e) {
        $("input[name=preview]").val("true");
        $("input[name=pageSuccess]").val($(this).parent().attr("data-preview-page"));
        $(".create-profile-form").attr("target", "_blank");
        $(".create-profile-form").submit();
    };

    var toggleBoxThemeInfoSettings = function toggleBoxThemeInfoSettings() {
        var t = $(this);
        var parentBoxHeader = t.closest('.box-theme-info-settings-outer-ctn');
        var boxSettings = parentBoxHeader.find('.box-theme-info-settings-ctn');

        if (parentBoxHeader.hasClass('open')) {
            boxSettings.slideUp(300);
            parentBoxHeader.removeClass('open');
        } else {
            boxSettings.slideDown(300);
            parentBoxHeader.addClass('open');
        }
    };

    var saveBoxThemeInfoIcon = function saveBoxThemeInfoIcon() {
        var t = $(this);
        var parentBox = t.closest('.box-theme-info-settings-ctn');
        var checkedRadio = parentBox.find('input[type="radio"]:checked');
        var iconChoiceError = parentBox.find('.box-theme-info-error');
        var iconChoiceSuccess = parentBox.find('.box-theme-info-success');

        iconChoiceError.slideUp(300);
        iconChoiceSuccess.slideUp(300);

        if (checkedRadio.length > 0) {
            var iconChoice = checkedRadio.val();
            var iconId = checkedRadio.attr('id');

            labels.save(iconId, iconChoice, 'fr', function () {
                labels.save(iconId, iconChoice, 'en', function () {
                    iconChoiceSuccess.slideDown(300);
                    setTimeout(function () {
                        iconChoiceSuccess.slideUp(300);
                    }, 5000);
                });
            });
        } else {
            iconChoiceError.slideDown(300);
            setTimeout(function () {
                iconChoiceError.slideUp(300);
            }, 5000);
        }
    };

    var toggleShowBoxInfo = function toggleShowBoxInfo() {
        var boxInfo = $(this).closest('.box-theme-info-ctn').find('.tooltip-ctn');

        if (boxInfo.hasClass('open')) {
            boxInfo.removeClass('open');
        } else {
            boxInfo.addClass('open');
        }
    };

    var deleteProfilePic = function deleteProfilePic() {
        var t = $(this);

        t.closest('.edit-profile-img').slideUp(300, function () {
            $(this).remove();
        });

        t.closest('.box-theme-content').append('<input type="hidden" name="delProfilePic" value="true"/>');
    };

    var updateFriendlyUrl = function updateFriendlyUrl() {
        var t = $(this);
        var string = t.val();

        string = string.trim();
        string = string.toLowerCase();
        string = string.replace(new RegExp("['`^¸:;.,¨!/$%?&*(){}\"]", "g"), "");
        string = string.replace(new RegExp(" ", "g"), "-");
        string = string.replace(new RegExp("(\\-)\\1+", "g"), "-");
        string = string.replace(new RegExp("[àâä]", "g"), "a");
        string = string.replace(new RegExp("[èêéë]", "g"), "e");
        string = string.replace(new RegExp("ç", "g"), "c");
        string = string.replace(new RegExp("[îï]", "g"), "i");
        string = string.replace(new RegExp("[òô]", "g"), "o");
        string = string.replace(new RegExp("û", "g"), "u");
        string = string.replace(new RegExp("œ", "g"), "oe");
        string = string.replace(new RegExp("æ", "g"), "ae");

        friendlyUrlInput.val(string).trigger('change');
    };

    var getAddressInput = function getAddressInput() {
        if (typeof addressInput !== 'undefined') addressInput;

        addressInput = $("input[name=address]").length !== 0 ? $("input[name=address]") : $("input[name=locationAddress]");
        if ($("input[name=address]").length === 0 && $("input[name=locationAddress]").length === 0) {
            addressInput = $("input[name=geolocalisation]");
        }

        return addressInput;
    };

    var init = function init() {
        loadTouchEvents($);

        createProfileBtn = $(".create-profile-form .create-profile-btn");
        createProfileBtn.on("click", createForm);

        previewProfileBtn = $(".preview-profile-btn");
        previewProfileBtn.on("click", previewForm);

        selectTypeProfile = $(".profile-type-select");
        selectTypeProfile.on("change", toggleItems);

        getAddressInput();

        cityInput = $("input[name=city]").length !== 0 ? $("input[name=city]") : $("input[name=locationCity]");
        cpInput = $("input[name=postalCode]").length !== 0 ? $("input[name=postalCode]") : $("input[name=locationPC]");
        provInput = $("input[name=province]").length !== 0 ? $("input[name=province]") : $("input[name=locationProvince]");
        countryInput = $("input[name=country]").length !== 0 ? $("input[name=country]") : $("input[name=locationCountry]");

        friendlyUrlInput = $("input[name=friendlyUrl]");
        friendlyUrlInput.on("change", checkValidFriendlyUrl);

        defaultBanner = $(".default-images-ctn .form-checkbox-ctn");
        defaultBanner.on("click", updateFileInput);

        boxThemeInfoBtn = $('.add-box-theme-info-btn');
        boxThemeInfoBtn.click(toggleBoxThemeInfoSettings);
        boxThemeSaveIconBtn = $('.save-box-theme-icon-btn');
        boxThemeSaveIconBtn.click(saveBoxThemeInfoIcon);
        boxThemeIcon = $('.box-theme-info-icon');
        boxThemeIcon.tap(toggleShowBoxInfo);

        deleteProfilePicBtn = $('.delete-profile-pic-btn');
        deleteProfilePicBtn.click(deleteProfilePic);

        profileNameInput = $('.profile-name');
        profileNameInput.keyup(updateFriendlyUrl);

        // checkAddress on init only for the profile page, profile form pages and event details page
        // add condition here to check more pages
        if ($('body').find('.create-profile-form').length !== 0 || $('body').find('.event-details-description-section').length !== 0 || $('body').find('.profile-page-description-tab-ctn').length !== 0) {
            checkAddress();
        }
        formValidator.init();
    };

    var profile = Fw.component.export('profile', {
        init: init,
        activateGlgAutocomplete: activateGlgAutocomplete,
        checkAddress: checkAddress
    });
})(jQuery);
$(window).on('load', function () {

    //AUTOCOMPLETE PROMOCODES
    $("body").on("click", function (event) {
        if (!$(event.target).hasClass('mg2-shop-autocomplete') && !$(event.target).hasClass('mg2-shop-linked-autocomplete')) {
            $(".mg2-shop-autocomplete").slideUp();
            $(".mg2-shop-autocomplete-edit").slideUp();
        }
    });

    $(".annAddPromoCode").on("click", annAddPromoCode);
    $(".annRemovePromoCode").on("click", annRemovePromoCode);

    $(".event_selection").change(function (event) {
        event.preventDefault();
        var eventsChecked = $("input.event_selection:checkbox:checked");
        var eventIDs = "";
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = eventsChecked[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var checkbox = _step.value;

                eventIDs += checkbox.value + ',';
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        eventIDs = eventIDs.replace(/,\s*$/, "");
        $("#eventsList").val(eventIDs);
        console.log(eventIDs);
    });

    $(".event_selection_update").change(function (event) {
        event.preventDefault();
        var update_id = $(this).attr("id");
        var eventsChecked = $("input.event_selection_update_" + update_id + ":checkbox:checked");
        var eventIDs = "";
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = eventsChecked[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var checkbox = _step2.value;

                eventIDs += checkbox.value + ',';
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        eventIDs = eventIDs.replace(/,\s*$/, "");
        $("#eventsListUpdate" + update_id).val(eventIDs);
        console.log(eventIDs);
    });

    // remove state to not always open on same box
    if ($('.mg2_detailed_options').length > 0) {
        window.history.replaceState({}, '', $('.mg2_detailed_options').attr('data-url'));
    }

    var $pickers = $('.mg2_admin_color_item__picker');
    if ($pickers.length != 0) {
        enablePickers($pickers);
    }

    // INIT MULTIPLE SELECTIONS
    if ($(".mg2_multiple-inputs-ctn")[0]) {
        $("body").on("click", function (e) {
            var $targ = $(e.target);
            var $ctn = $targ.closest(".mg2_multiple-inputs-ctn");

            if ($ctn.length) {
                $ctn.addClass("open");
            } else {
                $(".mg2_multiple-inputs-ctn").removeClass("open");
            }
        });

        $(".mg2_multiple-inputs-select-item-input").on("change", function (e) {
            var $inp = $(e.currentTarget);
            var isChecked = e.currentTarget.checked;
            var $ctn = $inp.closest(".mg2_multiple-inputs-ctn");
            var $select = $ctn.find(".mg2_multiple-inputs-select-hook");
            var $option = $select.find("option");
            var values = $option.val().length === 0 ? [] : $option.val().indexOf(",") === -1 ? [$option.val()] : $option.val().split(',');
            var texts = $option.text().trim().length === 0 ? [] : $option.text().trim().indexOf("\u200B,") === -1 ? [$option.text().trim()] : $option.text().trim().split("\u200B, ");
            var optionText = $inp.closest('.mg2_multiple-inputs-select-item').text();
            var inputIndex = values.indexOf($inp.val());

            if (inputIndex === -1) {
                texts.push(optionText);
                values.push($inp.val());
            } else {
                texts.splice(inputIndex, 1);
                values.splice(inputIndex, 1);
            }

            $select.html('<option value="' + values.join() + '">' + texts.join("\u200B, ") + '</option>');
        });
    }
});

function annRemovePromoCode() {
    window.location.reload();
    return false;
}

var annAddPromoCode = function annAddPromoCode(event) {
    event.preventDefault();
    var sub_total = $('#payment-process-subtotal-price');
    var shippingFee = $('#payment-process-free-shipping');
    var promo_applied = $('#errorPromo');
    var fees_service = $("#fees-service");
    var fees_tps = $("#fees-tps");
    var fees_tvq = $("#fees-tvq");
    var commission = $("#commission-fee");
    var packageError = $("#packagePromoCodeError");
    var packageTotal = document.getElementById('packageTotal') != null ? document.getElementById('packageTotal').value.trim() : 0;
    var packageTotal = 0; // Package is allowed for Promo codes fix
    console.log(fees_tvq);
    var net_total = $('#payment-process-step-1-amount-total-number');
    var net_total_2 = $('.mini-cart-total-amt');
    var promo = $("#promocodeId");
    var promotionlabel = $("#promotionlabel");
    var inputTextPromoCode = $("#annPromoCode");
    var addPromoButton = $("#annAddPromoCode");
    var cancelPromo = $("#annRemovePromoCode");
    var code = encodeURIComponent(document.getElementById('annPromoCode').value.trim());
    var lang = document.getElementById('lang').value;
    var member_id = document.getElementById('member_id').value;
    var event_id = document.getElementById('event_id').value;
    if (code !== "") {
        ajax('/action/epPromoCode?code=' + code + '&member_id=' + member_id + "&event_id=" + event_id, function (response) {
            console.log(response);
            if (response == "notfound") {
                if (lang == "fr") {
                    alert("Le code promotionnel n'est pas applicable!");
                } else {
                    alert("Promo code is not applicable!");
                }
            }

            if (packageError.length !== 0) {
                //packages available in the cart
                if (lang == "fr") {
                    packageError.html("Le code promotionnel n'est pas applicable pour le forfait!");
                } else {
                    packageError.html("Promo code is not applicable to packages!");
                }
                packageError.html(""); // Package is allowed for Promo codes fix
            }

            var responseArr = JSON.parse(response);
            if (responseArr != undefined && responseArr.length > 2) {

                sub_total_value = sub_total.html().trim();
                sub_total_value = sub_total_value.replace("$", "");
                sub_total_value = sub_total_value.replace(",", ".");
                sub_total_value = parseFloat(sub_total_value);

                if (packageTotal != 0) {
                    packageTotal = packageTotal.replace("$", "");
                    packageTotal = packageTotal.replace(",", ".");
                }
                sub_total_value_for_promo = sub_total_value - packageTotal;

                if (shippingFee.length !== 0) {
                    shipping_fee = shippingFee.html().trim();
                    shipping_fee = shipping_fee.replace("$", "");
                    shipping_fee = shipping_fee.replace(",", ".");
                    shipping_fee = parseFloat(shipping_fee);
                } else {
                    shipping_fee = 0;
                }

                fees_service_value = fees_service.html().trim();
                fees_service_value = fees_service_value.replace("$", "");
                fees_service_value = fees_service_value.replace(",", ".");
                fees_service_value = parseFloat(fees_service_value);

                fees_tps_value = fees_tps.html().trim();
                fees_tps_value = fees_tps_value.replace("$", "");
                fees_tps_value = fees_tps_value.replace(",", ".");
                fees_tps_value = parseFloat(fees_tps_value);

                fees_tvq_value = fees_tvq.html().trim();
                fees_tvq_value = fees_tvq_value.replace("$", "");
                fees_tvq_value = fees_tvq_value.replace(",", ".");
                fees_tvq_value = parseFloat(fees_tvq_value);

                if (commission.length !== 0) {
                    commission_value = commission.html().trim();
                    commission_value = commission_value.replace("$", "");
                    commission_value = commission_value.replace(",", ".");
                    commission_value = parseFloat(commission_value);
                } else {
                    commission_value = 0;
                }

                // console.log(sub_total_value);
                // console.log(fees_service_value);
                // console.log(fees_tps_value);
                // console.log(fees_tvq_value);

                promo_applied_value = promo_applied.html().trim();
                net_total_value = net_total.html().trim();
                if (responseArr[1] == 1) {
                    promo_applied_value = (sub_total_value_for_promo - shipping_fee) * responseArr[2] / 100;
                    promo_applied_value = promo_applied_value.toFixed(2);
                } else {
                    if (sub_total_value_for_promo === 0) {
                        promo_applied_value = 0;
                    } else {
                        promo_applied_value = responseArr[2];
                    }
                }
                net_total_value = sub_total_value - promo_applied_value;
                if (net_total_value < 0) {
                    net_total_value = 0;
                }
                net_total_value = net_total_value + fees_service_value + fees_tps_value + fees_tvq_value + commission_value;
                net_total_value = net_total_value.toFixed(2);

                // console.log(promo_applied_value);
                // console.log(net_total_value);

                if (lang == "fr") {
                    promo_applied_value = promo_applied_value.toString().replace(".", ",");
                    net_total_value = net_total_value.toString().replace(".", ",");
                }
                promo_applied.html("-" + promo_applied_value + "$");
                net_total.html(net_total_value + "$");
                net_total_2.html(net_total_value + "$");
                promo.val(responseArr[6]);
                promotionlabel.show();
                cancelPromo.show();
                inputTextPromoCode.hide();
                addPromoButton.hide();
            } else {
                if (lang == "fr") {
                    alert("Le code promotionnel n'est pas applicable!");
                } else {
                    alert("Promo code is not applicable!");
                }
            }
        });
    } else {
        $(".errorPromo").show();
    }
};

/* Let's add a promo code*/
function catalogAddPromoCode() {
    var chosenLinked = [];
    var code = encodeURIComponent(document.getElementById('shoppccode').value.trim());
    var sel = document.getElementById('shoppctype');
    var type = sel.options[sel.selectedIndex].value;
    var value = encodeURIComponent(document.getElementById('shoppcvalue').value);
    var maxuse = encodeURIComponent(document.getElementById('shoppcmaxuse').value);
    var pId = document.getElementById('shoppcpId') !== null ? encodeURIComponent(document.getElementById('shoppcpId').value) : 0;
    var exp = encodeURIComponent(document.getElementById('shoppcExpire').value);
    var expdd = encodeURIComponent(document.getElementById('shoppcday').value);
    var expmm = encodeURIComponent(document.getElementById('shoppcmonth').value);
    var expyy = encodeURIComponent(document.getElementById('shoppcyear').value);
    var pIds = document.getElementById('shoppcpIds') !== null ? encodeURIComponent(chosenLinked.join(",")) : "";
    var eventsList = encodeURIComponent(document.getElementById('eventsList').value);
    var parent_category_id = encodeURIComponent(document.getElementById('parent_category_id').value);
    var profile_id = encodeURIComponent(document.getElementById('profile_id').value);
    var oneTimeUse = "";
    var shipping = "";
    if (code !== "") {
        ajax('/action/shopPromoCodesForMember?code=' + code + '&value=' + value + '&type=' + type + '&maxUse=' + maxuse + '&productId=' + pId + '&expirationDate=' + exp + '&expirationDateDay=' + expdd + '&expirationDateMonth=' + expmm + '&expirationDateYear=' + expyy + shipping + oneTimeUse + "&productIds=" + pIds + "&eventsList=" + eventsList + "&parentCategoryId=" + parent_category_id + "&profileId=" + profile_id, function (response) {
            console.log(response);
            window.location.href = "/promo?t=1";
        });
    } else {
        $("#shoppccode").addClass("mg2-missing-error");
    }
}

var oPcCode = "";
var oPcVal = "";
var oPcType = "";
var oPcExp = "";
var oPcMax = "";
var openedPcId = "";
var oPcShipping = "";
var oPcOneTimeUse = "";
var oPcLinked = "";
function catalogModifyPCOpen(id) {
    if ($('.button_' + id).hasClass('hidden_button')) {
        if (openedPcId != '') {
            cancelModifyPc(openedPcId);
        }
        openedPcId = id;
        oPcCode = $('#mg2_pc_code_' + id).attr('value');
        oPcVal = $('#mg2_pc_value_' + id).attr('value');
        oPcType = $('#mg2_pc_type_' + id).val();
        oPcShipping = $('#mg2_pc_shipping_' + id).is(":checked");
        oPcOneTimeUse = $('#mg2_pc_oneTimeUse_' + id) !== null ? $('#mg2_pc_oneTimeUse_' + id).is(":checked") : "";
        oPcExp = $('#mg2_pc_exp_' + id).attr('value');
        oPcMax = $('#mg2_pc_max_' + id).attr('value');
        $('#shop_pc_' + id + ' .mg2_invisible_input').addClass('mg2_visible_input');
        $('#shop_pc_' + id + ' .mg2_catalog_pc').removeAttr('disabled');
        $('#shop_pc_' + id + ' .mg2_catalog_pc').removeClass('mg2_disabled_input');
        $('#shop_pc_' + id + ' .mg2_invisible_input').removeClass('mg2_invisible_input');
        $('#shop_pc_' + id + ' .mg2_catalog_pc').addClass('mg2_enabled_input');
        $('#shop_pc_' + id + ' .mg2_catalog_linked').removeClass('mg2_disabled_input');
        $('#shop_pc_' + id + ' .mg2_catalog_linked').addClass('mg2_enabled_input');
        $('#shop_pc_' + id + ' .mg2_catalog_shipping').removeAttr('disabled');
        if ($('#shop_pc_' + id + ' .mg2_catalog_oneTimeUse').length !== 0) {
            $('#shop_pc_' + id + ' .mg2_catalog_oneTimeUse').removeAttr('disabled');
        }
        // SetCaretAtEnd(document.getElementById('mg2_pc_code_' + id));
        $('#shop_pc_' + id + ' .event_selection_select').show();
        $('#shop_pc_' + id + ' .event_selection_show').hide();
        $('.button_' + id).addClass('hidden_button');
        $('.button_' + id + '.mg2_check').removeClass('hidden_button');
        $('.button_' + id + '.mg2_cancel').removeClass('hidden_button');
    } else {
        cancelModifyPc(id);
    }
}

function catalogModifyPC(id) {
    var chosenLinked = [];
    var mod = "type=" + encodeURIComponent(document.getElementById('mg2_pc_type_' + id).value);
    mod += "&id=" + encodeURIComponent(id);
    mod += "&code=" + encodeURIComponent(document.getElementById('mg2_pc_code_' + id).value);
    mod += "&value=" + encodeURIComponent(document.getElementById('mg2_pc_value_' + id).value);
    mod += "&maxUse=" + encodeURIComponent(document.getElementById('mg2_pc_max_' + id).value);
    mod += "&expirationDateDay=" + encodeURIComponent(document.getElementById('shoppcday_' + id).value);
    mod += "&expirationDateMonth=" + encodeURIComponent(document.getElementById('shoppcmonth_' + id).value);
    mod += "&expirationDateYear=" + encodeURIComponent(document.getElementById('shoppcyear_' + id).value);
    mod += "&productIds=" + encodeURIComponent(chosenLinked.join(","));
    mod += "&eventsList=" + encodeURIComponent(document.getElementById('eventsListUpdate' + id).value);
    mod += "&shipping=false";
    mod += "&oneTimeUse=false";
    ajax("/action/shopPromoCodesForMember?" + mod, function (response) {
        // catalogPcModified(response, id);
        console.log(response);
        window.location.href = "/promo?t=1";
    });
}
/* Once the option is modified, we close the modification display */
function catalogPcModified(response, id) {
    $('#shop_pc_' + id + ' .mg2-products-linked-names-tags').removeClass("new");
    cancelModifyPc(id, response);
}
function cancelModifyPc(id, response) {
    if (response == null || response == '') {
        $('#mg2_pc_code_' + id).val(oPcCode);
        $('#mg2_pc_value_' + id).val(oPcVal);
        $('#mg2_pc_type_' + id).val(oPcType);
        $('#mg2_pc_exp_' + id).val(oPcExp);
        $('#mg2_pc_max_' + id).val(oPcMax);
        $('#mg2_pc_linked_' + id).val(oPcLinked);
        if ($('#mg2_pc_oneTimeUse_' + id) !== null) {
            if (oPcOneTimeUse === true) {
                $('#mg2_pc_oneTimeUse_' + id).attr("checked", "true");
            } else {
                $('#mg2_pc_oneTimeUse_' + id).removeAttr("checked");
            }
        }
        if (oPcShipping === true) {
            $('#mg2_pc_shipping_' + id).attr("checked", "true");
        } else {
            $('#mg2_pc_shipping_' + id).removeAttr("checked");
        }
        $('#shop_pc_' + id + ' .mg2-products-linked-names-tags.new').remove();
        separateDateShop(document.getElementById('mg2_pc_exp_' + id), 'shoppcday_' + id, 'shoppcmonth_' + id, 'shoppcyear_' + id, document.getElementById('lang').value);
    }
    $('#shop_pc_' + id + ' .mg2_catalog_pc').attr('disabled', 'true');
    $('#shop_pc_' + id + ' .mg2_catalog_shipping').attr('disabled', 'true');
    if ($('#shop_pc_' + id + ' .mg2_catalog_shipping').length !== 0) {
        $('#shop_pc_' + id + ' .mg2_catalog_oneTimeUse').attr('disabled', 'true');
    }
    $('#shop_pc_' + id + ' .mg2_catalog_linked').attr('disabled', 'true');
    $('#shop_pc_' + id + ' .mg2_catalog_pc').removeClass('mg2_enabled_input');
    $('#shop_pc_' + id + ' .mg2_catalog_pc').addClass('mg2_disabled_input');
    $('#shop_pc_' + id + ' .mg2_visible_input').addClass('mg2_invisible_input');
    $('#shop_pc_' + id + ' .mg2_visible_input').removeClass('mg2_visible_input');
    $('#shop_pc_' + id + ' .event_selection_select').hide();
    $('#shop_pc_' + id + ' .event_selection_show').show();
    $('.button_' + id).addClass('hidden_button');
    $('.button_' + id + '.mg2_edit_icon').removeClass('hidden_button');
    openedPcId = "";
}

var confirm_box = false;
function shopDeletePromoCode(id) {
    if (id) {
        confirm_box = confirm("Are you sure to delete?");
        if (confirm_box) {
            ajax('/action/shopPromoCodesForMember?delete=true&id=' + id, function () {
                window.location.href = "/promo?t=1";
            });
        }
    } else {
        alert("Something went wrong!");
    }
}

function chooseDateShop(id, lang) {
    // if (lang == 'fr') {
    //     $(id).datepicker($.datepicker.regional[ "fr" ]);
    //     $(id).datepicker({});
    // } else {
    //     $(id).datepicker($.datepicker.regional[ "" ]);
    //     $(id).datepicker({});
    // }
    $(id).datepicker($.datepicker.regional[""]);
    $(id).datepicker({});
    $(id).datepicker('show');
}
function chooseDateShopRange(id, lang, startId, endId) {
    $('#' + startId).datepicker({
        numberOfMonths: 2,
        onSelect: function onSelect(selectedDate) {
            $("#" + endId).datepicker("option", "minDate", selectedDate);
            separateDateShop(selectedDate, 'startday', 'startmonth', 'startyear', lang);
            separateDateShop(document.getElementById(endId), 'endday', 'endmonth', 'endyear', lang);
        }
    });
    $('#' + endId).datepicker({
        numberOfMonths: 2,
        onSelect: function onSelect(selectedDate) {
            $("#" + startId).datepicker("option", "maxDate", selectedDate);
            separateDateShop(selectedDate, 'endday', 'endmonth', 'endyear', lang);
            separateDateShop(document.getElementById(startId), 'startday', 'startmonth', 'startyear', lang);
        }
    });
    if (lang === 'en') {
        $(id).datepicker("option", "dateFormat", "mm/dd/yy");
    }
    $(id).datepicker('show');
}
function separateDateShop(elmt, dayValue, monthValue, yearValue, lang) {
    var date = "";
    if (typeof elmt === 'string') {
        date = elmt;
    } else {
        date = elmt.value;
    }
    var year;
    var month;
    var day;
    // if (lang == 'fr') {
    //     day = date.substring(0, date.indexOf("/"));
    //     month = date.substring(date.indexOf("/") + 1, date.indexOf("/", date.indexOf("/") + 1));
    //     year = date.substring(date.indexOf("/", date.indexOf("/") + 1) + 1);
    // } else {
    //     month = date.substring(0, date.indexOf("/"));
    //     day = date.substring(date.indexOf("/") + 1, date.indexOf("/", date.indexOf("/") + 1));
    //     year = date.substring(date.indexOf("/", date.indexOf("/") + 1) + 1);
    // }
    month = date.substring(0, date.indexOf("/"));
    day = date.substring(date.indexOf("/") + 1, date.indexOf("/", date.indexOf("/") + 1));
    year = date.substring(date.indexOf("/", date.indexOf("/") + 1) + 1);
    month = month - 1;
    if (month == -1) {
        month = 11;
    }
    if (day == '') {
        document.getElementById(dayValue).value = -1;
        document.getElementById(monthValue).value = -1;
        document.getElementById(yearValue).value = -1;
    } else {
        document.getElementById(dayValue).value = day;
        document.getElementById(monthValue).value = month;
        document.getElementById(yearValue).value = year;
    }
}
(function ($, undefined) {
    /*
        * Mathilde Paccoud
        * Last update 25/03/2017
        * 
        * Purpose : Allows to store a session variable
        * 
        * @param : key - unique key to store a value in
        * @param : val - value to store in the label; if val is null : session variable is deleted
        * @param : callback - any function to be called once value is stored
        * 
        * Call : var session = Fw.component.models().session;
        */
    'use strict';

    var save = function save(key, val, callback) {
        if (val === null) {
            ajax("/action/sessionVariables?key=" + key, callback, true);
        } else {
            ajax("/action/sessionVariables?key=" + key + "&value=" + val, callback, true);
        }
    };

    var init = function init(page) {
        var currPage = $(page);
    };

    var session = Fw.component.export('session', {
        init: init,
        save: save
    });

    $(window).on("load", function () {
        init();
    });
})(jQuery);
(function ($, undefined) {

    'use strict';

    var responsiveDetector;
    var desktopActive = true;
    var textOuterCtn;
    var textCtn;
    var showMoreBtnCtn;
    var showMoreBtn;

    var checkWidth = function checkWidth() {
        if (responsiveDetector.css('visibility') === 'hidden') {
            if (desktopActive === false) {
                $('.show-more-text-and-btn-ctn.mobile-only').each(function () {
                    var t = $(this);
                    t.find(textOuterCtn).removeAttr('style');
                    t.find(showMoreBtnCtn).slideUp(300);
                });
            }

            desktopActive = true;
        } else {
            if (desktopActive === true) {
                $('.show-more-text-and-btn-ctn.mobile-only').each(function () {
                    initShowMoreBtn($(this));
                });
            }

            desktopActive = false;
        }
    };

    var initShowMoreBtn = function initShowMoreBtn(t) {
        if (t.find(textOuterCtn).height() < t.find(textCtn).height()) {
            t.find(showMoreBtnCtn).slideDown(300);
            t.find(showMoreBtn).click(showMoreText);
        }
    };

    var showMoreText = function showMoreText() {
        var t = $(this);
        var parentCtn = t.closest('.show-more-text-and-btn-ctn');
        var currTextOuterCtn = parentCtn.find(textOuterCtn);
        var textHeight = parentCtn.find(textCtn).height();

        currTextOuterCtn.css('max-height', textHeight);
        t.closest(showMoreBtnCtn).slideUp(300);

        setTimeout(function () {
            currTextOuterCtn.css('max-height', 'inherit'); // if resized
        }, 300);
    };

    var init = function init() {
        responsiveDetector = $('.responsive-detector');
        textOuterCtn = $('.show-more-text-outer-ctn');
        textCtn = $('.show-more-text-ctn');
        showMoreBtnCtn = $('.show-more-text-btn-ctn');
        showMoreBtn = $('.show-more-text-btn');

        showMoreBtn.click(showMoreText);

        $('.show-more-text-and-btn-ctn:not(.mobile-only)').each(function () {
            initShowMoreBtn($(this));
        });

        checkWidth();
        $(window).resize(function () {
            checkWidth();
        });
    };

    $(window).on('load', function () {
        init();
    });
})(jQuery);
(function ($, undefined) {
    // profils responsive
    'use strict';

    var slideInPopupBtn;
    var slideInPopupBackBtn;
    var responsiveDetector;
    var desktopActive = true;

    var checkWidth = function checkWidth() {
        if (responsiveDetector.css('visibility') === 'hidden') {
            if (desktopActive === false) {
                slideInPopupBackBtn.each(function () {
                    $(this).trigger('click');
                });
            }

            desktopActive = true;
        } else {
            desktopActive = false;
        }
    };

    var slideInPopup = function slideInPopup() {
        var t = $(this);
        var popupContentType = t.data('popup');
        var popupCtn = t.closest('.slide-in-popup-outer-ctn').find('.slide-in-popup-ctn');

        popupCtn.find('.slide-in-popup-content[data-popup=' + popupContentType + ']').addClass('selected');
        popupCtn.addClass('slide-in').addClass('open');
        $('body').addClass('no-scroll');
    };

    var slideOutPopup = function slideOutPopup() {
        var t = $(this);
        var popup = t.closest('.slide-in-popup-ctn');

        popup.removeClass('slide-in');
        $('body').removeClass('no-scroll');

        setTimeout(function () {
            popup.removeClass('open');
            popup.find('.slide-in-popup-content').each(function () {
                $(this).removeClass('selected');
            });
        }, 300);
    };

    var init = function init() {
        slideInPopupBtn = $('.slide-in-popup-btn');
        slideInPopupBackBtn = $('.slide-in-popup-header-ctn');
        responsiveDetector = $('.responsive-detector');

        slideInPopupBtn.click(slideInPopup);
        slideInPopupBackBtn.click(slideOutPopup);

        checkWidth();
        $(window).resize(function () {
            checkWidth();
        });
    };

    $(window).on('load', function () {
        init();
    });
})(jQuery);
(function ($, undefined) {

    'use strict';

    var addSlideBtn;
    var addSlideBox;
    var addSlideEventBtn;
    var addSlideEventBox;
    var sliderListElements;
    var deleteSlideBtn;
    var deleteSlideBtnConfirm;
    var toggleActiveBtn;
    var saveSlideBtn;
    var chooseEventBtn;

    var togglePanelImg = function togglePanelImg() {
        var t = $(this);
        if (t.hasClass("logged-nav-item-active")) {
            t.removeClass("logged-nav-item-active");
            addSlideBox.slideUp();
        } else {
            t.addClass("logged-nav-item-active");
            addSlideEventBox.slideUp();
            addSlideEventBtn.removeClass("logged-nav-item-active");
            addSlideBox.slideDown();
        }
    };

    var togglePanelEventSlide = function togglePanelEventSlide() {
        var t = $(this);
        if (t.hasClass("logged-nav-item-active")) {
            t.removeClass("logged-nav-item-active");
            addSlideEventBox.slideUp();
        } else {
            t.addClass("logged-nav-item-active");
            addSlideBox.slideUp();
            addSlideBtn.removeClass("logged-nav-item-active");
            addSlideEventBox.slideDown();
        }
    };

    var initSort = function initSort() {
        $(".slider-list-ctn").sortable({
            handle: ".handle",
            revert: 160,
            tolerance: "pointer",
            scrollSensitivity: 60,
            scrollSpeed: 30,
            update: function update(e, ui) {
                var index = ui.item.index();
                var id = $(ui.item).attr("data-id");

                var url = "/action/manageSlide";

                var data = new FormData();
                data.append("id", id);
                data.append("targetPosition", index);
                data.append("ajax", "true");

                $.ajax({
                    url: url,
                    data: data,
                    cache: false,
                    contentType: false,
                    processData: false,
                    type: 'POST',
                    success: function success(response) {}
                });
            }
        });
    };

    var slideId;
    var line;
    var deleteSlideConfirm = function deleteSlideConfirm() {
        var t = $(this);
        line = t.closest(".slider-list-elmt");
        slideId = t.attr("data-slideId");
    };

    var deleteSlide = function deleteSlide() {
        var url = "/action/manageSlide";

        var data = new FormData();
        data.append("id", slideId);
        data.append("delete", "true");
        data.append("ajax", "true");

        $.ajax({
            url: url,
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            type: 'POST',
            success: function success(response) {
                line.slideUp();
            }
        });
    };

    var toggleActive = function toggleActive() {
        var t = $(this);
        var active = t.hasClass("active");
        var id = t.attr("data-slideId");
        var url = "/action/manageSlide";

        var data = new FormData();
        data.append("id", id);
        data.append("active", !active);
        data.append("action", "true");
        data.append("ajax", "true");

        $.ajax({
            url: url,
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            type: 'POST',
            success: function success(response) {
                if (active) {
                    t.removeClass("active");
                } else {
                    t.addClass("active");
                }
            }
        });
    };

    var saveSlide = function saveSlide() {
        var form = $(this).closest(".add-slide-form");
        formValidator.validateForm(form);

        saveSlideBtn.addClass("disabled");
        if (!form.hasClass('has-error')) {
            form.submit();
        } else {
            saveSlideBtn.removeClass("disabled");
        }
    };

    var init = function init() {
        addSlideBox = $('.create-slider-image-box');
        addSlideBtn = $('.create-new-image-btn');
        addSlideBtn.on("click", togglePanelImg);

        addSlideEventBox = $('.create-slider-event-box');
        addSlideEventBtn = $('.create-slide-event-btn');
        addSlideEventBtn.on("click", togglePanelEventSlide);

        sliderListElements = $(".slider-list-elmt");
        if (sliderListElements.length !== 0) {
            initSort();
        }

        saveSlideBtn = $(".save-slide-btn");
        saveSlideBtn.on("click", saveSlide);

        deleteSlideBtn = $(".slide-delete");
        deleteSlideBtn.on("click", deleteSlideConfirm);

        deleteSlideBtnConfirm = $(".delete-slide-btn");
        deleteSlideBtnConfirm.on("click", deleteSlide);

        toggleActiveBtn = $(".slide-power");
        toggleActiveBtn.on("click", toggleActive);
    };

    var slider = Fw.component.export('slider', {
        init: init
    });
})(jQuery);
(function ($, d, g) {

    'use strict';

    var tabBtn;

    var changeTabContent = function changeTabContent() {
        var t = $(this);
        var href = t.attr("data-href");

        if (!t.hasClass('selected')) {
            tabBtn.addClass('disabled-events');

            if (href !== "" && href !== undefined) {
                location.href = href;
            } else {
                var parentCtn = t.closest('.tabs-bar-and-content-ctn');
                var chosenTabNumber = t.data('tab');

                parentCtn.find('.tabs-bar-item.selected').removeClass('selected');
                parentCtn.find('.tabs-bar-item[data-tab=' + chosenTabNumber + ']').addClass('selected');
                parentCtn.find('.tabs-content-inner-ctn.selected').fadeOut(300, function () {
                    $(this).removeClass('selected');
                    parentCtn.find('.tabs-content-inner-ctn[data-tab=' + chosenTabNumber + ']').fadeIn(300).addClass('selected');
                    tabBtn.removeClass('disabled-events');
                });
            }
        }
    };

    var init = function init() {
        tabBtn = $('.tabs-bar-item');
        tabBtn.click(changeTabContent);
    };

    $(g).on("load", init);
})(jQuery, document, window);
(function ($, undefined) {

    'use strict';

    var ticketListHeader;

    var toggleTicketList = function toggleTicketList() {
        var t = $(this);
        var parent = t.closest('.tickets-list-outer-ctn');
        var list = parent.find('.tickets-list-content-ctn');

        if (parent.hasClass('list-open')) {
            parent.removeClass('list-open');
            list.slideUp(300);
        } else {
            parent.addClass('list-open');
            list.slideDown(300);
        }
    };

    var init = function init() {
        ticketListHeader = $('.tickets-list-header-ctn');

        ticketListHeader.click(toggleTicketList);
    };

    $(window).on('load', function () {
        init();
    });
})(jQuery);
var lang = lang || document.documentElement.lang;

(function ($, d, g) {

    'use strict';

    var header;
    var popupBtn;
    var closePopupBtn;
    var closeSlideInPopupBtn;
    var siteOverlay;
    var toggleTriggerElement;
    var toggleTriggerElementOpen;
    var toggleTriggerElementClose;
    var toggleFormBtn;
    var closeToggleFormBtn;
    var tableActionPopupBtn;
    var tableActionCloseBtn;
    var closeWarningBoxBtn;
    var closeWarningBoxDefiniteBtn;
    var accordionHeader;
    var numbersOnlyInput;
    var doubleQuotePreventOnlyInput;
    var oneEventListStyle;
    var changeInputQtyBtn;
    var instructionsBoxBtn;
    var contactPopupSubmitBtn;
    var hideItemRadioBtn;
    var minOne;
    var maxHundread;
    var respDetectionSmScreen;

    var systemDateTime;

    var openPopup = function openPopup() {
        var t = $(this);
        var id = t.attr('id');
        if (id === undefined) {
            id = t.attr("data-id");
        }
        var parentCtn = t.closest('.popup-outer-ctn');
        var popup = $('.popup#' + id);

        if (popup.hasClass('slide-in') && !$('body').hasClass('no-scroll') && respDetectionSmScreen.css('visibility') === 'visible') {
            header.toggleScroll();
        }

        if (popup.length !== 0) {
            popup.addClass('open');

            if (popup.parent().closest('.popup-ctn').length === 0) {
                if (popup.attr('data-overlay-selector-class')) {
                    parentCtn.find('.' + popup.attr('data-overlay-selector-class')).addClass('active');
                } else {
                    $('.overlay', 'body').addClass('active');
                }
            }
        }
    };

    var closePopup = function closePopup() {
        var t = $(this);
        var id = t.closest('.popup-ctn').attr('id');
        var parentCtn = t.closest('.popup-outer-ctn');
        var popup = $('.popup[id=' + id + ']');

        if (popup.length !== 0) {
            popup.removeClass('open');

            if (popup.hasClass('slide-in') && $('body').hasClass('no-scroll')) {
                header.toggleScroll();
            }

            if (popup.parent().closest('.popup-ctn').length === 0 || popup.hasClass('remove-overlay')) {
                if (popup.attr('data-overlay-selector-class')) {
                    parentCtn.find('.' + popup.attr('data-overlay-selector-class')).removeClass('active');
                } else {
                    $('.overlay', 'body').removeClass('active');
                }
            }
        }
    };

    var toggleElement = function toggleElement(e) {
        var t = $(this);
        var parent = t.closest('.toggle-outer-ctn');
        var element = parent.children('.element-to-toggle');
        var delay = 0;
        var delay2 = 0;

        if (element.length === 0) {
            element = $('.element-to-toggle[data-id=' + t.attr('data-id') + ']');
        }

        if (t.hasClass("sliding")) {
            e.preventDefault();
        }
        t.addClass("sliding");

        // for buttons who also have a form validation on click
        if (t.hasClass('check-errors')) {
            delay2 = 300;
        }

        setTimeout(function () {
            if (element.find('.form-input.error').length > 0 && t.hasClass('check-errors')) {
                return false;
            }

            element.each(function (i) {
                var oneElement = $(this);

                if (i !== 0) {
                    delay = delay + 300;
                }

                setTimeout(function () {
                    if (oneElement.hasClass('hide')) {
                        oneElement.slideDown(300, function () {
                            t.removeClass("sliding");
                            $(this).removeClass('hide');

                            if (!$(this).hasClass('no-required')) {
                                if ($('input', $(this))) {
                                    $('input', $(this)).addClass('required');
                                }
                            }
                        });
                    } else {
                        oneElement.slideUp(300, function () {
                            t.removeClass("sliding");
                            $(this).addClass('hide');

                            if (!$(this).hasClass('no-required')) {
                                if ($('input', $(this))) {
                                    $('input', $(this)).removeClass('required');
                                }
                            }
                        });
                    }
                }, delay);
            });
        }, delay2);
    };

    var openToggleElement = function openToggleElement(e) {
        var t = $(this);
        var parent = t.closest('.toggle-outer-ctn');
        var element = parent.children('.element-to-toggle');

        if (element.hasClass('hide')) {
            element.slideDown(300, function () {
                $(this).removeClass('hide');
                if ($('.derequired', $(this))) {
                    $('.derequired', $(this)).addClass('required');
                }
            });
        }
    };

    var closeToggleElement = function closeToggleElement(e) {
        var t = $(this);
        var parent = t.closest('.toggle-outer-ctn');
        var element = parent.children('.element-to-toggle');

        if (!element.hasClass('hide')) {
            element.slideUp(300, function () {
                $(this).addClass('hide');
                if ($('.required', $(this))) {
                    $('.required', $(this)).removeClass('required');
                }
            });
        }
    };

    var toggleForm = function toggleForm() {
        var t = $(this);
        var forward = t.attr("data-forward");
        var parent = t.closest('.toggle-form-outer-ctn');
        var selectedFormNumber = t.data('number');
        var selectedForm = parent.find('.toggle-form-ctn[data-number=' + selectedFormNumber + ']');
        var displayedForm = parent.find('.toggle-form-ctn.open');
        var displayedFormNumber = displayedForm.data('number');

        if (forward !== undefined && forward !== '') {
            window.location = forward;
        } else if (displayedFormNumber === selectedFormNumber) {
            selectedForm.removeClass('open');

            setTimeout(function () {
                selectedForm.slideUp(400);
            }, 300);
        } else if (displayedFormNumber !== selectedFormNumber && displayedFormNumber !== undefined) {
            displayedForm.removeClass('open');

            setTimeout(function () {
                displayedForm.slideUp(400);

                setTimeout(function () {
                    selectedForm.slideDown(400);

                    setTimeout(function () {
                        selectedForm.addClass('open');
                    }, 400);
                }, 400);
            }, 300);
        } else {
            selectedForm.slideDown(400);

            setTimeout(function () {
                selectedForm.addClass('open');
            }, 400);
        }
    };

    var closeToggleForm = function closeToggleForm() {
        var t = $(this);
        var form = t.closest('.toggle-form-ctn');

        if (t.attr("data-url") !== undefined && t.attr("data-url") !== '') {
            window.location = t.attr("data-url");
        } else {
            form.removeClass('open');

            setTimeout(function () {
                form.slideUp(400);
            }, 300);
        }
    };

    var toggleActionsPopup = function toggleActionsPopup() {
        var t = $(this);
        var parent = t.closest('.table-action-btns-ctn');
        var table = t.closest('table');
        var closestRow = t.closest('tr');
        var ctn = closestRow;

        if (!closestRow.length) {
            ctn = parent; // also used for promotions page (not a table);
        }

        var rowActionButtons = ctn.find('.table-action-popup-btn');
        var actionsPopup = ctn.find('.table-actions-ctn');
        table.find('tr').each(function () {});

        var _close = function _close() {
            rowActionButtons.removeClass('active');
            table.find('.table-cell-overlay').fadeOut(300, function () {
                $(this).removeClass('active');
            });
            actionsPopup.removeClass('open');

            if (!parent.is('div')) {
                $('.overlay', 'body').removeClass('active-responsive');
            }
        };
        var _open = function _open() {
            rowActionButtons.addClass('active');
            table.find('.table-cell-overlay').fadeIn(300, function () {
                $(this).addClass('active');
            });
            setTimeout(function () {
                $("body").one("click", _close);
            }, 300);
            actionsPopup.addClass('open');

            if (!parent.is('div')) {
                $('.overlay', 'body').addClass('active-responsive');
            }
        };

        if (rowActionButtons.hasClass('active')) {
            _close();
        } else {
            _open();
        }
    };

    var closeActionPopup = function closeActionPopup() {
        var t = $(this);
        var table = t.closest('table');
        var rowActionButtons = t.closest('tr').find('.table-action-popup-btn');
        var actionsPopup = t.closest('tr').find('.table-actions-ctn');

        rowActionButtons.removeClass('active');
        table.find('.table-cell-overlay').fadeOut(300, function () {
            $(this).removeClass('active');
        });
        actionsPopup.removeClass('open');
        $('.overlay', 'body').removeClass('active-responsive');
    };

    var closeWarningBox = function closeWarningBox() {
        var t = $(this);
        var id = t.attr("data-id");

        var url = "/action/messages";
        url += "?ajax=true";
        url += "&read=true";
        url += "&id=" + id;

        ajax(url, function (response) {
            t.closest('.warning-box').slideUp(300, function () {
                t.remove();
            });
        }, true);
    };

    var closeWarningDefiniteBox = function closeWarningDefiniteBox() {
        var t = $(this);
        var id = t.attr("data-id");
        var pageId = t.attr("data-pageid");

        var url = '/action/manageGenData';
        url += '?field1=warningClose';
        url += '&field2=' + id;
        url += '&field3=' + pageId;
        url += '&ajax=true';

        ajax(url, function (response) {
            if (response.indexOf('success') !== -1) {
                t.closest(".warning-box").slideUp();
            }
        }, true);
    };

    var toggleAccordionContent = function toggleAccordionContent() {
        var content = $(this).closest('.accordion-outer-ctn').find('.accordion-content');

        if (content.hasClass('open')) {
            content.slideUp(300);
            content.removeClass('open');
        } else {
            content.slideDown(300);
            content.addClass('open');
        }
    };

    var typeNumbersOnly = function typeNumbersOnly(event) {
        if (!event.shiftKey && (event.which === 0 || event.which === 8 || event.which === 48 || event.which === 49 || event.which === 50 || event.which === 51 || event.which === 52 || event.which === 53 || event.which === 54 || event.which === 55 || event.which === 56 || event.which === 57)) {
            return true;
        } else {
            event.preventDefault();
            return false;
        }
    };

    var typePreventDoubleQuote = function typePreventDoubleQuote(event) {
        if (event.which === 34 || event.which === 35) {
            event.preventDefault();
            return false;
        } else {
            return true;
        }
    };

    var openEventDetails = function openEventDetails(event) {
        if ($(event.target).closest('.show-more-btn').length === 0 && !$(event.target).is('a') && $(event.target).closest('.show-more-atttending-artists-event-list-popup').length === 0) {
            var url = $(this).attr('data-url');
            window.location.href = url;
        }
    };

    var changeInputQty = function changeInputQty() {
        var t = $(this);
        var max = t.data('max-qty') ? t.data('max-qty') : false;
        var min = t.data('min-qty') ? t.data('min-qty') : 0;
        var input = t.closest('.qty-input-with-buttons').find('.form-input');
        var val = input.val().length ? parseInt(input.val()) : 0;

        if (t.hasClass('plus') && (val < max || max === false)) {
            input.val(val += 1);
            if (input.hasClass('form-select')) {
                input.trigger('change');
            }
        } else if (t.hasClass('minus') && val > min) {
            input.val(val -= 1);
            if (input.hasClass('form-select')) {
                input.trigger('change');
            }
        }

        disableQtyBtns(t, val, min, max);
    };

    var disableQtyBtns = function disableQtyBtns(t, val, min, max) {
        var minusBtn = t.closest('.qty-input-with-buttons').find('.change-qty-btn.minus');
        var plusBtn = t.closest('.qty-input-with-buttons').find('.change-qty-btn.plus');

        if (plusBtn.hasClass("locked")) {
            plusBtn.addClass('disabled');
            if (val !== min) {
                minusBtn.removeClass('disabled');
            }
        } else if (val === max) {
            plusBtn.addClass('disabled');
            minusBtn.removeClass('disabled');
        } else if (val === min) {
            minusBtn.addClass('disabled');
            plusBtn.removeClass('disabled');
        } else {
            plusBtn.removeClass('disabled');
            minusBtn.removeClass('disabled');
        }
    };

    var toggleInstructionsBox = function toggleInstructionsBox() {
        var box = $(this).closest('.instructions-box-outer-ctn').find('.instructions-box-ctn');
        box.slideToggle(300);
    };

    var submitContactForm = function submitContactForm() {
        var t = $(this);
        var form = t.closest('form');

        formValidator.validateForm(form);

        if (!form.hasClass('has-error')) {
            form.submit();
        }
    };

    var updateHideItemChoice = function updateHideItemChoice() {
        var t = $(this);
        var key = t.attr('name');
        var allChoices = t.closest('.hide-item-settings-ctn');
        var val = '';

        allChoices.find('.form-check-input').each(function () {
            if ($(this).prop('checked') === true) {
                val += $(this).val();
            }
        });

        labels.save(key, val, 'fr', function () {
            labels.save(key, val, 'en', function () {});
        });
    };

    var activateSystemTimer = function activateSystemTimer() {
        try {
            systemDateTime.setTime(systemDateTime.getTime() + 1000 * 60);
            d.getElementById("systemCurrentDate").value = systemDateTime.getFullYear() + "" + formatZeros(systemDateTime.getMonth() + 1) + "" + formatZeros(systemDateTime.getDate());
            d.getElementById("systemCurrentTime").value = formatZeros(systemDateTime.getHours()) + ":" + formatZeros(systemDateTime.getMinutes());
            setTimeout(activateSystemTimer, 1000 * 60);
        } catch (err) {
            console.error(err);
        }
    };

    var minOneVal = function minOneVal() {
        var t = $(this);
        if (parseFloat(t.val()) === 0 || t.hasClass('always-filled') && t.val() === '') {
            t.val(1);
        }
    };

    var maxHundreadVal = function maxHundreadVal() {
        var t = $(this);
        if (parseInt(t.val()) > 100) {
            t.val(100);
        }
    };

    var toggleTooltip = function toggleTooltip() {
        $('.input-tooltip[data-id=' + $(this).attr('data-id') + ']').fadeToggle();
    };

    var sendEmail = function sendEmail(email, subject, message, file, fields) {
        var callback = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function () {};

        var params = {
            email: email,
            subject: subject,
            file: file
        };
        if (message) {
            params.message = message;
        }
        for (var key in fields) {
            if (fields.hasOwnProperty(key) && /^field[123456]$/.test(key)) {
                params[key] = fields[key];
            }
        }
        $.ajax({
            url: "/action/sendEmail",
            method: "post",
            data: params,
            complete: function complete(response) {
                callback(response.responseText);
            }
        });
    };

    var init = function init() {
        loadTouchEvents($);

        header = Fw.modules.models().header;
        popupBtn = $('.popup-btn');
        closePopupBtn = $('.popup-ctn .popup-inner-close');
        closeSlideInPopupBtn = $('.close-slide-in-popup-btn');
        toggleTriggerElement = $('body:not(.is-logged-in) .toggle-trigger-element, .toggle-trigger-element.exception');
        toggleTriggerElementOpen = $('body:not(.is-logged-in) .toggle-trigger-element-open');
        toggleTriggerElementClose = $('body:not(.is-logged-in) .toggle-trigger-element-close');
        toggleFormBtn = $('body:not(.is-logged-in) .toggle-form-btn');
        closeToggleFormBtn = $('body:not(.is-logged-in) .close-toggle-form-btn');
        tableActionPopupBtn = $('.table-action-popup-btn');
        tableActionCloseBtn = $('.action-popup-responsive-close-btn');
        closeWarningBoxBtn = $('.close-warning-box-btn');
        closeWarningBoxDefiniteBtn = $('.close-warning-box-definite-btn');
        accordionHeader = $('.accordion-header');
        numbersOnlyInput = $('input.numbers-only');
        doubleQuotePreventOnlyInput = $('.prevent-double-quote-only');
        //        oneEventListStyle = $('.items-list-one-item-ctn.one-event');
        changeInputQtyBtn = $('.change-qty-btn');
        instructionsBoxBtn = $('.instructions-box-btn');
        contactPopupSubmitBtn = $('.contact-popup-submit-btn');
        hideItemRadioBtn = $('.hide-item-radio-btn');
        minOne = $('input.min-one');
        maxHundread = $('input.max-hundread');
        respDetectionSmScreen = $('.responsive-detector-sm');

        popupBtn.click(openPopup);
        closePopupBtn.click(closePopup);
        closeSlideInPopupBtn.click(closePopup);
        toggleTriggerElement.click(toggleElement);
        toggleTriggerElementOpen.click(openToggleElement);
        toggleTriggerElementClose.click(closeToggleElement);
        toggleFormBtn.click(toggleForm);
        closeToggleFormBtn.click(closeToggleForm);
        tableActionPopupBtn.click(toggleActionsPopup);
        closeWarningBoxBtn.click(closeWarningBox);
        closeWarningBoxDefiniteBtn.click(closeWarningDefiniteBox);
        accordionHeader.click(toggleAccordionContent);
        tableActionCloseBtn.click(closeActionPopup);
        numbersOnlyInput.keypress(typeNumbersOnly);
        doubleQuotePreventOnlyInput.keypress(typePreventDoubleQuote);
        //        oneEventListStyle.click(openEventDetails);
        changeInputQtyBtn.click(changeInputQty);
        instructionsBoxBtn.click(toggleInstructionsBox);
        contactPopupSubmitBtn.click(submitContactForm);
        hideItemRadioBtn.change(updateHideItemChoice);
        minOne.keyup(minOneVal);
        maxHundread.keyup(maxHundreadVal);
        $('body.is-admin .input-tooltip-btn').click(toggleTooltip);

        $("input.float-number").keypress(numLockFloat);

        if (d.getElementById("systemCurrentDate") && d.getElementById("systemCurrentTime")) {
            var sysCurDate = d.getElementById("systemCurrentDate").value;
            var sysCurTime = d.getElementById("systemCurrentTime").value;
            sysCurDate = sysCurDate.substr(0, 4) + "/" + sysCurDate.substr(4, 2) + "/" + sysCurDate.substr(6, 2);
            systemDateTime = new Date(sysCurDate + " " + sysCurTime);
            setTimeout(activateSystemTimer, 1000 * 60);
        }
    };

    var tools = Fw.component.export('tools', {
        init: init,
        disableQtyBtns: disableQtyBtns,
        sendEmail: sendEmail
    });
})(jQuery, document, window);

function formatDecimal(n, d) {
    if (isNaN(n) || (n - Math.floor(n)).length - 2 <= d) {
        return n;
    }
    var r = Math.pow(10, isNaN(d) ? 2 : d);
    return Math.round(n * r) / r;
}
function formatDecimal2(n, d) {
    var d2 = isNaN(d) ? 2 : d;
    return formatDecimal(formatDecimal(n, d2 + 1), d2);
}
function formatMoney($, round) {
    var lang = document.documentElement.lang,
        dec = round ? 0 : 2,
        x = isNaN($) ? parseFloat($.replace(",", ".")) : parseFloat($),
        res = x.toFixed(dec).toString();

    return lang === "en" ? "$" + res : res.replace(".", ",") + "$";
}
function formatZeros(n, l) {
    var str = n.toString();
    var nl = str.length;
    l = l || 2;
    while (nl < l) {
        str = "0" + str;
        nl++;
    }
    return str;
}
function getIntDateTime(y, m, d, h, mn) {
    var dt = getDateYMD(y, m, d) + formatZeros(h) + formatZeros(mn);
    return parseInt(dt);
}
function getDateYMD(y, m, d, a) {
    var im = parseInt(m) + 1;
    var array = [y, formatZeros(im), formatZeros(d)];
    return array.join(a ? a : "");
}
function getTimeHMS(h, m, s, a1, a2) {
    if (s === undefined || s === null || s === "") {
        return formatZeros(h) + (a1 ? a1 : "") + formatZeros(m);
    } else {
        return formatZeros(h) + (a1 ? a1 : "") + formatZeros(m) + (a2 ? a2 : "") + formatZeros(s);
    }
}
function getDatePrefix(o, prefix) {
    return getDateFormatted(o[prefix + "DateYear"], o[prefix + "DateMonth"], o[prefix + "DateDay"]);
}
function getTimePrefix(o, prefix) {
    return getTimeFormatted(o[prefix + "DateHour"], o[prefix + "DateMinute"]);
}
function getDateFormatted(y, m, d) {
    var om = { "en": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], "fr": ["janvier", "f\xE9vrier", "mars", "avril", "mai", "juin", "juillet", "ao\xFBt", "septembre", "octobre", "novembre", "decembre"] };
    var im = parseInt(m);
    switch (lang) {
        case "fr":
            return d + " " + om[lang][im] + " " + y;
        case "en":
            return om[lang][im] + " " + d + " " + y;
        default:
            return y + "-" + (im + 1) + "-" + d;
    }
}
function getTimeFormatted(t) {
    var a = [];
    var tf = "";
    if (lang === "fr") {
        if (t.match("h")) {
            tf = t;
        } else {
            a = t.split(":");
            tf = a[0] + "h" + a[1];
            if (a.length > 2) tf += "m" + a[2] + "s";
        }
    } else {
        if (t.match(":")) {
            tf = t;
        } else {
            var ih = t.search(/h/i);
            a[0] = t.substring(0, ih);
            a[1] = t.subtring(ih + 1);
            var im = t.search(/m/i);
            if (im > -1) {
                a[1] = t.substring(ih + 1, im);
                a[2] = t.substring(im + 1, t.length - 1);
            }
            tf = a.join(":");
        }
    }
    return tf;
}
function parseFormattedDate(date, sep) {
    var a = date.split(" "),
        d = isNaN(parseInt(a[0])) ? a[1] : a[0],
        m = isNaN(parseInt(a[0])) ? a[0] : a[1],
        y = a[2];

    return getDateYMD(y, parseMonthSystem(m), d, sep);
}
function parseMonthSystem(str) {
    var list = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
    if (lang === "fr") {
        list = ["janvier", "f\xE9vrier", "mars", "avril", "mai", "juin", "juillet", "ao\xFBt", "septembre", "octobre", "novembre", "decembre"];
    }
    return list.indexOf(str.toLowerCase());
}
function roundUpTime(time) {
    var c = time.split(":"),
        h = parseInt(c[0]),
        m = parseInt(c[1]);

    m = m - m % 15 + 15;
    if (m >= 60) {
        m = 0;
        h++;
    }
    return formatZeros(h % 24) + ":" + formatZeros(m);
}
function roundTime(time, rounder) {
    var d = time.match(/[h:]/),
        c = time.split(d),
        r = rounder ? rounder : 15,
        m = Math.round(parseInt(c[1]) / r) * r,
        h = parseInt(c[0]) + Math.floor(m / 60);

    return formatZeros(h % 24) + d + formatZeros(m % 60);
}

function encodeText(name) {
    name = name.replace(/\\xE0/g, '\xE0');
    name = name.replace(/\\xE2/g, '\xE2');
    name = name.replace(/\\xE3/g, '\xE3');
    name = name.replace(/\\xE4/g, '\xE4');
    name = name.replace(/\\xE5/g, '\xE5');
    name = name.replace(/\\xE7/g, '\xE7');
    name = name.replace(/\\xE9/g, '\xE9');
    name = name.replace(/\\xE8/g, '\xE8');
    name = name.replace(/\\xEA/g, '\xEA');
    name = name.replace(/\\xEB/g, '\xEB');
    name = name.replace(/\\xEE/g, '\xEE');
    name = name.replace(/\\xEF/g, '\xEF');
    name = name.replace(/\\xF1/g, '\xF1');
    name = name.replace(/\\xF2/g, '\xF2');
    name = name.replace(/\\xF3/g, '\xF3');
    name = name.replace(/\\xF4/g, '\xF4');
    name = name.replace(/\\xF6/g, '\xF6');
    name = name.replace(/\\xF9/g, '\xF9');
    name = name.replace(/\\xFB/g, '\xFB');
    name = name.replace(/\\xC0/g, '\xC0');
    name = name.replace(/\\xC2/g, '\xC2');
    name = name.replace(/\\xC7/g, '\xC7');
    name = name.replace(/\\xC8/g, '\xC8');
    name = name.replace(/\\xC9/g, '\xC9');
    name = name.replace(/\\xCA/g, '\xCA');
    name = name.replace(/\\xCB/g, '\xCB');
    name = name.replace(/\\xCE/g, '\xCE');
    name = name.replace(/\\xCF/g, '\xCF');
    name = name.replace(/\\xD1/g, '\xD1');
    name = name.replace(/\\xD4/g, '\xD4');
    name = name.replace(/\\xD9/g, '\xD9');
    name = name.replace(/\\xDB/g, '\xDB');
    return name;
}

function encodeInputText(name) {
    name = name.replace('Ã ', '\xE0');
    name = name.replace('Ã¢', '\xE2');
    name = name.replace('Ã£', '\xE3');
    name = name.replace('Ã¤', '\xE4');
    name = name.replace('Ã¥', '\xE5');
    name = name.replace('Ã§', '\xE7');
    name = name.replace('Ã©', '\xE9');
    name = name.replace('Ã¨', '\xE8');
    name = name.replace('Ãª', '\xEA');
    name = name.replace('Ã«', '\xEB');
    name = name.replace('Ã®', '\xEE');
    name = name.replace('Ã¯', '\xEF');
    name = name.replace('Ã±', '\xF1');
    name = name.replace('Ã²', '\xF2');
    name = name.replace('Ã³', '\xF3');
    name = name.replace('Ã´', '\xF4');
    name = name.replace('Ã¶', '\xF6');
    name = name.replace('Ã¹', '\xF9');
    name = name.replace('Ã»', '\xFB');
    name = name.replace('Ã€', '\xC0');
    name = name.replace('Ã‚', '\xC2');
    name = name.replace('Ã‡', '\xC7');
    name = name.replace('Ãˆ', '\xC8');
    name = name.replace('Ã‰', '\xC9');
    name = name.replace('ÃŠ', '\xCA');
    name = name.replace('Ã‹', '\xCB');
    name = name.replace('ÃŽ', '\xCE');
    name = name.replace('Ã?', '\xCF');
    name = name.replace('Ã’', '\xD1');
    name = name.replace('Ã�?', '\xD4');
    name = name.replace('Ã™', '\xD9');
    name = name.replace('Ã›', '\xDB');
    return name;
}

function pageScrlTo(pos) {
    $("html, body").animate({ scrollTop: pos });
}

function newXHR() {
    var xhr;
    if (window.XMLHttpRequest) {
        xhr = new XMLHttpRequest();
    } else {
        try {
            xhr = new ActiveXObject("Msxml2.XMLHTTP");
        } catch (e) {
            try {
                xhr = new ActiveXObject("Microsoft.XMLHTTP");
            } catch (e) {
                return null;
            }
        }
    }
    return xhr;
}
function siteAjax(url, callback, returnVar, blackout) {
    var xhr = newXHR();
    if (!xhr) return;
    if (blackout) ajaxBlackout(true);
    var noCache = "cache=" + Math.random();
    var nonCacheUrl = url + (url.indexOf("?") > -1 ? "&" : "?") + noCache;
    xhr.open("GET", nonCacheUrl, true);
    xhr.onreadystatechange = function () {
        if (this.readyState == 4) {
            if (this.status == 200) {
                if (callback) {
                    var res = this.responseText;
                    callback(res, returnVar);
                }
            } else {
                console.error(this.statusText);
                popErrorSite('errorMessageAjaxSite');
                document.getElementById('errorMessageAjaxSite').innerHTML = "Error " + this.status + "! Sending request failed.";
            }
            if (blackout) ajaxBlackout(false);
        }
    };
    xhr.send(null);
}
function siteAjaxFile(oFormElement, callback) {
    var success = false;

    function ajaxSuccess(response) {
        success = true;
        callback(response);
    }
    function ajaxError(status) {
        console.error(status);
        popErrorSite('errorMessageAjaxSite');
        document.getElementById('errorMessageAjaxSite').innerHTML = "Error " + status + "! Sending request failed.";
    }
    function ajaxComplete() {
        if (this.status === 200 && this.statusText === "OK") {
            ajaxSuccess(this.responseText);
        } else {
            ajaxError(this.status);
        }
    }
    function submitData(oData) {
        var oAjaxReq = new XMLHttpRequest();
        oAjaxReq.submittedData = oData;
        oAjaxReq.onload = ajaxComplete;
        oAjaxReq.open("post", oData.receiver, true);
        if (oData.technique === 3) {
            var sBoundary = "---------------------------" + Date.now().toString(16);
            oAjaxReq.setRequestHeader("Content-Type", "multipart\/form-data; boundary=" + sBoundary);
            oAjaxReq.sendAsBinary("--" + sBoundary + "\r\n" + oData.segments.join("--" + sBoundary + "\r\n") + "--" + sBoundary + "--\r\n");
        } else {
            oAjaxReq.setRequestHeader("Content-Type", oData.contentType);
            oAjaxReq.send(oData.segments.join(oData.technique === 2 ? "\r\n" : "&"));
        }
    }
    function processStatus(oData) {
        if (oData.status > 0) {
            return;
        }
        submitData(oData);
    }
    function pushSegment(oFREvt) {
        this.owner.segments[this.segmentIdx] += oFREvt.target.result + "\r\n";
        this.owner.status--;
        processStatus(this.owner);
    }
    function plainEscape(sText) {
        return sText.replace(/[\s\=\\]/g, "\\$&");
    }
    function SubmitRequest(oTarget) {
        var nFile,
            sFieldType,
            oField,
            oSegmReq,
            oFile,
            bIsPost = oTarget.method.toLowerCase() === "post";
        this.contentType = bIsPost && oTarget.enctype ? oTarget.enctype : "application\/x-www-form-urlencoded";
        this.technique = bIsPost ? this.contentType === "multipart\/form-data" ? 3 : this.contentType === "text\/plain" ? 2 : 1 : 0;
        this.receiver = oTarget.action;
        this.status = 0;
        this.segments = [];
        var fFilter = this.technique === 2 ? plainEscape : escape;
        for (var nItem = 0; nItem < oTarget.elements.length; nItem++) {
            oField = oTarget.elements[nItem];
            if (!oField.hasAttribute("name") && oField.name !== "") {
                continue;
            }
            sFieldType = oField.nodeName.toUpperCase() === "INPUT" ? oField.getAttribute("type").toUpperCase() : "TEXT";
            if (sFieldType === "FILE" && oField.files.length > 0) {
                if (this.technique === 3) {
                    for (nFile = 0; nFile < oField.files.length; nFile++) {
                        oFile = oField.files[nFile];
                        oSegmReq = new FileReader();
                        oSegmReq.segmentIdx = this.segments.length;
                        oSegmReq.owner = this;
                        oSegmReq.onload = pushSegment;
                        this.segments.push("Content-Disposition: form-data; name=\"" + oField.name + "\"; filename=\"" + oFile.name + "\"\r\nContent-Type: " + oFile.type + "\r\n\r\n");
                        this.status++;
                        oSegmReq.readAsBinaryString(oFile);
                    }
                } else {
                    for (nFile = 0; nFile < oField.files.length; this.segments.push(fFilter(oField.name) + "=" + fFilter(oField.files[nFile++].name))) {}
                }
            } else if (sFieldType !== "RADIO" && sFieldType !== "CHECKBOX" || oField.checked) {
                this.segments.push(this.technique === 3 ? "Content-Disposition: form-data; name=\"" + oField.name + "\"\r\n\r\n" + oField.value + "\r\n" : fFilter(oField.name) + "=" + fFilter(oField.value));
            }
        }
        processStatus(this);
    }

    new SubmitRequest(oFormElement);
}
function keepAlive(loop, time) {
    siteAjax('/action/keepAlive', function () {
        if (loop) setTimeout(function () {
            keepAlive(loop, time);
        }, time ? time : 15 * 60000);
    });
}

function triggerInputFocus(q, v, eventToTrigger) {
    var $e = $(q);
    if (v !== undefined && v !== null) {
        $e.val(v);
    }
    if ($e.val() != null && $e.val().trim().length > 0) {
        $e.closest(".input-ctn").addClass("focused");
    } else {
        $e.closest(".input-ctn").removeClass("focused");
    }
    if (eventToTrigger) {
        $e.trigger(eventToTrigger);
    }
}

function getDataSet(el) {
    var map = {};
    if (!el.dataset) {
        var as = el.attributes;
        var tuc = function tuc(x, y) {
            return y.toUpperCase();
        };
        for (var i = 0; i < as.length; i++) {
            var a = as[i];
            var n = a.name;
            var m = n.match(/^data-(.+)/);
            if (m) map[m[1].replace(/\-([a-z])/ig, tuc)] = a.value;
        }
    } else {
        map = el.dataset;
    }
    return map;
}

function jsonEscape(str) {
    // Ref. http://json.org/
    return str.replace(/\0/g, "").replace(/\\/g, "\\\\").replace(/\//g, "\\/").replace(/\n/g, "\\n").replace(/\f/g, "\\f").replace(/\r/g, "\\r").replace(/\t/g, "\\t").replace(/\v/g, "\\v");
}

function numLockFloat(e) {
    var k = e.which || e.keyCode || e.charCode;
    // Allow: BACKSPACE, TAB, ESCAPE, END, HOME, ARROWS, ., DELETE, NUMLOCK
    if ([0, 8, 9, 27, 35, 36, 37, 38, 39, 40, 46, 110, 144, 190].indexOf(k) > -1
    // Allow: Ctrl+A, Ctrl+C, Ctrl+X, Ctrl+V, Ctrl+Z, Ctrl+Y
    || [65, 67, 86, 88, 89, 90].indexOf(k) > -1 && (e.ctrlKey || e.metaKey)) {
        // Prevent more than 1 decimal point
        if ([110, 190].indexOf(k) > -1 && this.value.match(/\./)
        // keypress single quote is 39 and n is 110
        || [39, 110].indexOf(k) > -1 && e.type === "keypress") {
            e.preventDefault();
        } else {
            return;
        }
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || k < 48 || k > 57) && (k < 96 || k > 105 || e.type === "keypress")) {
        e.preventDefault();
    }
}
(function ($, undefined) {

	'use strict';

	var win;
	var winWidth;
	var winHeight;
	var items;

	var autoScreenHeight = function autoScreenHeight() {
		items.each(function () {
			var t = $(this);
			var attr = t.data('autoScreenAttr') === undefined ? 'min-height' : t.attr('data-auto-screen-attr');
			var offset = t.data('autoScreenOffset') !== undefined ? t.data('autoScreenOffset').replace(/\s+/g, '').split(',') : 0;
			var factor = t.data('autoScreenFactor') !== undefined ? t.data('autoScreenFactor') : 1;
			var offsetHeight = 0;

			$.each(offset, function (i) {
				var t = $(offset[i]);
				offsetHeight += t.height() + parseInt(t.css('border-top-width')) + parseInt(t.css('border-bottom-width')) + parseInt(t.css('padding-top')) + parseInt(t.css('padding-bottom'));
			});

			var newHeight = winHeight * factor - offsetHeight;

			t.css(attr, newHeight);
		});
	};

	var init = function init() {
		win = $(window);
		winWidth = win.width();
		winHeight = win.height();
		items = $('.js-auto-screen-height');

		autoScreenHeight();

		win.resize(function () {
			winWidth = win.width();
			winHeight = win.height();

			autoScreenHeight();
		});
	};

	init();
})(jQuery);
(function (window) {

	'use strict';

	// @NOTE: Entirely vanilla JS.

	var colorCanvas;
	var colorCursor;
	var hueCanvas;
	var hueCursor;
	var currentColorCtn;

	var currentColor;
	var hueColor;
	var colorInput;

	var hue = 0;
	var saturation = 1;
	var light = 0.5;

	var lang = document.documentElement.lang;

	/**
  * EXPOSED FUNCTIONS 
  */
	var init = function init() {
		if (document.getElementById('mg2ColorPicker')) {
			colorCanvas = document.getElementById('mg2ColorPicker');
			colorCursor = document.getElementById('mg2ColorCursor');
			hueCanvas = document.getElementById('mg2HuePicker');
			hueCursor = document.getElementById('mg2HueCursor');
			currentColorCtn = document.querySelector('.mg2-color-current');

			currentColorCtn.setAttribute('data-copy-text', currentColorCtn.getAttribute('data-copy-' + lang));
			currentColor = hueColor = colorCanvas.getAttribute('data-color');

			clearCanvasListeners();
			setupHueCanvas();
			setupCanvasListeners();
			setColor(currentColor);
		}
	};

	var getColor = function getColor() {
		return currentColor;
	};

	var setColor = function setColor(hex) {
		var hexVal = hex.charAt(0) === '#' ? hex.substr(1) : hex;
		var r = parseInt(hexVal.substr(0, 2), 16);
		var g = parseInt(hexVal.substr(2, 2), 16);
		var b = parseInt(hexVal.substr(4, 2), 16);
		var hslValues = rgbToHsl(r, g, b);
		var hsvValue, hsvSaturation;

		currentColor = hex;
		hue = hslValues[0] * 360;
		saturation = hslValues[1];
		light = hslValues[2];
		hsvValue = (light * 2 + saturation * (1 - Math.abs(light * 2 - 1))) / 2;
		hsvSaturation = hsvValue !== 0 ? 2 * (hsvValue - light) / hsvValue : 0;
		hueColor = 'hsl(' + hue + ', 100%, 50%)';

		setupColorCanvas();
		updateHue(hslValues[0] * hueCanvas.height);
		updateColor(hsvSaturation * colorCanvas.width, (1 - hsvValue) * colorCanvas.height);
	};
	/**
  * END OF EXPOSED FUNCTIONS 
  */

	/**
  * FUNCTIONS TAKEN FROM: http://axonflux.com/handy-rgb-to-hsl-and-rgb-to-hsv-color-model-c 
  */
	var hslToRgb = function hslToRgb() {
		var r, g, b;
		var h = hue / 360,
		    s = !isNaN(saturation) ? saturation : 1,
		    l = light;

		if (s === 0) {
			r = g = b = l; // achromatic
		} else {
			var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
			var p = 2 * l - q;
			r = hue2rgb(p, q, h + 1 / 3);
			g = hue2rgb(p, q, h);
			b = hue2rgb(p, q, h - 1 / 3);
		}

		return '#' + numToHex(Math.round(r * 255)) + numToHex(Math.round(g * 255)) + numToHex(Math.round(b * 255));
	};

	var hue2rgb = function hue2rgb(p, q, t) {
		if (t < 0) t += 1;
		if (t > 1) t -= 1;
		if (t < 1 / 6) return p + (q - p) * 6 * t;
		if (t < 1 / 2) return q;
		if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
		return p;
	};

	var rgbToHsl = function rgbToHsl(r, g, b) {
		var max, min, h, s, l;

		r /= 255;
		g /= 255;
		b /= 255;
		max = Math.max(r, g, b);
		min = Math.min(r, g, b);
		l = (max + min) / 2;

		if (max == min) {
			h = s = 0; // achromatic
		} else {
			var d = max - min;
			s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
			switch (max) {
				case r:
					h = (g - b) / d + (g < b ? 6 : 0);break;
				case g:
					h = (b - r) / d + 2;break;
				case b:
					h = (r - g) / d + 4;break;
			}
			h /= 6;
		}

		return [h, s, l];
	};
	/**
  * END OF FUNCTIONS TAKEN FROM: http://axonflux.com/handy-rgb-to-hsl-and-rgb-to-hsv-color-model-c 
  */

	/**
  * UTILITY FUNCTIONS
  */
	var numToHex = function numToHex(num) {
		var val = num.toString(16);
		return val.length === 1 ? 0 + val : val;
	};

	var clampValue = function clampValue(val, min, max) {
		return Math.min(Math.max(val, min), max);
	};

	var triggerCustomEvent = function triggerCustomEvent(eventName) {
		var event = new Event(eventName); // no IE11 support
		document.getElementById('mg2ColorPicker').dispatchEvent(event);
	};
	/**
  * END OF UTILITY FUNCTIONS
  */

	var clearCanvasListeners = function clearCanvasListeners() {
		colorCanvas.removeEventListener('mousedown', startDragColor);
		hueCanvas.removeEventListener('mousedown', startDragHue);
	};

	var setupCanvasListeners = function setupCanvasListeners() {
		colorCanvas.addEventListener('mousedown', startDragColor);
		hueCanvas.addEventListener('mousedown', startDragHue);
		currentColorCtn.addEventListener('click', copyColor);
	};

	var setupColorCanvas = function setupColorCanvas() {
		var ctx = colorCanvas.getContext('2d');

		paintColorCanvas(ctx);
	};

	var paintColorCanvas = function paintColorCanvas(ctx) {
		ctx.fillStyle = hueColor;
		ctx.fillRect(0, 0, colorCanvas.width, colorCanvas.height);

		paintWhiteGradient(ctx);
		paintBlackGradient(ctx);
	};

	var paintWhiteGradient = function paintWhiteGradient(ctx) {
		var whiteGradient = ctx.createLinearGradient(0, 0, colorCanvas.width, 0);
		whiteGradient.addColorStop(0, '#fff');
		whiteGradient.addColorStop(1, 'transparent');
		ctx.fillStyle = whiteGradient;
		ctx.fillRect(0, 0, colorCanvas.width, colorCanvas.height);
	};

	var paintBlackGradient = function paintBlackGradient(ctx) {
		var blackGradient = ctx.createLinearGradient(0, 0, 0, colorCanvas.height);
		blackGradient.addColorStop(0, 'transparent');
		blackGradient.addColorStop(1, '#000');
		ctx.fillStyle = blackGradient;
		ctx.fillRect(0, 0, colorCanvas.width, colorCanvas.height);
	};

	var setupHueCanvas = function setupHueCanvas() {
		var ctx = hueCanvas.getContext('2d');
		var gradient = ctx.createLinearGradient(0, 0, 0, hueCanvas.height);

		gradient.addColorStop(0, 'hsl(0, 100%, 50%)');
		gradient.addColorStop(0.17, 'hsl(61.2, 100%, 50%)');
		gradient.addColorStop(0.33, 'hsl(118.8, 100%, 50%)');
		gradient.addColorStop(0.50, 'hsl(180, 100%, 50%)');
		gradient.addColorStop(0.67, 'hsl(241.2, 100%, 50%)');
		gradient.addColorStop(0.83, 'hsl(298.8, 100%, 50%)');
		gradient.addColorStop(1, 'hsl(360, 100%, 50%)');

		ctx.fillStyle = gradient;
		ctx.fillRect(0, 0, hueCanvas.width, hueCanvas.height);
	};

	var startDragColor = function startDragColor(e) {
		e.preventDefault();

		moveDragColor(e);

		window.addEventListener('mousemove', moveDragColor);
		window.addEventListener('mouseup', stopDragColor);
	};

	var moveDragColor = function moveDragColor(e) {
		var rect = colorCanvas.getBoundingClientRect();
		var positionX = e.clientX - rect.left;
		var positionY = e.clientY - rect.top;
		var clampedX = clampValue(positionX, 0, colorCanvas.width);
		var clampedY = clampValue(positionY, 0, colorCanvas.height);

		updateColor(clampedX, clampedY);
	};

	var stopDragColor = function stopDragColor(e) {
		window.removeEventListener('mousemove', moveDragColor);
		window.removeEventListener('mouseup', stopDragColor);
	};

	// @NOTE: HSL calculations based on http://codeitdown.com/hsl-hsb-hsv-color/.
	var updateColor = function updateColor(x, y) {
		var ctx = colorCanvas.getContext('2d');
		var hsvValue, hsvSaturation;

		hsvValue = 1 - y / colorCanvas.height;
		hsvSaturation = x / colorCanvas.width;
		light = hsvValue / 2 * (2 - hsvSaturation);
		saturation = hsvValue * hsvSaturation / (1 - Math.abs(light * 2 - 1));
		currentColor = hslToRgb();

		currentColorCtn.style.background = currentColor;
		currentColorCtn.innerHTML = currentColor;

		colorCursor.style.top = y + "px";
		colorCursor.style.left = x + "px";
		colorCursor.style.background = currentColor;

		colorCursor.setAttribute('data-x', x);
		colorCursor.setAttribute('data-y', y);

		// triggerCustomEvent('colorupdate');
	};

	var startDragHue = function startDragHue(e) {
		e.preventDefault();

		moveDragHue(e);

		window.addEventListener('mousemove', moveDragHue);
		window.addEventListener('mouseup', stopDragHue);
	};

	var moveDragHue = function moveDragHue(e) {
		var rect = hueCanvas.getBoundingClientRect();
		var positionY = e.clientY - rect.top;
		var clampedY = clampValue(positionY, 0, hueCanvas.height);

		updateHue(clampedY);
	};

	var stopDragHue = function stopDragHue(e) {
		window.removeEventListener('mousemove', moveDragHue);
		window.removeEventListener('mouseup', stopDragHue);
	};

	var updateHue = function updateHue(y) {
		var ctx = hueCanvas.getContext('2d');
		var colorX = colorCursor.getAttribute('data-x') | 0;
		var colorY = colorCursor.getAttribute('data-y') | 0;

		hue = y / hueCanvas.height * 360;

		hueColor = 'hsl(' + hue + ', 100%, 50%)';
		paintColorCanvas(colorCanvas.getContext('2d'));
		updateColor(colorX, colorY);

		hueCursor.style.top = y + "px";
		hueCursor.style.background = hueColor;
	};

	var copyColor = function copyColor(e) {
		var copySupported = document.queryCommandSupported('copy');
		var currentlyFocusedElement = document.activeElement;

		if (copySupported) {
			var input = document.createElement('input');
			input.setAttribute('value', currentColor);
			currentColorCtn.appendChild(input);
			input.select();
			document.execCommand('copy');
			currentlyFocusedElement.focus();
			currentColorCtn.removeChild(input);
			currentColorCtn.classList.add('copied');
			updateDataInput(currentColor);
			setTimeout(function () {
				currentColorCtn.classList.remove('copied');
			}, 2000);
		}
	};

	var updateDataInput = function updateDataInput(c) {
		var parent = $(currentColorCtn).closest('.popup-outer-ctn');
		var inpName = $(currentColorCtn).attr("data-inp");
		var inp = $("input[name=" + inpName + "]", parent);

		inp.attr("value", c);
		inp.css("background-color", c);

		var luminance = { r: 0.2126, g: 0.7152, b: 0.0722 };
		var color = c; // your color
		var r = parseInt(color.substring(1, 3), 16);
		var g = parseInt(color.substring(3, 5), 16);
		var b = parseInt(color.substring(5), 16);
		var rgb = [r / 255, g / 255, b / 255];
		for (var i = rgb.length; i--;) {
			rgb[i] = rgb[i] <= 0.03928 ? rgb[i] / 12.92 : Math.pow((rgb[i] + 0.055) / 1.055, 2.4);
		}var thresh = luminance.r * rgb[0] + luminance.g * rgb[1] + luminance.b * rgb[2];

		if (thresh > 0.22) {
			inp.css("color", "black");
			inp.css("border-color", "black");
		} else {
			inp.css("color", "white");
			inp.css("border-color", "white");
		}
	};

	window.MG2 = window.MG2 || {};
	window.MG2.ColorPicker = window.MG2.ColorPicker || {
		init: init,
		getColor: getColor,
		setColor: setColor
	};
})(window);
(function ($, undefined) {

	'use strict';

	var init = function init() {
		if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
			$('html').addClass('mobile');
		}
	};

	init();
})(jQuery);
(function ($, undefined) {

	'use strict';

	var editableText;

	var moveEditableText = function moveEditableText() {
		var text = $('.editable-text-ctn');

		text.each(function () {
			var t = $(this);
			var ctn = t.parent('.js-editable-container');
			var pos;
			var receiver;

			if (t.attr('data-position') !== 0) {
				pos = t.attr('data-position');
			} else {
				pos = 1;
			}

			if ($('.js-editable-receiver[data-editable-receiver-position = ' + pos + ']', ctn).length !== 0) {
				receiver = $('.js-editable-receiver[data-editable-receiver-position = ' + pos + ']', ctn);
			} else {
				receiver = $('.js-editable-receiver', ctn);
			}

			if ($('.js-editable-receiver[data-editable-receiver-position]', ctn).length !== 0 && $('.js-editable-receiver[data-editable-receiver-position = ' + pos + ']', ctn).length === 0 && t.attr('data-position') !== '') {
				t.remove();
			} else if (ctn.length !== 0 && receiver.length !== 0) {
				t.detach().appendTo(receiver);
			}
		});
	};

	var addEditableTextClass = function addEditableTextClass() {
		$('.componentContainerDiv').addClass('js-editable-container');

		editableText.each(function () {
			var t = $(this);
			var parent = t.parent();

			parent.addClass('editable-text-ctn');
		});
	};

	var addEditableTextPosition = function addEditableTextPosition() {
		$('.js-editable-container').each(function () {
			var index = 1;
			var t = $(this);

			$('.editable-text-ctn', t).each(function () {
				var t = $(this);

				t.attr('data-position', index);

				index++;
			});
		});
	};

	var init = function init() {
		editableText = $('div[id^=displayTextInnerWindow]');

		addEditableTextClass();
		addEditableTextPosition();
		moveEditableText();
	};

	init();
})(jQuery);
(function ($, undefined) {

	'use strict';

	var addExternalLinkTarget = function addExternalLinkTarget() {
		$.expr[':'].external = function (obj) {
			var hostname = obj.hostname === '' ? location.hostname : obj.hostname;

			return !obj.href.match(/^mailto\:/) && hostname != location.hostname && !obj.href.match(/^javascript\:/) && !obj.href.match(/^tel\:/) && !obj.href.match(/^$/) || obj.href.match(/\.pdf$/);
		};

		$('a:external').attr('target', '_blank');
	};

	var pageLoad = function pageLoad() {
		addExternalLinkTarget();
	};

	pageLoad();
})(jQuery);

var formAnimate = Fw.component.models().formAnimate;
var login = Fw.component.models().login;
var profile = Fw.component.models().profile;
var tools = Fw.component.models().tools;
var formValidator = Fw.component.models().form;
var session = Fw.component.models().session;
var labels = Fw.component.models().labels;
var slider = Fw.component.models().slider;

(function ($, undefined) {

    'use strict';

    var isLoggedIn = false;
    var isMobile = false;
    var noScroll = false;
    var menuOpen = false;
    var win = $(window);
    var winWidth;
    var winHeight;
    var header;
    var navItems;
    var searchBar;
    var searchBtn;
    var searchOpenBtn;
    var searchCloseBtn;
    var pagerPerPage;
    var toggleMenuBtn;
    var respDetectionSmScreen;
    var respDetectionPhScreen;
    var profilesCtn;
    var loggedWithoutProfile;
    var accountValidatedPopup;

    var toggleScroll = function toggleScroll() {
        var diff;

        if ($('body').hasClass('no-scroll')) {
            // $('html').removeClass('no-scroll');
            $('body').removeClass('no-scroll');
            diff = 0;
            noScroll = false;
        } else {
            var w1 = win.width();
            // $('html').addClass('no-scroll');
            $('body').addClass('no-scroll');
            var w2 = win.width();
            diff = w2 - w1;
            noScroll = true;
        }

        changeScrollDiff(diff);
    };

    var changeScrollDiff = function changeScrollDiff(diff) {
        if (diff === 0) {
            $('.js-scroll-padding').removeAttr('style');
            $('.js-scroll-right').removeAttr('style');
        } else {
            $('.js-scroll-padding').css('padding-right', diff + 'px');
            $('.js-scroll-right').css('right', diff + 'px');
        }
    };
    var checkClick = function checkClick(event) {
        if (!$(event.target).closest('.sidenav-dashboard').length && !$(event.target).closest('.site-nav').length) {
            if (!!header.hasClass('menu-open')) {
                onClickMenuToggle();
            }
        }
    };
    var onClickMenuToggle = function onClickMenuToggle() {

        if (!!header.hasClass('menu-open')) {
            var transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend';
            header.removeClass('menu-open');
            menuOpen = false;

            header.on(transitionEnd, function (e) {
                $('body').removeClass('no-scroll');
                $('html').removeClass('no-scroll');
                noScroll = false;
                changeScrollDiff(0);
                $(this).off(e);
            });
        } else {
            var target = 0;

            if ($('.site-header').css('scroll-y') !== 'fixed' && $('.site-header').offset().top > 0) {
                target = $('.site-header').offset().top;
            }

            if (win.scrollTop() <= $('.site-header').offset().top) {
                $('html, body').animate({ scrollTop: target }, 10, function () {
                    openMenu();
                });
            } else {
                openMenu();
            }
            menuOpen = true;
        }
    };

    var checkScreenWidth = function checkScreenWidth() {
        if (profilesCtn.hasClass('open') || $('body').find('.popup.slide-in.open').length) {
            if (respDetectionSmScreen.css('visibility') !== 'visible') {
                if (noScroll === true) {
                    toggleScroll();
                }
            } else {
                if (noScroll === false) {
                    toggleScroll();
                }
            }
        } else if (menuOpen === true) {
            if (respDetectionPhScreen.css('visibility') !== 'visible') {
                if (noScroll === true) {
                    toggleScroll();
                }
            } else {
                if (noScroll === false) {
                    toggleScroll();
                }
            }
        }
    };

    var openMenu = function openMenu() {
        header.addClass('menu-open');
        menuOpen = true;

        if (respDetectionPhScreen.css('visibility') === 'visible' && noScroll === false) {
            toggleScroll();
        }
    };

    var closeMenu = function closeMenu() {
        if (header.hasClass('menu-open')) {
            header.removeClass('menu-open');
            menuOpen = false;

            if (respDetectionPhScreen.css('visibility') === 'visible' && noScroll === true) {
                toggleScroll();
            }
        }
    };

    var updateNavSelected = function updateNavSelected(page) {
        navItems.removeClass('selected');
        var handleObj = $('.main-content ' + page);
        var handle = handleObj.attr('data-page-nav');

        navItems.each(function () {
            var t = $(this);

            if (t.data('pageNav') === handle) {
                t.addClass('selected');
            }
        });
    };

    var menuScroll = function menuScroll() {
        if (window.pageYOffset !== 0) {
            $(".site-header").addClass("site-header-scroll");
        } else {
            if (!header.hasClass("site-header-connect")) {
                $(".site-header").removeClass("site-header-scroll");
            }
        }
    };

    /*var pageEnter = function (page) {
     updateNavSelected(page);
     };*/

    var openSearch = function openSearch(e) {
        searchBar.addClass("search-open");

        searchOpenBtn = $(".search-ctn.search-open .search-btn", header);
        searchOpenBtn.on('click', submitSearch);
    };

    var openSearch2 = function openSearch2(e) {
        e.preventDefault();
        openSearch();
        searchBar.find(".input").focus();
    };

    var submitSearch = function submitSearch() {
        $(this).closest('form').submit();
    };

    var closeSearch = function closeSearch(e) {
        searchOpenBtn.off('click', submitSearch);
        searchBar.removeClass("search-open");
    };

    var changePerPage = function changePerPage() {
        var t = $(this);
        var perPage = t.val();
        var page = t.attr("data-extra");
        var ctn = t.closest('.save-per-page');

        if (ctn.length) {
            ajax("/action/sessionVariables?key=perPage&value=" + perPage, function () {
                loadPerPage(page, perPage);
            }, true);
        } else {
            loadPerPage(page, perPage);
        }
    };

    var loadPerPage = function loadPerPage(page, perPage) {
        if (page.indexOf("?") === -1) {
            window.location = page + "?perPage=" + perPage;
        } else {
            window.location = page + "&perPage=" + perPage;
        }
    };

    function prlx() {
        var rate = 60,
            scroller = 0,
            y = 0,
            dy,
            sy,
            ey,
            el,
            em,
            ctn,
            h,
            elm;

        el = document.querySelector(".prlx-el");
        em = document.querySelector(".prlx-em");
        if (el) {
            ctn = el.parentElement;
            _scrl();
            _trans();
            window.addEventListener("scroll", _scrl);
        }

        function _scrl() {
            scroller = rate;
            h = ctn.clientHeight;
            sy = window.scrollY;
        }
        function _trans() {
            if (scroller > 0) {
                scroller--;
                dy = (sy - y) / 1.414;
                y += dy;
                if (sy <= h) {
                    if (scroller === 0) y = sy;
                    ey = y / 3;
                    domCbTransform(el, "translate3d(0," + ey + "px,0)");
                    domCbTransform(em, "translate3d(0," + ey * -1.5 + "px,0)");
                }
            }
            rAF(_trans);
        }
    };

    function cbTransform(arg) {
        return {
            "-webkit-transform": arg,
            "-moz-transform": arg,
            "-ms-transform": arg,
            "transform": arg
        };
    }
    function domCbTransform(el, arg) {
        if (el) {
            var css = cbTransform(arg);
            for (var p in css) {
                el.style[p] = css[p];
            }
        }
    }

    var checkCMSLogout = function checkCMSLogout() {
        if (document.cookie.indexOf('loginFromDashboard') > -1) {
            var logoutForm = $('#formLogout');
            logoutForm.attr('action', $('.dashboard-logout').attr('href'));
            $('#logoutWindow button.button-primary').click(function () {
                document.cookie = 'loginFromDashboard=false;max-age=1';
            });
        }
    };

    var init = function init() {
        profile.init();
        tools.init();
        slider.init();

        respDetectionPhScreen = $('.responsive-detector');
        respDetectionSmScreen = $('.responsive-detector-sm');
        profilesCtn = $('.my-profiles-window');
        header = $('.site-header');
        navItems = $('.nav-item-link', header);
        toggleMenuBtn = $('.site-header-menu-toggle-btn', header);
        loggedWithoutProfile = $('input[name="logged-without-profile"]', header);
        accountValidatedPopup = $('#validating-existing-account');

        // if logged in without having a profile
        var url = window.location.href;
        if (loggedWithoutProfile.length && url.indexOf(loggedWithoutProfile.val()) === -1 && !$("body").hasClass("is-admin")) {
            window.location.href = loggedWithoutProfile.val();
        }

        // if trying to validate while having a profile and account
        if (accountValidatedPopup.length) {
            accountValidatedPopup.addClass('open');
        }

        winWidth = win.width();
        winHeight = win.height();
        $('body').removeClass('no-scroll');
        $('html').removeClass('no-scroll');

        if ($('body').hasClass('is-logged-in')) {
            isLoggedIn = true;
        }

        toggleMenuBtn.on('click', onClickMenuToggle);
        $(document).on('click', checkClick);
        navItems.on('click', closeMenu);

        win.scroll(function () {
            menuScroll();
        });
        menuScroll();
        checkCMSLogout();

        /* On focus on the search input - start action */
        searchBar = $(".search-ctn", header);
        searchBar.find(".input").on("focus", openSearch);
        searchBtn = searchBar.find(".search-btn");
        searchBtn.click(openSearch2);
        searchCloseBtn = searchBar.find(".search-close");
        searchCloseBtn.on("click", closeSearch);

        pagerPerPage = $(".pager-select");
        pagerPerPage.on("change", changePerPage);

        win.resize(function () {
            if (win.width() != winWidth) {
                winHeight = win.height();
                winWidth = win.width();
            }
            if ($("#loginWindow").is(":visible") && $(".site-header-menu-toggle-ham").is(":visible")) {
                login.reinit();
                menuScroll();
            }

            checkScreenWidth();
        });
        formAnimate.init();
        if (!isLoggedIn) {
            login.init();
        }
        prlx();
    };

    $(window).on("load", function () {
        init();
    });

    var headerFunc = Fw.modules.export('header', {
        toggleScroll: toggleScroll
    });
})(jQuery);
(function ($, undefined) {

    'use strict';

    var currPage;
    var toggleProfilesBtn;
    var profileBtn;
    var navProfilesBtn;
    var respDetectionSmScreen;
    var respDetectionPhScreen;
    var win;
    var header;

    var toggleProfilesWin = function toggleProfilesWin(e) {
        var active = navProfilesBtn.hasClass("active");

        if (active) {
            checkClickMenuProfil(e);
        } else {
            $('.site-nav').removeClass('overflow-y-auto');
            if (respDetectionSmScreen.css('visibility') !== 'visible') {
                win.slideDown(function () {
                    $(this).addClass('open').removeAttr('style');
                });
            } else {
                setTimeout(function () {
                    win.addClass('open');
                }, 300);

                if (!$('body').hasClass('no-scroll')) {
                    header.toggleScroll();
                }
            }

            navProfilesBtn.addClass("active");
        }
    };

    var closeProfilesWindow = function closeProfilesWindow() {
        if ($('body').hasClass('no-scroll') && (respDetectionPhScreen.css('visibility') === 'hidden' || !$('header').hasClass('menu-open'))) {
            header.toggleScroll();
        }

        if (respDetectionSmScreen.css('visibility') !== 'visible') {
            win.slideUp(function () {
                $(this).removeClass('open').removeAttr('style');
            });
        } else {
            win.removeClass('open');
        }

        setTimeout(function () {
            $('.site-nav').addClass('overflow-y-auto');
        }, 300);
        navProfilesBtn.removeClass("active");
    };

    var checkClickMenuProfil = function checkClickMenuProfil(event) {
        if ((!$(event.target).closest(win).length || $(event.target).closest(toggleProfilesBtn).length) && win.hasClass('open')) {
            closeProfilesWindow();
        }
    };

    var logAs = function logAs() {
        var active = $(this).hasClass("active");

        if (!active) {
            $(this).find("form").submit();
        }
    };

    var init = function init(page) {
        currPage = $(page);
        header = Fw.modules.models().header;
        respDetectionSmScreen = $('.responsive-detector-sm', page);
        respDetectionPhScreen = $('.responsive-detector', page);

        /* Toggle My Profiles window*/
        win = $(".my-profiles-window");
        navProfilesBtn = $('.logged-nav-item-profiles');
        navProfilesBtn.on("click", toggleProfilesWin);
        toggleProfilesBtn = $(".open-profiles-window-btn", page);
        //toggleProfilesBtn.on("click",toggleProfilesWin);

        /* Log as My Profiles window*/
        profileBtn = $(".my-profiles-one-line:not(.disabled)", page);
        profileBtn.on("click", logAs);

        $(document).on('click', checkClickMenuProfil);
    };

    $(window).on("load", function () {
        init();
    });
})(jQuery);
(function ($, undefined) {

	"use strict";

	window.addEventListener('beforeunload', function () {
		window.parent.window.postMessage('iframe_before_unloading', '*');
	});
	window.addEventListener('unload', function () {
		window.parent.window.postMessage('iframe_unloading', '*');
	});
})(jQuery);
(function ($, undefined) {

	'use strict';

	var contactFormBtn;

	var sendContactFormEmailClass = function sendContactFormEmailClass() {
		var t = $(this);
		var validate = t.data('validate');
		var count = t.data('count');
		var form = t.closest($('.contactForm-Container'));

		var subject = $('.contactForm-subject', form).val();
		var email = $('.contactForm-email', form).val();
		var targetEmail = $('.targetEmail', form) ? $('.targetEmail', form).val() : "";
		var content = null;
		try {
			content = tinyMCE.get('contactForm-content', form).getContent();
		} catch (exception) {
			content = $('.contactForm-content', form).val();
		}

		var appendField = "";
		if ($('.fieldName1') !== null) {
			var total = 9;
			if (count) {
				total = count;
			}
			for (var i = 1; i < total; i++) {
				appendField += "&fieldName" + i + "=" + encodeURIComponent($('.fieldName' + i, form).val());
				if ($('.field' + i, form).attr('type') == "checkbox") {
					if ($('.field' + i, form).checked) {
						appendField += "&field" + i + "=checked.";
					} else {
						appendField += "&field" + i + "=not checked.";
					}
				} else {
					appendField += "&field" + i + "=" + encodeURIComponent($('.field' + i, form).val());
				}
			}
			appendField += "&count=" + total + "&targetEmail=" + targetEmail;
		}
		var captcha = $('.contactForm-captcha', form);
		if (captcha) {
			appendField += '&captcha=' + encodeURIComponent(captcha.val());
		}

		var validForm = true;
		var inputs = $('input', form);
		inputs.each(function () {
			var tInput = $(this);

			if ((tInput.attr('type') === "text" || tInput.attr('type') === "email" || tInput.attr('type') === "tel") && tInput.val() === "") {
				validForm = false;
			}
		});
		var textareas = $('textarea', form);
		textareas.each(function () {
			var tTextareas = $(this);

			if (tTextareas.val() === "") {
				validForm = false;
			}
		});

		if (!validForm && validate) {
			//popErrorDisplayOnSite('error.message.emptyForm');
			$('.contact-form-form-error', form).slideDown(200);
		} else {
			$('.contact-form-form-error', form).slideUp(200);
			ajax(actionPath + "contactUs?subject=" + encodeURIComponent(subject) + "&email=" + encodeURIComponent(email) + "&content=" + encodeURIComponent(content) + appendField, sendContactFormEmailConfirmClass(form));
		}
	};

	/*var popErrorDisplayOnSite = function (key) {
 	if (key.indexOf('errorMessageAjax') != -1) {
 		document.getElementById('errorMessageAjax').style.display = "block";
 		document.getElementById('errorMessageDivOriginal').style.display = "none";
 	} else {
 		document.getElementById('errorMessageAjax').style.display = "none";
 		document.getElementById('errorMessageDivOriginal').style.display = "block";
 		ajax('/action/getLabel?key='+key, popErrorCompleteDisplayOnSite);
 	}
 };*/

	var sendContactFormEmailConfirmClass = function sendContactFormEmailConfirmClass(form) {
		var bigCtn = form.closest('.contactForm-Container-big');

		$('.contactForm-Container', bigCtn).slideUp(1000, function () {
			$('.contactForm-sent', bigCtn).slideDown(300);
		});
	};

	var popErrorCompleteDisplayOnSite = function popErrorCompleteDisplayOnSite(response) {
		footerErrorMessage.slideDown(200);
	};

	var init = function init(page) {
		contactFormBtn = $('.js-contact-form-send');

		contactFormBtn.click(sendContactFormEmailClass);
	};

	init();
})(jQuery);
(function ($, undefined) {

	'use strict';

	var win = $(window);
	var slideItem;

	var checkSlideAnimation = function checkSlideAnimation() {
		var count = 0;
		slideItem.each(function () {
			var t = $(this);
			if (!t.hasClass('is-animated') && !t.hasClass('blog-post')) {
				var itemOffset;

				if (t.hasClass('up')) {
					itemOffset = t.offset().top - 200;
				} else {
					itemOffset = t.offset().top;
				}

				// if window already scrolled past (on refresh), pre-animate items above (win.scrollTop()
				if (win.scrollTop() > itemOffset + t.outerHeight() || t.hasClass('slick-slide')) {
					t.addClass('is-animated');
				} else if (win.scrollTop() + win.height() / 4 * 3 > itemOffset) {
					t.addClass('is-animated').attr('style', 'transition-delay: ' + count * 3 + '00ms;');
					count++;
				}
			}
		});
	};

	var init = function init() {
		slideItem = $('.anim-slide');

		checkSlideAnimation();

		win.scroll(function () {
			checkSlideAnimation();
		});
	};

	$(window).on('load', function () {
		init();
	});
})(jQuery);
(function ($, undefined) {

	'use strict';

	var currPage;
	var modifyPasswordBtn;
	var savePersonalInfosForm;
	var savePersonalInfosBtn;
	var savePaymentInfosForm;
	var savePaymentInfosBtn;
	var editPaymentInfosBtn;
	var deletePaymentInfosBtn;
	var saveBillingInfosForm;
	var saveBillingInfosBtn;
	var editBillingInfosBtn;
	var deleteBillingInfosBtn;

	var enablePasswordModification = function enablePasswordModification() {
		var t = $(this);
		var parent = t.closest('.box-theme-content');

		parent.find('.old-password').removeClass('disabled').removeClass('focused').find('input').val('');
		parent.find('.password').removeClass('disabled').removeClass('focused').find('input').val('');
		t.slideUp(300, function () {
			$(this).parent().slideUp(300, function () {
				$(this).remove();
			});
		});
	};

	var savePersonalInfos = function savePersonalInfos() {
		var btn = $(this);
		var form = btn.closest('.js-form');

		btn.addClass('disabled');
		formValidator.validateForm(form);

		if (!form.hasClass('has-error')) {
			var url = '/action/updatePerson';
			url += '?firstName=' + encodeURIComponent($('input[name="firstName"]', form).val());
			url += '&lastName=' + encodeURIComponent($('input[name="lastName"]', form).val());
			url += '&email=' + encodeURIComponent($('input[name="email"]', form).val());
			url += '&phone=' + encodeURIComponent($('input[name="phone"]', form).val());
			url += '&address=' + encodeURIComponent($('input[name="address"]', form).val());
			url += '&postalCode=' + encodeURIComponent($('input[name="postalCode"]', form).val());
			url += '&province=' + $('.province-select', form).val();
			url += '&city=' + encodeURIComponent($('input[name="city"]', form).val());
			url += '&country=' + $('select[name="country"]', form).val();
			url += '&field2=' + encodeURIComponent($('input[name="field2"]', form).val());
			url += '&field3=' + encodeURIComponent($('input[name="field3"]', form).val());
			url += '&field4=' + encodeURIComponent($('input[name="field4"]', form).val());
			url += '&field5=' + encodeURIComponent($('input[name="field5"]', form).val());
			url += '&field19=' + encodeURIComponent($('select[name="field19"]', form).val());
			if ($('input[name="field2"]', form).val() !== $('input[name="field2"]', form).attr("data-misc") || $('input[name="field3"]', form).val() !== $('input[name="field3"]', form).attr("data-misc")) {
				url += '&field18=false';
			}
			if (!$('.old-password', form).hasClass('disabled')) {
				url += '&currentPassword=' + encodeURIComponent($('input[name="currentPassword"]', form).val());
				url += '&password=' + encodeURIComponent($('input[name="password"]', form).val());
			}
			url += '&ajax=true';

			var obj = ajax(url, function (response) {
				btn.removeClass('disabled');

				if (response.indexOf('error') != -1) {
					form.find('.js-form-error-message.email-in-use').slideDown(300, function () {
						setTimeout(function () {
							form.find('.js-form-error-message.email-in-use').slideUp(300);
						}, 5000);
					});
				} else if (response.indexOf('wrong.password') != -1) {
					form.find('.js-form-error-message.old-password').slideDown(300, function () {
						setTimeout(function () {
							form.find('.js-form-error-message.old-password').slideUp(300);
						}, 5000);
					});
				} else if (response.indexOf('success') != -1) {
					removeTabWarning(form);
					form.find('.account-params-infos-missing-warning').slideUp(300, function () {
						$(this).remove();
					});
					form.find('.js-form-success-message').slideDown(300, function () {
						setTimeout(function () {
							form.find('.js-form-success-message').slideUp(300);
						}, 5000);
					});
				}
			}, true);
		} else {
			btn.removeClass('disabled');
		}
	};

	var savePaymentInfos = function savePaymentInfos() {
		var btn = $(this);
		var form = btn.closest('.js-form');

		btn.addClass('disabled');
		formValidator.validateForm(form);
		confirmBankAccountNumber(form);

		if (!form.hasClass('has-error') && !form.hasClass('has-bank-account-confirm-error')) {
			var bankCountry = $('select[name="field6"]', form);
			var bankName = $('input[name="field7"]', form).val();
			var bankAccountType = $('select[name="field8"]', form);
			var bankAccountNumber = $('input[name="bank-account-numbers-1"]').val() + $('input[name="bank-account-numbers-2"]').val() + $('input[name="bank-account-numbers-3"]').val();

			var url = '/action/updatePerson';
			url += '?field6=' + bankCountry.val();
			url += '&field7=' + encodeURIComponent(bankName);
			url += '&field8=' + bankAccountType.val();
			url += '&field9=' + bankAccountNumber;
			url += '&ajax=true';

			var obj = ajax(url, function (response) {
				btn.removeClass('disabled');

				if (response.indexOf('success') !== -1) {
					removeTabWarning(form);
					form.find('.js-form-success-message').slideDown(300, function () {
						setTimeout(function () {
							form.find('.js-form-success-message').slideUp(300);
						}, 5000);
					});
					form.find('.form-inputs-ctn').slideUp(300, function () {
						fillAndDisplayBankAccountInfos(form, bankCountry, bankName, bankAccountType, bankAccountNumber);
					});
				}
			}, true);
		} else {
			btn.removeClass('disabled');
		}
	};

	var confirmBankAccountNumber = function confirmBankAccountNumber(form) {
		var numberPartThree = $('input[name="bank-account-numbers-3"]', form);
		var fullNumber = $('input[name="field9"]', form);
		var bankNumberErrorMsg = form.find('.bank-account-number.error-msg');

		if (numberPartThree.val() !== '' && fullNumber.val() !== '') {
			if (numberPartThree.val() !== fullNumber.val()) {
				form.addClass('has-bank-account-confirm-error');
				numberPartThree.addClass('error').removeClass('success');
				fullNumber.addClass('error').removeClass('success');
				bankNumberErrorMsg.slideDown(300);
			} else {
				form.removeClass('has-bank-account-confirm-error');
				numberPartThree.removeClass('error').addClass('success');
				fullNumber.removeClass('error').addClass('success');
				bankNumberErrorMsg.slideUp(300);
			}
		}
	};

	var fillAndDisplayBankAccountInfos = function fillAndDisplayBankAccountInfos(form, bankCountry, bankName, bankAccountType, bankAccountNumber) {
		var displayBankInfosCtn = form.closest('.box-theme-content').find('.account-params-saved-payment-infos-ctn');

		$('.account-params-payment-infos-country', displayBankInfosCtn).html(bankCountry.find('option:selected').text());
		$('.account-params-payment-infos-bank', displayBankInfosCtn).html(bankName);
		$('.account-params-payment-infos-account-type', displayBankInfosCtn).html(bankAccountType.find('option:selected').text());
		$('.account-params-payment-infos-bank-account-1', displayBankInfosCtn).html(bankAccountNumber.substring(0, 5));
		$('.account-params-payment-infos-bank-account-2', displayBankInfosCtn).html(bankAccountNumber.substring(5, 8));
		$('.account-params-payment-infos-bank-account-3', displayBankInfosCtn).html(bankAccountNumber.substring(8));

		displayBankInfosCtn.slideDown(300);
	};

	var editInfos = function editInfos() {
		var t = $(this);

		t.closest('.saved-account-infos-display-ctn').slideUp(300, function () {
			t.closest('.box-theme-content').find('.js-form').slideDown(300);
			t.closest('.box-theme-content').find('.form-inputs-ctn').slideDown(300);
		});
	};

	var deletePaymentInfos = function deletePaymentInfos() {
		var t = $(this);
		var form = t.closest('.box-theme-content').find('.js-form');
		var tab = $('.tabs-bar-and-content-ctn.account-params-ctn').find('.account-tab-item[data-tab=' + form.closest('.tabs-content-inner-ctn').attr('data-tab') + ']');

		// reset form
		form.find('input:text, input:password, input:file, select, textarea').val('').removeClass('success');
		form.find('.input-ctn').removeClass('focused');

		// add tab warning
		tab.addClass('orange').find('.required-fields-completed-icon-ctn').fadeOut(300, function () {
			tab.find('.attention-required-icon-ctn').fadeIn(300);
		});

		// updatePerson (empty fields)
		var url = '/action/updatePerson?field6=&field7=&field8=&field9=&ajax=true';
		var obj = ajax(url, function () {
			// hide infos, show form
			t.closest('.saved-account-infos-display-ctn').slideUp(300, function () {
				t.closest('.box-theme-content').find('.form-inputs-ctn').slideDown(300);
			});
		}, true);
	};

	var removeTabWarning = function removeTabWarning(ctn) {
		var tabNumber = ctn.closest('.tabs-content-inner-ctn').attr('data-tab');
		var tab = $('.tabs-bar-and-content-ctn.account-params-ctn').find('.account-tab-item[data-tab=' + tabNumber + ']');

		tab.removeClass('orange');
		tab.find('.attention-required-icon-ctn').fadeOut(300, function () {
			tab.find('.required-fields-completed-icon-ctn').fadeIn(300);
		});
	};

	var checkCreditCardDate = function checkCreditCardDate(form) {
		var ctn = form.find('.month-year-ctn');
		var chosenMonthSelect = ctn.find('select[name=expMM]');
		var chosenYearSelect = ctn.find('select[name=expYY]');
		var chosenMonthVal = parseInt(chosenMonthSelect.val());
		var chosenYearVal = parseInt(chosenYearSelect.val());

		if (isNaN(chosenMonthVal) || isNaN(chosenYearVal)) {
			return;
		}

		var currMonth = parseInt(ctn.attr('data-curr-month'));
		var currYear = parseInt(ctn.attr('data-curr-year').substring(2));

		if (chosenYearVal > currYear) {
			form.removeClass('has-cc-expired-error');
			form.find('.js-form-error-message.credit-card-expired').slideUp();
			chosenMonthSelect.removeClass('error');
			chosenYearSelect.removeClass('error');
			return;
		} else if (chosenYearVal === currYear) {
			if (chosenMonthVal > currMonth) {
				form.removeClass('has-cc-expired-error');
				form.find('.js-form-error-message.credit-card-expired').slideUp();
				chosenMonthSelect.removeClass('error');
				chosenYearSelect.removeClass('error');
				return;
			} else {
				form.addClass('has-cc-expired-error');
				form.find('.js-form-error-message.credit-card-expired').slideDown();
				chosenMonthSelect.addClass('error');
				chosenYearSelect.addClass('error');
			}
		}
	};

	var saveBillingInfos = function saveBillingInfos() {
		var btn = $(this);
		var form = btn.closest('.js-form');

		formValidator.validateForm(form);
		checkCreditCardDate(form);

		if (!form.hasClass('has-error') && !form.hasClass('has-cc-expired-error')) {
			btn.addClass('disabled');
			var ccType = $('select[name="CCType"]', form);
			var name = $('input[name="name"]', form);
			var ccNumber = $('input[name="ccNumber"]', form);
			var expMM = $('select[name="expMM"]', form);
			var expYY = $('select[name="expYY"]', form);
			var street = $('input[name="street"]', form);
			var city = $('input[name="city"]', form);
			var country = $('select[name="country"]', form);
			var province = $('input[name="province"]', form);
			var pc = $('input[name="postalCode"]', form);
			var cvv = $('input[name="cvv"]', form);

			var url = '/action/epSaveCCInfos';
			url += '?CCType=' + ccType.val();
			url += '&name=' + encodeURIComponent(name.val());
			url += '&ccNumber=' + ccNumber.val();
			url += '&expMM=' + expMM.val();
			url += '&expYY=' + expYY.val();
			url += '&street=' + encodeURIComponent(street.val());
			url += '&city=' + encodeURIComponent(city.val());
			url += '&country=' + encodeURIComponent(country.val());
			url += '&province=' + encodeURIComponent(province.val());
			url += '&postalCode=' + encodeURIComponent(pc.val());
			url += '&ajax=true';

			var obj = ajax(url, function (response) {
				if (response.indexOf('success') !== -1) {
					removeTabWarning(form);
					form.find('.js-form-success-message').slideDown(300, function () {
						setTimeout(function () {
							form.find('.js-form-success-message').slideUp(300);
						}, 5000);
					});
					form.find('.form-inputs-ctn').slideUp(300, function () {
						fillAndDisplayBillingInfos(form, ccType.val(), name.val(), ccNumber.val().substring(ccNumber.val().length - 4), expMM.val() + "/" + expYY.val());

						ccNumber.val("");
						ccNumber.parent().removeClass("focused");
						cvv.val("");
						cvv.parent().removeClass("focused");
					});
				}
			}, true);
			btn.removeClass('disabled');
		}
	};

	var fillAndDisplayBillingInfos = function fillAndDisplayBillingInfos(form, ccType, name, ccNumber, exp) {
		var displayBillingInfosCtn = form.closest('.box-theme-content').find('.account-params-saved-billing-infos-ctn');

		$('.saved-billing-info-name', displayBillingInfosCtn).html(name);
		$('.saved-billing-info-ccnumber', displayBillingInfosCtn).html("**** **** **** " + ccNumber);
		$('.saved-billing-info-exp', displayBillingInfosCtn).html(exp);

		$('.credit-card-logo-ctn', displayBillingInfosCtn).removeClass("visa").removeClass("master").removeClass("amex").removeClass("discover");
		$('.credit-card-logo-ctn', displayBillingInfosCtn).addClass(ccType);
		$('.credit-card-logo-ctn', displayBillingInfosCtn).html($('.all-credit-card-logos-ctn .' + ccType, form).html());

		displayBillingInfosCtn.slideDown(300);
	};

	var deleteBillingInfos = function deleteBillingInfos() {
		var t = $(this);
		var form = t.closest('.box-theme-content').find('.js-form');
		var tab = $('.tabs-bar-and-content-ctn.account-params-ctn').find('.account-tab-item[data-tab=' + form.closest('.tabs-content-inner-ctn').attr('data-tab') + ']');

		var url = '/action/epSaveCCInfos';
		url += '?remove=true';
		url += '&ajax=true';

		var obj = ajax(url, function (response) {
			if (response.indexOf('success') !== -1) {
				// reset form
				form.find('input:text, input:password, input:file, select, textarea').val('').removeClass('success');
				form.find('.input-ctn').removeClass('focused');

				// add tab warning
				tab.addClass('orange').find('.required-fields-completed-icon-ctn').fadeOut(300, function () {
					tab.find('.attention-required-icon-ctn').fadeIn(300);
				});
				// hide infos, show form
				t.closest('.saved-account-infos-display-ctn').slideUp(300, function () {
					t.closest('.box-theme-content').find('.form-inputs-ctn').slideDown(300);
				});
			}
		}, true);
	};

	var init = function init(page) {
		currPage = $(page);

		modifyPasswordBtn = $('.account-params-modify-password-btn');
		savePersonalInfosForm = $('.account-params-personal-infos-form');
		savePersonalInfosBtn = $('.save-personal-infos-btn', savePersonalInfosForm);
		savePaymentInfosForm = $('.account-params-payment-infos-form');
		savePaymentInfosBtn = $('.save-payment-infos-btn', savePaymentInfosForm);
		editPaymentInfosBtn = $('.edit-payment-infos-btn');
		deletePaymentInfosBtn = $('.delete-payment-infos-btn');
		saveBillingInfosForm = $('.account-params-billing-infos-form');
		saveBillingInfosBtn = $('.save-billing-infos-btn', saveBillingInfosForm);
		editBillingInfosBtn = $('.edit-billing-infos-btn');
		deleteBillingInfosBtn = $('.delete-billing-infos-btn');

		modifyPasswordBtn.click(enablePasswordModification);
		savePersonalInfosBtn.click(savePersonalInfos);
		savePaymentInfosBtn.click(savePaymentInfos);
		editPaymentInfosBtn.click(editInfos);
		deletePaymentInfosBtn.click(deletePaymentInfos);
		saveBillingInfosBtn.click(saveBillingInfos);
		editBillingInfosBtn.click(editInfos);
		deleteBillingInfosBtn.click(deleteBillingInfos);

		// Country / Province select
		initChangeStates([$('select[name="country"]'), $('select[name="billing-country"]')]);
		$('select[name="country"]').change(function () {
			initChangeStates($(this));
		});

		$('select[name="billing-country"]').change(function () {
			initChangeStates($(this));
		});
	};

	$(window).on("load", function () {
		init();
	});
})(jQuery);
(function ($, d, g) {

    'use strict';

    var showMoreBtn;
    var filterBtn;
    var toggleAccountBtn;
    var toggleProfileBtn;
    var submitManualOperationBtn;
    var confirmForm;
    var deleteUserBtn;
    var deleteUserProfileBtn;
    var toggleServiceFeesBtn;
    var toggleAuto;

    var confirmAction = function confirmAction(e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        if (confirmForm) {
            ajaxBlackout(true);
            confirmForm.submit();
        }
    };

    var toggleDisplayElements = function toggleDisplayElements() {
        var btn = $(this),
            sel = btn.parent().find(btn.attr("data-selectors"));

        if (btn.hasClass("active")) {
            sel.addClass("hide");
            btn.removeClass("active");
        } else {
            sel.removeClass("hide");
            btn.addClass("active");
        }
    };

    var detectLanding = function detectLanding() {
        if (d.querySelector(".account-login-landing")) {
            d.querySelector(".open-login-btn").click();
        }
    };

    var submitFilter = function submitFilter() {
        $(this).closest('form').submit();
    };

    var toggleAccountActivation = function toggleAccountActivation() {
        var t = $(this);
        var action = t.hasClass("toggle-account-disabled");
        var activate = action ? "account-validated" : "disabled";
        var deleteAction = t.closest('.users-table-actions-ctn').find('.table-delete-action');

        var urlSuspend = "/action/epSuspendAccount";
        urlSuspend += "?id=" + t.attr("data-id");
        urlSuspend += "&suspend=" + !action;
        urlSuspend += "&ajax=true";

        ajax(urlSuspend, function () {
            if (action) {
                t.removeClass("toggle-account-disabled");
                t.find("p").html(t.attr("data-deactivate"));
                deleteAction.addClass('hide');
            } else {
                t.addClass("toggle-account-disabled");
                t.find("p").html(t.attr("data-activate"));
                deleteAction.removeClass('hide');
            }
        }, true);
    };

    var toggleProfileActivation = function toggleProfileActivation() {
        var t = $(this);
        var activate = t.hasClass("toggle-profile-disabled");

        var urlSuspend = "/action/epSuspendAccount";
        urlSuspend += "?profileId=" + t.attr("data-id");
        urlSuspend += "&suspend=" + !activate;
        urlSuspend += "&ajax=true";

        ajax(urlSuspend, function (response) {
            if (activate) {
                t.removeClass("toggle-profile-disabled");
                t.find("p").html(t.attr("data-deactivate"));
            } else {
                t.addClass("toggle-profile-disabled");
                t.find("p").html(t.attr("data-activate"));
            }
        }, true);
    };

    var submitManOpForm = function submitManOpForm() {
        var t = $(this);
        var form = t.closest('.js-form');
        var amount = $('input[name="amt"]', form);
        var zeroOrUnderError = $('.js-form-error-message.requested-amount-zero-or-under', form);

        formValidator.validateForm(form);

        if (!form.hasClass('has-error')) {
            t.addClass('disabled');

            if (parseFloat(amount.val()) <= 0) {
                t.removeClass("disabled");
                zeroOrUnderError.slideDown();
            } else {
                zeroOrUnderError.slideUp();
                var profileId = $('input[name="profileId"]', form);
                var type;
                var typeChoiceInputs = form.find('input[name="balance-choice-' + profileId.val() + '"]');
                typeChoiceInputs.each(function () {
                    if ($(this).prop('checked') === true) {
                        type = $(this).val();
                    }
                });
                var positive = $('select[name="positive"]', form);
                var comment = $('textarea[name="comment"]', form);

                var url = '/action/epUpdateBalance';
                url += '?profileId=' + profileId.val();
                url += '&type=' + type;
                url += '&positive=' + positive.val();
                url += '&amt=' + amount.val();
                url += '&comment=' + encodeURIComponent(comment.val());
                url += '&ajax=true';

                ajax(url, function (response) {
                    t.removeClass('disabled');

                    if (response.indexOf('fail') !== -1) {
                        form.find('.js-form-error-message.fail-msg').slideDown(function () {
                            setTimeout(function () {
                                $(this).slideUp();
                            }, 5000);
                        });
                    } else {
                        t.closest('.popup-ctn').find('.popup-inner-close').trigger('click');
                        form.find('input[type=number], select, textarea').val('').removeClass('success');
                        form.find('.input-ctn').removeClass('focused');

                        var balanceOwing = fixNum(response.split('*')[1]);
                        var balanceOwingTd = t.closest('tr').find('.balance-owing-to-epass').find('p');
                        var balanceOwed = fixNum(response.split('*')[0]);
                        var balanceOwedTd = t.closest('tr').find('.balance-owed-to-profile').find('p');
                        var lang = $('input#lang').val();

                        if (lang === 'fr') {
                            balanceOwingTd.html(balanceOwing + '$');
                            balanceOwedTd.html(balanceOwed + '$');
                        } else {
                            balanceOwingTd.html('$ ' + balanceOwing);
                            balanceOwedTd.html('$ ' + balanceOwed);
                        }
                    }
                }, true);
            }
        }
    };

    var fixNum = function fixNum(x, n) {
        var m = n ? n : 2;
        var y = parseFloat(x);
        if (y < 0) {
            return Math.abs(y).toFixed(m) * -1;
        } else {
            return y.toFixed(m);
        }
    };

    var deleteUser = function deleteUser(e) {
        confirmForm = $(this).closest("form")[0];
        $("#user_account_prompt_delete .popup-inner-content-btn .btn").click(confirmAction);
        openWindow("user_account_prompt_delete", true);
    };

    var deleteUserProfile = function deleteUserProfile(e) {
        confirmForm = $(this).closest("form")[0];
        $("#user_profile_prompt_delete .popup-inner-content-btn .btn").click(confirmAction);
        openWindow("user_profile_prompt_delete", true);
    };

    var toggleServiceFees = function toggleServiceFees() {
        var t = $(this);
        var activate = true;

        if (t.hasClass('active')) {
            activate = false;
        }

        var url = '/action/manageGenData';
        url += '?id=' + t.attr('id');
        url += '&field12=' + activate;
        url += '&ajax=true';

        ajax(url, function (response) {
            if (response.indexOf('success') !== -1) {
                if (activate) {
                    t.addClass('active');
                    t.find('p').html(t.attr('data-deactivate'));
                } else {
                    t.removeClass('active');
                    t.find('p').html(t.attr('data-activate'));
                }
            }
        }, true);
    };

    var toggleAutoPayment = function toggleAutoPayment() {
        var t = $(this);
        var id = t.attr("data-id");

        var url = "/action/manageGenData";
        url += "?ajax=true";
        url += "&id=" + id;
        url += "&field13=" + t.hasClass("active");

        ajax(url, function (response) {
            if (response.indexOf("success") !== -1) {
                if (t.hasClass("active")) {
                    t.find("p").text(t.attr("data-activate"));
                } else {
                    t.find("p").text(t.attr("data-deactivate"));
                }
                t.toggleClass("active");
            }
        }, true);
    };

    var init = function init() {
        showMoreBtn = $(".btn-show-more");
        showMoreBtn.click(toggleDisplayElements);

        filterBtn = $(".user-filter");
        filterBtn.change(submitFilter);

        toggleAccountBtn = $(".toggle-account-activation");
        toggleAccountBtn.click(toggleAccountActivation);

        toggleProfileBtn = $(".toggle-profile-activation");
        toggleProfileBtn.click(toggleProfileActivation);

        submitManualOperationBtn = $('.submit-manual-op-btn');
        submitManualOperationBtn.click(submitManOpForm);

        deleteUserBtn = $('.delete-user-account');
        deleteUserBtn.click(deleteUser);

        deleteUserProfileBtn = $('.delete-user-profile');
        deleteUserProfileBtn.click(deleteUserProfile);

        toggleServiceFeesBtn = $('.toggle-service-fees-action');
        toggleServiceFeesBtn.click(toggleServiceFees);

        toggleAuto = $('.toggle-auto-balance');
        toggleAuto.click(toggleAutoPayment);
    };

    $(g).on("load", function () {
        if (d.getElementById("jsAdminUserAccounts")) {
            detectLanding();
            init();
        }
    });
})(jQuery, document, window);
(function ($, undefined) {

	'use strict';

	var formAnimate;
	var formValidator;
	var tools;
	var win;
	var formBtn;
	var formCtn;
	var consignesRecapCtn;
	var consignesRecapCtnHeight;
	var consignesRecapOuterCtn;
	var consignesRecapOuterCtnTop;
	var consignesRecapOuterCtnHeight;
	var showTicketCatsBtn;
	var showTicketCatsBtnResp;
	var ticketChoiceCheck;
	var cartRecap;
	var consignesQtyCtn;
	var deleteTicketChoiceBtn;
	var qtyInput;
	var shippingMode;
	var confirmOrderBtn;
	var showTicketsDetailBtn;
	var printConsigneTicketsBtn;

	var checkScroll = function checkScroll() {
		consignesRecapCtnHeight = consignesRecapCtn.height();
		consignesRecapOuterCtnTop = consignesRecapOuterCtn.offset().top - $('.site-header').height();
		consignesRecapOuterCtnHeight = consignesRecapOuterCtn.height();
		var maxBottom = consignesRecapOuterCtnHeight + consignesRecapOuterCtnTop - consignesRecapCtnHeight;

		if (win.scrollTop() > maxBottom) {
			$('.consignes-recap-outer-ctn.absolute').css('top', consignesRecapOuterCtnHeight - consignesRecapCtnHeight + 'px');
		} else if (win.scrollTop() > consignesRecapOuterCtnTop && !(win.scrollTop() > maxBottom)) {
			$('.consignes-recap-outer-ctn.absolute').css('top', win.scrollTop() - consignesRecapOuterCtnTop + 'px');
		} else if (win.scrollTop() <= consignesRecapOuterCtnTop) {
			$('.consignes-recap-outer-ctn.absolute').css('top', '0px');
		}
	};

	var showTicketCats = function showTicketCats() {
		var t = $(this);
		var parentTd = t.closest('td');
		var parentTr = t.closest('tr');

		parentTd.toggleClass('open');
		parentTr.next('.consigne-table-tickets-cats').slideToggle();
	};

	var ticketToQtyBox = function ticketToQtyBox() {
		var t = $(this);
		var id = t.attr('id');
		var ticketsBox = $('.consignes-tickets-ctn');
		var qtyBox = $('.consignes-qty-box');
		var qtyBoxInnerCtn = $('.consignes-qty-tickets-outer-ctn', qtyBox);
		var currItem = qtyBox.find('.tickets-list-one-ticket-ctn[data-id=' + id + ']');

		if (currItem.length) {
			currItem.remove();
			addToCart(id, 0);
		} else {
			var ctn = t.closest('.tickets-list-one-ticket-content');
			var eventName = t.closest('.tickets-list-outer-ctn').find('.tickets-list-header').html();
			var name = ctn.find('.name').html();
			var price = ctn.find('.price').html();
			var max = ctn.attr('data-max');
			var ticketClone = qtyBox.find('.event-folders-ticket-temp.hide').clone();
			var deleteTicketChoiceBtn = ticketClone.find('.delete-btn');
			var qtyInput = ticketClone.find('.form-input');

			ticketClone.find('.tickets-list-one-ticket-ctn').attr('data-id', id);
			ticketClone.find('.name').html(eventName + ' - ' + name);
			ticketClone.find('.price').html(price);
			qtyBoxInnerCtn.append(ticketClone.children());
			tools.init();
			formAnimate.init();
			qtyBoxInnerCtn.addClass('filled');
			addToCart(id, 1);

			deleteTicketChoiceBtn.click(deleteTicket);

			qtyInput.attr('max', max);
			qtyInput.keyup(checkQtyMax);
			qtyInput.focusout(updateQty);
		}

		if (qtyBoxInnerCtn.children().length === 0) {
			qtyBoxInnerCtn.removeClass('filled');
		}
	};

	var deleteTicket = function deleteTicket() {
		var ticketsBox = $('.consignes-tickets-ctn');
		var id = $(this).closest('.tickets-list-one-ticket-ctn').attr('data-id');
		ticketsBox.find('.package-ticket-choice[id=' + id + ']').trigger('click');
		addToCart(id, 0);
	};

	var updateQty = function updateQty() {
		var id = $(this).closest('.tickets-list-one-ticket-ctn').attr('data-id');

		addToCart(id, $(this).val());
	};

	var checkQtyMax = function checkQtyMax() {
		if (parseInt($(this).val()) > parseInt($(this).attr('max'))) {
			$(this).val($(this).attr('max'));
		}
	};

	var addToCart = function addToCart(id, qty) {
		var url = '/action/epAddCart?ajax=true&consigne';
		url += '&ticketId=' + id;

		ajax(url + '&remove=true', function (response) {
			if (response.indexOf('success') !== -1) {
				if (qty !== 0) {
					ajax(url + '&quantity=' + qty, function (response) {
						if (response.indexOf('success') !== -1) {
							updateRecap();
						}
					}, true);
				} else {
					updateRecap(id, qty);
				}
			}
		}, true);
	};

	var updateRecap = function updateRecap(id, qty) {
		var url = '/action/epJsonCart?consigne=true';

		if (qty === 0 && cartRecap.find('.consignes-recap-one-item[id=' + id + ']').length) {
			cartRecap.find('.consignes-recap-one-item[id=' + id + ']').remove();
		}

		ajax(url, function (response) {
			var json = JSON.parse(response.trim());

			$.each(json, function (k, v) {
				if (json[k].id) {
					var item;

					if (cartRecap.find('.consignes-recap-one-item[id=' + json[k].id + ']').length) {
						item = cartRecap.find('.consignes-recap-one-item[id=' + json[k].id + ']');
					} else {
						item = $('.consignes-recap-one-item-outer-ctn.hide').clone();
					}

					item.find('.consignes-recap-item-name').html(encodeText(json[k].name));
					item.find('.consignes-recap-one-item').attr('id', json[k].id);
					item.find('.consignes-recap-item-price .amount').html(json[k].subPrice);
					item.find('.consignes-recap-item-qty').html(json[k].quantity);

					if (item.hasClass('hide')) {
						$('.consignes-recap-items-ctn').append(item.children());
					}
				} else {
					if (json[k].tickets === '0') {
						$('.consignes-recap-outer-ctn.absolute').fadeOut();
					} else {
						$('.consignes-recap-outer-ctn.absolute').fadeIn();
					}

					cartRecap.find('.recap-total.shipping-fees').html(json[k].shipping);
					cartRecap.find('.recap-total.subtotal').html(json[k].subTotalTickets);
					cartRecap.find('.recap-total.tps').html(json[k].tps);
					cartRecap.find('.recap-total.tvq').html(json[k].tvq);
					cartRecap.find('.recap-total.total').html(json[k].totalPriceTickets);
				}
			});

			consignesQtyCtn.find('.consigne-ticket-qty').removeClass('disabled');
		}, true);
	};

	var updateShippingMode = function updateShippingMode() {
		var url = '/action/epConsignePayment?ajax=true';
		url += '&shipping=' + $(this).val();

		ajax(url, function (response) {
			if (response.indexOf('success') !== -1) {
				updateRecap();
			}
		}, true);
	};

	var confirmOrder = function confirmOrder() {
		var t = $(this);
		var form = t.closest('form');

		formValidator.validateForm(form);

		if (!form.hasClass('has-error')) {
			t.addClass('disabled');
			form.submit();
		} else {
			t.closest('.popup').find('.popup-inner-close').trigger('click');
		}
	};

	var showTicketsDetail = function showTicketsDetail() {
		var t = $(this);
		var eventId = t.attr("data-eventid");
		var ticketId = t.attr("data-ticketid");
		var code = t.attr("data-code");

		var url = "/action/epFetchConsigneTickets";
		url += "?eventId=" + eventId;
		url += "&ticketId=" + ticketId;
		ajax(url, function (response, event) {
			var json = JSON.parse(response.trim());
			$('#consigne-table-one-ticket-cat-popup-' + ticketId + ' .one-participant-row:not(.clone)').remove();
			$.each(json, function (k, v) {
				var clone = $(".one-participant-row.clone").clone();

				clone.find(".ticket-number").html(json[k].index);
				clone.find(".ticket-code").html(json[k].qrCode);
				if (json[k].scannedIn) {
					clone.find(".toggle-ticket-activation-btn").remove();
				} else {
					clone.find(".toggle-ticket-activation-btn").attr("data-id", json[k].id);
					clone.find(".toggle-ticket-activation-btn").attr("data-eventid", eventId);
					var active;
					if (json[k].active) {
						clone.find(".scanned-ticket-text").remove();
						active = false;
					} else {
						clone.find(".toggle-ticket-activation-btn .btn-placeholder").html(clone.find(".toggle-ticket-activation-btn").attr("data-activate"));
						clone.addClass("inactive");
						clone.find(".scanned-ticket-text").remove();
						active = true;
					}
					initToggleActive(event, clone.find(".toggle-ticket-activation-btn"), json[k].qrCode, active, eventId);
				}
				clone.removeClass("hide");
				clone.removeClass("clone");
				$('#consigne-table-one-ticket-cat-popup-' + ticketId + ' .participants-list-table').append(clone);
			});
		}, true);
	};

	var initToggleActive = function initToggleActive(e, elmt, qr, active, eventId) {
		elmt.click(function () {
			var url = "/action/epQR";
			url += "?qr=" + qr;
			url += "&validate=" + eventId;
			url += "&activate=" + elmt.closest(".one-participant-row").hasClass("inactive");
			ajax(url, function (response) {
				if (elmt.closest(".one-participant-row").hasClass("inactive")) {
					elmt.find(".btn-placeholder").html(elmt.attr("data-cancel"));
				} else {
					elmt.find(".btn-placeholder").html(elmt.attr("data-activate"));
				}
				elmt.closest(".one-participant-row").toggleClass("inactive");
			}, true);
		});
	};

	var printTickets = function printTickets() {
		var t = $(this);
		var ctn = t.closest(".print-tickets-ctn");
		var from = ctn.find(".consigne-ticket-from").val();
		var to = ctn.find(".consigne-ticket-to").val();
		var url = '/action/epPrintTickets';
		url += '?ajax=true';
		url += '&id=' + $(this).attr('id');

		if (from.trim() !== '') {
			url += '&from=' + from;
		}
		if (to.trim() !== '') {
			url += '&to=' + to;
		}

		ajax(url, function (response) {
			if (response.indexOf('success') !== -1) {
				t.closest('.popup-ctn').find('.popup-inner-close').trigger('click');
			}
		}, true);
	};

	var emptyCart = function emptyCart() {
		ajax('/action/epAddCart?clear=true&ajax=true', function (response) {
			if (response.indexOf('success') !== -1) {
				cartRecap.find('.consignes-recap-items-ctn .consignes-recap-one-item').remove();
				updateRecap();
				$('.items-from-other-page-in-cart').slideUp();
			}
		}, true);
	};

	var init = function init() {
		formAnimate = Fw.component.models().formAnimate;
		formValidator = Fw.component.models().form;
		tools = Fw.component.models().tools;
		win = $(window);
		formBtn = $('.add-new-item-btn.consigne');
		formCtn = $('.create-consignes-form-ctn');
		consignesRecapCtn = $('.consignes-recap-outer-ctn.invisible');
		consignesRecapOuterCtn = $('.consignes-tab-1-recap-ctn');
		showTicketCatsBtn = $('.show-ticket-cats');
		showTicketCatsBtnResp = $('.consigne-table-ticket-cats-btn-resp');
		ticketChoiceCheck = $('.consignes-tickets-box .package-ticket-choice');
		cartRecap = $('.consignes-recap-ctn');
		consignesQtyCtn = $('.consignes-qty-tickets-outer-ctn');
		deleteTicketChoiceBtn = $('.delete-btn', consignesQtyCtn);
		qtyInput = $('.form-input', consignesQtyCtn);
		shippingMode = $('.consignes-delivery-mode');
		confirmOrderBtn = $('.consignes-recap-confirm-order-btn');
		showTicketsDetailBtn = $('.show-tickets');
		printConsigneTicketsBtn = $('.print-consigne-tickets-btn');

		deleteTicketChoiceBtn.click(deleteTicket);
		qtyInput.keyup(checkQtyMax);
		qtyInput.focusout(updateQty);
		shippingMode.click(updateShippingMode);
		confirmOrderBtn.click(confirmOrder);
		showTicketsDetailBtn.click(showTicketsDetail);
		printConsigneTicketsBtn.click(printTickets);
		$('.add-new-item-btn.consigne.js-empty-cart').click(emptyCart);

		formBtn.click(function () {
			setTimeout(function () {
				if (formCtn.hasClass('open')) {
					checkScroll();

					win.scroll(function () {
						checkScroll();
					});
					win.resize(function () {
						checkScroll();
					});
				}
			}, 500);
		});

		showTicketCatsBtn.click(showTicketCats);
		ticketChoiceCheck.change(ticketToQtyBox);

		if (cartRecap.length) {
			updateRecap();
		}
	};

	$(window).on('load', function () {
		init();
	});
})(jQuery);
(function ($, d, g) {
    'use strict';

    var lang = d.documentElement.lang;
    var manageTicketsPath = "/action/epManageTickets";
    var managePoolsPath = "/action/epManagePools";
    var managePrivateLinksPath = "/action/epManagePrivateLinks";
    var managePalierPath = "/action/epManagePalier";
    var managePackagePath = "/action/epManagePass";
    var manageMerchPath = "/action/epManageEventProducts";
    var steps = {
        info: 1,
        visual: 2,
        ticket: 3,
        package: 4,
        merch: 5,
        privateLink: 6,
        confirm: 7
    };

    var currPage;
    var eventAgeSelectInput;
    var eventTypeRadioInput;
    var nextStepBtn;
    var oneStepCtn;
    var showStepsRespBtn;
    var createEventForm;
    var createEventBtn;
    var previewEventBtn;
    var publishEventBtn;
    var modifyEventBtn;
    var datePickerInput;
    var timePickerInput;
    var eventVisibilityChoice;
    var eventPublicationChoice;
    var searchProfileInput;
    var searchInputAndDropDownCtn;
    var searchDropDown;
    var searchDropDownChoiceOuterCtn;
    var searchDropDownChoiceInnerCtn;
    var addNewArtistBtn;
    var addNewLocationBtn;
    var profileSelectionBox;
    var addressInput;
    var cityInput;
    var cpInput;
    var provInput;
    var countryInput;
    var toggleSubBtn;
    var toggleServiceFeesBtn;
    var togglePoolingQtyBtn;
    var poolingQtyCtn;
    var poolingQtySelect;
    var serviceFeesCtn;
    var editEventId;

    var displayedProfiles = [];
    var onsave = false;

    var event_recur_type = "";
    var event_start_date = "";
    var event_start_time = "";
    var event_end_date = "";
    var event_end_time = "";
    var event_door_date = "";
    var event_door_time = "";

    var _PASSTICKETS = {};

    var checkAgeChoice = function checkAgeChoice() {
        var t = $(this);
        var parentCtn = t.closest('.box-theme-content');
        var otherAgeTextInput = parentCtn.find('.admission-age-other-ctn');

        if (t.val() === 'other') {
            otherAgeTextInput.slideDown(300, function () {
                $(this).removeClass('hide');
                $('input[name="admissionOther"]', $(this)).addClass('required');
            });
        } else {
            if (!otherAgeTextInput.hasClass('hide')) {
                otherAgeTextInput.slideUp(300, function () {
                    $(this).addClass('hide');
                    $('input[name="admissionOther"]', $(this)).removeClass('required');
                });
            }
        }
    };

    var checkEventType = function checkEventType() {
        var t = $(this);
        var oneDayInputs = $('.event-form-one-day-inputs-ctn');
        var multipleDaysInputs = $('.event-form-multiple-days-inputs-ctn');
        var curType = t.val();
        var otherType = "multiple-days";

        if (curType === 'multiple-days') {
            otherType = "one-day";
            oneDayInputs.slideUp(300, function () {
                $(this).addClass('hide');
                $('.event-datetime-start-and-end-ctn input, .event-form-doors-ctn input', $(this)).removeClass('required');
                $('.event-form-doors-ctn .toggle-trigger-element', $(this)).prop('checked', false);
                $('.event-form-doors-ctn .element-to-toggle', $(this)).addClass('hide').removeAttr('style');
                $('.event-form-doors-ctn .element-to-toggle .input-ctn', $(this)).removeClass('focused');
                $('.event-form-doors-ctn .element-to-toggle input', $(this)).val('');

                multipleDaysInputs.slideDown(300, function () {
                    $(this).removeClass('hide');
                    $('.event-datetime-start-and-end-ctn input', $(this)).addClass('required').blur(formValidator.formItemsBlur);
                });
            });
        } else {
            $(".ticket-form-dates-wrap>.ticket-type-multiple-days").appendTo($(".ticket-form-dates-temp"));
            multipleDaysInputs.slideUp(300, function () {
                $(this).addClass('hide');
                $('.event-datetime-start-and-end-ctn input', $(this)).removeClass('required');

                oneDayInputs.slideDown(300, function () {
                    $(this).removeClass('hide');
                    $('.event-datetime-start-and-end-ctn input, .event-form-doors-ctn .timepicker', $(this)).addClass('required').blur(formValidator.formItemsBlur);
                });
            });
        }
        $(".ticket-form-dates-wrap>.ticket-type-" + otherType).appendTo($(".ticket-form-dates-temp"));
        $(".ticket-form-dates-temp>.ticket-type-" + curType).appendTo($(".ticket-form-dates-wrap"));
        $(".ticket-form-ctn.open .close-toggle-form-btn").trigger("click");
    };

    var validateVenue = function validateVenue(parent) {
        var locationBox = parent.find('.account-box.profile-selection.location');

        if (!locationBox.find('.one-profile-selected-ctn:not(.clone)').length) {
            parent.addClass('error-location').addClass('has-error');
            locationBox.find('input').addClass('error');
            parent.find('.js-form-error-message.error-location').slideDown();
        } else {
            parent.removeClass('error-location');
            parent.find('.js-form-error-message.error-location').slideUp();
        }
    };

    var setEventDateTime = function setEventDateTime() {
        event_recur_type = $(".event-form-step-ctn[data-step='1'] .recurring-event-choice-ctn input:checked").val();
        event_start_date = $("#start-date-create-event-" + event_recur_type).val();
        event_start_time = $("#start-time-create-event-" + event_recur_type).val();
        event_end_date = $("#end-date-create-event-" + event_recur_type).val();
        event_end_time = $("#end-time-create-event-" + event_recur_type).val();
        var isOtherDate = $("#create-event-door-other-date").prop("checked");
        event_door_date = isOtherDate ? $("#door-date-create-event-" + event_recur_type).val() : event_start_date;
        event_door_time = $("#door-time-create-event-" + event_recur_type).val();
    };

    var validateMerchDelivery = function validateMerchDelivery() {
        var postal = $('input[name=postalDelivery]');
        var pickup = $('input[name=pickupDelivery]');
        var deliveryChoiceError = $('.js-form-error-message.shipping-check');

        if (!postal.is(':checked') && !pickup.is(':checked') && $('.event-form-products-table tbody').find('tr').length !== 0) {
            postal.closest('.form-checkbox-ctn').addClass('error');
            pickup.closest('.form-checkbox-ctn').addClass('error');
            $('.create-event-form').addClass('error-shipping');
            deliveryChoiceError.slideDown();
        } else {
            postal.closest('.form-checkbox-ctn').removeClass('error');
            pickup.closest('.form-checkbox-ctn').removeClass('error');
            $('.create-event-form').removeClass('error-shipping');
            deliveryChoiceError.slideUp();
        }
    };

    var transiting = false;
    var transtime = 300;

    var changeStep = function changeStep(currentStep, chosenStep) {
        var currentStepNumber = $('.steps-bar-one-step-outer-ctn[data-step=' + currentStep + ']'),
            parentBar = currentStepNumber.closest('.steps-bar-outer-ctn').find('.steps-bar-ctn'),
            currentFormStepCtn = $('.event-form-step-ctn[data-step=' + currentStep + ']');

        if (currentStep === steps.info || currentStep === steps.visual || currentStep === steps.ticket || currentStep === steps.merch) {
            if (currentStep === steps.merch) {
                validateMerchDelivery();
                if ($('.create-event-form').hasClass('error-shipping')) {
                    return false;
                }
            }
            if (currentStep === steps.ticket) {
                formValidator.validateForm($('.service-fees-options-ctn'));
            } else {
                formValidator.validateForm(currentFormStepCtn);
            }
        }

        if (currentStep === steps.info) {
            validateVenue(currentFormStepCtn);
        }
        // if not current step and if no errors or is admin
        if (!transiting && currentStep !== chosenStep && !currentFormStepCtn.hasClass('error-location') && (!currentFormStepCtn.hasClass('has-error') && currentStep !== steps.ticket || currentStep === steps.ticket && !$('.service-fees-options-ctn').hasClass('has-error') || $('body').hasClass('is-logged-in'))) {
            // Assign event's date and time values
            setEventDateTime();

            var missingStepsErrorMsg = $('.js-form-error-message.form-step.error-msg');
            var chosenFormStepCtn = $('.event-form-step-ctn[data-step=' + chosenStep + ']');

            $('.steps-bar-one-step-outer-ctn.active-responsive').removeClass('active-responsive');
            $('.steps-bar-one-step-outer-ctn[data-step=' + chosenStep + ']').addClass('active-responsive');
            $('.create-event-steps-choice-ctn').slideUp(300);
            showStepsRespBtn.removeClass('open');

            missingStepsErrorMsg.slideUp(300);
            // handle form
            currentFormStepCtn.fadeOut(300, function () {
                currentFormStepCtn.removeClass('active');
                chosenFormStepCtn.fadeIn(300).addClass('active');
                pageScrlTo(0);
            });

            nextStepBtn.attr('data-step', chosenStep);
            publishEventBtn.attr('data-step', chosenStep);

            // handle steps bar
            transiting = true;
            if (chosenStep < currentStep) {
                transtime = 300 / (currentStep - chosenStep);
                parentBar.css("transition-duration", transtime + "ms");
                removeBarProgress(currentStep, chosenStep, parentBar, transtime);
            } else {
                transtime = 300 / (chosenStep - currentStep);
                parentBar.css("transition-duration", transtime + "ms");
                addBarProgress(currentStep, chosenStep, parentBar, transtime);
            }

            // In step 3 we retrieve the capacity in case it has been changed or 
            // new location is added.
            if (chosenStep === steps.ticket && createEventForm.find(".event-room-cap").length) {
                var cap = createEventForm.find(".event-room-cap").val();
                if (cap !== '-1' && cap !== '') {
                    createEventForm.find(".tickets-total-capacity").val(isNaN(cap) ? 0 : cap);
                    checkEventCapacity();
                }
            }

            // Load ticket list in step 4, les forfaits, whenever we go into this step
            // so that all newly created tickets created will be displayed here.
            if (chosenStep === steps.package) {
                loadPackageDirectories(createEventForm.find("[name='id']").val());
            }
            if (chosenStep === steps.privateLink) {
                loadPrivateDirectories(createEventForm.find("[name='id']").val());
            }
        }
    };

    var chooseStep = function chooseStep(e) {
        var t = $(this);
        var currentStep = t.closest('.create-event-page-wrapper').find('.event-form-step-ctn.active').data('step');
        var chosenStep = t.closest('.steps-bar-one-step-outer-ctn').data('step');

        changeStep(currentStep, chosenStep);
    };

    var goToNextStep = function goToNextStep(e) {
        var t = $(this);
        var currentStep = parseInt(t.attr('data-step'));
        var nextStep = currentStep + 1;

        if (!$('.steps-bar-one-step-outer-ctn[data-step=' + (currentStep + 1) + ']').length) {
            nextStep = currentStep + 2;
        }

        changeStep(currentStep, nextStep);
    };

    var removeBarProgress = function removeBarProgress(currentStep, chosenStep, parent, transtime) {
        if (!$('.steps-bar-one-step-outer-ctn[data-step=' + currentStep + ']').length) {
            currentStep = currentStep - 1;
        }

        var stepCtn = $('.steps-bar-one-step-outer-ctn[data-step=' + currentStep + ']', parent);
        var tt = transtime ? transtime : 0;

        stepCtn.addClass('active').removeClass('done');

        if (currentStep !== chosenStep) {
            setTimeout(function () {
                stepCtn.removeClass('active');
                currentStep--;

                if (currentStep >= chosenStep) {
                    setTimeout(function () {
                        removeBarProgress(currentStep, chosenStep, parent, transtime);
                    }, tt * 0.95);
                }
            }, tt * 1.05);
        } else {
            transiting = false;
        }
    };

    var addBarProgress = function addBarProgress(currentStep, chosenStep, parent, transtime) {
        var stepCtn = $('.steps-bar-one-step-outer-ctn[data-step=' + currentStep + ']', parent);
        var nextStep = $('.steps-bar-one-step-outer-ctn[data-step=' + (currentStep + 1) + ']', parent);
        if (!nextStep.length) {
            nextStep = $('.steps-bar-one-step-outer-ctn[data-step=' + (currentStep + 2) + ']', parent);
        }

        var tt = transtime ? transtime : 0;

        if (currentStep !== chosenStep) {
            stepCtn.addClass('done').removeClass('active');

            setTimeout(function () {
                nextStep.addClass('active');
                currentStep++;

                if (currentStep <= chosenStep) {
                    setTimeout(function () {
                        addBarProgress(currentStep, chosenStep, parent, transtime);
                    }, tt * 0.95);
                }
            }, tt * 1.05);
        } else {
            transiting = false;
        }
    };

    var showSteps = function showSteps(e) {
        var t = $(this);

        $('.create-event-steps-choice-ctn').slideToggle(300);
        t.toggleClass('open');
    };

    var saveEvent = function saveEvent(e) {
        $(window).unbind('beforeunload');
        eventPublicationChoice.eq(1).prop(true);
        submitEventForm(true);
    };

    var publishEvent = function publishEvent(e) {
        $(window).unbind('beforeunload');
        var t = $(this);
        var eventFormStepCtn = $('.event-form-step-ctn');
        var currStepCtn = eventFormStepCtn.filter(".active");

        if (t.hasClass('disabled')) {
            return false;
        }
        t.addClass('disabled');
        formValidator.validateForm(eventFormStepCtn.eq(steps.info - 1));
        formValidator.validateForm(eventFormStepCtn.eq(steps.visual - 1));
        formValidator.validateForm(eventFormStepCtn.eq(steps.confirm - 1));
        if (currStepCtn.hasClass('has-error') || createEventForm.hasClass('has-step-error')) {
            t.removeClass('disabled');
            $(window).bind('beforeunload', function () {
                return true;
            });
        } else {
            $('.js-form-error-message.form-step.error-msg').slideUp(300);
            submitEventForm(true);
        }
    };

    var savePubEvent = function savePubEvent(e) {
        $(window).unbind('beforeunload');
        var t = $(this);
        var currStepCtn = $(".event-form-step-ctn.active");

        if (t.hasClass('disabled')) {
            return false;
        }
        t.addClass('disabled');

        if (currStepCtn.data('step') !== steps.ticket && currStepCtn.data('step') !== steps.package && currStepCtn.data('step') !== steps.privateLink) {
            formValidator.validateForm(currStepCtn);
        }

        if (currStepCtn.hasClass('has-error') || createEventForm.hasClass('has-step-error')) {
            t.removeClass('disabled');
        } else {
            $('.js-form-error-message.form-step.error-msg').slideUp(300);
            submitEventForm(true);
        }
    };

    var openEventModifiedPopup = function openEventModifiedPopup(e) {
        // Stop publishEvent and savePubEvent functions
        e.stopImmediatePropagation();

        var $it = $(e.currentTarget);
        var $popup = $('.event-modified-popup');

        // Hide and show respective buttons
        if ($it.hasClass('publish-event-btn')) {
            $popup.find('.modify-event-btn').hide();
            $popup.find('.publish-event-btn').show();
        } else {
            $popup.find('.publish-event-btn').hide();
            $popup.find('.modify-event-btn').show();
        }
        // Open confirmation popup
        $popup.addClass('open');
        $('.parametered-page>.overlay').addClass('active');
    };

    var previewEvent = function previewEvent(e) {
        createEventForm.find('input[name=preview]').val('true');
        createEventForm.find('.create-event-forward').removeAttr('name');
        createEventForm.find('.preview-event-forward').attr('name', 'pageSuccess');
        createEventForm.attr('target', '_blank');
        submitEventForm(true);

        setTimeout(function () {
            createEventForm.find('input[name=preview]').val('false');
            createEventForm.find('.create-event-forward').attr('name', 'pageSuccess');
            createEventForm.find('.preview-event-forward').removeAttr('name');
            createEventForm.removeAttr('target');
        }, 5);
    };

    var submitEventForm = function submitEventForm(ignore) {
        if (ignore) {
            ignoreInputs($('.event-form-one-day-inputs-ctn.hide'));
            ignoreInputs($('.event-form-multiple-days-inputs-ctn.hide'));
            ignoreInputs($('.clone'));
        }
        createEventForm.submit();
        if (ignore) {
            g.setTimeout(function () {
                cancelIgnoreInputs($('.event-form-one-day-inputs-ctn.hide'));
                cancelIgnoreInputs($('.event-form-multiple-days-inputs-ctn.hide'));
                cancelIgnoreInputs($('.clone'));
            });
        }
    };

    var ignoreInputs = function ignoreInputs(ctn) {
        ctn.find('input').each(function () {
            var t = $(this);
            t.attr('data-input-name', t.attr('name'));
            t.attr('name', 'ignore');
        });
    };

    var cancelIgnoreInputs = function cancelIgnoreInputs(ctn) {
        ctn.find('input').each(function () {
            var t = $(this);
            t.attr('name', t.attr('data-input-name'));
        });
    };

    var getPickerDate = function getPickerDate() {
        var dateSplitVal = $(this).val().split('/');
        var name = $(this).attr('name');
        var parent = $(this).closest('.fake-ctn');

        parent.find('input[name=' + name + 'DateYear]').val(dateSplitVal[0]);
        parent.find('input[name=' + name + 'DateMonth]').val(parseInt(dateSplitVal[1]) - 1);
        parent.find('input[name=' + name + 'DateDay]').val(dateSplitVal[2]);

        if (name === 'door') {
            $("#tdib_dt_one-day .tdibv-door-date").text(getDateFormatted(dateSplitVal[0], parseInt(dateSplitVal[1]) - 1, dateSplitVal[2]));
        }
    };

    var getPickerTime = function getPickerTime() {
        var timeSplitVal = $(this).val().split(':');
        var name = $(this).attr('name');
        var parent = $(this).closest('.fake-ctn');

        parent.find('input[name=' + name + 'DateHour]').val(timeSplitVal[0]);
        parent.find('input[name=' + name + 'DateMinute]').val(timeSplitVal[1]);
    };

    var changeDateTimepickerRange = function changeDateTimepickerRange(dp, input, parentCtn, minDate, isStart) {
        var startDate = $('.start-date.datepicker', parentCtn);
        var endDate = $('.end-date.datepicker', parentCtn);

        if (input.hasClass('datepicker') && input.val() !== '') {
            var chosenDate = input.val();
            var splitChosenDate = chosenDate.split('/');

            if (parentCtn.hasClass('one-day') || input.hasClass("same-date")) {
                if (isStart === true) {
                    var chosenDateObj = new Date(splitChosenDate[0], splitChosenDate[1] - 1, splitChosenDate[2]);
                    var nextDayDateObj = new Date(chosenDateObj.setDate(chosenDateObj.getDate() + 1));

                    startDate.datetimepicker({
                        startDate: chosenDate,
                        minDate: minDate,
                        maxDate: false
                    });
                    endDate.datetimepicker({
                        startDate: chosenDate,
                        minDate: chosenDate,
                        maxDate: nextDayDateObj
                    });

                    addChosenDate(startDate, chosenDate, 'date');

                    endDate.closest('.event-form-datetime-right').removeClass('disabled');
                    endDate.val('').removeClass('success');
                    endDate.closest('.input-ctn').removeClass('focused').removeClass('error');
                } else {
                    addChosenDate(endDate, chosenDate, 'date');
                }
            } else {
                if (input.hasClass('start-date')) {
                    endDate.datetimepicker({
                        minDate: splitChosenDate[0] + '/' + splitChosenDate[1] + '/' + parseInt(splitChosenDate[2]),
                        maxDate: false
                    });
                } else if (input.hasClass('end-date')) {
                    startDate.datetimepicker({
                        minDate: false,
                        maxDate: splitChosenDate[0] + '/' + splitChosenDate[1] + '/' + parseInt(splitChosenDate[2])
                    });
                }
            }

            compareDates(startDate, endDate, parentCtn);
        }

        if (input.hasClass('timepicker') && input.val() !== '') {
            checkLimitTimeRange(parentCtn, input);
        }
    };

    var compareDates = function compareDates(startDate, endDate, parentCtn) {
        if (startDate.val() && endDate.val()) {
            var startDateVal = new Date(startDate.val().split('/')[0], startDate.val().split('/')[1] - 1, startDate.val().split('/')[2]);
            var endDateVal = new Date(endDate.val().split('/')[0], endDate.val().split('/')[1] - 1, endDate.val().split('/')[2]);

            if (startDateVal.getTime() === endDateVal.getTime()) {
                parentCtn.addClass('limit-time-range');
                checkLimitTimeRange(parentCtn, null);
            } else {
                parentCtn.removeClass('limit-time-range');
                checkLimitTimeRange(parentCtn, null);
            }
        }
    };

    var checkLimitTimeRange = function checkLimitTimeRange(parentCtn, input) {
        var startTime = $('.start-time.timepicker', parentCtn);
        var endTime = $('.end-time.timepicker', parentCtn);

        if (parentCtn.hasClass('limit-time-range')) {
            var chosenTime;

            if (input !== null && input.length) {
                chosenTime = input.val();
            } else if (startTime.val()) {
                chosenTime = startTime.val();
            } else if (endTime.val()) {
                chosenTime = endTime.val();
            } else {
                return;
            }

            var currDate = new Date();
            var timeVal = new Date(currDate.getFullYear(), currDate.getMonth(), currDate.getDate(), chosenTime.split(':')[0], chosenTime.split(':')[1], '0');

            // on time change
            if (input !== null && input.length) {
                if (input.hasClass('start-time') && chosenTime !== '') {
                    endTime.datetimepicker({
                        minTime: timeVal
                    });
                } else if (input.hasClass('end-time') && chosenTime !== '') {
                    startTime.datetimepicker({
                        maxTime: timeVal
                    });
                }
            } else {
                // on date change
                if (startTime.val()) {
                    if (endTime.val()) {
                        var startTimeVal = new Date(currDate.getFullYear(), currDate.getMonth(), currDate.getDate(), startTime.val().split(':')[0], startTime.val().split(':')[1], '0');
                        var endTimeVal = new Date(currDate.getFullYear(), currDate.getMonth(), currDate.getDate(), endTime.val().split(':')[0], endTime.val().split(':')[1], '0');

                        if (endTimeVal < startTimeVal) {
                            endTime.val('').removeClass('success');
                            endTime.closest('.input-ctn').removeClass('focused').removeClass('error');
                        }
                    }
                    endTime.datetimepicker({
                        minTime: timeVal
                    });
                } else if (endTime.val()) {
                    startTime.datetimepicker({
                        maxTime: timeVal
                    });
                }
            }
        } else {
            endTime.datetimepicker({
                minTime: false
            });
            startTime.datetimepicker({
                maxTime: false
            });
        }
    };

    var addChosenDate = function addChosenDate(input, value, type) {
        input.val(value).addClass('success');
        input.closest('.input-ctn').addClass('focused');

        if (type === 'date') {
            input.trigger('change', getPickerDate);
        } else {
            input.trigger('change', getPickerTime);
        }
    };

    var checkVisibilityChoice = function checkVisibilityChoice() {
        var t = $(this);
        var parent = t.closest('.box-theme-content');
        var publicDescription = parent.find('.public.event-visibility-description');
        var privateDescription = parent.find('.private.event-visibility-description');

        parent.find('.event-text-description-ctn').slideDown(300, function () {
            if (t.prop('checked') && t.val() === 'on') {
                // public
                privateDescription.slideUp(300, function () {
                    publicDescription.slideDown(300);
                });
            } else if (t.prop('checked') && t.val() === 'off') {
                // private
                publicDescription.slideUp(300, function () {
                    privateDescription.slideDown(300);
                });
            }
        });
    };

    var checkPublicationChoice = function checkPublicationChoice() {
        var t = $(this);
        var val = t.val();
        var parent = t.closest('.box-theme-content');
        var publishDescription = parent.find('.publish.event-publication-description');
        var draftDescription = parent.find('.draft.event-publication-description');
        var planificationDescription = parent.find('.planification.event-publication-description');
        var planificationInputsCtn = parent.find('.event-publication-planification-inputs-ctn');

        parent.find('.event-text-description-ctn').slideDown(300);
        publishEventBtn.find(".active").removeClass("active");
        publishEventBtn.find("span").eq(val).addClass("active");
        if (t.prop("checked")) {
            if (val === "0") {
                //publish
                draftDescription.slideUp(300);
                planificationDescription.slideUp(300);
                planificationInputsCtn.slideUp(300, function () {
                    $('input', $(this)).removeClass('required');
                });
                setTimeout(function () {
                    publishDescription.slideDown(300);
                }, 300);
            } else if (val === "2") {
                //plan
                publishDescription.slideUp(300);
                draftDescription.slideUp(300);
                setTimeout(function () {
                    planificationDescription.slideDown(300);
                    planificationInputsCtn.slideDown(300, function () {
                        $('input', $(this)).addClass('required');
                    });
                }, 300);
            } else {
                //draft
                publishDescription.slideUp(300);
                planificationDescription.slideUp(300);
                planificationInputsCtn.slideUp(300, function () {
                    $('input', $(this)).removeClass('required');
                });
                setTimeout(function () {
                    draftDescription.slideDown(300);
                }, 300);
            }
        }
    };

    var searchProfile = function searchProfile() {
        var t = $(this);
        var type = t.data('misc');
        var searchVal = encodeInputText(t.val());
        var parentCtn = t.closest(searchInputAndDropDownCtn);
        var dropDownDisplayedProfiles = parentCtn.find(searchDropDownChoiceInnerCtn).find('.search-drop-down-one-item');

        if (searchVal !== '') {
            parentCtn.find(searchDropDown).slideDown(300);
            ajax('/action/epSearchProfiles?type=' + type + '&q=' + searchVal, function (response) {
                var json = JSON.parse(response.trim());
                var newResults = [];

                if (json.length > 0) {
                    $.each(json, function (k, v) {
                        var id = json[k].id;
                        newResults.push(id);

                        if ($.inArray(id, displayedProfiles) === -1) {
                            populateDropDown(parentCtn, json[k], type);
                        }
                    });

                    removeUnrelatedProfilesFromDropDown(parentCtn, displayedProfiles, newResults);
                    displayedProfiles = newResults;

                    parentCtn.find(searchDropDownChoiceOuterCtn).slideDown(300);
                } else {
                    parentCtn.find(searchDropDownChoiceOuterCtn).slideUp(300);
                    emptyDropDown(dropDownDisplayedProfiles);
                }
            }, true);
        } else {
            parentCtn.find(searchDropDown).slideUp(300);
            emptyDropDown(dropDownDisplayedProfiles);
        }
    };

    var emptyDropDown = function emptyDropDown(profiles) {
        displayedProfiles = [];
        profiles.slideUp(300, function () {
            $(this).remove();
        });
    };

    var removeUnrelatedProfilesFromDropDown = function removeUnrelatedProfilesFromDropDown(parentCtn, displayedProfiles, newResults) {
        var _remove = function _remove() {
            $(this).remove();
        };
        if (displayedProfiles.length > 0 && newResults.length > 0) {
            for (var i = 0; i < displayedProfiles.length; i++) {
                if ($.inArray(displayedProfiles[i], newResults) === -1) {
                    parentCtn.find('.search-drop-down-one-item#' + displayedProfiles[i]).slideUp(300, _remove);
                }
            }
        }
    };

    var populateDropDown = function populateDropDown(parentCtn, profileObj, type) {
        var id = profileObj.id;
        var name = encodeText(profileObj.field3);
        var email = encodeText(profileObj.field7);
        var friendlyUrl = profileObj.friendlyUrl;
        var imageObj = JSON.parse(profileObj.field5);
        var image = imageObj.profileMediaId.length !== 0 && imageObj.profileMediaId !== '0' ? imageObj.profileMediaId : type;
        var addressObj = JSON.parse(encodeText(profileObj.field6));
        var address = addressObj.address + ', ' + addressObj.city + ', ' + addressObj.province + '  ' + addressObj.postalCode;
        var cap = addressObj.capacity;

        var dropDownItemCtn = parentCtn.find('.search-drop-down-one-item#clone').clone();
        dropDownItemCtn.attr('data-name', name).attr('data-image', image).attr('data-address', address).attr('data-url', friendlyUrl).attr('data-email', email).attr('data-cap', cap);

        styleAndAppendClone(dropDownItemCtn, parentCtn.find(searchDropDownChoiceInnerCtn), id, name, image, address);

        // add listener
        $('.select-profile-from-drop-down#' + id).click(addSelectedProfile);
    };

    var styleAndAppendClone = function styleAndAppendClone(clone, container, id, name, image, address) {
        clone.find('.search-drop-down-one-item-name').html(name);

        if (image !== '') {
            clone.find('.bg-pic').css('background-image', 'url(/static/uploaded/Profile/' + image + '-profile.jpg)');
        }

        if (address !== '') {
            clone.find('.search-drop-down-one-item-location').html(address);
        }

        if (clone.hasClass('search-drop-down-one-item')) {
            clone.attr('id', id);
        } else {
            clone.find('.search-drop-down-one-item').attr('id', id);
        }

        clone.hide().removeClass('clone');
        container.append(clone);
        clone.slideDown(300);
    };

    var addSelectedProfile = function addSelectedProfile() {
        var t = $(this);
        var type = t.data('type');
        var id = t.attr('id');
        var name = t.data('name');
        var image = t.data('image');
        var address = t.data('address');
        var cap = t.data('cap');
        //var url = t.data('url');
        //var email = t.data('email');
        var parentCtn = t.closest('.box-theme-content');
        var clone = parentCtn.find('.one-profile-selected-ctn.clone.existing-profile').clone();
        //var inputName = clone.data('input-name');
        var selectedProfilesCtn = parentCtn.find('.selected-profiles-ctn');
        var selectedProfileNumber = parseInt(selectedProfilesCtn.find('.one-profile-selected-ctn').length) + 1;
        var isNewProfile = false;

        // check if artist is already in the list of selected artists
        if (type === 0) {
            var prevSelectedArtists = [];

            selectedProfilesCtn.find('.one-profile-selected-ctn').each(function () {
                var t = $(this);
                var prevSeletedArtistId = t.find('.search-drop-down-one-item').attr('id');

                prevSelectedArtists.push(prevSeletedArtistId);
            });

            if ($.inArray(id, prevSelectedArtists) === -1) {
                // if new selection
                clone.attr('data-position', selectedProfileNumber);
                clone.find('input[name=relationId]').val('').attr('name', 'relationId' + selectedProfileNumber);
                clone.find('input[name=artistId]').val(id).attr('name', 'artistId' + selectedProfileNumber);
                isNewProfile = true;
            } else {
                // reset search
                emptyDropDown(parentCtn.find(searchDropDownChoiceInnerCtn).find('.search-drop-down-one-item'));
                resetSearchProfileInput(parentCtn);
            }
        }

        // location profile
        if (type === 2) {
            $('.tickets-total-capacity').val(cap);
            checkEventCapacity();
            // only one location per event
            parentCtn.find(searchInputAndDropDownCtn).slideUp(300, function () {
                $(this).find('.search-profile-input').removeClass('required');
            });
            clone.find('input[name=locationId]').val(id);
        }

        // listener
        clone.find('.one-profile-selected-remove-btn').click(removeSelectedProfile);

        // displaying selection and resetting search
        if (type !== 0 || type === 0 && isNewProfile === true) {
            styleAndAppendClone(clone, selectedProfilesCtn, id, name, image, address);
            emptyDropDown(parentCtn.find(searchDropDownChoiceInnerCtn).find('.search-drop-down-one-item'));
            resetSearchProfileInput(parentCtn);
        }
    };

    var removeSelectedProfile = function removeSelectedProfile() {
        var t = $(this);
        var profileToRemove = t.closest('.one-profile-selected-ctn');
        var profileRelationId = profileToRemove.attr('data-relation-id');
        var selectedProfilesCtn = t.closest('.selected-profiles-ctn');
        var type = profileToRemove.find('.search-drop-down-one-item').data('type');
        var parentCtn = t.closest('.box-theme-content');

        if (profileRelationId !== '') {
            if (createEventForm.find('input[name=deleteInvitationIds]').length) {
                var delInvitationIdsInput = createEventForm.find('input[name=deleteInvitationIds]');
                var delInvitationIdsInputVal = delInvitationIdsInput.val() + ',' + profileRelationId;

                delInvitationIdsInput.val(delInvitationIdsInputVal);
            } else {
                createEventForm.append('<input type="hidden" name="deleteInvitationIds" value="' + profileRelationId + '"/>');
            }
        }

        profileToRemove.slideUp(300, function () {
            $(this).remove();

            if (type === 2) {
                parentCtn.find(searchInputAndDropDownCtn).slideDown(300, function () {
                    $(this).find('.search-profile-input').addClass('required');
                });
            }

            // if artist, reassign input numbers
            if (type === 0) {
                var count = 1;

                selectedProfilesCtn.find('.one-profile-selected-ctn').each(function () {
                    var t = $(this);
                    var previousPosition = t.attr('data-position');

                    $(this).find('input[name=artistId' + previousPosition + ']').attr('name', 'artistId' + count);
                    $(this).find('input[name=artistName' + previousPosition + ']').attr('name', 'artistName' + count);
                    $(this).find('input[name=relationId' + previousPosition + ']').attr('name', 'relationId' + count);
                    $(this).find('input[name=artistEmail' + previousPosition + ']').attr('name', 'artistEmail' + count);
                    t.attr('data-position', count);
                    count++;
                });
            }
        });
    };

    var addNewProfile = function addNewProfile() {
        var t = $(this);
        var boxCtn = t.closest('.box-theme-ctn');
        var nameInput = boxCtn.find(searchProfileInput);

        if (nameInput.val() !== '') {
            if (nameInput.attr('name') === 'artistName') {
                addNewArtist(boxCtn, nameInput);
            } else if (nameInput.attr('name') === 'locationName') {
                addNewLocation(boxCtn, nameInput);
            }
        }
    };

    var addNewArtist = function addNewArtist(ctn, nameInput) {
        var clone = ctn.find('.one-profile-selected-ctn.clone.no-profile').clone();
        var selectedProfilesCtn = ctn.find('.selected-profiles-ctn');
        var selectedProfileNumber = parseInt(selectedProfilesCtn.find('.one-profile-selected-ctn').length) + 1;
        var name = nameInput.val();

        clone.attr('data-position', selectedProfileNumber);
        clone.find('input[name=artistName]').attr('name', 'artistName' + selectedProfileNumber).val(name);
        clone.find('input[name=artistEmail]').attr('name', 'artistEmail' + selectedProfileNumber);

        styleAndAppendClone(clone, selectedProfilesCtn, '', name, '', '');
        addSelectedProfileListeners(clone);
        resetSearchProfileInput(ctn);
    };

    var addNewLocation = function addNewLocation(ctn, nameInput) {
        var name = nameInput.val();
        var noAddressClone = ctn.find('.one-profile-selected-ctn.clone.no-profile').clone();
        var form = ctn.find('.event-form-address-ctn');
        var selectedProfilesCtn = ctn.find('.selected-profiles-ctn');

        ctn.find(searchInputAndDropDownCtn).slideUp(300, function () {
            $(this).find('.search-profile-input').removeClass('required');
            resetSearchProfileInput($(this));
            noAddressClone.append('<input type="hidden" name="locationName" value="' + name + '" />');
            styleAndAppendClone(noAddressClone, selectedProfilesCtn, '', name, '', '');
            addSelectedProfileListeners(noAddressClone);
            form.slideDown(300, function () {
                $('input', $(this)).addClass('required');
                profile.activateGlgAutocomplete();
                profile.checkAddress();
                setTimeout(function () {
                    addressInput.removeAttr("placeholder");
                }, 100);
            });
        });
    };

    var saveNewLocation = function saveNewLocation(name, ctn, form, selectedProfilesCtn) {
        formValidator.validateForm(form);

        if (!form.hasClass('has-error')) {
            var newLocationDisplay = ctn.find('.one-profile-selected-ctn.no-profile:not(.clone)');
            newLocationDisplay.find('.search-drop-down-one-item-location').html(addressInput.val() + ', ' + cityInput.val() + ', ' + provInput.val() + '  ' + cpInput.val());

            newLocationDisplay.find('.location-datetime-ctn').slideDown(300);
            newLocationDisplay.find('.send-profile-invitation-ctn').slideDown(300);
            newLocationDisplay.find('input[name=locationName]').val(name);

            form.slideUp(300, function () {
                $('input', $(this)).removeClass('required');
            });

            newLocationDisplay.find('.editable-item-btn').click(function () {
                form.slideDown(300, function () {
                    $('input', $(this)).addClass('required');
                });
            });
        }
    };

    var addSelectedProfileListeners = function addSelectedProfileListeners(ctn) {
        ctn.find('.one-profile-selected-remove-btn').click(removeSelectedProfile);
        var box = ctn.closest('.box-theme-ctn.profile-selection');

        if (box.hasClass('location')) {
            var form = box.find('.event-form-address-ctn');
            var profilesCtn = box.find('.selected-profiles-ctn');

            $('.save-new-location').click(function () {
                saveNewLocation(profilesCtn.find('.search-drop-down-one-item-name').html(), box, box.find('.event-form-address-ctn'), profilesCtn);
            });

            ctn.find('.one-profile-selected-remove-btn').click(function () {
                form.slideUp(150, function () {
                    $(this).find('.input-ctn').each(function () {
                        $(this).removeClass('focused');
                        $(this).find('input').removeClass('success').removeClass('error').val('').removeClass('required');
                    });

                    form.find('#map-ctn').empty().removeAttr('style').removeClass("activated");
                    $('.create-event-form').find('input[name="lat"]').val('');
                    $('.create-event-form').find('input[name="lng"]').val('');
                });

                setTimeout(function () {
                    searchInputAndDropDownCtn.slideDown(300);
                }, 300);
            });

            ctn.find('.editable-item-btn').click(function () {
                form.slideDown(300, function () {
                    $('input', $(this)).addClass('required');
                    profile.activateGlgAutocomplete();
                    profile.checkAddress();
                });
            });
        }

        formAnimate.init();
        ctn.find('.profile-invitation-popup-btn').click(showInvitationPopup);
        ctn.find('.cancel-profile-invitation-btn').click(function () {
            hideInvitationPopup($(this), false);
        });
        ctn.find('.send-profile-invitation-btn').click(function () {
            hideInvitationPopup($(this), true);
        });
    };

    var resetSearchProfileInput = function resetSearchProfileInput(container) {
        container.find(searchDropDown).slideUp(300);
        container.find(searchProfileInput).val('');
        container.find('.input-ctn').removeClass('focused');
        container.find('input').removeClass('success').removeClass('error');
    };

    var showInvitationPopup = function showInvitationPopup() {
        var t = $(this);
        var parentCtn = t.closest('.send-profile-invitation-ctn');
        var relatedPopup = parentCtn.find('.tooltip-ctn.send-profile-invitation');

        if ($('.tooltip-ctn.send-profile-invitation.open').closest('.send-profile-invitation-ctn') !== parentCtn) {
            $('.tooltip-ctn.send-profile-invitation.open').removeClass('open');
        }
        relatedPopup.addClass('open');
    };

    var hideInvitationPopup = function hideInvitationPopup(t, required) {
        var relatedPopup = t.closest('.tooltip-ctn.send-profile-invitation');
        var input = relatedPopup.find('input');
        var emailError = relatedPopup.find('.js-form-error-message.email');

        if (required === true) {
            input.addClass('required');
            formValidator.validateForm(relatedPopup);

            if (relatedPopup.hasClass('has-error')) {
                emailError.slideDown(300, function () {
                    setTimeout(function () {
                        $(this).slideUp(300);
                    }, 5000);
                });
            } else {
                relatedPopup.removeClass('open');
            }
        } else {
            relatedPopup.removeClass('has-error');
            emailError.slideUp(300);
            input.val('');
            input.closest('.input-ctn').removeClass('focused');
            input.removeClass('required').removeClass('error').removeClass('success');

            relatedPopup.removeClass('open');
        }
    };

    var getStatusValue = function getStatusValue(current, start, end, active, stock) {
        if (!active) {
            return -1;
        } else if (current < start) {
            return 0;
        } else if (current <= end && current >= start) {
            return 1;
        } else if (current > end) {
            return 2;
        } else if (stock <= 0) {
            return 3;
        }
    };

    var getStatusText = function getStatusText(s, d) {
        if (lang === "fr") {
            switch (s.toString()) {
                case "0":
                    return "En vente &agrave; partir du " + "<span class='table-status-timeframe'>" + d[0] + "</span>";
                case "1":
                    return "En vente jusqu'au " + "<span class='table-status-timeframe'>" + d[1] + "</span>";
                case "2":
                    return "Vente termin&eacute;e";
                case "3":
                    return "Quantit&eacute; &eacute;puis&eacute;e";
                default:
                    return "Vente suspendue";
            }
        } else {
            switch (s.toString()) {
                case "0":
                    return "On sale starting from " + "<span class='table-status-timeframe'>" + d[0] + "</span>";
                case "1":
                    return "On sale until " + "<span class='table-status-timeframe'>" + d[1] + "</span>";
                case "2":
                    return "Sale ended";
                case "3":
                    return "Sold out";
                default:
                    return "Sale suspended";
            }
        }
    };

    var getStatusColor = function getStatusColor(s, active) {
        if (!active) {
            return "orange";
        } else {
            switch (s.toString()) {
                case "0":
                    return "yellow";
                case "1":
                    return "blue";
                case "2":
                case "3":
                    return "red";
                default:
                    return "orange";
            }
        }
    };

    var getDateByName = function getDateByName(ctnq, name, sep) {
        var ctn = $(ctnq);
        return getDateYMD(ctn.find("input[name='" + name + "Year']").val(), ctn.find("input[name='" + name + "Month']").val(), ctn.find("input[name='" + name + "Day']").val(), sep);
    };
    var getTimeByName = function getTimeByName(ctnq, name, sep) {
        var ctn = $(ctnq);
        return getTimeHMS(ctn.find("input[name='" + name + "Hour']").val(), ctn.find("input[name='" + name + "Minute']").val(), sep);
    };
    var nextDate = function nextDate(d, n) {
        try {
            if (n === undefined) n = 1;
            var _ = new Date(d);
            var _d = _.getDate() + n;
            if (_d > 31) {
                _d = _.getTime() + n * 24 * 60 * 60 * 1000;
                _.setTime(_d);
            } else {
                _.setDate(_d);
            }
            return _.getFullYear() + "/" + formatZeros(_.getMonth() + 1) + "/" + formatZeros(_.getDate());
        } catch (ex) {
            return null;
        }
    };
    var nextHour = function nextHour(dt, n) {
        try {
            if (n === undefined) n = 1;
            var _ = new Date(dt);
            _.setHours(_.getHours() + n);
            return _.getFullYear() + "/" + formatZeros(_.getMonth() + 1) + "/" + formatZeros(_.getDate()) + " " + _.toTimeString();
        } catch (ex) {
            return null;
        }
    };

    var startNewTicket = function startNewTicket(e, p) {
        if (p) return;
        if (serviceFeesCtn.length !== 0) {
            toggleServiceFeesBtn.removeClass("active");
            serviceFeesCtn.slideUp();
        }
        var form = $(".ticket-form-ctn"),
            type = $(".event-form-step-ctn[data-step='1'] .recurring-event-choice-ctn input:checked").val(),
            cd = $("#systemCurrentDate").val().replace(/-/g, "/"),
            ct = roundTime($("#systemCurrentTime").val());

        cd = cd.substr(0, 4) + "/" + cd.substr(4, 2) + "/" + cd.substr(6, 2);

        form.find(".create-ticket-btn").text(function () {
            return $(this).attr("data-" + lang + "-label");
        });
        form.find("input, textarea, select").each(function () {
            var $this = $(this),
                name = $this.attr("name"),
                type = $this.attr("type");

            if (type === "radio" || type === "checkbox") {
                var checked = $this.prop("checked");
                if (name === "free") {
                    if ($this.val() === "false" && !checked) {
                        $this.trigger("click");
                    }
                } else if (name === "pooling") {
                    $this.prop("checked", false).triggerHandler("click");
                } else {
                    if (checked) {
                        $this.prop("checked", false).triggerHandler("click");
                    }
                }
            } else {
                if (name !== "eventId") {
                    $this.val("");
                    if (type !== "hidden") {
                        $this.removeClass("error success");
                        $this.closest(".input-ctn").removeClass("focused");
                    }
                }
            }
        });
        // Reset pricing
        form.find(".ticket-price-inner-ctn").removeClass("soldisabled").removeAttr("tabIndex").show().find(".ticket-price-input-final, .ticket-price-input-raw").removeClass("disabled").prop("disabled", false).closest(".input-ctn").removeClass("disabled disabled-ctn");
        form.find(".ticket-price-inner-ctn .form-checkbox-ctn").removeClass("disabled disabled-ctn").show().find(".form-check-input").removeClass("disabled").prop("disabled", false);
        // Reset quantities
        $(".ticket-form-info-quantity-sold, .ticket-form-info-quantity-remain", form).text("0");

        if (type === "one-day") {
            var vsdt = nextHour(event_door_date + " " + event_door_time, -1),
                vedt = nextHour(event_end_date + " " + event_end_time);

            triggerInputFocus("#customStart-date-ticket", event_start_date, "change");
            triggerInputFocus("#customStart-time-ticket", event_start_time, "change");
            triggerInputFocus("#customEnd-date-ticket", event_end_date, "change");
            triggerInputFocus("#customEnd-time-ticket", event_end_time, "change");
            changeTicketDisplayInfoBox($("#tdib_ed_" + type), event_start_date, event_start_time, event_end_time);
            changeTicketDisplayInfoBox($("#tdib_dt_" + type), event_door_date, event_door_time, "");
            $(".display-on-ticket-check").prop("checked", false);
            triggerInputFocus("#customDoorStart-time-ticket", event_door_time, "change");
            triggerInputFocus("#customDoorStart-date-ticket", event_door_date, "change");
            $(".tdib-yes-display").removeClass("hide");
            $(".tdib-no-display").addClass("hide");
            triggerInputFocus("#sellingStart-date-" + type, cd, "change");
            triggerInputFocus("#sellingStart-time-" + type, ct, "change");
            triggerInputFocus("#sellingEnd-date-" + type, event_door_date, "change");
            triggerInputFocus("#sellingEnd-time-" + type, event_door_time, "change");
            triggerInputFocus("#validityStart-date-" + type, vsdt.substring(0, 10), "change");
            triggerInputFocus("#validityStart-time-" + type, vsdt.substring(11, 16), "change");
            triggerInputFocus("#validityEnd-date-" + type, vedt.substring(0, 10), "change");
            triggerInputFocus("#validityEnd-time-" + type, vedt.substring(11, 16), "change");
        } else {
            var inpSMT = $("#customStart-date-" + type),
                inpEMT = $("#customEnd-date-" + type);

            inpSMT.datetimepicker({
                minDate: event_start_date,
                maxDate: event_end_date,
                onShow: function onShow(ct) {
                    this.setOptions({
                        maxDate: inpEMT.val() !== "" ? inpEMT.val() : event_end_date
                    });
                },
                onChangeDateTime: function onChangeDateTime(dp, input) {}
            });
            inpEMT.datetimepicker({
                minDate: event_start_date,
                maxDate: event_end_date,
                onShow: function onShow(ct) {
                    this.setOptions({
                        minDate: inpSMT.val() !== "" ? inpSMT.val() : event_start_date
                    });
                },
                onChangeDateTime: function onChangeDateTime(dp, input) {}
            });

            var _setDefault = function _setDefault() {
                var tsd = inpSMT.val(),
                    tst = $("#customStart-time-" + type).val(),
                    ted = inpEMT.val(),
                    tet = $("#customEnd-time-" + type).val(),
                    isOtherDate = $("#create-ticket-door-other-date").prop("checked"),
                    doorDate = isOtherDate ? $("#customDoorStart-date-" + type).val() : tsd,
                    doorTime = $(this).val(),
                    vsdt = nextHour(doorDate + " " + doorTime, -1),
                    vedt = nextHour(ted + " " + tet);

                if (tsd === "" || ted === "" || tst === "" || tet === "" || doorDate === "" || doorTime === "") {
                    return false;
                }
                triggerInputFocus("#sellingStart-date-" + type, cd, "change");
                triggerInputFocus("#sellingStart-time-" + type, ct, "change");
                triggerInputFocus("#sellingEnd-date-" + type, doorDate, "change");
                triggerInputFocus("#sellingEnd-time-" + type, doorTime, "change");
                triggerInputFocus("#validityStart-date-" + type, vsdt.substring(0, 10), "change");
                triggerInputFocus("#validityStart-time-" + type, vsdt.substring(11, 16), "change");
                triggerInputFocus("#validityEnd-date-" + type, vedt.substring(0, 10), "change");
                triggerInputFocus("#validityEnd-time-" + type, vedt.substring(11, 16), "change");
                $(this).off("change", _setDefault);
            };
            $("#customDoorStart-time-" + type).on("change", _setDefault);
        }
    };

    var changeTicketDisplayInfoBox = function changeTicketDisplayInfoBox(ctn, d, ts, te) {
        if (d) {
            var a = d.split("/");
            var df = getDateFormatted(a[0], parseInt(a[1]) - 1, a[2]);
            ctn.find(".tdibv-date").text(df);
        }
        if (ts) {
            ctn.find(".tdibv-time-start").text(getTimeFormatted(ts));
        }
        if (te) {
            ctn.find(".tdibv-time-end").text(getTimeFormatted(te));
        }
    };

    var checkToDisplayEventDT = function checkToDisplayEventDT() {
        var ctn = $(this).closest(".ticket-form-ctn"),
            names = $(this).val().split(",");

        for (var i = 0; i < names.length; i++) {
            var elS = ctn.find("[name='" + names[i] + "']");
            if ($(this).prop("checked")) {
                elS.addClass("nontake");
            } else {
                elS.removeClass("nontake");
            }
        }
    };

    var modifyTicketDisplayEventDate = function modifyTicketDisplayEventDate(e) {
        var pu = $(this).closest(".popup");
        var box = $("#tdib_ed_one-day");

        if (pu.find(".display-on-ticket-check").prop("checked")) {
            box.find(".tdib-yes-display").addClass("hide");
            box.find(".tdib-no-display").removeClass("hide");
        } else {
            var date = $("#customStart-date-ticket").val().split("/");
            box.find(".tdibv-date").text(getDateFormatted(date[0], parseInt(date[1]) - 1, date[2]));
            box.find(".tdibv-time-start").text(getTimeFormatted($("#customStart-time-ticket").val()));
            box.find(".tdibv-time-end").text(getTimeFormatted($("#customEnd-time-ticket").val()));
            box.find(".tdib-yes-display").removeClass("hide");
            box.find(".tdib-no-display").addClass("hide");
        }
        pu.find(".popup-inner-close").trigger("click");
    };

    var modifyTicketDisplayDoorTime = function modifyTicketDisplayDoorTime(e) {
        var pu = $(this).closest(".popup");
        var box = $("#tdib_dt_one-day");

        if (pu.find(".display-on-ticket-check").prop("checked")) {
            box.find(".tdib-yes-display").addClass("hide");
            box.find(".tdib-no-display").removeClass("hide");
        } else {
            var date = $("#customDoorStart-date-ticket").val().split("/");
            box.find(".tdibv-date").text(getDateFormatted(date[0], parseInt(date[1]) - 1, date[2]));
            box.find(".tdibv-time-start").text(getTimeFormatted($("#customDoorStart-time-ticket").val()));
            box.find(".tdib-yes-display").removeClass("hide");
            box.find(".tdib-no-display").addClass("hide");
        }
        pu.find(".popup-inner-close").trigger("click");
    };

    var toggleTicketStageForm = function toggleTicketStageForm(e) {
        if (serviceFeesCtn.length !== 0) {
            toggleServiceFeesBtn.removeClass("active");
            serviceFeesCtn.slideUp();
        }
        if ($("#palierStart-date-0").val() === "") {
            var cd = $("#systemCurrentDate").val();
            cd = cd.substr(0, 4) + "/" + cd.substr(4, 2) + "/" + cd.substr(6, 2);
            triggerInputFocus("#palierStart-date-0", cd, "change");
        }
        if ($("#palierStart-time-0").val() === "") {
            var ct = roundTime($("#systemCurrentTime").val());
            triggerInputFocus("#palierStart-time-0", ct, "change");
        }
        if ($("#palierEnd-date-0").val() === "") {
            triggerInputFocus("#palierEnd-date-0", event_door_date, "change");
        }
        if ($("#palierEnd-time-0").val() === "") {
            triggerInputFocus("#palierEnd-time-0", event_door_time, "change");
        }
    };

    var togglePriceBox = function togglePriceBox(e) {
        var rad = $(this);
        var box = rad.closest(".ticket-price-inner-ctn").find(".tickets-price-box");

        if (rad.prop("checked") && rad.val() === "true" || !rad.prop("checked")) {
            if (!rad.hasClass("toggle-trigger-element")) box.slideUp(300);
            box.find(".required").addClass("derequired").removeClass("required error");
        } else {
            if (!rad.hasClass("toggle-trigger-element")) box.slideDown(300);
            box.find(".derequired").addClass("required").removeClass("derequired success");
            if ($("input[name = 'passPrice']").length === 0) {
                box.find(".ticket-price-input-raw, .ticket-price-input-fee, .ticket-price-input-final, .ticket-price-input-service-fee").val("");
            }
            box.find(".input-ctn").removeClass('focused');
        }
    };

    var calcTicketPriceRaw = function calcTicketPriceRaw() {
        var inpTot = $(this),
            ctn = inpTot.closest(".box-content-ticket-price"),
            inpRaw = ctn.find(".ticket-price-input-raw"),
            inpFee = ctn.find(".ticket-price-input-fee"),
            inpServFee = ctn.find(".ticket-price-input-service-fee"),
            originalVal = inpTot.val(),
            val = inpTot.val();
        if (inpServFee.length !== 0 && inpServFee.val() !== 0) {
            val = val - inpServFee.val();
        }

        if (val !== "" && !isNaN(val)) {
            var da = ctn.data(),
                a = isNaN(da.base) ? 1 : parseFloat(da.base),
                b = isNaN(da.percent) ? 0.03 : parseFloat(da.percent) / 100,
                c = isNaN(da.tax1) || isNaN(da.tax2) ? 1.14975 : parseFloat(da.tax1) + parseFloat(da.tax2) + 1,
                min = formatDecimal2(a * c),
                t = formatDecimal2(Math.max(parseFloat(val), min)),
                f = formatDecimal2(t - (t - a * c) / (1 + b * c)),
                p = formatDecimal(t - f),
                sf = inpServFee.length !== 0 ? formatDecimal(inpServFee.val()) : formatDecimal(0);

            // Revised EP fee ticket level rounded calculations
            var ep_fee = Math.round((1 + da.percent * val / 100) * 100) / 100;
            var tax1 = Math.round(da.tax1 * ep_fee * 100) / 100;
            var tax2 = Math.round(da.tax2 * ep_fee * 100) / 100;
            f = formatDecimal2(ep_fee + tax1 + tax2);
            t = formatDecimal(p + f + sf);

            inpRaw.val(p.toFixed(2));
            inpFee.val(f.toFixed(2));

            if (inpServFee !== undefined) {
                inpServFee.val(sf.toFixed(2));
            }
            inpTot.val(formatDecimal2(Math.max(parseFloat(originalVal), min)).toFixed(2));
        } else {
            inpRaw.val("");
            inpFee.val("");
            if (inpServFee.length !== 0) {
                inpServFee.val("");
            }
        }
        triggerInputFocus(inpRaw);
        if (inpServFee.length !== 0) {
            triggerInputFocus(inpServFee);
        }
        triggerInputFocus(inpTot);
    };

    var applyPackagePriceFinal = function applyPackagePriceFinal(e, inp, values) {
        var inpRaw = inp !== null && inp !== undefined ? inp : $(this),
            ctn = inpRaw.closest(".box-content-ticket-price"),
            inpTot = ctn.find(".ticket-price-input-final"),
            inpFee = ctn.find(".ticket-price-input-fee");

        if (values === undefined || values.length == 0) {
            inpRaw.val(formatDecimal2(values['price']));
            inpFee.val(formatDecimal2(values['fees']));
            inpTot.val(formatDecimal2(values['total']));
        }
        triggerInputFocus(inpRaw);
        triggerInputFocus(inpTot);
    };

    var calcTicketPriceFinal = function calcTicketPriceFinal(e, inp) {
        var inpRaw = inp !== null && inp !== undefined ? inp : $(this),
            ctn = inpRaw.closest(".box-content-ticket-price"),
            inpTot = ctn.find(".ticket-price-input-final"),
            inpFee = ctn.find(".ticket-price-input-fee"),
            inpServFee = ctn.find(".ticket-price-input-service-fee"),
            val = inpRaw.val();

        if ($(this).hasClass('ticket-price-input-service-fee')) {
            val = inpServFee.val();
            inpRaw = ctn.find(".ticket-price-input-raw");
        }

        if (val !== "" && !isNaN(val)) {
            var da = ctn.data(),
                a = isNaN(da.base) ? 1 : parseFloat(da.base),
                b = isNaN(da.percent) ? 0.03 : parseFloat(da.percent) / 100,
                c = isNaN(da.tax1) || isNaN(da.tax2) ? 1.14975 : parseFloat(da.tax1) + parseFloat(da.tax2) + 1,
                min = 0,
                p = !isNaN(inpRaw.val()) && inpRaw.val() !== '' ? formatDecimal2(Math.max(parseFloat(inpRaw.val()), min)) : 0,
                f = formatDecimal2((a + b * p) * c),
                sf = inpServFee.length !== 0 && !isNaN(inpServFee.val()) && inpServFee.val() !== '' && parseFloat(inpRaw.val()).toFixed(2) !== '0.00' ? formatDecimal2(parseFloat(inpServFee.val())) : 0,
                t = formatDecimal(p + f + sf);

            // Revised EP fee ticket level rounded calculations
            var ep_fee = Math.round((1 + da.percent * inpRaw.val() / 100) * 100) / 100;
            var tax1 = Math.round(da.tax1 * ep_fee * 100) / 100;
            var tax2 = Math.round(da.tax2 * ep_fee * 100) / 100;
            f = formatDecimal2(ep_fee + tax1 + tax2);
            t = formatDecimal(p + f + sf);

            inpRaw.val(p.toFixed(2));
            inpFee.val(f.toFixed(2));
            if (inpServFee.length !== 0) {
                inpServFee.val(sf.toFixed(2));
            }
            inpTot.val(t.toFixed(2));
        } else {
            if (!$(this).hasClass('ticket-price-input-service-fee')) {
                inpTot.val("");
                if (inpServFee.length !== 0) {
                    inpServFee.val("");
                }
                inpFee.val("");
            }
        }
        triggerInputFocus(inpRaw);
        if (inpServFee.length !== 0) {
            triggerInputFocus(inpServFee);
        }
        triggerInputFocus(inpTot);
    };

    var checkEventCapacity = function checkEventCapacity(e) {
        var inp = $(this),
            qty = isNaN(inp.val()) ? 0 : parseInt(inp.val()),
            inpTot = $(".tickets-total-quantity"),
            tot = (isNaN(inpTot.val()) ? -1 : parseInt(inpTot.val())) + qty,
            inpCap = $(".tickets-total-capacity"),
            cap = isNaN(inpCap.val()) ? -1 : parseInt(inpCap.val()),
            inpInv = $(".tickets-total-inventory"),
            inv = isNaN(inpInv.val()) ? 0 : parseInt(inpInv.val()),
            warnBox = $(".tickets-over-capacity");

        if (cap < tot) {
            warnBox.fadeIn(400, function () {
                $(this).removeClass("hide");
            });
        } else {
            warnBox.fadeOut(400, function () {
                $(this).addClass("hide");
            });
        }
        if (!isNaN(qty) && !isNaN(inv)) {
            inp.val(Math.max(qty, inv));
        }
    };

    var updateTicketsTotal = function updateTicketsTotal() {
        var total = 0;
        $(".tickets-list-one-ticket-ctn").each(function () {
            var x = parseInt($(this).attr("data-number"));
            if (!isNaN(x)) total += x;
        });
        $(".tickets-total-quantity").val(total);
    };

    var createTicket = function createTicket(e) {
        var form = $(this).closest(".ticket-form-ctn"),
            inps = form.find("input, textarea, select"),
            fpt = $('.fee-per-transaction-ctn'),
            fptickets = $('.fee-per-ticket-ctn'),
            pooling = $('.pooling-qy-ctn'),
            oData = {},
            data = "";

        formValidator.validateForm(form);

        if (form.hasClass("has-error")) {
            return false;
        }

        if (pooling !== undefined && pooling.find("input[type='checkbox']").is(":checked") && (poolingQtySelect.val() === "" || poolingQtySelect.val() == "-1")) {
            alert("Please select pool");
            return false;
        }

        pageScrlTo(form.parent().offset().top - 100);

        inps.each(function () {
            var name = $(this).attr("name");
            if (name && name.trim() !== "") {
                var inp = $(this),
                    type = inp.attr("type"),
                    val = inp.val() != null ? inp.val().trim() : "",
                    checkType = type === "checkbox" || type === "radio";

                if ((checkType && inp.prop("checked") || !checkType) && !inp.hasClass("nontake")) {
                    if (inp.hasClass("datepicker")) {
                        name += "Date";
                    } else if (inp.hasClass("timepicker")) {
                        name += "Time";
                    }
                    if (!oData.hasOwnProperty(name)) oData[name] = val;
                    data += "&" + name + "=" + val;
                }
            }
        });

        if (pooling !== undefined) {
            data += "&pooling=" + pooling.find("input[type='checkbox']").is(":checked");
        }
        if (fpt !== undefined && fptickets !== undefined) {
            data += "&feePerTransaction=" + fpt.find("input[type='checkbox']").is(":checked");

            var amount = 0;
            if (fpt.find("input[type='checkbox']").is(":checked")) {
                amount = $(".transaction-service-fee").val();
                if (amount == "") {
                    amount = 0;
                }
            }
            data += "&feePerTransactionAmount=" + amount;
            data += "&feePerTicketCheck=" + fptickets.find("input[type='checkbox']").is(":checked");
        }
        var _fail = function _fail() {
            //Do something;
        };
        var _succeed = function _succeed(response) {
            var $tb = $(".event-form-tickets-table>tbody"),
                pos = $tb.find("tr").length,
                $tr = $tb.find("tr:eq(0)").clone(true, true),
                $tdStat = $tr.find(".table-status"),
                date = new Date(),
                curDate = date.getFullYear() + "" + (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "" + (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + "" + (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + "" + (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()),
                sellStartDate = getDateYMD(oData.sellingStartDateYear, oData.sellingStartDateMonth, oData.sellingStartDateDay) + getTimeHMS(oData.sellingStartDateHour, oData.sellingStartDateMinute),
                sellEndDate = getDateYMD(oData.sellingEndDateYear, oData.sellingEndDateMonth, oData.sellingEndDateDay) + getTimeHMS(oData.sellingEndDateHour, oData.sellingEndDateMinute),
                dfStart = getDateFormatted(oData.sellingStartDateYear, oData.sellingStartDateMonth, oData.sellingStartDateDay),
                tfStart = getTimeFormatted(oData.sellingStartDateHour + ":" + oData.sellingStartDateMinute),
                dfEnd = getDateFormatted(oData.sellingEndDateYear, oData.sellingEndDateMonth, oData.sellingEndDateDay),
                tfEnd = getTimeFormatted(oData.sellingEndDateHour + ":" + oData.sellingEndDateMinute),
                fp = oData.free === "true" ? 0 : parseFloat(oData.finalPrice),
                mf = oData.free === "true" ? lang === "fr" ? "gratuit" : "free" : formatMoney(fp),
                stat = 0,
                active = true,
                stock = parseInt(oData.qty),
                service = oData.feePerTicket;
            //Add ticket to the list table
            if (oData.ticketId.toString() === response) {
                $tr = $tb.find("tr[data-tkid='" + oData.ticketId + "']");
                $tdStat = $tr.find(".table-status");
                oData.active = $tr.find(".table-status").attr("data-active");
                active = oData.active === "true";
                stock -= parseInt(oData.inventory);

                if ($(".event-form-packages-table .event-package-ticket-name[data-id = " + oData.ticketId + "]").length !== 0) {
                    $(".event-form-packages-table .event-package-ticket-name[data-id = " + oData.ticketId + "]").text(oData.ticketName);
                }
            } else {
                oData.ticketId = response.trim();
                oData.active = active.toString();
                oData.inventory = 0;
                $tb.append($tr);
                $tr.removeAttr("style").removeAttr("class");
                $tr.attr("data-tkid", oData.ticketId);
                $tr.find(".table-position p").html(pos);
            }

            if ($tb.find('tr:not(.event-form-tickets-row-temp)').length > 0) {
                $('.no-elements-to-display-msg.tickets').fadeOut(function () {
                    $('.event-form-tickets-table').fadeIn();
                });
            }

            $tr.find(".preview-ticket-btn").attr("href", "/action/epTicketsPDF?ticketId=" + oData.ticketId);
            $tr.find(".event-form-ticket-table-name").html(oData.ticketName);
            $tr.find(".event-form-ticket-table-description").html(oData.ticketDescription);
            $tr.find(".table-money p").html(mf);
            $tr.find(".table-money").attr("data-price", fp);
            $tr.find(".table-money").attr("data-service", service);
            stat = getStatusValue(curDate, sellStartDate, sellEndDate, active, stock);

            $tdStat.attr("data-stat", stat).attr("data-active", active).attr("data-osd", dfStart).attr("data-ost", tfStart).attr("data-oed", dfEnd).attr("data-oet", tfEnd);
            if (!$tr.hasClass("ticket-is-staged")) {
                $tdStat.attr("data-ssd", dfStart).attr("data-sst", tfStart).attr("data-sed", dfEnd).attr("data-set", tfEnd);
                $tr.find(".table-status-colorbar").attr("class", function () {
                    return "table-status-colorbar " + $(this).attr("data-sc" + stat);
                });
                $tr.find(".table-status-text").html(function () {
                    var a = [dfStart, dfEnd];
                    var b = "";
                    if (a[stat]) b = "<span class='table-status-timeframe'>" + a[stat] + "</span>";
                    if (stat == -1) {
                        return $(this).attr("data-st");
                    } else {
                        return $(this).attr("data-st" + stat) + b;
                    }
                });
            }
            $tr.find(".table-quantity p").html(oData.qty + "<span class='table-quantity-left'>(" + stock + ")</span>");
            $tr.find(".xdata").text(JSON.stringify(oData));
            $tr.find("[name='ticketId']").val(oData.ticketId);

            //Add ticket to the staging list (palier)
            var ti = $("#tl1t_" + oData.ticketId);
            if (!ti[0]) {
                ti = $(".ticket-stage-form-ctn .tickets-list-one-ticket-temp").clone(true, true);
                ti.removeClass("tickets-list-one-ticket-temp hide").attr("id", "tl1t_" + oData.ticketId).appendTo(".manage-levels-tickets-list-ctn .tickets-list-content-ctn");
            }
            ti.attr("data-name", oData.ticketName).attr("data-price", oData.finalPrice).attr("data-number", oData.qty).attr("data-door", oData.customDoorStartDate + " " + oData.customDoorStartEnd);
            ti.find(".form-check-input").attr("id", "tl1tCb_" + oData.ticketId).val(oData.ticketId);
            ti.find(".name").text(oData.ticketName);
            ti.find(".price").text(mf);
            ti.find(".date").text(dfStart + ", " + (lang === "fr" ? oData.sellingStartTime.replace(":", "h") : oData.sellingStartTime));

            //Modify existing staged ticket (palier)
            var tir = $("#tl1tr_" + oData.ticketId);
            if (tir[0]) {
                tir.find(".table-ticket-name p").text(oData.ticketName);
                tir.find(".table-quantity p").text(oData.qty);
                tir.find(".table-money p").text(mf);
            }

            //Remove from all pooling 
            $(".event-form-pool-table tr").each(function () {
                $(this).find('.table-tickets-inner p').has('span[data-id="' + oData.ticketId + '"]').remove();
            });

            // Update Pooling if added
            if (pooling !== undefined && pooling.find("input[type='checkbox']").is(":checked")) {
                setTimeout(function () {
                    // Re-select after a delay to ensure new rows are available
                    var matchingRow = $('.event-form-pool-table tr[data-pqid="' + oData.poolId + '"]');
                    if (matchingRow.length) {
                        var newParagraph = $("<p>").append($("<span>").addClass("event-pool-ticket-name").attr("data-id", oData.ticketId).text(oData.ticketName));

                        matchingRow.find(".table-tickets-inner").append(newParagraph);
                    }
                }, 0);
            }

            updateTicketsTotal();
            //Trigger this button will clear all inputs and close the form
            $(".add-new-item-btn.ticket").trigger("click");
        };

        ajax(manageTicketsPath + "?ajax=true" + encodeURI(data), function (response) {
            if (response.trim() == "Having in packages") {
                if (lang === "fr") {
                    alert("Ce billet est inclus dans un forfait. Veuillez le retirer du forfait avant de modifier les prix..!");
                } else {
                    alert("This ticket is included in a package. Please remove the ticket from the package before changing the price..!");
                }
                _fail();
            } else if (response.trim() !== "fail") {
                _succeed(response.trim());
            } else {
                _fail();
            }
        });
    };

    var createPool = function createPool(e) {
        var form = $(this).closest(".pooling-qty-ctn"),
            inps = form.find("input, textarea, select"),
            oData = {},
            data = "";

        formValidator.validateForm(form);
        if (form.hasClass("has-error")) {
            return false;
        }

        pageScrlTo(form.parent().offset().top - 100);

        inps.each(function () {
            var name = $(this).attr("name");
            if (name && name.trim() !== "") {
                var inp = $(this),
                    type = inp.attr("type"),
                    val = inp.val().trim(),
                    checkType = type === "checkbox" || type === "radio";

                if ((checkType && inp.prop("checked") || !checkType) && !inp.hasClass("nontake")) {
                    if (inp.hasClass("datepicker")) {
                        name += "Date";
                    } else if (inp.hasClass("timepicker")) {
                        name += "Time";
                    }
                    if (!oData.hasOwnProperty(name)) oData[name] = val;
                    data += "&" + name + "=" + val;
                }
            }
        });
        data += "&active=true"; //+ (oData.active==='true'?'true':'false');

        var _succeed = function _succeed(response) {
            var $tb = $(".event-form-pool-table>tbody"),
                pos = $tb.find("tr").length,
                $tr = $tb.find("tr:eq(0)").clone(true, true),
                $tdStat = $tr.find(".table-status"),
                stat = 0,
                active = true,
                poolQty = parseInt(oData.poolQty);
            //Add ticket to the list table
            if (oData.poolId != null && oData.poolId.toString() === response) {
                $tr = $tb.find("tr[data-pqid='" + oData.poolId + "']");
                $tdStat = $tr.find(".table-status");
                oData.active = $tr.find(".table-status").attr("data-active");
                active = oData.active === "true";
                poolQty -= parseInt(oData.poolQty);
            } else {
                oData.poolId = response.trim();
                oData.active = active.toString();
                $tb.append($tr);
                $tr.removeAttr("style").removeAttr("class");
                $tr.attr("data-pqid", oData.poolId);
            }

            $tr.find(".event-form-pool-table-name").html(oData.poolName);
            $tr.find(".event-form-pool-table-pool-qty").html(oData.poolQty + "(0)");

            $tr.find(".xdata").text(JSON.stringify(oData));
            $tr.find("[name='poolId']").val(oData.poolId);

            //updateTicketsTotal();
            //Trigger this button will clear all inputs and close the form
            $(".manage-pooling-qty").trigger("click");
        };

        ajax(managePoolsPath + "?ajax=true" + encodeURI(data), function (response) {
            if (response.trim().includes("fail")) {
                if (response.trim().includes("changeQtyVialate")) {
                    var args = response.trim().split("_");
                    if (lang === "fr") {
                        alert("Des billets sont associés à ce groupe de billets. Vous devez retirer les billets de ce groupe avant de pouvoir le supprimer.");
                    } else {
                        alert("You cannot change the initial quantity than the tickets sold. You have already sold #" + args[1]);
                    }
                }
            } else if (!response.trim().includes("fail")) {
                _succeed(response.trim());
            } else {
                alert(response.trim());
            }
        });
    };

    ///////----end private link ------////////


    var modifyTicket = function modifyTicket(e) {
        var btn = $(this),
            item = btn.closest("tr");
        var form = $(".ticket-form-ctn"),
            xdata = jsonEscape(item.find(".xdata").eq(0).text()),
            oData = JSON.parse(xdata),
            isFee = $('.fee-per-ticket'),
            isPooling = $('.ticket-pool-qty'),
            poolingEnabled = false;

        pageScrlTo(form.parent().offset().top);

        if (!form.hasClass("open")) {
            $(".add-new-item-btn.ticket").trigger("click", { type: "modify" });
        }
        $(".create-ticket-btn", form).text(function () {
            return $(this).attr("data-" + lang + "-label2");
        });

        // Set event date and time on display to default
        try {
            triggerInputFocus("#customStart-date-ticket", event_start_date, "change");
            triggerInputFocus("#customStart-time-ticket", event_start_time, "change");
            triggerInputFocus("#customEnd-date-ticket", event_end_date, "change");
            triggerInputFocus("#customEnd-time-ticket", event_end_time, "change");
            triggerInputFocus("#customDoorStart-date-ticket", event_door_date, "change");
            triggerInputFocus("#customDoorStart-time-ticket", event_door_time, "change");
        } catch (ex) {}

        for (var name in oData) {
            var el = form.find("[name='" + name + "']");
            if (name.substr(name.length - 4) === "Date") {
                el = form.find(".datepicker[name='" + name.substring(0, name.length - 4) + "']");
            } else if (name.substr(name.length - 4) === "Time") {
                el = form.find(".timepicker[name='" + name.substring(0, name.length - 4) + "']");
                oData[name] = oData[name].replace("h", ":");
            }
            if (el.length > 0) {
                var type = el.attr("type");
                var value = oData[name];

                if (type === "radio") {
                    el.each(function () {
                        if ($(this).val() === value) {
                            $(this).prop("checked", true).triggerHandler("change");
                        }
                    });
                } else if (type === "checkbox") {
                    if (name === "pooling") {
                        if (value == "true") {
                            isPooling.prop("checked", true);
                            poolingEnabled = true;
                            isPooling.triggerHandler("click");
                        } else {
                            isPooling.prop("checked", false);
                            poolingEnabled = false;
                            isPooling.triggerHandler("click");
                        }
                        if (parseInt(oData.qtySold) > 0) {
                            isPooling.prop("disabled", true);
                            poolingQtySelect.prop("disabled", true);
                        } else {
                            isPooling.prop("disabled", false);
                            poolingQtySelect.prop("disabled", false);
                        }
                    } else {
                        if (el.prop("checked") !== (el.val() === value)) {
                            el.trigger("click").triggerHandler("change");
                        }
                    }
                } else {
                    if (name === "feePerTicket") {
                        if (!isFee.is(":checked")) {
                            value = 0;
                        }
                    }

                    if (name === "poolId") {
                        $(".poolingQtyId").val(value);
                    }

                    if (el[0].tagName === 'TEXTAREA') {
                        value = value.replace(/(?:\\r\\n|\\r|\\n)/g, '\n');
                    }

                    el.val(value);

                    if (type !== "hidden") {
                        el.triggerHandler("blur");
                        triggerInputFocus(el);
                    }
                }
                if (el.closest(".ticket-displayed-info-box-popup-content").length > 0) {
                    el.closest(".ticket-displayed-info-box-popup-content").find(".modify-ticket-display-btn").click();
                }
            }
        }
        calcTicketPriceFinal(e, $(".ticket-price-input-raw:not(.ticket-price-door-input-raw)"));

        var esd = event_start_date.replace(/\//g, "-") + "T" + (event_start_time && event_start_time !== "" ? event_start_time + ":00.0" : "00:00:00.0");
        var eed = event_end_date.replace(/\//g, "-") + "T" + (event_end_time && event_end_time !== "" ? event_end_time + ":00.0" : "00:00:00.0");
        var start = new Date(esd);
        var end = new Date(eed);
        var today = new Date();
        // Prevent door price change after the event started or at least 1 ticket has been sold
        var doorPriceCtn = form.find(".ticket-door-price-ctn");
        if (parseInt(oData.qtySold) > 0 || start && start.getTime() < today.getTime()) {
            doorPriceCtn.addClass("soldisabled").attr("tabIndex", "-1");
            if (oData.doorPriceActivated === "true") {
                doorPriceCtn.show();
                doorPriceCtn.find(".ticket-price-door-choice").addClass("disabled").prop("disabled", true).closest(".form-checkbox-ctn").addClass("disabled disabled-ctn");
                doorPriceCtn.find(".ticket-price-input-final, .ticket-price-input-raw").removeClass("success error").addClass("disabled").prop("disabled", true).closest(".input-ctn").addClass("disabled disabled-ctn");
            } else {
                doorPriceCtn.hide();
            }
        } else {
            doorPriceCtn.removeClass("soldisabled").removeAttr("tabIndex").show();
            doorPriceCtn.find(".ticket-price-door-choice").removeClass("disabled").prop("disabled", false).closest(".form-checkbox-ctn").removeClass("disabled disabled-ctn");
            doorPriceCtn.find(".ticket-price-input-final, .ticket-price-input-raw").removeClass("disabled").prop("disabled", false).closest(".input-ctn").removeClass("disabled disabled-ctn");
        }
        // Prevent online price change if a ticket was bought or event has ended
        var onlinePriceCtn = form.find(".ticket-online-price-ctn");
        if (parseInt(oData.qtySold) > 0 || parseInt(oData.inventory) > 0 || end && end.getTime() < today.getTime()) {
            onlinePriceCtn.addClass("soldisabled").attr("tabIndex", "-1");
            onlinePriceCtn.find(".ticket-price-input-final, .ticket-price-input-raw").removeClass("success error").addClass("disabled").prop("disabled", true).closest(".input-ctn").addClass("disabled disabled-ctn");
            if (oData.free === "false") {
                onlinePriceCtn.find(".ticket-price-online-choice.pay").addClass("disabled").prop("disabled", true).closest(".form-checkbox-ctn").addClass("disabled disabled-ctn").show();
                onlinePriceCtn.find(".ticket-price-online-choice.free").addClass("disabled").prop("disabled", true).closest(".form-checkbox-ctn").addClass("disabled disabled-ctn").hide();
            } else {
                onlinePriceCtn.find(".ticket-price-online-choice.free").addClass("disabled").prop("disabled", true).closest(".form-checkbox-ctn").addClass("disabled disabled-ctn").show();
                onlinePriceCtn.find(".ticket-price-online-choice.pay").addClass("disabled").prop("disabled", true).closest(".form-checkbox-ctn").addClass("disabled disabled-ctn").hide();
            }
        } else {
            onlinePriceCtn.removeClass("soldisabled").removeAttr("tabIndex");
            onlinePriceCtn.find(".ticket-price-input-final, .ticket-price-input-raw").removeClass("disabled").prop("disabled", false).closest(".input-ctn").removeClass("disabled disabled-ctn");
            onlinePriceCtn.find(".ticket-price-online-choice").removeClass("disabled").prop("disabled", false).closest(".form-checkbox-ctn").removeClass("disabled disabled-ctn").show();
        }

        form.find(".ticket-form-info-quantity-sold").text(oData.inventory);
        if (!poolingEnabled) {
            form.find(".ticket-form-info-quantity-remain").text(parseInt(oData.qty) - parseInt(oData.inventory));
        }

        if (oData.customDoorStartDate && oData.customDoorStartDate !== oData.customStartDate) {
            $("#create-ticket-door-other-date").trigger("click");
        }
    };
    var modifyPool = function modifyPool(e) {
        var btn = $(this),
            item = btn.closest("tr");
        var form = $(".pooling-qty-ctn"),
            xdata = jsonEscape(item.find(".xdata").eq(0).text()),
            oData = JSON.parse(xdata);

        pageScrlTo(form.parent().offset().top);

        if (!form.hasClass("open")) {
            $(".manage-pooling-qty").trigger("click", { type: "modify" });
        }
        $(".create-pool-btn", form).text(function () {
            return $(this).attr("data-" + lang + "-label2");
        });

        for (var name in oData) {
            var el = form.find("[name='" + name + "']");

            if (el.length > 0) {
                var type = el.attr("type");
                var value = oData[name];

                if (type === "radio") {
                    el.each(function () {
                        if ($(this).val() === value) {
                            $(this).prop("checked", true).triggerHandler("change");
                        }
                    });
                } else if (type === "checkbox") {
                    if (el.prop("checked") !== (el.val() === value)) {
                        el.trigger("click").triggerHandler("change");
                    }
                } else {

                    if (el[0].tagName === 'TEXTAREA') {
                        value = value.replace(/(?:\\r\\n|\\r|\\n)/g, '\n');
                    }

                    el.val(value);

                    if (type !== "hidden") {
                        el.triggerHandler("blur");
                        triggerInputFocus(el);
                    }
                }
            }
        }
    };

    var sortableOptions = function sortableOptions(what) {
        var _updateTickets = function _updateTickets(ui) {
            var $el = ui.item,
                $list = $el.parent().children(),
                sel = ".table-position p",
                cur = parseInt($el.attr("data-index")),
                pos = $el.index(),
                s = $list.length - 1;

            $el.removeAttr("data-index");
            if (cur !== pos) {
                ajax(manageTicketsPath + "?ajax=true&ticketId=" + $el.attr("data-tkid") + "&eventId=" + $el.attr("data-evid") + "&targetPosition=" + (pos - 1), function (response) {
                    if (response.trim() !== "fail") {
                        for (var i = 1; i <= s; i++) {
                            var row = $list.eq(i);
                            row.find(sel).html(i);
                        }
                    } else {
                        $el.insertBefore($list.eq(cur < pos ? cur : cur + 1));
                    }
                });
            }
        };
        var _updateTicketStage = function _updateTicketStage(ui) {
            var $el = ui.item,
                $list = $el.parent().children(),
                sel = ".table-position p",
                cur = parseInt($el.attr("data-index")),
                pos = $el.index(),
                s = $list.length - 1;

            $el.removeAttr("data-index");
            if (cur !== pos) {
                for (var i = 1; i <= s; i++) {
                    var row = $list.eq(i);
                    row.find(sel).html(i);
                }
                if (pos === s) {
                    var id = $el.attr("id").split("_")[1];
                    defaultStageEndDate($("#tl1t_" + id).attr("data-door"));
                }
            }
        };

        var _updatePackage = function _updatePackage(ui) {
            var $el = ui.item,
                $list = $el.parent().children(),
                sel = ".table-position p",
                cur = parseInt($el.attr("data-index")),
                pos = $el.index(),
                s = $list.length - 1;

            $el.removeAttr("data-index");
            if (cur !== pos) {
                ajax(managePackagePath + "?ajax=true&passId=" + $el.attr("data-pkid") + "&eventId=" + $el.attr("data-evid") + "&targetPosition=" + (pos - 1), function (response) {
                    if (response.trim() !== "fail") {
                        for (var i = 1; i <= s; i++) {
                            var row = $list.eq(i);
                            row.find(sel).html(i);
                        }
                    } else {
                        $el.insertBefore($list.eq(cur < pos ? cur : cur + 1));
                    }
                });
            }
        };
        var _updateMerch = function _updateMerch(ui) {
            var $el = ui.item,
                $list = $el.parent().children(),
                sel = ".table-position p",
                cur = parseInt($el.attr("data-index")),
                pos = $el.index(),
                s = $list.length - 1;

            $el.removeAttr("data-index");
            if (cur !== pos) {
                ajax(manageMerchPath + "?ajax=true&linkId=" + $el.attr("data-linkid") + "&productId=" + $el.attr("data-productid") + "&eventId=" + $el.attr("data-evid") + "&targetPosition=" + pos, function (response) {
                    if (response.trim() !== "fail") {
                        for (var i = 0; i <= s; i++) {
                            var row = $list.eq(i);
                            row.find(sel).html(i + 1);
                        }
                    } else {
                        $el.insertBefore($list.eq(cur < pos ? cur : cur + 1));
                    }
                });
            }
        };
        var o = {
            items: "tr",
            handle: ".table-position-btn",
            helper: function helper(e, tr) {
                var $originals = tr.children();
                var $helper = tr.clone();
                $helper.children().each(function (index) {
                    // Set helper cell sizes to match the original sizes
                    $(this).width($originals.eq(index).outerWidth());
                });
                return $helper;
            },
            cancel: "input,textarea,select,option",
            revert: false,
            tolerance: "pointer",
            scrollSensitivity: 60,
            scrollSpeed: 30,
            start: function start(e, ui) {
                var $el = ui.item;
                $el.attr("data-index", $el.index());
            },
            stop: function stop(e, ui) {
                switch (what) {
                    case "ticket":
                        _updateTickets(ui);
                        break;
                    case "stage":
                        _updateTicketStage(ui);
                        break;
                    case "package":
                        _updatePackage(ui);
                        break;
                    case "merch":
                        _updateMerch(ui);
                        break;
                }
            }
        };
        return o;
    };

    var sortItemUp = function sortItemUp(e) {
        var it = $(this),
            el = it.closest("tr"),
            sib = el.prev(),
            cur = el.index();

        var _move = function _move() {
            el.insertBefore(sib);
            el.find(".table-position p").html(cur - 1);
            sib.find(".table-position p").html(cur);
        };
        var _complete = function _complete(response) {
            if (response.trim() !== "fail") _move();
        };

        if (cur > 1) {
            // Deduct 1 extra position as there is 1 template element at index 0
            var targetIndex = cur - 2;
            switch (el.attr("data-type")) {
                case "ticket":
                    ajax(manageTicketsPath + "?ajax=true&ticketId=" + el.attr("data-tkid") + "&eventId=" + el.attr("data-evid") + "&targetPosition=" + targetIndex, _complete);
                    break;
                case "stage":
                    if (el.next().length === 0) {
                        var id = sib.attr("id").split("_")[1];
                        defaultStageEndDate($("#tl1t_" + id).attr("data-door"));
                    }
                    _move();
                    break;
                case "package":
                    ajax(managePackagePath + "?ajax=true&passId=" + el.attr("data-pkid") + "&eventId=" + el.attr("data-evid") + "&targetPosition=" + targetIndex, _complete);
                    break;
            }
        }
    };

    var sortItemDown = function sortItemDown(e) {
        var it = $(this),
            el = it.closest("tr"),
            sib = el.next(),
            cur = el.index();

        var _move = function _move() {
            sib.insertBefore(el);
            el.find(".table-position p").html(cur + 1);
            sib.find(".table-position p").html(cur);
        };
        var _complete = function _complete(response) {
            if (response.trim() !== "fail") _move();
        };

        if (sib.length > 0) {
            // Deduct 1 extra position as there is 1 template element at index 0
            var targetIndex = cur;
            switch (el.attr("data-type")) {
                case "ticket":
                    ajax(manageTicketsPath + "?ajax=true&ticketId=" + el.attr("data-tkid") + "&eventId=" + el.attr("data-evid") + "&targetPosition=" + targetIndex, _complete);
                    break;
                case "stage":
                    _move();
                    if (el.next().length === 0) {
                        var id = el.attr("id").split("_")[1];
                        defaultStageEndDate($("#tl1t_" + id).attr("data-door"));
                    }
                    break;
                case "package":
                    ajax(managePackagePath + "?ajax=true&passId=" + el.attr("data-pkid") + "&eventId=" + el.attr("data-evid") + "&targetPosition=" + targetIndex, _complete);
                    break;
            }
        }
    };

    var confirmDeleteTicket = function confirmDeleteTicket(e) {
        var btn = $(this);
        e.stopImmediatePropagation();
        var item = e.data.item,
            evid = item.attr("data-evid"),
            tkid = item.attr("data-tkid");

        ajax(manageTicketsPath + "?ajax=true&eventId=" + evid + "&delete=true&ticketId=" + tkid, function (response) {
            if (response.trim() !== "fail") {
                var table = $('tr[data-tkid=' + tkid + ']').closest('.event-form-tickets-table');
                item.remove();
                if ($("#ticketFormTkId").val() === tkid) {
                    $(".ticket-form-ctn .close-toggle-form-btn").click();
                }
                $("#tl1t_" + tkid).remove();
                $("#tl1tr_" + tkid).remove();
                updateTicketsTotal();
                delete _PASSTICKETS[tkid];

                if (table.find('tbody tr:not(.event-form-tickets-row-temp)').length === 0) {
                    table.fadeOut(function () {
                        $('.no-elements-to-display-msg.tickets').fadeIn();
                    });
                }
            }
        });
        closeWindow("deleteTicketConfirmPopup");
    };

    var deleteTicket = function deleteTicket() {
        var btnDel = $(this),
            data = { item: btnDel.closest("tr") },
            btnYes = $("#deleteTicketConfirmPopup .popup-btn-confirm"),
            btnNo = $("#deleteTicketConfirmPopup .popup-btn-cancel");

        btnYes.one("click", data, confirmDeleteTicket);
        btnNo.one("click", function (e) {
            btnYes.off("click", confirmDeleteTicket);
            closeWindow("deleteTicketConfirmPopup");
        });
        $("#deleteTicketConfirmPopup").css("position", "absolute");
        openWindow("deleteTicketConfirmPopup", true);
    };

    var toggleTicketSale = function toggleTicketSale() {
        var btn = $(this),
            item = btn.closest("tr"),
            qeid = "&eventId=" + item.data("evid"),
            qtid = "&ticketId=" + item.data("tkid"),
            elCell = item.find(".table-status"),
            elColor = item.find(".table-status-colorbar"),
            elText = item.find(".table-status-text"),
            sus = "suspend-sale-btn",
            act = "activate-sale-btn";

        if (btn.hasClass(sus)) {
            ajax(manageTicketsPath + "?ajax=true&active=false" + qeid + qtid, function (response) {
                if (response.trim() !== "fail") {
                    btn.addClass(act).removeClass(sus);
                    elCell.attr("data-active", "false");
                    elColor.attr("class", "table-status-colorbar " + elColor.attr("data-sc"));
                    elText.html(elText.attr("data-st"));
                }
            });
        } else if (btn.hasClass(act)) {
            ajax(manageTicketsPath + "?ajax=true&active=true" + qeid + qtid, function (response) {
                if (response.trim() !== "fail") {
                    btn.addClass(sus).removeClass(act);
                    elCell.attr("data-active", "true");
                    elColor.attr("class", "table-status-colorbar " + elColor.attr("data-sc1"));
                    elText.html(elText.attr("data-st1") + "<span class='table-status-timeframe'>" + elCell.attr("data-sed") + "</span>");
                    var data = {
                        stat: elCell.attr("data-stat"),
                        ssd: elCell.attr("data-ssd"),
                        sed: elCell.attr("data-esd"),
                        dateList: [this.ssd, this.sed],
                        date: ""
                    };
                    elColor.attr("class", "table-status-colorbar " + elColor.attr("data-sc" + data.stat));
                    if (data.dateList[data.stat]) data.date = "<span class='table-status-timeframe'>" + data.dateList[data.stat] + "</span>";
                    elText.html(elText.attr("data-st" + data.stat) + data.date);
                }
            });
        }
    };

    var setDoorDate = function setDoorDate(e) {
        if (!$(e.data[0]).prop("checked")) {
            $(e.data[1]).val($(this).val()).change().parent().addClass("focused");
        }
    };

    var defaultStageEndDate = function defaultStageEndDate(datetime) {
        if (event_recur_type === "multiple-days" && $("#stageFormId").val() === "") {
            try {
                var doorDate = new Date(datetime),
                    openTime = new Date(doorDate.setTime(doorDate.getTime() - 60000 * 15));

                triggerInputFocus("#palierEnd-date-0", openTime.getFullYear() + "/" + formatZeros(openTime.getMonth() + 1) + "/" + formatZeros(openTime.getDate()), "change");
                triggerInputFocus("#palierEnd-time-0", openTime.getHours() + ":" + formatZeros(openTime.getMinutes()), "change");
            } catch (err) {}
        }
    };

    var addOrRemoveStageTicket = function addOrRemoveStageTicket(e) {
        var cb = $(this),
            remove = !cb.prop("checked"),
            id = cb.val(),
            tb = $(".tickets-stage-table>tbody"),
            tr = remove ? $("#tl1tr_" + id) : $(".tickets-list-trow-temp", tb).clone(true, true);

        if (cb.prop("disabled")) {
            return false;
        }
        if (remove) {
            var pos = parseInt(tr.find(".table-position p").text());

            tr.nextAll("tr").each(function (i) {
                $(this).find(".table-position p").text(pos++);
            });
            tr.remove();
        } else {
            var item = cb.closest(".tickets-list-one-ticket-ctn"),
                data = item.data(),
                fp = parseFloat(data.price),
                mf = 0;

            try {
                mf = fp === 0 ? lang === "fr" ? "gratuit" : "free" : formatMoney(fp);
            } catch (ex) {}
            tr.removeAttr("style").removeAttr("class").attr("id", "tl1tr_" + id);
            tr.find(".table-position p").text(tb.children().length);
            tr.find(".table-ticket-name p").text(data.name);
            tr.find(".table-money p").text(mf);
            tr.find(".table-quantity p").text(data.number);
            tr.appendTo(tb);
            // "La date de fin devrait etre 15 minutes avant l'ouverture des porte 
            // du dernier billets du palier". Recurrent event.
            defaultStageEndDate(data.door);
        }
    };

    var removeStageTicket = function removeStageTicket(e) {
        var tr = $(this).closest("tr"),
            id = tr.attr("id").split("_")[1];

        $("#tl1tCb_" + id).click();
    };

    var saveStageTicket = function saveStageTicket(e) {
        var form = $(".ticket-stage-form-ctn");

        formValidator.validateForm(form);
        if (form.hasClass("has-error")) {
            return false;
        }

        var eid = $("#ticketFormEvId").val(),
            pid = $("#stageFormId").val(),
            data = "?ajax=true&eventId=" + eid + "&palierId=" + pid,
            oData = {},
            list = "";

        var _complete = function _complete(resp) {
            if (resp !== "fail") {
                if (pid !== "") {
                    $("#stageFormId").val(resp.trim());
                }
                $(".event-form-tickets-table>tbody>tr:gt(0)").each(function () {
                    var tr = $(this),
                        tdStat = tr.find(".table-status"),
                        tdData = getDataSet(tdStat[0]),
                        toChange = tdData.stat != -1 && tdData.stat != 3 && tdData.active,
                        cls = "ticket-is-staged",
                        ctnq = ".ticket-stage-form-ctn",
                        arrRaw = [$("#systemCurrentDate").val() + $("#systemCurrentTime").val().replace(":", "")],
                        arrFormatted = [];

                    if (oData.ticketIds.indexOf(tr.attr("data-tkid")) > -1) {
                        tr.addClass(cls);
                        arrFormatted[0] = getDatePrefix(oData, "palierStart");
                        arrFormatted[1] = getDatePrefix(oData, "palierEnd");
                        arrFormatted[2] = getTimePrefix(oData, "palierStart");
                        arrFormatted[3] = getTimePrefix(oData, "palierEnd");
                        if (toChange) {
                            arrRaw[1] = getDateByName(ctnq, "palierStartDate") + getTimeByName(ctnq, "palierStartDate");
                            arrRaw[2] = getDateByName(ctnq, "palierEndDate") + getTimeByName(ctnq, "palierEndDate");
                            tdData.stat = getStatusValue(arrRaw[0], arrRaw[1], arrRaw[2], true, 1);
                            tdStat.attr("data-stat", tdData.stat);
                            tdStat.find(".table-status-text").html(getStatusText(tdData.stat, arrFormatted));
                            tdStat.find(".table-status-colorbar").attr("class", "table-status-colorbar " + getStatusColor(tdData.stat, true));
                        }
                        tdStat.attr("data-ssd", arrFormatted[0]).attr("data-sst", arrFormatted[2]).attr("data-sed", arrFormatted[1]).attr("data-set", arrFormatted[3]);
                    } else if (tr.hasClass(cls)) {
                        tr.removeClass("ticket-is-staged");
                        arrFormatted = [tdData.osd, tdData.oed, tdData.ost, tdData.oet];
                        if (toChange) {
                            arrRaw[1] = parseFormattedDate(arrFormatted[0]) + arrFormatted[2].replace(/[h:]/, "");
                            arrRaw[2] = parseFormattedDate(arrFormatted[1]) + arrFormatted[3].replace(/[h:]/, "");
                            tdData.stat = getStatusValue(arrRaw[0], arrRaw[1], arrRaw[2], true, 1);
                            tdStat.attr("data-stat", tdData.stat);
                            tdStat.find(".table-status-text").html(getStatusText(tdData.stat, arrFormatted));
                            tdStat.find(".table-status-colorbar").attr("class", "table-status-colorbar " + getStatusColor(tdData.stat, true));
                        }
                        tdStat.attr("data-ssd", arrFormatted[0]).attr("data-sst", arrFormatted[2]).attr("data-sed", arrFormatted[1]).attr("data-set", arrFormatted[3]);
                    }
                });
                form.find(".close-toggle-form-btn").click();
            } else {}
        };

        $(".ticket-stage-form-ctn .event-datetime-start-and-end-ctn input[type='hidden']").each(function () {
            var inp = $(this);
            data += "&" + inp.attr("name") + "=" + inp.val().trim();
            oData[inp.attr("name")] = inp.val().trim();
        });
        if ($("#stageFormHideInactive").prop("checked")) {
            data += "&hideInactive=on";
            oData.hideInactive = "on";
        }
        oData.ticketIds = ["0"];
        $(".tickets-stage-table>tbody tr").each(function (index) {
            if (index > 0) {
                var id = $(this).attr("id");
                var idn = id.substr(id.indexOf("_") + 1);
                list += (list === "" ? "" : ",") + idn;
                oData.ticketIds[index] = idn;
            }
        });
        data += "&ticketIds=" + list;

        ajax(managePalierPath + encodeURI(data), _complete);
    };

    var showTicketList = function showTicketList(e) {
        $(this).parent().toggleClass("list-open");
        $(this).next().slideToggle(200);
    };

    var addTicketToPackage = function addTicketToPackage(e, ctn, source, rebates) {
        var id = $(source).attr("data-id"),
            $target = $(ctn).find(".tickets-list-one-ticket-ctn[data-id='" + id + "']"),
            $folder = $target.closest(".event-folder-single"),
            locked = $(ctn).closest(".soldlocked").length !== 0,
            // If the package was sold at least 1, its modification is locked
        packageTypeMulti = $(".package-multiple-choice input").is(":checked");

        $target.removeClass("hide").addClass("selected");
        if (rebates !== undefined && rebates !== '') {
            $target.find(".package-ticket-rebate input").val(rebates.rebate);
            $target.find(".package-ticket-door-rebate input").val(rebates.doorRebate);
        }

        /*Calculate rebates on pass - setup online & door rebate inputs */
        if (!locked) {
            $target.find("input.float-number").keydown(numLockFloat);
            if (packageTypeMulti) {
                var reb = $(".tickets-list-one-ticket-ctn.selected input[name = 'rebate'][value != '']").val();
                var rebDoor = $(".tickets-list-one-ticket-ctn.selected input[name = 'doorRebate'][value != '']").val();
                $target.closest(".event-folders-tickets-list").find(".package-ticket-rebate input").val(reb);
                $target.closest(".event-folders-tickets-list").find(".package-ticket-door-rebate input").val(rebDoor);
            }
            $target.find(".package-ticket-rebate input").keyup(calculatePackagePrice);
            $target.find(".package-ticket-door-rebate input").keyup(calculatePackageDoorPrice);
        } else {
            $target.find(".package-ticket-rebate-number-input-ctn").removeClass("focused");
            $target.find("input.float-number").addClass("disabled").prop("disabled", true);
        }
        calculatePackagePrice();
        calculatePackageDoorPrice();

        if ($(".ticket-price-door-choice[name = 'passDoorPriceActivated']").is(":checked")) {
            $target.find(".package-ticket-door-rebate").addClass("activated");
        } else {
            $target.find(".package-ticket-door-rebate").removeClass("activated");
        }

        if ($(".ticket-price-online-choice[name = 'passFree']:checked").val() === 'true') {
            $target.find(".package-ticket-rebate").addClass("disabled");
        } else {
            $target.find(".package-ticket-rebate").removeClass("disabled");
        }

        $(source).addClass("ui-dropped");
        if (!$folder.hasClass("list-open")) {
            $folder.removeClass("hide");
            showTicketList.apply($folder.find(".tickets-list-header-outer-ctn")[0]);
        }

        if (e === null) return;

        // Par d�faut, la date/heure "au" est plac�e au m�me moment que celle du 
        // billet qui a la date de fin de mise en vente la plus tardive, parmi les 
        // billets inclus dans le forfait.
        var inpED = d.getElementById("passEnd-date-4"),
            inpET = d.getElementById("passEnd-time-4"),
            inDate = new Date(inpED.value + " " + inpET.value),
            ed = $(source).attr("data-end"),
            srcDate = new Date(ed);

        if (inDate < srcDate || inpED.value === "") {
            triggerInputFocus(inpED, ed.substring(0, 11), "change");
        }
        if (inDate < srcDate || inpET.value === "") {
            triggerInputFocus(inpET, ed.substring(11), "change");
        }
    };

    var addTicketToPrivateLink = function addTicketToPrivateLink(e, ctn, source, rebates) {
        var id = $(source).attr("data-id"),
            $target = $(ctn).find(".private-tickets-list-one-ticket-ctn[data-id='" + id + "']"),
            $folder = $target.closest(".private-event-folder-single"),
            locked = $(ctn).closest(".soldlocked").length !== 0,
            // If the package was sold at least 1, its modification is locked
        packageTypeMulti = $(".package-multiple-choice input").is(":checked");

        $target.removeClass("hide").addClass("selected");
        if (rebates !== undefined && rebates !== '') {
            $target.find(".package-ticket-rebate input").val(rebates.rebate);
            $target.find(".package-ticket-door-rebate input").val(rebates.doorRebate);
        }

        // /*Calculate rebates on pass - setup online & door rebate inputs */
        // if (!locked) {
        //     $target.find("input.float-number").keydown(numLockFloat);
        //     if(packageTypeMulti){
        //         var reb = $(".private-tickets-list-one-ticket-ctn.selected input[name = 'rebate'][value != '']").val();
        //         var rebDoor = $(".private-tickets-list-one-ticket-ctn.selected input[name = 'doorRebate'][value != '']").val();
        //         // $target.closest(".private-event-folders-tickets-list").find(".package-ticket-rebate input").val(reb);
        //         // $target.closest(".private-event-folders-tickets-list").find(".package-ticket-door-rebate input").val(rebDoor);
        //     }
        //     // $target.find(".package-ticket-rebate input").keyup(calculatePackagePrice);
        //     // $target.find(".package-ticket-door-rebate input").keyup(calculatePackageDoorPrice);
        // } else {
        //     $target.find(".package-ticket-rebate-number-input-ctn").removeClass("focused");
        //     $target.find("input.float-number").addClass("disabled").prop("disabled", true);
        // }
        // calculatePackagePrice();
        // calculatePackageDoorPrice();

        // if ($(".ticket-price-door-choice[name = 'passDoorPriceActivated']").is(":checked")) {
        //     $target.find(".package-ticket-door-rebate").addClass("activated");
        // } else {
        //     $target.find(".package-ticket-door-rebate").removeClass("activated");
        // }
        //
        // if ($(".ticket-price-online-choice[name = 'passFree']:checked").val() === 'true') {
        //     $target.find(".package-ticket-rebate").addClass("disabled");
        // } else {
        //     $target.find(".package-ticket-rebate").removeClass("disabled");
        // }

        $(source).addClass("ui-dropped");
        if (!$folder.hasClass("list-open")) {
            $folder.removeClass("hide");
            showTicketList.apply($folder.find(".private-tickets-list-header-outer-ctn")[0]);
        }

        if (e === null) return;

        // Par d�faut, la date/heure "au" est plac�e au m�me moment que celle du
        // billet qui a la date de fin de mise en vente la plus tardive, parmi les
        // billets inclus dans le forfait.
        var inpED = d.getElementById("passEnd-date-4"),
            inpET = d.getElementById("passEnd-time-4"),
            inDate = new Date(inpED.value + " " + inpET.value),
            ed = $(source).attr("data-end"),
            srcDate = new Date(ed);

        if (inDate < srcDate || inpED.value === "") {
            triggerInputFocus(inpED, ed.substring(0, 11), "change");
        }
        if (inDate < srcDate || inpET.value === "") {
            triggerInputFocus(inpET, ed.substring(11), "change");
        }
    };

    function updateAllRebateValues() {
        var t = $(this);
        var reb = t.val();
        if (t.closest(".package-ticket-rebate").length !== 0) {
            t.closest(".event-folders-tickets-list").find(".package-ticket-rebate input").val(reb);
            calculatePackagePrice();
        }
        if (t.closest(".package-ticket-door-rebate").length !== 0) {
            t.closest(".event-folders-tickets-list").find(".package-ticket-door-rebate input").val(reb);
            calculatePackageDoorPrice();
        }
    }
    function getMinValue(name) {
        var max = [];
        var i = 0;
        $(".tickets-list-one-ticket-ctn.selected input[name = '" + name + "']").each(function () {
            var num;
            if (name == 'doorRebate') {
                num = $(this).attr("data-doorprice");
            } else {
                num = $(this).attr("max");
            }
            max[i] = parseFloat(num);
            i++;
        });
        if (max.length === 0) {
            max[0] = -1;
        }
        return Math.min.apply(Math, max);
    }

    function balanceTicketsValues(name, val, max) {
        var finalVal = 0;
        if (val !== undefined) {
            finalVal = max - val;
            if (finalVal < 0) {
                finalVal = 0;
            }
        } else {
            if (name == 'doorRebate') {
                finalVal = $(".tickets-list-one-ticket-ctn.selected input[name = " + name + "]").attr("data-doorprice") - $(".tickets-list-one-ticket-ctn.selected input[name = " + name + "]").val();
            } else {
                finalVal = $(".tickets-list-one-ticket-ctn.selected input[name = " + name + "]").attr("max") - $(".tickets-list-one-ticket-ctn.selected input[name = " + name + "]").val();
            }
        }
        var minVal = getMinValue(name);
        if (minVal !== -1 && finalVal > minVal) {
            finalVal = minVal;
        }
        $(".tickets-list-one-ticket-ctn.selected input[name = " + name + "]").each(function () {
            if (name == 'doorRebate') {
                $(this).val($(this).attr("data-doorprice") - finalVal);
            } else {
                $(this).val($(this).attr("max") - finalVal);
            }
        });
    }
    //Automatically calculates the raw price by deducting the rebates entered for the online price
    var calculatePackagePrice = function calculatePackagePrice(e) {
        var t = $(this);
        var val = t.val(); //rebate applied
        var max = t.attr("max"); //original price
        var packageMulti = $(".package-multiple-choice input").is(":checked");
        if (parseFloat(val) > parseFloat(max)) {
            t.val(max);
        }
        if (packageMulti) {
            balanceTicketsValues("rebate", val, max);
        }

        var isFree = $(".ticket-price-online-choice").val();
        if (isFree === 'false') {
            var total = 0;
            var values = [];
            var ctn = $(".tickets-price-online .ticket-price-input-raw").closest(".box-content-ticket-price");
            var inpServFee = ctn.find(".pass-fee-price-inputs-ctn input[name = 'passServiceFee']");
            values['price'] = 0;
            values['fees'] = 0;
            values['service_fee'] = 0;
            values['total'] = 0;
            if (packageMulti) {
                var reb = $(".tickets-list-one-ticket-ctn.selected input[name = 'rebate']").val();
                var maxVal = $(".tickets-list-one-ticket-ctn.selected input[name = 'rebate']").attr("max");
                // total = (maxVal - reb) * $(".package-multiple-choice-number input").val();
                var quantity = $(".package-multiple-choice-number input").val();
                var pp = maxVal - reb;
                var da = ctn.data(),
                    a = isNaN(da.base) ? 1 : parseFloat(da.base),
                    b = isNaN(da.percent) ? 0.03 : parseFloat(da.percent) / 100,
                    c = isNaN(da.tax1) || isNaN(da.tax2) ? 1.14975 : parseFloat(da.tax1) + parseFloat(da.tax2) + 1,
                    min = 0,
                    p = !isNaN(pp) && pp !== '' ? formatDecimal2(Math.max(parseFloat(pp), min)) : 0,
                    f = formatDecimal2((a + b * p) * c),
                    sf = inpServFee.length !== 0 && !isNaN(inpServFee.val()) && inpServFee.val() !== '' && parseFloat(pp).toFixed(2) !== '0.00' ? formatDecimal2(parseFloat(inpServFee.val())) : 0,
                    _t = formatDecimal(p + f + sf);
                // Revised EP fee ticket level rounded calculations
                var ep_fee = Math.round((1 + da.percent * pp / 100) * 100) / 100;
                var tax1 = Math.round(da.tax1 * ep_fee * 100) / 100;
                var tax2 = Math.round(da.tax2 * ep_fee * 100) / 100;
                f = formatDecimal2(ep_fee + tax1 + tax2);
                _t = formatDecimal(p + f + sf);
                console.log(f);
                console.log(quantity);
                values['price'] = formatDecimal2(p * quantity);
                values['fees'] = formatDecimal2(f * quantity);
                values['service_fee'] = formatDecimal2(sf * quantity);
                values['total'] = formatDecimal2(_t * quantity);
                console.log(values);
            } else {
                $(".tickets-list-one-ticket-ctn.selected input[name = 'rebate']").each(function () {
                    // total += $(this).attr("max") - $(this).val();
                    var pp = $(this).attr("max") - $(this).val();
                    var da = ctn.data(),
                        a = isNaN(da.base) ? 1 : parseFloat(da.base),
                        b = isNaN(da.percent) ? 0.03 : parseFloat(da.percent) / 100,
                        c = isNaN(da.tax1) || isNaN(da.tax2) ? 1.14975 : parseFloat(da.tax1) + parseFloat(da.tax2) + 1,
                        min = 0,
                        p = !isNaN(pp) && pp !== '' ? formatDecimal2(Math.max(parseFloat(pp), min)) : 0,
                        f = formatDecimal2((a + b * p) * c),
                        sf = inpServFee.length !== 0 && !isNaN(inpServFee.val()) && inpServFee.val() !== '' && parseFloat(pp).toFixed(2) !== '0.00' ? formatDecimal2(parseFloat(inpServFee.val())) : 0,
                        t = formatDecimal(p + f + sf);
                    // Revised EP fee ticket level rounded calculations
                    var ep_fee = Math.round((1 + da.percent * pp / 100) * 100) / 100;
                    var tax1 = Math.round(da.tax1 * ep_fee * 100) / 100;
                    var tax2 = Math.round(da.tax2 * ep_fee * 100) / 100;
                    f = formatDecimal2(ep_fee + tax1 + tax2);
                    t = formatDecimal(p + f + sf);
                    console.log(f);
                    values['price'] += formatDecimal2(p);
                    values['fees'] += formatDecimal2(f);
                    values['service_fee'] += formatDecimal2(sf);
                    values['total'] += formatDecimal2(t);
                    console.log(values);
                });
            }

            $(".tickets-price-online .ticket-price-input-raw").val(total);
            // calcTicketPriceFinal(e, $(".tickets-price-online .ticket-price-input-raw"));
            applyPackagePriceFinal(e, $(".tickets-price-online .ticket-price-input-raw"), values);
        }
    };
    //Automatically calculates the raw price by deducting the rebates entered for the door price
    var calculatePackageDoorPrice = function calculatePackageDoorPrice(e) {
        var t = $(this);
        var val = t.val();
        var max = t.attr("data-doorprice");
        var packageMulti = $(".package-multiple-choice input").is(":checked");
        if (parseInt(val) > parseInt(max)) {
            t.val(max);
        }
        if (packageMulti) {
            balanceTicketsValues("doorRebate", val, max);
        }

        var total = 0;
        var values = [];
        var ctn = $(".ticket-price-door-input-raw").closest(".box-content-ticket-price");
        var inpServFee = ctn.find(".pass-fee-price-inputs-ctn input[name = 'passServiceFee']");
        values['price'] = 0;
        values['fees'] = 0;
        values['service_fee'] = 0;
        values['total'] = 0;
        if (packageMulti) {
            var reb = $(".tickets-list-one-ticket-ctn.selected input[name = 'doorRebate']").val();
            var maxVal = $(".tickets-list-one-ticket-ctn.selected input[name = 'doorRebate']").attr("data-doorprice");
            // total = (maxVal - reb) * $(".package-multiple-choice-number input").val();
            var quantity = $(".package-multiple-choice-number input").val();
            var pp = maxVal - reb;
            var da = ctn.data(),
                a = isNaN(da.base) ? 1 : parseFloat(da.base),
                b = isNaN(da.percent) ? 0.03 : parseFloat(da.percent) / 100,
                c = isNaN(da.tax1) || isNaN(da.tax2) ? 1.14975 : parseFloat(da.tax1) + parseFloat(da.tax2) + 1,
                min = 0,
                p = !isNaN(pp) && pp !== '' ? formatDecimal2(Math.max(parseFloat(pp), min)) : 0,
                f = formatDecimal2((a + b * p) * c),
                sf = inpServFee.length !== 0 && !isNaN(inpServFee.val()) && inpServFee.val() !== '' && parseFloat(pp).toFixed(2) !== '0.00' ? formatDecimal2(parseFloat(inpServFee.val())) : 0,
                _t2 = formatDecimal(p + f + sf);
            // Revised EP fee ticket level rounded calculations
            var ep_fee = Math.round((1 + da.percent * pp / 100) * 100) / 100;
            var tax1 = Math.round(da.tax1 * ep_fee * 100) / 100;
            var tax2 = Math.round(da.tax2 * ep_fee * 100) / 100;
            f = formatDecimal2(ep_fee + tax1 + tax2);
            _t2 = formatDecimal(p + f + sf);
            console.log(f);
            console.log(quantity);
            values['price'] = formatDecimal2(p * quantity);
            values['fees'] = formatDecimal2(f * quantity);
            values['service_fee'] = formatDecimal2(sf * quantity);
            values['total'] = formatDecimal2(_t2 * quantity);
            console.log(values);
        } else {
            $(".tickets-list-one-ticket-ctn.selected input[name = 'doorRebate']").each(function () {
                // total += $(this).attr("max") - $(this).val();
                var pp = $(this).attr("data-doorprice") - $(this).val();
                var da = ctn.data(),
                    a = isNaN(da.base) ? 1 : parseFloat(da.base),
                    b = isNaN(da.percent) ? 0.03 : parseFloat(da.percent) / 100,
                    c = isNaN(da.tax1) || isNaN(da.tax2) ? 1.14975 : parseFloat(da.tax1) + parseFloat(da.tax2) + 1,
                    min = 0,
                    p = !isNaN(pp) && pp !== '' ? formatDecimal2(Math.max(parseFloat(pp), min)) : 0,
                    f = formatDecimal2((a + b * p) * c),
                    sf = inpServFee.length !== 0 && !isNaN(inpServFee.val()) && inpServFee.val() !== '' && parseFloat(pp).toFixed(2) !== '0.00' ? formatDecimal2(parseFloat(inpServFee.val())) : 0,
                    t = formatDecimal(p + f + sf);
                // Revised EP fee ticket level rounded calculations
                var ep_fee = Math.round((1 + da.percent * pp / 100) * 100) / 100;
                var tax1 = Math.round(da.tax1 * ep_fee * 100) / 100;
                var tax2 = Math.round(da.tax2 * ep_fee * 100) / 100;
                f = formatDecimal2(ep_fee + tax1 + tax2);
                t = formatDecimal(p + f + sf);
                console.log(f);
                values['price'] += formatDecimal2(p);
                values['fees'] += formatDecimal2(f);
                values['service_fee'] += formatDecimal2(sf);
                values['total'] += formatDecimal2(t);
                console.log(values);
            });
        }
        $(".ticket-price-door-input-raw").val(total);
        // calcTicketPriceFinal(e, $(".ticket-price-door-input-raw"));   
        applyPackagePriceFinal(e, $(".ticket-price-door-input-raw"), values);
    };

    var activatePassRebateTicket = function activatePassRebateTicket(e) {
        if ($(this).is(":checked")) {
            $(".tickets-list-one-ticket-ctn.selected .package-ticket-door-rebate").addClass("activated");
        } else {
            $(".tickets-list-one-ticket-ctn.selected .package-ticket-door-rebate").removeClass("activated");
        }
    };

    var toggleOnlineRebate = function toggleOnlineRebate(e) {
        if ($(this).val() === 'true') {
            $(".tickets-list-one-ticket-ctn.selected .package-ticket-rebate").addClass("disabled");
        } else {
            $(".tickets-list-one-ticket-ctn.selected .package-ticket-rebate").removeClass("disabled");
            calculatePackagePrice();
        }
    };

    var removeTicketFromPackage = function removeTicketFromPackage(e) {
        var $item = $(this).closest(".tickets-list-one-ticket-ctn"),
            id = $item.attr("data-id"),
            $source = $(e.data).find(".tickets-list-one-ticket-ctn[data-id='" + id + "']"),
            $folder = $item.closest(".event-folder-single");

        $item.addClass("hide").removeClass("selected");
        $source.removeClass("ui-dropped");
        // If all tickets in this event are not selected, hide the folder
        if ($item.parent().children(".selected").length < 1) {
            $folder.addClass("hide");
            showTicketList.apply($folder.find(".tickets-list-header-outer-ctn")[0]);
        }
    };

    var removeTicketFromPrivateLink = function removeTicketFromPrivateLink(e) {
        var $item = $(this).closest(".private-tickets-list-one-ticket-ctn"),
            id = $item.attr("data-id"),
            $source = $(e.data).find(".private-tickets-list-one-ticket-ctn[data-id='" + id + "']"),
            $folder = $item.closest(".private-event-folder-single");

        $item.addClass("hide").removeClass("selected");
        $source.removeClass("ui-dropped");
        // If all tickets in this event are not selected, hide the folder
        if ($item.parent().children(".selected").length < 1) {
            $folder.addClass("hide");
            showTicketList.apply($folder.find(".private-tickets-list-header-outer-ctn")[0]);
        }
    };

    var unloadTickets = function unloadTickets(resource) {
        var res = typeof resource === "string" ? JSON.parse(resource) : resource,
            ctnL = d.querySelector(".left .event-folders-tickets-list"),
            ctnR = d.querySelector(".right .event-folders-tickets-list"),
            temp = d.querySelector(".event-folders-temp>:first-child"),
            tempT = d.querySelector(".event-folders-ticket-temp>:first-child");

        var _selectTicket = function _selectTicket(e) {
            addTicketToPackage(e, ctnR, $(this).closest(".tickets-list-one-ticket-ctn"));
            $(this).closest(".associate-package-tickets-boxes-outer-ctn")[0].scrollLeft = 400;
        };

        // Clear the list to re-add all of the tickets
        ctnL.innerHTML = ctnR.innerHTML = "";
        // Generate all the event folders
        for (var i in res) {
            var o = res[i],
                clone = temp.cloneNode(true),
                list = clone.querySelector(".tickets-list-content-ctn");

            if (o.status === "1") $(clone).addClass("draft");
            clone.querySelector(".tickets-list-header").innerHTML = o.eventName || createEventForm.find("[name='name']").val();
            if (o.startTime && o.startDate) {
                clone.querySelector(".tickets-list-subheader").innerHTML = o.startTime + ", " + o.startDate;
            } else {
                var eventType = createEventForm.find("[name='ticketType']:checked").val(),
                    eventDate = "",
                    eventHour = "",
                    aEventDate = [];

                if (eventType === "one-day") {
                    eventDate = $("#start-date-create-event-one-day").val();
                    eventHour = getTimeFormatted(createEventForm.find("#start-time-create-event-one-day").val()) + ", ";
                } else {
                    eventDate = $("#start-date-create-event-multiple-days").val();
                }
                aEventDate = eventDate.split(eventDate.match(/-|\//)[0]);
                clone.querySelector(".tickets-list-subheader").innerHTML = eventHour + getDateFormatted(aEventDate[0], aEventDate[1], aEventDate[2]);
            }

            var tickets = o.tickets;
            tickets.sort(function (a, b) {
                return a.ticketName.localeCompare(b.ticketName);
            });
            // Generate all of the tickets in the processing event
            for (var j in o.tickets) {
                var oT = o.tickets[j],
                    cloneT = tempT.cloneNode(true);

                list.appendChild(cloneT);
                cloneT.querySelector(".name").innerHTML = oT.ticketName;
                cloneT.querySelector(".price").innerHTML = formatMoney(oT.ticketPrice);
                //                cloneT.querySelector(".price").innerHTML = formatMoney(oT.ticketFinalPrice);
                cloneT.setAttribute("data-end", oT.sellingEndDate.substring(0, 16).replace(/-/g, "/"));
                cloneT.setAttribute("data-qty", oT.quantity);
                cloneT.setAttribute("data-sold", oT.sold);
                // Add prefix "P1" with ticketId for more uniqueness
                cloneT.setAttribute("data-id", "P1" + oT.ticketId);
                cloneT.setAttribute("data-price", oT.ticketFinalPrice);
                $(cloneT).find("input.float-number").keypress(numLockFloat);
                $(cloneT).find("input.float-number").attr("max", oT.ticketPrice.replace(",", "."));
                $(cloneT).find("input.float-number").attr("data-doorprice", oT.ticketDoorPrice.replace(",", "."));

                if (oT.palier || !oT.active || oT.status === "2" || oT.status === "3") {
                    $(cloneT).addClass("unavailable").find(".svg-cancel").removeClass("hide");
                } else {
                    $(cloneT).addClass("ui-draggable").find(".svg-circles").removeClass("hide").addClass("draggable");
                    $(".svg-folder", cloneT).removeClass("hide").click(_selectTicket);
                }
            }
            if (o.tickets.length > 0) {
                // Hide ended and cancelled events
                if (!(o.available && o.available === "true" || o.eventId === editEventId)) {
                    $(clone).addClass("hide");
                }
                // Append event folder clones to left and right box
                ctnL.appendChild(clone);
                // Duplicate hidden list of tickets for the display later
                var clone2 = clone.cloneNode(true);
                ctnR.appendChild(clone2);
                clone.id = "eftll_" + o.eventId;
                // Remove unneccessary handlers in this list
                //*we'll keep the unavailable tickets for the modification of the old bundle
                //$(".unavailable", clone2).remove();
                $(".svg-circles, .svg-folder", clone2).remove();
                $(".svg-cancel", clone2).addClass("hide");
                $(".svg-x", clone2).removeClass("hide").click(ctnL, removeTicketFromPackage);
                $(".ui-draggable", clone2).addClass("hide");
                $(clone2).addClass("hide");
            }
        }
        // Create accordion action to the folders
        if (!ctnL.hasAttribute("data-ff")) {
            $(ctnL).on("click", ".tickets-list-header-outer-ctn", showTicketList).attr("data-ff", "");
        }
        if (!ctnR.hasAttribute("data-ff")) {
            $(ctnR).on("click", ".tickets-list-header-outer-ctn", showTicketList).attr("data-ff", "");
        }
        // Make items in the left block draggable
        $(".ui-draggable", ctnL).draggable({
            handle: ".draggable",
            containment: "document",
            helper: "clone",
            revert: true,
            revertDuration: 200,
            zIndex: 20,
            start: function start(e, ui) {
                $(this).addClass("holding");
            },
            stop: function stop(e, ui) {
                $(this).removeClass("holding");
            }
        });
        // Make the most outer container on the right the drop zone for the tickets
        $(".associate-package-tickets-box.right").droppable({
            accept: ".left .ui-draggable",
            tolerance: "touch",
            activate: function activate() {
                $(this).addClass("droppable-active");
            },
            deactivate: function deactivate() {
                $(this).removeClass("droppable-active droppable-highlight");
            },
            over: function over() {
                $(this).addClass("droppable-highlight");
            },
            out: function out() {
                $(this).removeClass("droppable-highlight");
            },
            drop: function drop(e, ui) {
                $(this).removeClass("droppable-active droppable-highlight");
                // Hide revert animation on dragging item helper
                ui.helper.hide();
                addTicketToPackage(e, this, ui.draggable[0]);
            }
        });
    };

    var unloadPrivateTickets = function unloadPrivateTickets(resource) {
        var res = typeof resource === "string" ? JSON.parse(resource) : resource,
            ctnL = d.querySelector(".left .private-event-folders-tickets-list"),
            ctnR = d.querySelector(".right .private-event-folders-tickets-list"),
            temp = d.querySelector(".private-event-folders-temp>:first-child"),
            tempT = d.querySelector(".private-event-folders-ticket-temp>:first-child");

        var _selectTicket = function _selectTicket(e) {
            addTicketToPrivateLink(e, ctnR, $(this).closest(".private-tickets-list-one-ticket-ctn"));
            $(this).closest(".associate-private-link-tickets-boxes-outer-ctn")[0].scrollLeft = 400;
        };

        // Clear the list to re-add all of the tickets
        ctnL.innerHTML = ctnR.innerHTML = "";
        // Generate all the event folders
        for (var i in res) {
            var o = res[i],
                clone = temp.cloneNode(true),
                list = clone.querySelector(".private-tickets-list-content-ctn");

            if (o.status === "1") $(clone).addClass("draft");
            clone.querySelector(".private-tickets-list-header").innerHTML = o.eventName || createEventForm.find("[name='name']").val();
            if (o.startTime && o.startDate) {
                clone.querySelector(".private-tickets-list-subheader").innerHTML = o.startTime + ", " + o.startDate;
            } else {
                var eventType = createEventForm.find("[name='ticketType']:checked").val(),
                    eventDate = "",
                    eventHour = "",
                    aEventDate = [];

                if (eventType === "one-day") {
                    eventDate = $("#start-date-create-event-one-day").val();
                    eventHour = getTimeFormatted(createEventForm.find("#start-time-create-event-one-day").val()) + ", ";
                } else {
                    eventDate = $("#start-date-create-event-multiple-days").val();
                }
                aEventDate = eventDate.split(eventDate.match(/-|\//)[0]);
                clone.querySelector(".private-tickets-list-subheader").innerHTML = eventHour + getDateFormatted(aEventDate[0], aEventDate[1], aEventDate[2]);
            }

            var tickets = o.tickets;
            tickets.sort(function (a, b) {
                return a.ticketName.localeCompare(b.ticketName);
            });
            // Generate all of the tickets in the processing event
            for (var j in o.tickets) {
                var oT = o.tickets[j],
                    cloneT = tempT.cloneNode(true);

                list.appendChild(cloneT);
                cloneT.querySelector(".name").innerHTML = oT.ticketName;
                cloneT.querySelector(".price").innerHTML = formatMoney(oT.ticketPrice);
                //                cloneT.querySelector(".price").innerHTML = formatMoney(oT.ticketFinalPrice);
                cloneT.setAttribute("data-end", oT.sellingEndDate.substring(0, 16).replace(/-/g, "/"));
                cloneT.setAttribute("data-qty", oT.quantity);
                cloneT.setAttribute("data-sold", oT.sold);
                // Add prefix "P1" with ticketId for more uniqueness
                cloneT.setAttribute("data-id", "P1" + oT.ticketId);
                cloneT.setAttribute("data-price", oT.ticketFinalPrice);
                $(cloneT).find("input.float-number").keypress(numLockFloat);
                $(cloneT).find("input.float-number").attr("max", oT.ticketPrice.replace(",", "."));

                $(cloneT).addClass("ui-draggable").find(".svg-circles").removeClass("hide").addClass("draggable");
                $(".svg-folder", cloneT).removeClass("hide").click(_selectTicket);
            }
            if (o.tickets.length > 0) {
                // Hide ended and cancelled events
                // if (!(o.available && o.available === "true" || o.eventId === editEventId)) {
                //     $(clone).addClass("hide");
                // }
                // Append event folder clones to left and right box
                ctnL.appendChild(clone);
                // Duplicate hidden list of tickets for the display later
                var clone2 = clone.cloneNode(true);
                ctnR.appendChild(clone2);
                clone.id = "eftll_" + o.eventId;
                // Remove unneccessary handlers in this list
                //*we'll keep the unavailable tickets for the modification of the old bundle
                //$(".unavailable", clone2).remove();
                $(".svg-circles, .svg-folder", clone2).remove();
                $(".svg-cancel", clone2).addClass("hide");
                $(".svg-x", clone2).removeClass("hide").click(ctnL, removeTicketFromPrivateLink);
                $(".ui-draggable", clone2).addClass("hide");
                $(clone2).addClass("hide");
            }
        }

        // Create accordion action to the folders
        if (!ctnL.hasAttribute("data-ff")) {
            $(ctnL).on("click", ".private-tickets-list-header-outer-ctn", showTicketList).attr("data-ff", "");
        }

        if (!ctnR.hasAttribute("data-ff")) {
            $(ctnR).on("click", ".private-tickets-list-header-outer-ctn", showTicketList).attr("data-ff", "");
        }

        if (!$(ctnL).hasClass("list-open")) {
            $(ctnL).removeClass("hide");
            showTicketList.apply($(ctnL).find(".private-tickets-list-header-outer-ctn")[0]);
        }
        // Make items in the left block draggable
        $(".ui-draggable", ctnL).draggable({
            handle: ".draggable",
            containment: "document",
            helper: "clone",
            revert: true,
            revertDuration: 200,
            zIndex: 20,
            start: function start(e, ui) {
                $(this).addClass("holding");
            },
            stop: function stop(e, ui) {
                $(this).removeClass("holding");
            }
        });

        $(".associate-private-link-tickets-box.right").droppable({
            accept: ".left .ui-draggable",
            tolerance: "touch",
            activate: function activate() {
                $(this).addClass("droppable-active");
            },
            deactivate: function deactivate() {
                $(this).removeClass("droppable-active droppable-highlight");
            },
            over: function over() {
                $(this).addClass("droppable-highlight");
            },
            out: function out() {
                $(this).removeClass("droppable-highlight");
            },
            drop: function drop(e, ui) {
                $(this).removeClass("droppable-active droppable-highlight");
                // Hide revert animation on dragging item helper
                ui.helper.hide();
                addTicketToPrivateLink(e, this, ui.draggable[0]);
            }
        });

        //  $(".private-tickets-list-header-outer-ctn").trigger("click");
    };

    var loadPackageDirectories = function loadPackageDirectories(eventId) {
        ajax(managePackagePath + "?list=true" + (eventId ? "&eventId=" + eventId : ""), function (response) {
            if (response.trim() !== "fail") {
                unloadTickets(response.trim());
            }
        }, true);
    };
    var loadPrivateDirectories = function loadPrivateDirectories(eventId) {
        ajax(managePrivateLinksPath + "?list=true" + (eventId ? "&eventId=" + eventId : ""), function (response) {
            if (response.trim() !== "fail") {
                unloadPrivateTickets(response.trim());
            }
        }, true);
    };

    var createPrivateLink = function createPrivateLink(e) {
        var form = $(this).closest(".create-private-link-form"),
            inps = form.find("input, textarea, select"),
            inpIds = inps.filter("[name='ticketIds']"),
            ids = [],
            oldIds = [],
            data = "",
            oData = {};
        oData.ticketsHTMList = "";
        $(".private-tickets-list-one-ticket-ctn.selected", form).each(function () {
            // Generate the array of ticket ids and add it to the input.
            // We are doing this before validating the form so that error will be added
            // if this input is required and empty.
            ids.push(this.getAttribute("data-id").replace("P1", ""));

            var id = this.getAttribute("data-id").substring(2);
            oData.ticketsHTMList += "<p><span class='event-private-link-ticket-name' data-id='" + id + "'>" + this.querySelector(".name").innerHTML + "</span> - " + $(this).closest(".private-event-folder-single").find(".private-tickets-list-header-text-ctn .private-tickets-list-header").text() + "</p>";
        });

        // Before assigning new value to the ticketIds, check if there is an old
        // list of tickets in order to re-enable the checkboxes in the stage group
        // if the number of tickets set in the bundle is 0.
        if (inpIds.val() !== "") oldIds = inpIds.val().split(",");
        inpIds.val(ids.join(","));

        inps.each(function () {
            var name = $(this).attr("name");
            if (name && name.trim() !== "") {
                var inp = $(this),
                    type = inp.attr("type"),
                    val = inp.val().trim(),
                    checkType = type === "checkbox" || type === "radio";

                if ((checkType && inp.prop("checked") || !checkType) && !inp.hasClass("nontake")) {
                    if (inp.hasClass("datepicker")) {
                        name += "Date";
                    } else if (inp.hasClass("timepicker")) {
                        name += "Time";
                    }
                    if (!oData.hasOwnProperty(name)) oData[name] = val;
                    data += "&" + name + "=" + val;
                }
            }
        });
        if (!(oData.privateLinkId != null && oData.privateLinkId !== '')) {
            oData.active = 'true';
        }

        data += "&active=" + (oData.active === 'true' ? 'true' : 'false');

        formValidator.validateForm(form);
        // Validate form if there is any tickets selected
        // if (ids.length === 0)
        //     form.addClass("has-error");


        // Check if this bundle has multiple choice and compare the minimum of tickets
        if (oData.passType === "1") {
            var minTickets = oData.passNbrToChoose - ids.length;
            if (minTickets > 0) {
                form.addClass("has-error");
                alert("Veuillez ajouter " + minTickets + " billets de plus \xE0 votre forfait pour continuer.");
            }
            if (!(oData.passNbrToChoose > 0)) form.addClass("has-error");
        }

        if (form.hasClass("has-error")) {
            return false;
        }

        var _succeed = function _succeed(response) {
            var $tb = $(".event-form-private-link-table>tbody"),
                $tr = $tb.find("tr:eq(0)").clone(true, true),
                rws = $(".event-form-private-link-table>tbody>tr").length - 1;
            var fullurl = $(".p_protocol").val() + $(".p_domain").val() + "/" + $(".p_lang").val() + ($(".p_lang").val() === "fr" ? eventLinkFR : eventLinkEN) + $(".p_friendlyUrl").val() + '/' + oData.url;
            if (oData.privateLinkId.toString() === response.trim()) {
                $tr = $tb.find("tr[data-pkid='" + oData.privateLinkId + "']");
                //  $tr.find(".table-private-id").html(oData.privateLinkId);
                $tr.find(".table-private-internal-name").html(oData.internalName);
                $tr.find(".table-private-subtitle").html(oData.subtitle);
                $tr.find(".table-private-url").html(fullurl);
                $tr.find(".table-tickets-inner").html(oData.ticketsHTMList);
                $tr.find(".xdata").text(JSON.stringify(oData));
            } else {
                oData.privateLinkId = response.trim();
                $tb.append($tr);
                $tr.removeAttr("style").removeAttr("class");
                $tr.attr("data-pkid", oData.privateLinkId);
                $tr.attr("data-evid", oData.eventId);
                // $tr.find(".table-private-id").html(rws+1);
                $tr.find(".table-private-internal-name").html(oData.internalName);
                $tr.find(".table-private-subtitle").html(oData.subtitle);
                $tr.find(".table-private-url").html(fullurl);
                $tr.find(".table-tickets-inner").html(oData.ticketsHTMList);
                $tr.find(".table-status-text").html(oData.active === "true" ? "Active" : "Inactive");
                var ticketIds = oData.ticketIds.split(",");
                // var rebates = oData.name.split(",");
                // var doorRebates = oData.doorRebates.split(",");
                // for (var i = 0; i < ticketIds.length; i++) {
                //     oData["passTicket-" + ticketIds[i]] = {"name" : rebates[i], "description" : doorRebates[i]};
                // };
                $tr.find(".xdata").html(JSON.stringify(oData));
                $tb.append($tr);
            }

            // Trigger this button will clear all inputs and close the form
            $(".add-new-item-btn.private").trigger("click");
            // Refresh list of tickets and event folders
            loadPrivateDirectories();
        };
        pageScrlTo(form.parent().offset().top - 100);
        ajax(managePrivateLinksPath + "?ajax=true" + encodeURI(data), function (response) {
            if (!response.trim().includes("fail")) {
                _succeed(response.trim());
            } else {
                var errors = response.trim().split("-");
                alert(errors[1]);
            }
        });
    };

    var createPackage = function createPackage(e) {
        var form = $(this).closest(".create-package-form"),
            inps = form.find("input, textarea, select"),
            inpIds = inps.filter("[name='ticketIds']"),
            inpRebates = inps.filter("[name='rebates']"),
            inpDoorRebates = inps.filter("[name='doorRebates']"),
            ids = [],
            rebates = [],
            doorRebates = [],
            oldIds = [],
            data = "",
            oData = {};

        oData.ticketsQty = 0;
        oData.ticketsSold = 0;
        oData.ticketsSoldOut = false;
        oData.ticketsHTMList = "";
        $(".tickets-list-one-ticket-ctn.selected", form).each(function () {
            // Generate the array of ticket ids and add it to the input.
            // We are doing this before validating the form so that error will be added
            // if this input is required and empty.
            ids.push(this.getAttribute("data-id").replace("P1", ""));
            var rebate = $(this).find(".package-ticket-rebate input").val();
            rebates.push(rebate === '' ? 0 : rebate);
            var doorRebate = $(this).find(".package-ticket-door-rebate input").val();
            doorRebates.push(doorRebate === '' ? 0 : doorRebate);
            // Calculate the total ticket quantities and inventories.
            oData.ticketsQty += parseInt(this.getAttribute("data-qty"));
            oData.ticketsSold += parseInt(this.getAttribute("data-sold"));
            if (parseInt(this.getAttribute("data-qty")) <= parseInt(this.getAttribute("data-sold"))) {
                oData.ticketsSoldOut = true;
            }
            var id = this.getAttribute("data-id").substring(2);
            oData.ticketsHTMList += "<p><span class='event-package-ticket-name' data-id='" + id + "'>" + this.querySelector(".name").innerHTML + "</span> - " + $(this).closest(".event-folder-single").find(".tickets-list-header-text-ctn .tickets-list-header").text() + "</p>";
        });
        // Before assigning new value to the ticketIds, check if there is an old
        // list of tickets in order to re-enable the checkboxes in the stage group
        // if the number of tickets set in the bundle is 0.
        if (inpIds.val() !== "") oldIds = inpIds.val().split(",");
        inpIds.val(ids.join(","));

        inpRebates.val(rebates.join(","));
        inpDoorRebates.val(doorRebates.join(","));

        formValidator.validateForm(form);
        // Validate form if there is any tickets selected
        if (ids.length === 0) form.addClass("has-error");

        inps.each(function () {
            var name = $(this).attr("name");
            if (name && name.trim() !== "") {
                var inp = $(this),
                    type = inp.attr("type"),
                    val = inp.val().trim(),
                    checkType = type === "checkbox" || type === "radio";

                if ((checkType && inp.prop("checked") || !checkType) && !inp.hasClass("nontake")) {
                    if (inp.hasClass("datepicker")) {
                        name += "Date";
                    } else if (inp.hasClass("timepicker")) {
                        name += "Time";
                    }
                    if (!oData.hasOwnProperty(name)) oData[name] = val;
                    data += "&" + name + "=" + val;
                }
            }
        });
        // Check if this bundle has multiple choice and compare the minimum of tickets
        if (oData.passType === "1") {
            var minTickets = oData.passNbrToChoose - ids.length;
            if (minTickets > 0) {
                form.addClass("has-error");
                alert("Veuillez ajouter " + minTickets + " billets de plus \xE0 votre forfait pour continuer.");
            }
            if (!(oData.passNbrToChoose > 0)) form.addClass("has-error");
        }

        if (form.hasClass("has-error")) {
            return false;
        }

        var _succeed = function _succeed(response) {
            var $tb = $(".event-form-packages-table>tbody"),
                pos = $tb.find("tr").length,
                $tr = $tb.find("tr:eq(0)").clone(true, true),
                date = new Date(),

            //                curDate = $("#systemCurrentDate").val(),                
            curDate = date.getFullYear() + "" + (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "" + (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()),
                sellEndDate = getDateYMD(oData.passEndDateYear, oData.passEndDateMonth, oData.passEndDateDay),
                fp = oData.passFree === "true" ? 0 : parseFloat(oData.passFinalPrice),
                mf = oData.passFree === "true" ? lang === "fr" ? "gratuit" : "free" : formatMoney(fp),
                stat = 0,
                active = true,
                stock = parseInt(oData.qty),
                hasEventTicket = false;

            // There are new added tickets, increase their counts
            for (var ind in ids) {
                if (oldIds.indexOf(ind) === -1) {
                    if (_PASSTICKETS[ind]) {
                        _PASSTICKETS[ind]++;
                    } else {
                        _PASSTICKETS[ind] = 1;
                    }
                }
            }
            // Some tickets are removed, decrease their counts
            for (var inx in oldIds) {
                if (ids.indexOf(inx) === -1) {
                    if (_PASSTICKETS[inx]) {
                        _PASSTICKETS[inx]--;
                    }
                }
            }
            // Immediately disable or enable the checkboxes in the stage group
            for (var tkid in _PASSTICKETS) {
                var el = d.getElementById("tl1t_" + ids[tkid]);
                if (el) {
                    hasEventTicket = true;
                    if (_PASSTICKETS[tkid] > 0) {
                        if (!$(el).hasClass("local-disabled")) $(el).addClass("local-disabled").find(".form-checkbox-ctn").addClass("disabled").find(".form-check-input").attr("disabled", "true");
                    } else {
                        if ($(el).hasClass("local-disabled")) $(el).removeClass("local-disabled").find(".form-checkbox-ctn").removeClass("disabled").find(".form-check-input").attr("disabled", "false");
                    }
                }
            }
            // If the package contains no tickets in the current event then it will
            // not be added or will be removed. Only in Create Event!
            if (!hasEventTicket && createEventForm.length > 0) {
                if (oData.passId.toString() === response.trim()) {
                    $tr = $tb.find("tr[data-pkid='" + oData.passId + "']");
                    var __reposition = function __reposition($row) {
                        if ($row[0]) {
                            $row.find(".table-position p").html($row.find(".table-position p").html() - 1);
                            __reposition($row.next());
                        }
                    }($tr.next());
                    $tr.remove();
                }
            } else {
                // Add package to the list table
                if (oData.passId.toString() === response.trim()) {
                    $tr = $tb.find("tr[data-pkid='" + oData.passId + "']");
                    oData.active = $tr.find(".table-status").attr("data-active-e");
                    oData.activeAll = $tr.find(".table-status").attr("data-active-a");
                    active = oData.active !== "false" && oData.activeAll !== "false";
                    if (oData.activeAll === "false") {
                        stat = -1;
                    } else if (oData.active === "false") {
                        stat = -2;
                    }
                    stock -= parseInt(oData.inventory);
                } else {
                    oData.passId = response.trim();
                    oData.active = active.toString();
                    oData.inventory = 0;
                    $tb.append($tr);
                    $tr.removeAttr("style").removeAttr("class");
                    $tr.attr("data-pkid", oData.passId);
                    $tr.find(".table-position p").html(pos);
                    $tr.find(".table-status").attr("data-active-e", oData.active).attr("data-active-a", oData.active);
                }
                $tr.find(".table-package-name").html(oData.passName);
                $tr.find(".table-package-type").html(function () {
                    return $(this).attr("data-type" + oData.passType);
                });
                $tr.find(".table-money p").html(mf);
                $tr.find(".table-quantity p").html(oData.qty + "<span class='table-quantity-left'>(" + stock + ")</span>");
                if (curDate > sellEndDate) {
                    $tr.find(".table-status").attr("data-stat", "2");
                    if (active) stat = 2;
                } else if (stock <= 0) {
                    $tr.find(".table-status").attr("data-stat", "3");
                    if (active) stat = 3;
                } else if (oData.ticketsSoldOut) {
                    $tr.find(".table-status").attr("data-stat", "4");
                    if (active) stat = 4;
                }
                $tr.find(".table-status-colorbar").attr("class", function () {
                    return "table-status-colorbar " + $(this).attr("data-sc" + stat);
                });
                $tr.find(".table-status-text").html(function () {
                    return $(this).attr("data-st" + stat);
                });
                $tr.find(".table-tickets-inner").html(oData.ticketsHTMList);

                var ticketIds = oData.ticketIds.split(",");
                var rebates = oData.rebates.split(",");
                var doorRebates = oData.doorRebates.split(",");
                for (var i = 0; i < ticketIds.length; i++) {
                    oData["passTicket-" + ticketIds[i]] = { "rebate": rebates[i], "doorRebate": doorRebates[i] };
                };
                $tr.find(".xdata").text(JSON.stringify(oData));
            }
            // Trigger this button will clear all inputs and close the form
            $(".add-new-item-btn.package").trigger("click");
            // Refresh list of tickets and event folders
            loadPackageDirectories();
        };

        pageScrlTo(form.parent().offset().top - 100);

        ajax(managePackagePath + "?ajax=true" + encodeURI(data), function (response) {
            if (response.trim() !== "fail") {
                _succeed(response.trim());
            } else {
                // Something here
            }
        });
    };

    var startNewPool = function startNewPool(e, p) {
        if (p) return;

        var form = $(".pooling-qty-ctn");
        form.find("input, textarea, select").each(function () {
            var $this = $(this),
                name = $this.attr("name"),
                type = $this.attr("type");

            if (type === "radio" || type === "checkbox") {
                var checked = $this.prop("checked");
                if (name === "passFree") {
                    if ($this.val() === "false" && !checked) $this.trigger("click");
                } else if (name === "passType") {
                    if ($this.val() === "0") $this.trigger("click");
                } else {
                    if (checked) $this.prop("checked", false).triggerHandler("click");
                }
            } else {
                if (name !== "eventId") {
                    $this.val("");
                    if (type !== "hidden") {
                        $this.removeClass("error success");
                        $this.closest(".input-ctn").removeClass("focused");
                    }
                }
            }
        });
    };

    var startNewPrivateLink = function startNewPrivateLink(e, p) {
        if (p) return;

        var form = $(".create-private-link-form"),
            cd = $("#systemCurrentDate").val();
        form.find(".create-private-link-btn").text(function () {
            return $(this).attr("data-label");
        });
        var eventId;
        form.find("input, textarea, select").each(function () {
            var $this = $(this),
                name = $this.attr("name"),
                type = $this.attr("type");

            if (type === "radio" || type === "checkbox") {
                var checked = $this.prop("checked");
                if (name === "passFree") {
                    if ($this.val() === "false" && !checked) $this.trigger("click");
                } else if (name === "passType") {
                    if ($this.val() === "0") $this.trigger("click");
                } else {
                    if (checked) $this.prop("checked", false).triggerHandler("click");
                }
            } else {
                if (name !== "eventId") {
                    $this.val("");
                    if (type !== "hidden") {
                        $this.removeClass("error success");
                        $this.closest(".input-ctn").removeClass("focused");
                    }
                } else {
                    eventId = $this.val();
                }
                if (name === "url") {
                    $this.prop("readonly", false);
                }
            }
        });

        form.find(".package-multiple-choice-number-input-ctn").removeClass("disabled disabled-ctn").find(".form-input").removeClass("disabled").removeAttr("disabled");

        form.find(".associate-private-link-tickets-boxes-outer-ctn").removeClass("soldlocked");
        form.find(".associate-private-link-tickets-box").show();
        form.find(".tickets-list-one-ticket-ctn.selected").each(function () {
            $(this).find(".handler .svg-x").click();
        });
        loadPrivateDirectories(createEventForm.find("[name='id']").val());
    };

    var startNewPackage = function startNewPackage(e, p) {
        if (p) return;

        var form = $(".create-package-form"),
            cd = $("#systemCurrentDate").val(),
            ct = roundTime($("#systemCurrentTime").val());

        cd = cd.substr(0, 4) + "/" + cd.substr(4, 2) + "/" + cd.substr(6, 2);

        // Set isAPass checkbox
        var isAPassCheckbox = form.find("[name='isAPass']");
        isAPassCheckbox.prop("disabled", false);

        form.find(".create-package-btn").text(function () {
            return $(this).attr("data-label");
        });
        form.find("input, textarea, select").each(function () {
            var $this = $(this),
                name = $this.attr("name"),
                type = $this.attr("type");

            if (type === "radio" || type === "checkbox") {
                var checked = $this.prop("checked");
                if (name === "passFree") {
                    if ($this.val() === "false" && !checked) $this.trigger("click");
                } else if (name === "passType") {
                    if ($this.val() === "0") $this.trigger("click");
                } else {
                    if (checked) $this.prop("checked", false).triggerHandler("click");
                }
            } else {
                if (name !== "eventId") {
                    $this.val("");
                    if (type !== "hidden") {
                        $this.removeClass("error success");
                        $this.closest(".input-ctn").removeClass("focused");
                    }
                }
            }
        });
        form.find(".package-standard-choice, .package-multiple-choice").show();
        form.find(".package-multiple-choice-number-input-ctn").removeClass("disabled disabled-ctn").find(".form-input").removeClass("disabled").removeAttr("disabled");
        form.find(".ticket-form-info-quantity-sold, .ticket-form-info-quantity-remain").text("0");
        form.find(".ticket-price-outer-ctn").show();
        form.find(".soldisabled").hide();
        form.find(".associate-package-tickets-boxes-outer-ctn").removeClass("soldlocked");
        form.find(".associate-package-tickets-box").show();
        triggerInputFocus("#passStart-date-4", cd, "change");
        triggerInputFocus("#passStart-time-4", ct, "change");
        form.find(".tickets-list-one-ticket-ctn.selected").each(function () {
            $(this).find(".handler .svg-x").click();
        });
    };

    var modifyPackage = function modifyPackage(e) {
        var btn = $(this),
            item = btn.closest("td"),
            form = $(".create-package-form"),
            xdata = jsonEscape(item.find(".xdata").text()),
            oData = JSON.parse(xdata),
            idList = oData.ticketIds.split(","),
            leftBox = form.find(".associate-package-tickets-box.left"),
            rightBox = form.find(".associate-package-tickets-box.right");

        var isAPassCheckbox = form.find("[name='isAPass']");
        isAPassCheckbox.prop("checked", oData.isAPass === "true" || oData.isAPass === true);
        isAPassCheckbox.prop("disabled", true);

        if (item.closest("table").hasClass("packages-archive-table")) {
            return false;
        }
        pageScrlTo(form.parent().offset().top);

        if (!form.hasClass("open")) {
            $(".add-new-item-btn.package").trigger("click", { type: "modify" });
        }
        $(".create-package-btn", form).text(function () {
            return $(this).attr("data-label2");
        });

        for (var name in oData) {
            var el = form.find("[name='" + name + "']");
            if (name.substr(name.length - 4) === "Date") {
                el = form.find(".datepicker[name='" + name.substring(0, name.length - 4) + "']");
            } else if (name.substr(name.length - 4) === "Time") {
                el = form.find(".timepicker[name='" + name.substring(0, name.length - 4) + "']");
                oData[name] = oData[name].replace("h", ":");
            }
            if (el.length > 0) {
                var type = el.attr("type");
                var value = oData[name];

                if (type === "radio") {
                    el.each(function () {
                        if ($(this).val() === value) {
                            $(this).prop("checked", true).triggerHandler("change");
                        }
                    });
                } else if (type === "checkbox") {
                    if (el.prop("checked") !== (el.val() === value)) {
                        el.trigger("click").triggerHandler("change");
                    }
                } else {
                    el.val(value);
                    if (type !== "hidden") {
                        el.triggerHandler("blur");
                        triggerInputFocus(el);
                    }
                }
            }
            if (name === "passFree") {
                if (value && value.toString() === "true") {
                    form.find(".soldisabled-pay .ticket-price-online-choice").prop("checked", false);
                    form.find(".soldisabled-free .ticket-price-online-choice").prop("checked", true).triggerHandler("change");
                } else {
                    form.find(".soldisabled-free .ticket-price-online-choice").prop("checked", false);
                    form.find(".soldisabled-pay .ticket-price-online-choice").prop("checked", true).triggerHandler("change");
                }
            } else if (name === "passDoorPriceActivated") {
                form.find(".soldisabled .ticket-price-door-choice").prop("checked", value && value.toString() === "true").triggerHandler("click change");
            }
        }
        // Prevent price change and association if a bundle was bought
        if (parseInt(oData.qtySold) > 0 || parseInt(oData.inventory) > 0) {
            form.find(".associate-package-tickets-boxes-outer-ctn").addClass("soldlocked");
            leftBox.hide();
            form.find(".ticket-price-outer-ctn").hide();
            form.find(".soldisabled").css("display", "flex");
            if (oData.passFree === "false") {
                form.find(".soldisabled-pay").css("display", "");
                form.find(".soldisabled-free").hide();
                form.find(".soldisabled .ticket-price-input-raw").val(oData.passPrice);
                form.find(".soldisabled .ticket-price-input-fee").val(oData.passFees);
                form.find(".soldisabled .ticket-price-input-final").val(oData.passFinalPrice);
            } else {
                form.find(".soldisabled-pay").hide();
                form.find(".soldisabled-free").css("display", "");
            }
            if (oData.passDoorPriceActivated === "true") {
                form.find(".soldisabled-door").css("display", "");
                form.find(".tickets-doors-price-info").show();
                form.find(".tickets-price-box-door").show();
                form.find(".soldisabled input[name = 'doorPrice']").val(oData.doorPrice);
                form.find(".soldisabled input[name = 'doorFees']").val(oData.doorFees);
                form.find(".soldisabled input[name = 'doorFinalPrice']").val(oData.doorFinalPrice);
            } else {
                form.find(".soldisabled-door").hide();
                form.find(".tickets-doors-price-info").hide();
                form.find(".tickets-price-box-door").hide();
            }
            if (oData.passType === "1") {
                form.find(".package-standard-choice").hide();
                form.find(".package-multiple-choice").show();
                form.find(".package-multiple-choice-number-input-ctn").addClass("disabled disabled-ctn").find(".form-input").addClass("disabled").attr("disabled", "true");
            } else {
                form.find(".package-standard-choice").show();
                form.find(".package-multiple-choice").hide();
                form.find(".package-multiple-choice-number-input-ctn").removeClass("disabled disabled-ctn").find(".form-input").removeClass("disabled").removeAttr("disabled");
            }
        } else {
            form.find(".associate-package-tickets-boxes-outer-ctn").removeClass("soldlocked");
            leftBox.show();
            form.find(".ticket-price-outer-ctn").css("display", "");
            form.find(".soldisabled").hide();
            form.find(".package-standard-choice, .package-multiple-choice").show();
            form.find(".package-multiple-choice-number-input-ctn").removeClass("disabled disabled-ctn").find(".form-input").removeClass("disabled").removeAttr("disabled");
        }
        form.find(".ticket-form-info-quantity-sold").text(oData.inventory);
        form.find(".ticket-form-info-quantity-remain").text(parseInt(oData.qty) - parseInt(oData.inventory));
        // Clear the ticket list from the previous modification
        rightBox.find(".selected").each(function () {
            removeTicketFromPackage.call(this, { data: leftBox });
        });
        // Display the selected tickets using the ids
        for (var i = 0; i < idList.length; i++) {
            try {
                var ticketInfos = oData["passTicket-" + idList[i]];
                addTicketToPackage(null, rightBox[0], leftBox.find(".tickets-list-one-ticket-ctn[data-id='P1" + idList[i] + "']"), ticketInfos);
            } catch (err) {}
        }
    };

    var statusPrivateLink = function statusPrivateLink(e) {
        var btn = $(this),
            item = btn.closest("td"),
            xdata = jsonEscape(item.find(".xdata").text()),
            data = "",
            oData = JSON.parse(xdata),
            sus = "suspend-sale-btn",
            act = "activate-sale-btn";

        data += "&privateLinkId=" + oData.privateLinkId;
        data += "&eventId=" + oData.eventId;
        data += "&active=" + (oData.active === "true" ? "false" : "true");

        var _succeed = function _succeed(response) {
            var $tb = $(".event-form-private-link-table>tbody"),
                $tr = $tb.find("tr:eq(0)").clone(true, true),
                rws = $(".event-form-private-link-table>tbody>tr").length - 1;
            if (oData.privateLinkId.toString() === response.trim()) {
                oData.active = oData.active === "true" ? "false" : "true";
                if (oData.active === "true") {
                    btn.addClass(sus).removeClass(act);
                } else {
                    btn.addClass(act).removeClass(sus);
                }
                $tr = $tb.find("tr[data-pkid='" + oData.privateLinkId + "']");
                // //  $tr.find(".table-private-id").html(oData.privateLinkId);
                // $tr.find(".table-private-internal-name").html(oData.internalName);
                // $tr.find(".table-private-subtitle").html(oData.subtitle);
                // $tr.find(".table-private-url").html(oData.url);
                // $tr.find(".table-tickets-inner").html(oData.ticketsHTMList);
                $tr.find(".table-status-text").html(oData.active === "true" ? "Active" : "Inactive");
                $tr.find(".table-status-colorbar").attr("class", "table-status-colorbar " + (oData.active === "true" ? "blue" : "red"));
                $tr.find(".xdata").text(JSON.stringify(oData));
            }
        };

        ajax(managePrivateLinksPath + "?ajax=true&statusUpdate=true" + encodeURI(data), function (response) {
            if (response.trim() !== "fail") {
                _succeed(response.trim());
            } else {
                // Something here
            }
        });
    };

    var modifyPrivateLink = function modifyPrivateLink(e) {
        var btn = $(this),
            item = btn.closest("td"),
            form = $(".create-private-link-form"),
            xdata = jsonEscape(item.find(".xdata").text()),
            oData = JSON.parse(xdata),
            idList = oData.ticketIds.split(","),
            leftBox = form.find(".associate-private-link-tickets-box.left"),
            rightBox = form.find(".associate-private-link-tickets-box.right");

        if (item.closest("table").hasClass("packages-archive-table")) {
            return false;
        }

        form.find(".form-private-link-id").val(oData.id);
        pageScrlTo(form.parent().offset().top);

        if (!form.hasClass("open")) {
            $(".add-new-item-btn.private").trigger("click", { type: "modify" });
        }
        $(".create-private-link-btn", form).text(function () {
            return $(this).attr("data-label2");
        });

        for (var name in oData) {
            var el = form.find("[name='" + name + "']");
            if (el.length > 0) {
                var type = el.attr("type");
                var value = oData[name];

                if (type === "radio") {
                    el.each(function () {
                        if ($(this).val() === value) {
                            $(this).prop("checked", true).triggerHandler("change");
                        }
                    });
                } else if (type === "checkbox") {
                    if (el.prop("checked") !== (el.val() === value)) {
                        el.trigger("click").triggerHandler("change");
                    }
                } else {
                    el.val(value);
                    if (type !== "hidden") {
                        el.triggerHandler("blur");
                        triggerInputFocus(el);
                    }
                }

                if (name === "url") {
                    el.prop("readonly", true);
                }
            }
        }

        rightBox.find(".selected").each(function () {
            removeTicketFromPrivateLink.call(this, { data: leftBox });
        });
        // Display the selected tickets using the ids
        for (var i = 0; i < idList.length; i++) {
            try {
                var ticketInfos = oData["passTicket-" + idList[i]];
                addTicketToPrivateLink(null, rightBox[0], leftBox.find(".private-tickets-list-one-ticket-ctn[data-id='P1" + idList[i] + "']"), ticketInfos);
            } catch (err) {}
        }
    };

    var togglePackageVisibility = function togglePackageVisibility(e) {
        var btn = $(this),
            item = btn.closest("tr"),
            qeid = "&eventId=" + item.data("evid"),
            qpid = "&passId=" + item.data("pkid"),
            elCell = item.find(".table-status"),
            elColor = item.find(".table-status-colorbar"),
            elText = item.find(".table-status-text"),
            sus = "suspend-sale-btn",
            act = "activate-sale-btn";

        if (item.closest("table").hasClass("packages-archive-table")) {
            return false;
        }
        if (btn.hasClass(sus)) {
            ajax(managePackagePath + "?ajax=true&hideFromEvent=false" + qeid + qpid, function (response) {
                if (response.trim() !== "0" && response.trim() !== "fail") {
                    btn.addClass(act).removeClass(sus);
                    elCell.attr("data-active-e", "false");
                    elCell.attr("data-stat", "4");
                    elColor.attr("class", "table-status-colorbar " + elColor.attr("data-sc-2"));
                    elText.html(elText.attr("data-st-2"));
                }
            });
        } else {
            ajax(managePackagePath + "?ajax=true&hideFromEvent=true" + qeid + qpid, function (response) {
                if (response.trim() !== "0" && response.trim() !== "fail") {
                    btn.addClass(sus).removeClass(act);
                    elCell.attr("data-active-e", "true");
                    var stat = elCell.attr("data-active-a") === "false" ? "-1" : elCell.attr("data-stat");
                    elColor.attr("class", "table-status-colorbar " + elColor.attr("data-sc" + stat));
                    elText.html(elText.attr("data-st" + stat));
                }
            });
        }
    };

    var togglePackageSale = function togglePackageSale(e) {
        var btn = $(this),
            item = btn.closest("tr"),
            qpid = "&passId=" + item.data("pkid"),
            elCell = item.find(".table-status"),
            elColor = item.find(".table-status-colorbar"),
            elText = item.find(".table-status-text"),
            sus = "suspend-sale-btn",
            act = "activate-sale-btn";

        if (item.closest("table").hasClass("packages-archive-table")) {
            return false;
        }
        if (btn.hasClass(sus)) {
            ajax(managePackagePath + "?ajax=true&active=false" + qpid, function (response) {
                if (response.trim() !== "0" && response.trim() !== "fail") {
                    btn.addClass(act).removeClass(sus);
                    elCell.attr("data-active-a", "false");
                    elColor.attr("class", "table-status-colorbar " + elColor.attr("data-sc-1"));
                    elText.html(elText.attr("data-st-1"));
                }
            });
        } else {
            ajax(managePackagePath + "?ajax=true&active=true" + qpid, function (response) {
                if (response.trim() !== "0" && response.trim() !== "fail") {
                    btn.addClass(sus).removeClass(act);
                    elCell.attr("data-active-a", "true");
                    var stat = elCell.attr("data-active-e") === "false" ? "-2" : elCell.attr("data-stat");
                    elColor.attr("class", "table-status-colorbar " + elColor.attr("data-sc" + stat));
                    elText.html(elText.attr("data-st" + stat));
                }
            });
        }
    };

    var duplicatePackage = function duplicatePackage(e) {
        var item = $(this).closest("tr"),
            id = item.attr("data-pkid");

        if (item.closest("table").hasClass("packages-archive-table")) {
            return false;
        }
        ajax(managePackagePath + "?ajax=true&duplicate=true&passId=" + id, function (response) {
            if (response.trim() !== "fail") {
                var newId = response.substring(0, response.indexOf("-")),
                    clone = item.clone(true, true),
                    colStat = clone.find(".table-status"),
                    oData = {};

                clone.appendTo(item.parent());
                clone.attr("data-pkid", newId);
                // Check if the bundle's sale was out-of-stock then restock it as
                // this cloned bundle is new, the stock is restored. Default status is 1
                if (colStat.attr("data-stat") === "3") {
                    colStat.attr("data-stat", "1");
                    colStat.find(".table-status-colorbar").attr("class", "table-status-colorbar " + colStat.find(".table-status-colorbar").attr("data-sc1"));
                    colStat.find(".table-status-text").html(colStat.find(".table-status-text").attr("data-st1"));
                }
                clone.find(".table-quantity-left").html(clone.find(".table-quantity p")[0].childNodes[0].textContent);
                try {
                    oData = JSON.parse(jsonEscape(clone.find(".xdata").text()));
                } catch (err) {}
                // In case of error, skip data change
                // Assign new id and inventory in the data
                if (oData.passId) {
                    oData.passId = newId;
                    oData.inventory = 0;
                    clone.find(".xdata").text(JSON.stringify(oData));
                }
            } else {
                // Duplicate error
            }
        }, true);
    };

    var toggleArchivePackage = function toggleArchivePackage(e) {
        var btn = $(this),
            item = btn.closest("tr"),
            qpid = "&passId=" + item.data("pkid"),
            elCell = item.find(".table-status"),
            elColor = item.find(".table-status-colorbar"),
            elText = item.find(".table-status-text"),
            sus = "suspend-sale-btn",
            act = "activate-sale-btn";

        if (btn.hasClass(sus)) {
            ajax(managePackagePath + "?ajax=true&archive=true" + qpid, function (response) {
                if (response.trim() !== "fail") {
                    if (response.trim().split("-")[1] !== "true") {
                        return false;
                    }
                    btn.addClass(act).removeClass(sus);
                    elColor.attr("class", "table-status-colorbar " + elColor.attr("data-sc-3"));
                    elText.html(elText.attr("data-st-3"));
                    item.appendTo($(".packages-archive-table>tbody"));
                }
            });
        } else {
            ajax(managePackagePath + "?ajax=true&archive=false" + qpid, function (response) {
                if (response.trim() !== "fail") {
                    if (response.trim().split("-")[1] !== "false") {
                        return false;
                    }
                    btn.addClass(sus).removeClass(act);
                    var stat = elCell.attr("data-active-a") === "false" ? "-1" : elCell.attr("data-stat");
                    elColor.attr("class", "table-status-colorbar " + elColor.attr("data-sc" + stat));
                    elText.html(elText.attr("data-st" + stat));
                    item.appendTo($(".event-form-packages-table:not(.packages-archive-table)>tbody"));
                }
            });
        }
    };

    var displayPackageArchives = function displayPackageArchives(e) {
        var btn = $(this);
        if (!btn.hasClass("animing")) {
            btn.toggleClass("open animing");
            $(".packages-archive-table-ctn").slideToggle(300, function () {
                btn.removeClass("animing");
            });
        }
    };

    var displayPackageNumberInput = function displayPackageNumberInput(e) {
        if (this.checked) {
            var targ = $(this).closest(".package-type-choices-ctn").find(".package-multiple-choice-number");
            if (this.value === "1") {
                targ.removeClass("hide").find(".input").addClass("required");
                $(".package-minimum-tickets-amount-ctn").removeClass("hide");

                calculatePackagePrice();
                calculatePackageDoorPrice();
            } else {
                targ.addClass("hide").find(".input").removeClass("required");
                $(".package-minimum-tickets-amount-ctn").addClass("hide");
            }
        }
    };

    var changePackageMinTickets = function changePackageMinTickets(e) {
        var val = parseInt(this.value) || 1;
        if (val < 1) val = 1;

        var inp = this;
        setTimeout(function () {
            inp.value = val;
            d.querySelector(".package-minimum-tickets-amount-ctn .number").innerHTML = val;
        }, 60);
        calculatePackagePrice();
        calculatePackageDoorPrice();
    };

    var confirmDeletePackage = function confirmDeletePackage(e) {
        e.stopImmediatePropagation();
        var item = e.data.item;
        var pkid = item.attr("data-pkid");
        var xdata = jsonEscape(item.find(".xdata").eq(0).text());
        var oData = JSON.parse(xdata);
        var ticketIds = oData.ticketIds;

        ajax(managePackagePath + "?ajax=true&delete=true&passId=" + pkid, function (response) {
            if (response.trim() === "success") {
                item.remove();
                if ($(".form-package-id").val() === pkid) {
                    $(".create-package-form .close-toggle-form-btn").click();
                }
                // Release the bound tickets
                for (var tkid in _PASSTICKETS) {
                    var el = d.getElementById("tl1t_" + ticketIds[tkid]);
                    if (el && _PASSTICKETS[tkid] <= 0 && $(el).hasClass("local-disabled")) {
                        $(el).removeClass("local-disabled").find(".form-checkbox-ctn").removeClass("disabled").find(".form-check-input").attr("disabled", "false");
                    }
                }
            }
        });
        closeWindow("deletePackageConfirmPopup");
    };

    var deletePackage = function deletePackage(e) {
        var btnYes = $("#deletePackageConfirmPopup .popup-btn-confirm"),
            btnNo = $("#deletePackageConfirmPopup .popup-btn-cancel");

        btnYes.one("click", { item: $(this).closest("tr") }, confirmDeletePackage);
        btnNo.one("click", function (e) {
            btnYes.off("click", confirmDeletePackage);
            closeWindow("deletePackageConfirmPopup");
        });
        $("#deletePackageConfirmPopup").css("position", "absolute");
        openWindow("deletePackageConfirmPopup", true);
    };

    var deletePrivateLink = function deletePrivateLink(e) {
        var btnYes = $("#deletePrivateLinkConfirmPopup .popup-btn-confirm"),
            btnNo = $("#deletePrivateLinkConfirmPopup .popup-btn-cancel");

        btnYes.one("click", { item: $(this).closest("tr") }, confirmDeletePrivateLink);
        btnNo.one("click", function (e) {
            btnYes.off("click", confirmDeletePrivateLink);
            closeWindow("deletePrivateLinkConfirmPopup");
        });
        $("#deletePrivateLinkConfirmPopup").css("position", "absolute");
        openWindow("deletePrivateLinkConfirmPopup", true);
    };

    var confirmDeletePrivateLink = function confirmDeletePrivateLink(e) {
        e.stopImmediatePropagation();
        var item = e.data.item;
        var pkid = item.attr("data-pkid");
        var evid = item.attr("data-evid");
        var xdata = jsonEscape(item.find(".xdata").eq(0).text());
        var oData = JSON.parse(xdata);
        var ticketIds = oData.ticketIds;

        ajax(managePrivateLinksPath + "?ajax=true&delete=true&privateLinkId=" + pkid + "&eventId=" + evid, function (response) {
            if (response.trim() === "success") {
                item.remove();
                if ($(".form-private-link-id").val() === pkid) {
                    $(".create-private-link-form .close-toggle-form-btn").click();
                }
                for (var tkid in _PASSTICKETS) {
                    var el = d.getElementById("tl1t_" + ticketIds[tkid]);
                    if (el && _PASSTICKETS[tkid] <= 0 && $(el).hasClass("local-disabled")) {
                        $(el).removeClass("local-disabled").find(".form-checkbox-ctn").removeClass("disabled").find(".form-check-input").attr("disabled", "false");
                    }
                }
            }
        });
        closeWindow("deletePrivateLinkConfirmPopup");
    };

    var deletePool = function deletePool(e) {
        var btnYes = $("#deletePoolConfirmPopup .popup-btn-confirm"),
            btnNo = $("#deletePoolConfirmPopup .popup-btn-cancel");

        btnYes.one("click", { item: $(this).closest("tr") }, confirmDeletePool);
        btnNo.one("click", function (e) {
            btnYes.off("click", confirmDeletePool);
            closeWindow("deletePoolConfirmPopup");
        });
        $("#deletePoolConfirmPopup").css("position", "absolute");
        openWindow("deletePoolConfirmPopup", true);
    };

    var confirmDeletePool = function confirmDeletePool(e) {
        e.stopImmediatePropagation();
        var item = e.data.item;
        var pqid = item.attr("data-pqid");
        var evid = item.attr("data-evid");
        var xdata = jsonEscape(item.find(".xdata").eq(0).text());

        ajax(managePoolsPath + "?ajax=true&delete=true&poolId=" + pqid + "&eventId=" + evid, function (response) {
            if (response.trim().includes("fail")) {
                if (response.trim().includes("deletePoolVialate")) {
                    if (lang === "fr") {
                        alert("Des billets sont associés à ce groupe de billets. Vous devez retirer les billets de ce groupe avant de pouvoir le supprimer.");
                    } else {
                        alert("Tickets are already assigned to this pool. Please remove the tickets from this pool before deleting it.");
                    }
                }
            } else if (response.trim() === "success") {
                item.remove();
                if ($(".poolId").val() === pqid) {
                    $(".create-pool-form .close-toggle-form-btn").click();
                }
            }
        });
        closeWindow("deletePoolConfirmPopup");
    };

    var handleServiceFee = function handleServiceFee(event) {
        var t = $(this);

        if (t.hasClass('fee-per-transaction')) {
            $('.transaction-service-fee-ctn').slideToggle();
            $('.transaction-service-fee').toggleClass('required');
            $('.fee-per-ticket-ctn').toggleClass('disabled');
        } else {
            $('.fee-per-transaction-ctn').toggleClass('disabled');
            $('.ticket-service-fee-ctn').toggleClass('hide');
            $('.ticket-price-outer-ctn:not(.soldisabled) .ticket-price-input-service-fee').toggleClass('required');
            if (!t.is(":checked")) {
                $('.ticket-price-input-service-fee').val(0);
                $(".ticket-price-outer-ctn").each(function (e) {
                    calcTicketPriceFinal(e, $(this).find(".ticket-price-input-raw"));
                });
                $(".event-form-tickets-table .table-money").each(function () {
                    var t = $(this);
                    var ser = t.attr("data-service");
                    if (ser !== null && ser !== undefined) {
                        var price = t.attr("data-price");
                        var fPrice = Number.parseFloat(price) - Number.parseFloat(ser);
                        t.find("p").text(formatMoney(fPrice));
                        t.attr("data-price", fPrice);
                    }
                });
            } else {
                $(".event-form-tickets-table .table-money").each(function () {
                    var t = $(this);
                    var ser = t.attr("data-service");
                    if (ser !== null && ser !== undefined) {
                        var price = t.attr("data-price");
                        var fPrice = Number.parseFloat(price) + Number.parseFloat(ser);
                        t.find("p").text(formatMoney(fPrice));
                        t.attr("data-price", fPrice);
                    }
                });
                if ($(".toggle-form-ctn.open").length !== 0 && $("#ticketFormTkId").attr("value") !== null && $("#ticketFormTkId").attr("value") !== undefined) {
                    var sf = $(".event-form-tickets-table").find("tr[data-tkid = " + $("#ticketFormTkId").attr("value") + "]").find(".table-money").attr("data-service");
                    if (sf !== null && sf !== undefined) {
                        $('.ticket-price-input-service-fee').val(sf);
                        calcTicketPriceFinal(event, $(".ticket-price-input-raw"));
                    }
                }
            }
        }
    };

    //Event info
    var initStep1 = function initStep1() {
        eventAgeSelectInput = $('.event-age-select');
        eventAgeSelectInput.change(checkAgeChoice);
        eventTypeRadioInput = $('.form-check-input[name="ticketType"]');
        eventTypeRadioInput.change(checkEventType);
        nextStepBtn = $('.next-step-event-btn');
        nextStepBtn.click(goToNextStep);
        oneStepCtn = $('.steps-bar-one-step-number-outer-ctn');
        oneStepCtn.click(chooseStep);
        showStepsRespBtn = $('.create-event-choose-step-responsive-btn');
        showStepsRespBtn.click(showSteps);
        createEventBtn = $('.create-event-btn');
        createEventBtn.click(saveEvent);
        $('.popup-event-modified-btn').click(openEventModifiedPopup);
        publishEventBtn = $(".publish-event-btn");
        publishEventBtn.click(publishEvent);
        modifyEventBtn = $(".modify-event-btn");
        modifyEventBtn.click(savePubEvent);
        previewEventBtn = $('.preview-event-btn');
        previewEventBtn.click(previewEvent);
        eventVisibilityChoice = $('.event-visibility-choice');
        eventVisibilityChoice.change(checkVisibilityChoice);
        eventPublicationChoice = $('.event-publication-choice');
        eventPublicationChoice.change(checkPublicationChoice);
        searchProfileInput = $('.search-profile-input');
        searchProfileInput.keyup(searchProfile);
        searchInputAndDropDownCtn = $('.search-input-and-drop-down-ctn');
        searchDropDown = $('.search-drop-down');
        searchDropDownChoiceOuterCtn = $('.search-drop-down-choices-outer-ctn');
        searchDropDownChoiceInnerCtn = $('.search-drop-down-choices-inner-ctn');
        addressInput = $("input[name=locationAddress]");
        cityInput = $("input[name=locationCity]");
        cpInput = $("input[name=locationPC]");
        provInput = $("input[name=locationProvince]");
        countryInput = $("input[name=locationCountry]");
        addNewArtistBtn = $('.add-new-artist-btn');
        addNewArtistBtn.click(addNewProfile);
        addNewLocationBtn = $('.add-new-location-btn');
        addNewLocationBtn.click(addNewProfile);
        profileSelectionBox = $('.box-theme-ctn.profile-selection');
    };

    //Tickets and palier
    var initStep3 = function initStep3() {
        $(".fee-per-transaction").change(handleServiceFee);
        $(".fee-per-ticket").change(handleServiceFee);
        $(".add-new-item-btn.ticket").click(startNewTicket);
        $(".manage-levels-btn").click(toggleTicketStageForm);
        $(".ticket-qty-input").change(checkEventCapacity);
        $(".display-on-ticket-check").change(checkToDisplayEventDT);
        $(".ticket-price-online-choice").change(togglePriceBox);
        $(".ticket-price-door-choice").change(togglePriceBox);
        $(".ticket-price-input-raw").change(calcTicketPriceFinal);
        $(".ticket-price-input-service-fee").change(calcTicketPriceFinal);
        $(".ticket-price-input-final").change(calcTicketPriceRaw);
        $(".create-ticket-btn").click(createTicket);
        $(".event-form-tickets-table>tbody").sortable(new sortableOptions("ticket"));
        $(".event-form-tickets-table .table-delete-btn").click(deleteTicket);
        $(".toggle-ticket-sale-btn").click(toggleTicketSale);
        $(".modify-ticket-btn").click(modifyTicket);
        $(".modify-pool-btn").click(modifyPool);
        $(".table-position-arrow-btn.up").click(sortItemUp);
        $(".table-position-arrow-btn.down").click(sortItemDown);
        $(".event-form-pool-table .table-delete-btn").click(deletePool);
        $(".create-pool-btn").click(createPool);
        $(".manage-pooling-qty").click(startNewPool);
        $("#start-date-create-event-one-day").change(["#create-event-door-other-date", "#door-date-create-event-one-day"], setDoorDate);
        $("#customStart-date-multiple-days").change(["#create-ticket-door-other-date", "#customDoorStart-date-multiple-days"], setDoorDate);
        $(".modify-ticket-display-date").click(modifyTicketDisplayEventDate);
        $(".modify-ticket-display-door-time").click(modifyTicketDisplayDoorTime);

        $(".tickets-list-one-ticket-check").change(addOrRemoveStageTicket);
        $(".tickets-stage-table>tbody").sortable(new sortableOptions("stage"));
        $(".tickets-stage-table .table-delete-btn").click(removeStageTicket);
        $(".tickets-stage-save-btn").click(saveStageTicket);

        toggleServiceFeesBtn = $('.manage-service-fee');
        toggleServiceFeesBtn.on("click", toggleServiceFeeAction);
        togglePoolingQtyBtn = $('.ticket-pool-qty');
        togglePoolingQtyBtn.on("click", togglePoolingQtyAction);
        poolingQtySelect = $('.event-pooling-selection-ctn>select');
        poolingQtySelect.on("change", changeEventPool);
        serviceFeesCtn = $(".service-fees-options-ctn");
        poolingQtyCtn = $(".pooling-qty-items-ctn");
    };

    //Package Bundle Forfait
    var initStep4 = function initStep4() {
        try {
            $.extend(_PASSTICKETS, PASSTICKETS);
        } catch (err) {}

        $(".add-new-item-btn.package").click(startNewPackage);
        $(".create-package-btn").click(createPackage);
        $(".modify-package-btn").click(modifyPackage);
        $(".toggle-package-visible-btn").click(togglePackageVisibility);
        $(".toggle-package-sale-btn").click(togglePackageSale);
        $(".toggle-package-archive-btn").click(toggleArchivePackage);
        $(".duplicate-package-btn").click(duplicatePackage);
        $(".forfaits-archives-btn").click(displayPackageArchives);
        $(".event-form-packages-table").sortable(new sortableOptions("package"));
        $(".package-type-choices-ctn .radio").on("change", displayPackageNumberInput);
        $(".package-multiple-choice-number-input-ctn input").on("change", changePackageMinTickets);
        $(".event-form-packages-table .table-delete-btn").click(deletePackage);
    };

    var initStep6new = function initStep6new() {
        try {
            $.extend(_PASSTICKETS, PASSTICKETS);
        } catch (err) {}

        $(".add-new-item-btn.private").click(startNewPrivateLink);
        $(".create-private-link-btn").click(createPrivateLink);
        $(".modify-private-link-btn").click(modifyPrivateLink);
        $(".status-private-link-btn").click(statusPrivateLink);
        $(".event-form-private-link-table .table-delete-btn").click(deletePrivateLink);
        //  $(".toggle-package-visible-btn").click(togglePackageVisibility);
        //  $(".toggle-package-sale-btn").click(togglePackageSale);
        //  $(".toggle-package-archive-btn").click(toggleArchivePackage);
        //  $(".duplicate-package-btn").click(duplicatePackage);
        //  $(".forfaits-archives-btn").click(displayPackageArchives);
        // $(".event-form-packages-table").sortable(new sortableOptions("package"));
        //  $(".package-type-choices-ctn .radio").on("change", displayPackageNumberInput);
        // $(".package-multiple-choice-number-input-ctn input").on("change", changePackageMinTickets);
        // $(".event-form-packages-table .table-delete-btn").click(deletePackage);
    };

    //Merch
    var initStep5 = function initStep5() {
        $(".event-form-products-table>tbody").sortable(new sortableOptions("merch"));
    };

    var toggleSubAction = function toggleSubAction() {
        var t = $(this);
        var sub = t.next(".sub-ctn");
        if (t.find("input[type=checkbox]").is(":checked")) {
            sub.slideDown();
        } else {
            sub.slideUp();
        }
    };

    var toggleServiceFeeAction = function toggleServiceFeeAction() {
        var t = $(this);

        if (t.hasClass("active")) {
            serviceFeesCtn.slideUp();
            t.removeClass("active");
        } else {
            t.addClass("active");
            serviceFeesCtn.slideDown();
        }
    };
    var togglePoolingQtyAction = function togglePoolingQtyAction() {
        var t = $(this);
        if (!t.prop("checked")) {
            poolingQtyCtn.slideUp();
            poolingQtySelect.removeAttr("required");
            t.removeClass("active");
            // $(".ticket-form-infos-inputs-ctn").find(".ticket-qty-input").prop("readonly",false);
            // $(".ticket-form-infos-inputs-ctn").find(".min-one").prop("readonly",false);
        } else {

            var _succeed = function _succeed(response) {
                var poolSelect = $(".event-pooling-selection-ctn>select");
                var json = JSON.parse(response.trim());
                var items = "<option value='-1' dt-poolqty='0' dt-usedqty='0'>Select a pool</option>";
                for (var i = 0; i < json.length; i++) {
                    var item = json[i];
                    var selected = "";
                    if ($(".poolingQtyId").val() == item.poolId) {
                        selected = "selected";
                        var remain = parseInt(item.poolQty, 10) - parseInt(item.usedQty, 10);
                        $(".ticket-form-infos-inputs-ctn").find(".ticket-form-info-quantity-remain").text(remain);
                    }
                    items += "<option value='" + item.poolId + "' dt-poolqty='" + item.poolQty + "' dt-usedqty='" + item.usedQty + "' " + selected + ">" + item.poolName + " (" + item.usedQty + "/" + item.poolQty + ")" + "</option>";
                }
                poolSelect.html(items);
                // $(".ticket-form-infos-inputs-ctn").find(".ticket-qty-input").prop("readonly",true);
                // $(".ticket-form-infos-inputs-ctn").find(".min-one").prop("readonly",true);
                t.addClass("active");
                poolingQtySelect.prop("required", true);
                poolingQtyCtn.slideDown();
            };

            ajax(managePoolsPath + "?ajax=true&list=true&eventId=" + $("#ticketFormEvId").val(), function (response) {
                if (!response.trim().includes("fail")) {
                    _succeed(response.trim());
                } else {
                    alert(response.trim());
                }
            });
        }
    };

    var changeEventPool = function changeEventPool() {
        var t = $(this);
        var option = t.find("option[value='" + t.val() + "']");
        if (option != null) {
            var poolQty = option.attr("dt-poolqty");
            var usedQty = option.attr("dt-usedqty");
            // var remain= $(".ticket-form-infos-inputs-ctn").find(".ticket-form-info-quantity-remain").text();
            if (parseInt(poolQty, 10) > 0) {
                var remain = parseInt(poolQty, 10) - parseInt(usedQty, 10);
                $(".ticket-form-infos-inputs-ctn").find(".ticket-form-info-quantity-remain").text(remain);
            }
            //$(".ticket-form-infos-inputs-ctn").find(".ticket-qty-input").val(poolQty);
            //  $(".ticket-form-infos-inputs-ctn").find(".min-one").val(parseInt(poolQty,10)-parseInt(usedQty,10));
            // console.log(poolQty +" ," +usedQty);
        }
    };

    var init = function init() {
        currPage = $(".page");
        createEventForm = $('.create-event-form');
        editEventId = createEventForm.find('input[name="id"]').val();
        datePickerInput = $('.datepicker');
        datePickerInput.change(getPickerDate);
        timePickerInput = $('.timepicker');
        timePickerInput.change(getPickerTime);
        toggleSubBtn = $('.toggle-sub-ctn');
        toggleSubBtn.on("click", toggleSubAction);

        if (createEventForm.length > 0) {
            initStep1();
            initStep3();
            initStep4();
            initStep5();
            initStep6new();
        } else if (d.getElementById("manage_packages")) {
            loadPackageDirectories();
            loadPrivateDirectories();
            initStep3();
            initStep4();
            initStep5();
            initStep6new();
        }

        if (profileSelectionBox !== undefined) {
            // event profiles selection listeners
            profileSelectionBox.find('.one-profile-selected-ctn').each(function () {
                addSelectedProfileListeners($(this));
            });
        }

        if (searchProfileInput !== undefined) {
            // if focusin another search input on the page: hide drop down, reset input and displayed profiles array
            searchProfileInput.focusin(function () {
                var parent = $(this).closest(searchInputAndDropDownCtn);
                var pageCtn = parent.closest('.page');

                pageCtn.find(searchInputAndDropDownCtn).each(function () {
                    if ($(this) !== parent) {
                        resetSearchProfileInput($(this));
                        emptyDropDown($(this).find(searchDropDownChoiceInnerCtn).find('.search-drop-down-one-item'));
                    }
                });
            });
        }

        // DATETIME PICKERS INIT AND SETTINGS

        if (createEventForm.hasClass('fr')) {
            $.datetimepicker.setLocale('fr');
        }

        $('.event-datetime-start-and-end-ctn:not(.planification)').each(function () {
            var t = $(this);
            var minDate;

            if (t.closest('.event-form-step-ctn').length) {
                minDate = 0;
            } else {
                minDate = false;
            }

            compareDates($('.datepicker.start-date', t), $('.datepicker.end-date', t), t);

            // distinct inits for each input to enable individual datetimepicker options changes later
            $('.datepicker.start-date', t).datetimepicker({
                timepicker: false,
                format: 'Y/m/d',
                formatDate: 'Y/m/d',
                scrollInput: false,
                minDate: minDate,
                onChangeDateTime: function onChangeDateTime(dp, input) {
                    changeDateTimepickerRange(dp, input, t, minDate, true);
                }
            });

            var startDateVal = $('.datepicker.start-date', t).val();
            var startDateLimit = new Date(startDateVal.split('/')[0], startDateVal.split('/')[1] - 1, startDateVal.split('/')[2]);

            $('.datepicker.end-date', t).datetimepicker({
                timepicker: false,
                format: 'Y/m/d',
                formatDate: 'Y/m/d',
                scrollInput: false,
                minDate: t.hasClass('limit-time-range') ? startDateLimit : minDate,
                maxDate: t.hasClass('limit-time-range') ? new Date(startDateLimit.setDate(startDateLimit.getDate() + 1)) : false,
                onChangeDateTime: function onChangeDateTime(dp, input) {
                    changeDateTimepickerRange(dp, input, t, minDate);
                }
            });

            $('.timepicker.start-time', t).datetimepicker({
                datepicker: false,
                format: 'H:i',
                step: 15,
                scrollInput: true,
                onChangeDateTime: function onChangeDateTime(dp, input) {
                    changeDateTimepickerRange(dp, input, t, null, true);
                }
            });

            $('.timepicker.end-time', t).datetimepicker({
                datepicker: false,
                format: 'H:i',
                step: 15,
                scrollInput: true,
                onChangeDateTime: function onChangeDateTime(dp, input) {
                    changeDateTimepickerRange(dp, input, t);
                }
            });

            checkLimitTimeRange(t, $('.timepicker.start-time', t));
            checkLimitTimeRange(t, $('.timepicker.end-time', t));
        });

        // disable past dates and time for planned events
        $('.event-datetime-start-and-end-ctn.planification').each(function () {
            var t = $(this);

            $('.datepicker', t).datetimepicker({
                timepicker: false,
                format: 'Y/m/d',
                scrollInput: false,
                minDate: 0,
                onChangeDateTime: function onChangeDateTime(dp, input) {
                    var today = new Date();
                    var dateChoice = input.datetimepicker('getValue');

                    if (dateChoice !== ('' || null)) {
                        if (today.getFullYear() === dateChoice.getFullYear() && today.getMonth() === dateChoice.getMonth() && today.getDate() === dateChoice.getDate()) {
                            $('.timepicker', t).datetimepicker('setOptions', {
                                minTime: 0
                            });
                        } else if (today.getFullYear() !== dateChoice.getFullYear() || today.getMonth() !== dateChoice.getMonth() || today.getDate() !== dateChoice.getDate()) {
                            $('.timepicker', t).datetimepicker('setOptions', {
                                minTime: false
                            });
                        }
                    }
                }
            });

            $('.timepicker', t).datetimepicker({
                datepicker: false,
                format: 'H:i',
                step: 15,
                scrollInput: false,
                minTime: 0
            });
        });

        // individual pickers
        $('.single-picker .datepicker').datetimepicker({
            timepicker: false,
            format: 'Y/m/d',
            scrollInput: false
        });

        $('.single-picker .timepicker').datetimepicker({
            datepicker: false,
            format: 'H:i',
            step: 15,
            scrollInput: false
        });

        //When price at door activated for pass : display door rebate input for each ticket
        $(".ticket-price-door-choice[name = 'passDoorPriceActivated']").on("change", activatePassRebateTicket);
        //When free online price activated for pass : hide rebate input for each ticket
        $(".ticket-price-online-choice[name = 'passFree']").on("click", toggleOnlineRebate);

        if ($('.create-event-form').length > 0) {
            $(window).bind('beforeunload', function () {
                return true;
            });
        }
    };

    $(g).on("load", init);
})(jQuery, document, window);
(function ($, undefined) {

   'use strict';

   var currPage;
   var profile;

   var selectProfile = function selectProfile() {
      var id = $(this).attr("data-profile-id");
      $(".link-profile-invitation input[name=id]").val(id);
   };

   var init = function init(page) {
      currPage = $(page);

      profile = $(".invitation-choice-profiles .items-list-one-item-ctn");
      profile.on("click", selectProfile);
   };

   $(window).on("load", function () {
      init();
   });
})(jQuery);
(function ($, undefined) {

	'use strict';
	//    var profile = Fw.component.models().profile;

	var currPage;

	var init = function init(page) {
		currPage = $(page);

		//        profile.init(page);
	};

	$(window).on("load", function () {
		init();
	});
})(jQuery);
(function ($, undefined) {

    'use strict';

    var filterBox;
    var archiveBtn;
    var approveTaxBtn;
    var cancelRefBtn;
    var acceptRefundBtn;
    var transferBtn;
    var eventRefundAmount;
    var shipTicketsBtn;
    var shipTicketsFromPayBtn;
    var rebillBtn;
    var approveAppBtn;
    var refuseAppBtn;
    var tools;

    var filterBy = function filterBy() {
        var t = $(this);
        t.closest("form").submit();
    };

    var archiveAlert = function archiveAlert() {
        var t = $(this);
        var id = t.attr("data-id");
        var archived = t.hasClass("archived");
        t.addClass("disabled");

        var url = "/action/epManageAlerts";
        url += "?ajax=true";
        url += "&id=" + id;
        url += "&archive=" + !archived;

        ajax(url, function () {
            t.closest("tr").addClass("toggle-archive-selected");
            window.setTimeout(function () {
                var cl = t.closest("tr").clone(true);
                t.closest("tr").find("td").slideUp(function () {
                    var text = "";
                    if (archived) {
                        cl.find(".table-alerts-list-archive-action").removeClass("archived");
                        text = cl.find(".table-alerts-list-archive-action").find("p").attr("data-archive");
                        cl.find(".table-alerts-list-archive-action").find("p").html(text);
                        cl.insertAfter('.not-archive-table-list tr:first');
                    } else {
                        cl.find(".table-alerts-list-archive-action").addClass("archived");
                        text = cl.find(".table-alerts-list-archive-action").find("p").attr("data-unarchive");
                        cl.find(".table-alerts-list-archive-action").find("p").html(text);
                        cl.insertAfter('.archive-table-list tr:first');
                    }

                    cl.removeClass("toggle-archive-selected");
                    cl.find("button.disabled").removeClass("disabled");
                    $(this).parent().remove();
                });
            }, 1000);
        }, true);
    };

    var approveTax = function approveTax() {
        var t = $(this);
        var id = t.attr("data-id");
        var accepted = t.hasClass("accepted");
        t.addClass("disabled");

        var url = "/action/updatePersonFields";
        url += "?ajax=true";
        url += "&id=" + id;
        url += "&field18=" + !accepted;

        ajax(url, function () {
            var text = "";
            if (accepted) {
                t.removeClass("accepted");
                text = t.find("p").attr("data-approve");
                t.find("p").html(text);
            } else {
                t.addClass("accepted");
                text = t.find("p").attr("data-approved");
                t.find("p").html(text);
            }
            t.removeClass("disabled");
        }, true);
    };

    /* Request for refund already created : this cancels it. */
    var cancelRefundPaymentFromAlert = function cancelRefundPaymentFromAlert() {
        var t = $(this);
        t.addClass("disabled");
        var id = t.attr("data-id");
        var url = "/action/epRefund?ajax=true";
        url += "&cancel=true";
        if (id !== '-1') {
            url += "&paymentId=" + id;
        } else if (id === '-1') {
            url += '&alertId=' + t.closest('tr').attr('data-id');
        }

        ajax(url, function (response) {
            t.addClass("canceled");
            t.closest(".table-alerts-actions").find(".table-alerts-list-approve-refund-action").addClass("disabled");
            var text = t.find("p").attr("data-canceled");
            t.find("p").html(text);
        }, true);
    };

    /* Request for refund already created : accept it. */
    var acceptRefundPaymentFromAlert = function acceptRefundPaymentFromAlert() {
        var t = $(this);
        t.addClass("disabled");
        var id = t.attr("data-id");
        var url = "/action/epRefund?ajax=true";
        if (id !== '-1') {
            url += "&paymentId=" + id;
        } else if (id === '-1') {
            url += '&accept=true&alertId=' + t.closest('tr').attr('data-id');
        }

        ajax(url, function (response) {
            t.addClass("accepted");
            t.closest(".table-alerts-actions").find(".table-alerts-list-cancel-refund-action").addClass("disabled");
            var text = t.find("p").attr("data-approved");
            t.find("p").html(text);
        }, true);
    };

    var updateShippedTickets = function updateShippedTickets() {
        var t = $(this);
        var id = t.attr("data-id");
        var post = true;

        if (t.hasClass('shipped')) {
            post = false;
        }

        var url = "/action/epManageAlerts?ajax=true";
        url += "&id=" + id;
        url += "&post=" + post;

        ajax(url, function (response) {
            if (t.hasClass('shipped')) {
                t.removeClass("shipped");
                var text = t.find("p").attr("data-ship");
            } else {
                t.addClass("shipped");
                var text = t.find("p").attr("data-shipped");
            }
            t.find("p").html(text);
        }, true);
    };

    var updateShippedTicketsFromPayment = function updateShippedTicketsFromPayment() {
        var t = $(this);
        var id = t.attr("data-id");
        var post = true;

        if (t.hasClass('shipped')) {
            post = false;
        }

        var url = "/action/epManageTransactions?ajax=true";
        url += "&paymentId=" + id;
        url += "&post=" + post;

        ajax(url, function (response) {
            var cell = t.closest("tr").find(".transaction-detail span");
            var text = "";
            var cellText = "";
            if (t.hasClass('shipped')) {
                t.removeClass("shipped");
                text = t.find("p").attr("data-ship");
                cellText = cell.attr("data-ship");
            } else {
                t.addClass("shipped");
                text = t.find("p").attr("data-shipped");
                cellText = cell.attr("data-shipped");
            }
            t.find("p").html(text);
            cell.html(cellText);
        }, true);
    };

    var transferPayment = function transferPayment() {
        var t = $(this);
        var line = t.closest(".alert-line");
        var ctn = t.closest(".claim-payment-popup");
        var input = ctn.find(".claim-amt-payment");
        var amt = input.val();
        var id = t.attr("data-id");

        formValidator.validateForm(ctn);
        t.addClass("disabled");

        if (!ctn.hasClass('has-error')) {
            var url = "/action/epManageAlerts";
            url += "?ajax=true";
            url += "&id=" + id;
            url += "&field2=true";
            url += "&field5=" + amt;

            ajax(url, function () {
                line.find(".sum-transfered").html(amt + "$");
                line.find(".table-alerts-list-accept-transfer-action").addClass("accepted").addClass("disabled");
                var text = line.find(".table-alerts-list-accept-transfer-action p").attr("data-accepted");
                line.find(".table-alerts-list-accept-transfer-action p").html(text);
            }, true);
        }
    };

    var getEventRefundAmounts = function getEventRefundAmounts() {
        eventRefundAmount.each(function () {
            var t = $(this);

            var url = '/action/epRefund';
            url += '?eventId=' + t.attr('data-id');
            url += '&data=true&ajax=true';
            ajax(url, function (response) {
                t.find('.amount').html(parseFloat(response.split('~')[0]).toFixed(2));
                t.find('.consignes').html(response.split('~')[4]);
            }, true);
        });
    };

    var rebillAction = function rebillAction() {
        var t = $(this);
        var ctn = t.closest(".js-form");
        var input = ctn.find(".rebill-input-amt input");
        var amt = input.val();
        var profileId = ctn.find("input[name=profileId]").val();
        var alertId = ctn.find("input[name=alertId]").val();
        var personId = ctn.find("input[name=personId]").val();
        var btn = t.closest("tr").find(".table-alerts-list-re-bill-action");
        var zeroOrUnderError = $('.js-form-error-message.requested-amount-zero-or-under', ctn);
        var fail = $('.fail-msg', ctn);
        var success = $('.js-form-success-message', ctn);

        formValidator.validateForm(ctn);

        if (!ctn.hasClass('has-error')) {
            t.addClass("disabled");
            if (parseFloat(amt) <= 0) {
                t.removeClass("disabled");
                zeroOrUnderError.slideDown();
            } else {
                var url = "/action/epMonthlyPayments";
                url += "?alertId=" + alertId;
                url += "&profileId=" + profileId;
                url += "&personId=" + personId;
                url += "&amt=" + amt;

                ajax(url, function (response) {
                    t.removeClass("disabled");
                    if (response.trim() === "null") {
                        btn.addClass("accepted");
                        btn.find("p").text(btn.find("p").attr("data-accepted"));
                        success.slideDown();
                    } else {
                        fail.slideDown();
                    }
                }, true);
            }
        }
    };

    var approveApp = function approveApp() {
        var t = $(this);
        var refuseBtn = $(this).closest(".admin-alerts-actions").find(".table-alerts-list-refuse-app");
        var id = t.attr("data-id");
        var appId = t.attr("data-gid");
        var lang = $("html").attr('lang');
        var email = t.attr('data-email');
        var alreadyApproved = t.hasClass("accepted");

        var url = "/action/manageGenData";
        url += "?ajax=true";
        url += "&id=" + appId;
        url += "&field2=2";

        ajax(url, function () {
            var url2 = "/action/epManageAlerts";
            url2 += "?ajax=true";
            url2 += "&id=" + id;
            url2 += "&field2=true";
            url2 += "&field3=false";
            ajax(url2, function () {
                var text = "";
                t.addClass("accepted");
                text = t.find("p").attr("data-approved");
                t.find("p").html(text);
                t.removeClass("disabled");

                refuseBtn.removeClass("refused");
                text = refuseBtn.find("p").attr("data-refuse");
                refuseBtn.find("p").html(text);

                if (!alreadyApproved) {
                    var subject = lang === "fr" ? "Votre demande pour une application mobile a été acceptée!" : "Your request for a mobile app has been approved!";
                    tools.sendEmail(email, subject, null, "app-approved-" + lang, null, function (response) {});
                }
            }, true);
        }, true);
    };

    var refuseApp = function refuseApp() {
        var t = $(this);
        var id = t.attr("data-id");
        var appId = t.attr("data-gid");
        var acceptBtn = $(this).closest(".admin-alerts-actions").find(".table-alerts-list-validate-app");
        var email = t.attr('data-email');
        var lang = $("html").attr('lang');
        var alreadyRefused = t.hasClass("refused");

        var url = "/action/manageGenData";
        url += "?ajax=true";
        url += "&id=" + appId;
        url += "&field2=3";

        ajax(url, function () {
            var url2 = "/action/epManageAlerts";
            url2 += "?ajax=true";
            url2 += "&id=" + id;
            url2 += "&field2=false";
            url2 += "&field3=true";
            ajax(url2, function () {
                var text = "";
                t.addClass("refused");
                text = t.find("p").attr("data-refused");
                t.find("p").html(text);
                t.removeClass("disabled");

                acceptBtn.removeClass("accepted");
                text = acceptBtn.find("p").attr("data-approve");
                acceptBtn.find("p").html(text);

                if (!alreadyRefused) {
                    var subject = lang === "fr" ? "Votre demande pour une application mobile a été refusée" : "Your request for a mobile app has been denied";
                    tools.sendEmail(email, subject, null, "app-refused-" + lang, null, function (response) {});
                }
            }, true);
        }, true);
    };

    var init = function init(page) {
        tools = Fw.component.models().tools;
        filterBox = $(".filter-alerts-select");
        filterBox.on("change", filterBy);

        archiveBtn = $(".table-alerts-list-archive-action");
        archiveBtn.on("click", archiveAlert);

        approveTaxBtn = $(".table-alerts-list-validate-tax-action");
        approveTaxBtn.on("click", approveTax);

        cancelRefBtn = $(".table-alerts-list-cancel-refund-action:not(.canceled)");
        cancelRefBtn.on("click", cancelRefundPaymentFromAlert);

        acceptRefundBtn = $(".table-alerts-list-approve-refund-action:not(.accepted)");
        acceptRefundBtn.on("click", acceptRefundPaymentFromAlert);

        transferBtn = $(".make-payment-confirm-btn");
        transferBtn.on("click", transferPayment);

        eventRefundAmount = $('.event-refund-amount, .event-refund-consignes');

        if (eventRefundAmount.length) {
            getEventRefundAmounts();
        }

        shipTicketsBtn = $('.table-alerts-list-ship-consigne-action');
        shipTicketsBtn.click(updateShippedTickets);

        shipTicketsFromPayBtn = $('.table-transactions-list-ship-consigne-action');
        shipTicketsFromPayBtn.click(updateShippedTicketsFromPayment);

        rebillBtn = $('.submit-rebill-btn');
        rebillBtn.click(rebillAction);

        approveAppBtn = $(".table-alerts-list-validate-app");
        approveAppBtn.on("click", approveApp);

        refuseAppBtn = $(".table-alerts-list-refuse-app");
        refuseAppBtn.on("click", refuseApp);
    };

    $(window).on("load", function () {
        init();
    });
})(jQuery);
(function ($, undefined) {

    'use strict';

    var currPage;
    var claimPaymentBtn;

    var claimPayment = function claimPayment() {
        var t = $(this);
        var ctn = t.closest(".claim-payment-popup");
        var input = ctn.find(".claim-amt-payment");
        var amt = input.val();
        var limit = input.attr("max");
        var limitExceededError = $('.js-form-error-message.requested-amount-excedes-balance', ctn);
        var zeroOrUnderError = $('.js-form-error-message.requested-amount-zero-or-under', ctn);

        formValidator.validateForm(ctn);

        if (!ctn.hasClass('has-error')) {
            t.addClass("disabled");

            if (parseFloat(amt) <= 0) {
                t.removeClass("disabled");
                zeroOrUnderError.slideDown();
            } else {
                if (parseFloat(amt) <= parseFloat(limit)) {
                    limitExceededError.slideUp();
                    zeroOrUnderError.slideUp();
                    var url = "/action/epAddAlert";
                    url += "?ajax=true";
                    url += "&amt=" + amt;

                    ajax(url, function () {
                        ctn.find(".request-success").slideDown();
                        window.setTimeout(function () {
                            location.reload();
                        }, 1500);
                    }, true);
                } else {
                    t.removeClass("disabled");
                    limitExceededError.slideDown();
                }
            }
        }
    };

    var init = function init(page) {
        currPage = $(page);

        claimPaymentBtn = $(".claim-payment-confirm-btn");
        claimPaymentBtn.on("click", claimPayment);
    };

    $(window).on("load", function () {
        init();
    });
})(jQuery);
(function ($, undefined) {

	'use strict';
	//    var profile = Fw.component.models().profile;

	var currPage;

	var init = function init(page) {
		currPage = $(page);

		//        profile.init(page);
	};

	$(window).on("load", function () {
		init();
	});
})(jQuery);
(function ($, d, g) {

    'use strict';

    var void0 = function void0() {};
    var lang = d.documentElement.lang;
    var ua = navigator.userAgent;
    var isSafari = ua.indexOf("Safari") > -1 && ua.indexOf("Chrome") === -1;
    var isPhod = ua.match(/(iPhone|iPod)/i);

    var currPage;
    var eventTicketsCtn;
    var ticketQtySel;
    var addCartBtn;
    var addCartProductBtn;
    var tabsBar;
    var tabsCtn;
    var getPackageTicketsListBtn;
    var prevSelectedTickets;
    var cartCtn;
    var picPreview;
    var openProductPopupBtn;
    var respDetectionSmScreen;
    var productOptionSelect;
    var removeFromCart;

    var updateCart = function updateCart(q, p, nofx, f) {
        var $q = $(".dynamic-qty");
        var $p = $(".cart-tickets-price");
        // var $f = $(".cart-tickets-price-fees");
        if (nofx) {
            $q.html(q);
            $p.html(formatMoney(p));
            $f.html(formatMoney(f));
        } else {
            $q.fadeOut(200, function () {
                $q.html(q);
                $q.fadeIn(200);
            });
            $p.fadeOut(200, function () {
                $p.html(formatMoney(p));
                $p.fadeIn(200);
            });
            // $f.fadeOut(200, function(){
            //     $f.html(formatMoney(f));
            //     $f.fadeIn(200);
            // });
        }
    };

    var sumCart = function sumCart() {
        if ($(this).closest('.event-tickets-ctn').length !== 0) {
            var t = $(this);
            var count = 0;
            var total = 0;
            var fees = 0;
            ticketQtySel.each(function () {
                count += parseInt($(this).val());
                total += parseFloat($(this.options[this.selectedIndex]).data("value"));
                fees += parseFloat($(this.options[this.selectedIndex]).data("fees"));
            });
            if (addCartBtn.hasClass('disabled') && count !== 0) {
                addCartBtn.removeClass('disabled');
            } else if (!addCartBtn.hasClass('disabled') && count === 0) {
                addCartBtn.addClass('disabled');
            }
            updateCart(count, total, null, fees);
            tools.disableQtyBtns(t, t.val(), t.find('option:first-child').val(), t.find('option:last-child').val());
        }
    };

    var sessionDirectEntrance = "virtualCashierDirectEntrance";
    var checkQty = function checkQty(e, t) {
        //        var t = $(this);
        var ctn = t.closest('.virtual-cash-ticket-ctn');
        var check = ctn.find('.virtual-cash-checked-icon');
        $(".virtual-cashier-continue").addClass("disabled");
        setTimeout(function () {
            if (parseInt(ctn.find('select').val()) > 0) {
                check.removeClass('hidden');
                $(".virtual-cash-step-1-warning-1").slideUp();
                if (ctn.attr("data-pass") === 'true') {
                    $(".virtual-cash-step-1-options-ctn").find("input[name='directEntrance']").prop("checked", false);
                    $(".virtual-cash-step-1-options-ctn").find("input[name='directEntrance']").attr("disabled", true);
                    $(".virtual-cash-step-1-options-ctn").find(".check-direct-entrance").addClass("disabled").addClass("fade");

                    session.save(sessionDirectEntrance, "false", function () {});

                    //                    checkInventory(t, ctn.attr("data-id"));
                }
            } else {
                var counter = 0;
                $(".virtual-cash-ticket-ctn[data-pass = 'true']").each(function () {
                    counter += parseInt($(this).find(".event-ticket-select").val());
                });
                if (counter === 0) {
                    $(".virtual-cash-step-1-options-ctn").find("input[name='directEntrance']").removeAttr("disabled");
                    $(".virtual-cash-step-1-options-ctn").find(".check-direct-entrance").removeClass("disabled").removeClass("fade");
                }
                check.addClass('hidden');
                //                checkInventory(t, ctn.attr("data-id"));
            }
            $(".virtual-cashier-continue").removeClass("disabled");
        }, 300);
    };

    var addCart = function addCart(e) {
        var t = $(this);
        var ids = "";
        var qtys = "";
        var doorPrices = "";
        var passTicketIds = "";
        var eventId = "";
        var hasError = false;
        var delay = 0;

        if (t.hasClass('change-qty-btn')) {
            // leave time to change qty before updating cart
            delay = 100;
        }

        console.log('calling facebook function AddToCart ...............');
        fbq('track', 'AddToCart');
        // fbq('trackCustom', 'EpassliveTestAddToCart');

        setTimeout(function () {
            if (t.closest(".virtual-cash-ticket-ctn").length !== 0) {
                checkQty(e, t);
            }
            $(".event-one-ticket-select-qty").each(function (e) {
                var t = $(this);
                var qty = t.find(".event-ticket-select").val();
                ids += t.attr("data-id") + ",";
                qtys += qty + ",";
                if (t.closest(".virtual-cash-ticket-ctn").length !== 0) {
                    doorPrices += t.closest(".virtual-cash-ticket-ctn").attr("data-doorPrice") + ",";
                }

                if (t.data('is-multiple-choices') === true) {
                    var parent = t.closest('.event-one-ticket-ctn');
                    var nbrToChoose = t.data('nbr-to-choose');

                    var par = parent.closest(".virtual-cash-ticket-ctn");
                    if (par.length !== 0) {
                        var id = par.attr("data-id");
                        var doorPrice = par.attr("data-doorPrice") === 'true';
                        if (doorPrice) {
                            parent = $(".virtual-cash-ticket-ctn[data-id = '" + id + "'][data-doorPrice = '" + !doorPrice + "']");
                        }
                    }

                    var checkboxes = parent.find('.form-check-input');
                    var count = 0;
                    if (!checkboxes) {
                        handleMulTicketsChoiceMissing(e, t);
                        hasError = true;
                    } else {
                        if (parseInt(qty) !== 0) {
                            checkboxes.each(function () {
                                if ($(this).prop('checked') === true) {
                                    passTicketIds += $(this).val() + '-';
                                    count++;

                                    if (count === nbrToChoose) {
                                        passTicketIds += ',';
                                    }
                                }
                            });
                        } else {
                            passTicketIds += "0,";
                        }
                    }
                    if (count !== nbrToChoose && qty > 0) {
                        handleMulTicketsChoiceMissing(e, t);
                        hasError = true;
                        if (t.closest(".virtual-cash-ticket-ctn").length !== 0) {
                            t.closest(".virtual-cash-ticket-ctn").find(".event-ticket-select").val("0");
                            t.closest(".virtual-cash-ticket-ctn").find(".change-qty-btn.minus").addClass("disabled");
                        }
                    }
                } else {
                    if (t.attr('data-is-pass') === 'true') {
                        passTicketIds += t.attr('data-pass-tickets-ids') + ',';
                    } else {
                        passTicketIds += "X,";
                    }
                }

                eventId = t.attr('data-event-id');
                t.find(".event-ticket-select").addClass("disabled");
            });

            if (!hasError) {
                t.addClass('disabled');
                var jsessionId = getCookieValue('JSESSIONID');
                var submitCart = $('#ifsubmitCart').val();

                if (submitCart == 'Submit') {
                    $('#ifoverride').val('true');
                    $('#ifticketIds').val(ids);
                    $('#ifquantitys').val(qtys);
                    $('#ifpassTicketIds').val(passTicketIds);
                    $('#ifeventId').val(eventId);
                    if (doorPrices !== '') {
                        $('#ifdoorPrices').val(doorPrices);
                    }
                    if (t.closest(".virtual-cash-ticket-ctn").length !== 0) {
                        $('#ifvirtualCashier').val('true');
                    }
                    $('#ifsubmitCartForm').submit();
                } else {
                    var url = "/action/epAddCart";
                    url += "?ajax=true&override=true";
                    url += "&jsessionId=" + jsessionId;
                    url += "&ticketIds=" + ids;
                    url += "&quantitys=" + qtys;
                    url += "&passTicketIds=" + passTicketIds;
                    url += "&eventId=" + eventId;
                    if (doorPrices !== '') {
                        url += "&doorPrices=" + doorPrices;
                    }
                    if (t.closest(".virtual-cash-ticket-ctn").length !== 0) {
                        url += "&virtualCashier=true";
                    }
                    if (t.data('flush-cart') && t.data('flush-cart') === true) {
                        ajax('/action/epAddCart?clear=true&ajax=true&jsessionId=' + jsessionId, function (response) {
                            addToCartAjax(url, t);
                        }, true);
                    } else {
                        addToCartAjax(url, t);
                    }
                }
            }
        }, delay);
    };

    var addCartProduct = function addCartProduct(e) {
        var t = $(this);
        var hasError = false;
        var ctn = t.closest(".product-add-to-cart-outer-ctn");
        var qty = ctn.find("select[name = 'qty']").val();
        var eventId = t.attr("data-eid");
        var productId = t.attr("data-id");
        var optionId = ctn.find("select[name = 'option']");
        var jsessionId = getCookieValue('JSESSIONID');

        if (!hasError) {
            t.addClass('disabled');
            console.log('calling facebook function product AddToCart ...............');
            fbq('track', 'AddToCart');
            // fbq('trackCustom', 'EpassliveTestAddToCart');

            var submitCart = $('#ifpsubmitCart').val();

            if (submitCart == 'Submit') {
                $('#ifpoverride').val('true');
                $('#ifpproductId').val(productId);
                $('#ifpquantity').val(qty);
                $('#ifpeventId').val(eventId);
                if (optionId !== undefined) {
                    $('#ifpoptionId').val(optionId.val());
                }
                $('#ifpsubmitCartForm').submit();
            } else {
                var url = "/action/epAddCart";
                url += "?ajax=true&override=true";
                url += "&jsessionId=" + jsessionId;
                url += "&productId=" + productId;
                url += "&quantity=" + qty;
                url += "&eventId=" + eventId;

                if (optionId !== undefined) {
                    url += "&optionId=" + optionId.val();
                }

                if (t.data('flush-cart') && t.data('flush-cart') === true) {
                    ajax('/action/epAddCart?clear=true&ajax=true&jsessionId=' + jsessionId, function (response) {
                        $('.items-from-other-page-in-cart').slideUp();
                        addToCartProductAjax(url, t, ctn, optionId, qty, productId);
                    }, true);
                } else {
                    addToCartProductAjax(url, t, ctn, optionId, qty, productId);
                }
            }
        }
    };

    var addToCartProductAjax = function addToCartProductAjax(url, t, ctn, option, productQty, productId) {
        ajax(url, function (response) {
            if (response.indexOf("error") !== -1) {
                updateCartProduct(0);
                //                $(".cart-ticket-error").slideDown();

                if (!addCartBtn.hasClass('change-qty-btn')) {
                    t.removeClass('disabled');
                } else {
                    addCartBtn.each(function () {
                        var select = $(this).closest('.qty-input-with-buttons').find('select');
                        tools.disableQtyBtns(select, select.val(), select.find('option:first-child').val(), select.find('option:last-child').val());
                    });
                }
            } else {
                t.removeClass("disabled");
                //                $(".cart-ticket-error").slideUp();
                var merchQty = parseInt(response.substring(response.indexOf("/") + 1).trim());
                var qty = parseInt(response.split(':')[1].split('-')[0]) + merchQty;
                updateCartProduct(qty === "" ? 0 : qty);

                if (option !== undefined && option.length !== 0) {
                    option.find('option[value=' + option.val() + ']').data('cart', parseInt(productQty));
                    adjustAvailableProdQty(option);
                }

                var virtualCashCtn = ctn.closest('.profile-one-product-ctn');
                var virtualCashQtyCtn = virtualCashCtn.find('.virtual-cash-qty-check');
                if (virtualCashQtyCtn) {
                    var virtualCashDeliveryOptions = $('.merch-delivery-inputs-ctn');
                    if (merchQty > 0) {
                        virtualCashDeliveryOptions.slideDown();
                        virtualCashDeliveryOptions.find('.payment-process-radio').addClass('required');

                        addCartLineProduct(virtualCashCtn, productQty, option, productId);
                    } else {
                        virtualCashDeliveryOptions.slideUp();
                        virtualCashDeliveryOptions.find('.payment-process-radio').removeClass('required');
                        addCartLineProduct(virtualCashCtn, productQty, option, productId);
                    }
                    updateQtysInCart();
                    //                    virtualCashQtyCtn.find('.qty').html(productQty);
                    //                    if (productQty !== '0') {
                    //                        virtualCashQtyCtn.fadeIn();
                    //                    } else {
                    //                        virtualCashQtyCtn.fadeOut();
                    //                    }
                }

                var productCtn = virtualCashCtn ? virtualCashCtn : ctn;

                if (!productCtn.find(addCartBtn).hasClass('change-qty-btn')) {
                    productCtn.find('select[name = "qty"]').val("0");
                    productCtn.find('.change-qty-btn.minus').addClass('disabled');
                    productCtn.find('.change-qty-btn.plus').removeClass('disabled');
                    productCtn.find('.product-element-added').slideDown("fast", function () {
                        $(this).removeClass("hide");
                    });
                    t.removeClass('disabled');

                    window.setTimeout(function () {
                        productCtn.find('.product-element-added').slideUp("fast", function () {
                            $(this).addClass("hide");
                        });
                    }, 3000);
                } else {
                    productCtn.find(addCartBtn).each(function () {
                        var select = $(this).closest('.qty-input-with-buttons').find('select');
                        select.val(0);
                        tools.disableQtyBtns(select, select.val(), select.find('option:first-child').val(), select.find('option:last-child').val());
                    });
                }
            }
        }, true);
    };

    var addCartLineProduct = function addCartLineProduct(virtualCashCtn, merchQty, option, productId) {
        var optionId = -1;
        if (option !== undefined && option.length !== 0) {
            optionId = option.val();
        }

        if ($(".payment-process-table-row[data-productId=" + productId + "][data-optionId=" + optionId + "]").length !== 0) {
            var row = $(".payment-process-table-row[data-productId=" + productId + "][data-optionId=" + optionId + "]");
            if (merchQty === '0') {
                row.remove();
            } else {
                row.find(".table-cell-qty.hide-responsive-ph").text(merchQty);
                row.find(".table-cell-qty.hide-desktop-ph").text(merchQty + "QT");
                row.find(".table-cell-price .nowrap").text(setMoney(parseFloat(virtualCashCtn.find(".product-price").attr("data-price") * merchQty), false));
            }
        } else if (merchQty !== '0') {
            var template = $(".cart-merch-template").children().clone();
            template.attr("data-productId", productId);
            template.attr("data-optionId", optionId);
            template.find(".payment-process-delete-item-btn-ajax").on("click", removeItem);
            template.find("input[name='productId']").val(productId);
            var optionName = "";
            if (option !== undefined && option.length !== 0) {
                template.find("input[name='optionId']").val(optionId);
                optionName = " - " + option.find("option:selected").text();
            }
            template.find(".table-cell-name").text(virtualCashCtn.find(".profile-one-product-top-ctn .profile-one-product-name").text() + optionName);

            template.find(".table-cell-price-1 .nowrap").text(setMoney(parseFloat(virtualCashCtn.find(".product-price").attr("data-price")), false));
            template.find(".table-cell-qty.hide-responsive-ph").text(merchQty);
            template.find(".table-cell-qty.hide-desktop-ph").text(merchQty + "QT");
            template.find(".table-cell-price .nowrap").text(setMoney(parseFloat(virtualCashCtn.find(".product-price").attr("data-price") * merchQty), false));
            template.removeClass("template");

            $(".virtual-cash-merch-cart").removeClass("hide");
            $(".virtual-cashier-hide-on-empty").removeClass("disabled");

            $(".payment-process-table").append(template);
            $(".virtual-cash-step-2-warning-2").slideUp();
        }
        var table = $(".payment-process-table");
        var section = $(".virtual-cash-merch-cart");

        if (table.find(".payment-process-table-row:not(.template)").length === 1) {
            section.addClass("hide");
            $(".virtual-cashier-hide-on-empty").addClass("disabled");
            $(".js-form-error-message.fields").slideUp();
        }

        if (merchQty !== '0') {
            $('html, body').animate({
                scrollTop: $(".virtual-cash-merch-cart").offset().top - 90
            }, 500);
        }
    };

    var updateQtysInCart = function updateQtysInCart() {
        $(".virtual-cash-product").each(function () {
            var productId = $(this).attr("data-id");
            var virtualCashQtyCtn = $(this).find('.virtual-cash-qty-check');
            var table = $(".payment-process-table");
            if (table.find(".payment-process-table-row[data-productId=" + productId + "]").length !== 0) {
                var counter = 0;
                table.find(".payment-process-table-row[data-productId=" + productId + "]").each(function () {
                    counter += parseInt($(this).find(".table-cell-qty.hide-responsive-ph").text());
                });
                if (counter === 0) {
                    virtualCashQtyCtn.fadeOut();
                } else {
                    virtualCashQtyCtn.fadeIn();
                    virtualCashQtyCtn.find(".qty").text(counter);
                }
            } else {
                virtualCashQtyCtn.fadeOut();
            }
        });
    };

    //Removes an item in ajax (virtual Cashier)
    var removeItem = function removeItem() {
        var t = $(this);
        var form = t.closest("form");
        var url = form.attr("action");
        var first = true;
        var id = -1;

        form.find("input").each(function () {
            if ($(this).attr("name") !== 'pageName') {
                if (!first) {
                    url += "&";
                } else {
                    url += "?";
                }
                url += $(this).attr("name") + "=" + encodeURIComponent($(this).val());
                first = false;

                if ($(this).attr("name") === 'productId') {
                    id = $(this).val();
                }
            }
        });
        url += "&ajax=true";
        ajax(url, function (response) {
            if (response.indexOf("success") !== -1) {
                var section = t.closest(".virtual-cash-merch-cart");
                var table = t.closest(".payment-process-table");
                t.closest(".payment-process-table-row").remove();

                if (table.find(".payment-process-table-row:not(.template)").length === 1) {
                    section.addClass("hide");
                    $(".virtual-cashier-hide-on-empty").addClass("disabled");
                    var virtualCashDeliveryOptions = $('.merch-delivery-inputs-ctn');
                    virtualCashDeliveryOptions.slideUp();
                    virtualCashDeliveryOptions.find('.payment-process-radio').removeClass('required');
                    $(".js-form-error-message.fields").slideUp();
                }
                updateQtysInCart();
            }
        }, true);
    };

    var updateCartProduct = function updateCartProduct(q, nofx) {
        var $q = $(".cart-products-count");
        if (nofx) {
            $q.html(q);
        } else {
            $q.fadeOut(200, function () {
                $q.html(q);
                $q.fadeIn(200);
            });
        }
    };

    var addToCartAjax = function addToCartAjax(url, t) {
        ajax(url, function (response) {
            if (response.indexOf("error") !== -1) {
                updateCart(0, 0, null, 0);
                $(".event-one-ticket-select-qty").find(".event-ticket-select").removeClass("disabled");
                $(".cart-ticket-error").slideDown();

                if (!addCartBtn.hasClass('change-qty-btn')) {
                    t.removeClass('disabled');
                } else {
                    addCartBtn.each(function () {
                        var select = $(this).closest('.qty-input-with-buttons').find('select');
                        tools.disableQtyBtns(select, select.val(), select.find('option:first-child').val(), select.find('option:last-child').val());
                    });
                }
            } else {
                $(".cart-ticket-error").slideUp();
                var qty = response.substring(response.indexOf(":") + 1, response.indexOf("-")).trim();
                var total = response.substring(response.indexOf("-") + 1, response.indexOf("/")).trim();
                updateCart(qty === "" ? 0 : qty, total === "" ? 0 : total, null, 0);

                $(".event-one-ticket-select-qty").find(".event-ticket-select").removeClass("disabled");

                if (!addCartBtn.hasClass('change-qty-btn')) {
                    if (qty !== '0' && qty !== '') {
                        window.location.href = addCartBtn.attr('data-forward');
                    } else {
                        if (!t.hasClass("locked")) {
                            t.removeClass('disabled');
                        }
                    }
                } else {
                    if ($(".virtual-cash-resp-wrap").length !== 0) {
                        checkInventory(t, t.closest(".event-one-ticket-select-qty").attr("data-id"));
                    }
                    addCartBtn.each(function () {
                        var select = $(this).closest('.qty-input-with-buttons').find('select');
                        tools.disableQtyBtns(select, select.val(), select.find('option:first-child').val(), select.find('option:last-child').val());
                    });
                }
            }
        }, true);
    };

    var checkInventory = function checkInventory(t, id) {
        if ($(".virtual-cash-ticket-ctn[data-id = " + id + "]").length > 1) {
            var max = parseInt(t.attr("data-max-qty"));
            var count = 0;
            $(".virtual-cash-ticket-ctn[data-id = " + id + "]").each(function () {
                count += parseInt($(this).find(".event-ticket-select").val());
            });
            if (count === max) {
                $(".virtual-cash-ticket-ctn[data-id = " + id + "]").each(function () {
                    $(this).find(".change-qty-btn.plus").addClass("locked");
                    $(this).find(".warning-no-tickets").slideDown();
                });
            } else {
                $(".virtual-cash-ticket-ctn[data-id = " + id + "]").each(function () {
                    $(this).find(".change-qty-btn.plus").removeClass("locked");
                    $(this).find(".warning-no-tickets").slideUp();
                });
            }
        }
    };

    var handleMulTicketsChoiceMissing = function handleMulTicketsChoiceMissing(e, t) {
        var errorSelectTickets = t.closest(".event-one-ticket-ctn").find('.event-details-error-select-tickets-msg');

        errorSelectTickets.addClass('open');
        setTimeout(function () {
            errorSelectTickets.removeClass('open');
        }, 5000);
        return;
    };

    var initStickyTabs = function initStickyTabs() {
        var y1 = tabsBar.offset().top;
        if (y1 > $(window).scrollTop() && tabsCtn.hasClass("sticky")) {
            tabsCtn.removeClass("sticky");
            // tabsBar.removeAttr('style');
        }
        if (y1 <= $(window).scrollTop() && !tabsCtn.hasClass("sticky")) {
            tabsCtn.addClass("sticky");
        }
        rAF(initStickyTabs);
    };
    var setTabsBarHeight = function setTabsBarHeight() {
        tabsBar.height(tabsCtn.height());
    };

    var initStickyCart = function initStickyCart() {
        var y1 = $('.profile-merch-outer-ctn').offset().top - 115 - $('.site-header').height() - $('.tabs-bar').height();
        if (y1 > $(window).scrollTop() && cartCtn.hasClass("fixed")) {
            cartCtn.removeClass("fixed");
        }
        if (y1 <= $(window).scrollTop() && !cartCtn.hasClass("fixed")) {
            cartCtn.addClass("fixed");
        }
        rAF(initStickyCart);
    };

    var popContactForm = function popContactForm(e) {
        var pu = $("#" + $(this).attr("data-id"));
        if (pu.length !== 0) {
            pu.addClass("open");
            $("body .overlay").addClass("active");
        }
    };

    var sendContact = function sendContact(e) {
        var popup = $(this).closest('.popup-ctn');
        e.preventDefault();
        var inps = this.elements,
            data = "?personId=0&file=contact-organizer";

        for (var i = 0; i < inps.length; i++) {
            var inp = inps[i];
            if ($(inp).hasClass("required") && $(inp).hasClass("error")) {
                return false;
            }
            if (inp.name !== "") {
                data += "&" + inp.name + "=" + inp.value;
            }
        }
        ajax(this.action + encodeURI(data), function () {
            popup.find('.input-ctn').removeClass('focused');
            popup.find('.form-input').removeClass('success').val('');
            popup.find('.contact-message-sent-success-msg').slideDown();
            setTimeout(function () {
                $("#event-details-contact-popup").removeClass("open");
                $("body .overlay").removeClass("active");
                popup.find('.contact-message-sent-success-msg').slideUp();
            }, 5000);
        });

        return false;
    };

    var checkUrlContact = function checkUrlContact() {
        var url = window.location.href;

        if (url.indexOf('contact=true') !== -1) {
            $('.profile-infos-table .popup-btn').trigger('click');
        }
    };

    var getTicketsList = function getTicketsList() {
        var t = $(this);
        var url = t.attr('data-url');
        var parent = t.closest('.standard-package-tickets-list');
        var ctn = parent.find('.event-folders-tickets-list');
        var tickets = parent.find('.event-details-chosen-tickets-ctn');
        var preSelectedTickets = parent.find('input[name="prev-selected-tickets"]');

        // if ajax already fetched
        if (ctn.children().length !== 0) {
            parent.find('.tickets-list-popup-btn').trigger('click');
            return;
        }

        var popup = parent.find('.event-details-tickets-list-popup');

        ajax(url, function (response) {
            var json = JSON.parse(response);
            $.each(json, function (k, v) {
                var eventFolderClone = parent.find('.event-folders-temp.hide').clone();
                var innerCtn = eventFolderClone.find('.tickets-list-content-ctn');
                var eventInfos = json[k];
                var eventLocation = eventInfos.name;
                var eventStartDate = ', ' + eventInfos.startDate;
                var displayEndTime = eventInfos.displayEndTime;
                var tickets = eventInfos.tickets;

                eventFolderClone.find('.tickets-list-header').html(eventInfos.eventName);
                eventFolderClone.find('.tickets-list-header-ctn').click(toggleEventTicketsList);

                $.each(tickets, function (k, v) {
                    var dateTime = '';
                    if (v.ticketStartDate !== eventInfos.startDate) {
                        eventStartDate = '';
                        if (displayEndTime === 'true') {
                            if (lang === 'fr') {
                                dateTime += 'Du ';
                            } else {
                                dateTime += 'From ';
                            }
                        }
                    }
                    dateTime += v.ticketStartDate + ', ' + v.ticketStartTime;
                    if (displayEndTime === 'true' && v.ticketEndDate && v.ticketEndDate !== '' && v.ticketEndDate !== v.ticketStartDate) {
                        dateTime += '<br/>';
                        if (lang === 'fr') {
                            dateTime += 'Au ';
                        } else {
                            dateTime += 'To ';
                        }
                        dateTime += v.ticketEndDate;
                    }
                    if (displayEndTime === 'true' && v.ticketEndTime && v.ticketEndTime !== '') {
                        if (v.ticketEndDate && v.ticketEndDate !== '' && v.ticketEndDate !== v.ticketStartDate) {
                            dateTime += ', ';
                        } else {
                            if (lang === 'fr') {
                                dateTime += ' à ';
                            } else {
                                dateTime += ' at ';
                            }
                        }

                        dateTime += v.ticketEndTime;
                    }

                    var ticketClone = parent.find('.event-folders-ticket-temp.hide').clone();
                    ticketClone.find('.form-check-input.package-ticket-choice').val(v.ticketId);
                    ticketClone.find('.name').html(v.ticketName);
                    if (dateTime.indexOf('undefined') === -1) {
                        ticketClone.find('.datetime').html(dateTime);
                    } else {
                        ticketClone.find('.datetime').remove();
                        ticketClone.find('.events-list-one-event-price-icon').remove();
                        ticketClone.find('.separator').remove();
                    }

                    ticketClone.find('.form-check-input.package-ticket-choice').change(updateTicketChoiceCount);

                    innerCtn.append(ticketClone.children());
                });

                eventFolderClone.find('.tickets-list-subheader').html(eventLocation + eventStartDate);

                if (eventFolderClone.find('.tickets-list-one-ticket-ctn').length) {
                    ctn.append(eventFolderClone.children());
                }
            });

            if (!preSelectedTickets.length) {
                parent.find('.tickets-list-popup-btn').trigger('click');
            } else {
                parent.find('.form-check-input.package-ticket-choice').each(function () {
                    if (preSelectedTickets.val().indexOf($(this).val()) !== -1) {
                        $(this).trigger('click');
                    }
                });
            }
        }, true);
    };

    var toggleEventTicketsList = function toggleEventTicketsList() {
        $(this).closest('.event-folder-single').toggleClass('list-open');
        $(this).closest('.event-folder-single').find('.tickets-list-content-ctn').slideToggle();
    };

    var updateTicketChoiceCount = function updateTicketChoiceCount() {
        var t = $(this);
        var ctn = t.closest('.event-one-ticket-ctn');
        var parent = t.closest('.tickets-choice-popup-content');
        var nbrLeftToChoose = parent.data('nbr-left');

        if (t.prop('checked') && nbrLeftToChoose > 0) {
            nbrLeftToChoose--;
            parent.find('.count').html(nbrLeftToChoose);
            parent.data('nbr-left', nbrLeftToChoose);
            updateTicketChoiceList(ctn, t.val(), t.closest('.tickets-list-one-ticket-content').find('.name').html(), 'add');
        } else if (!t.prop('checked')) {
            nbrLeftToChoose++;
            parent.find('.count').html(nbrLeftToChoose);
            parent.data('nbr-left', nbrLeftToChoose);
            updateTicketChoiceList(ctn, t.val(), null, 'remove');
        }

        if (nbrLeftToChoose === 0) {
            parent.find('.form-check-input').each(function () {
                if (!$(this).prop('checked')) {
                    $(this).closest('.tickets-list-one-ticket-content').addClass('disabled');
                }
            });
        } else if (parent.find('.tickets-list-one-ticket-content.disabled').length > 0) {
            parent.find('.form-check-input').each(function () {
                if (!$(this).prop('checked')) {
                    $(this).closest('.tickets-list-one-ticket-content').removeClass('disabled');
                }
            });
        }
    };

    var updateTicketChoiceList = function updateTicketChoiceList(ctn, id, name, type) {
        var selectTicketsText = ctn.find('.get-package-tickets-list.multiple:not(.icon)');
        var listOuterCtn = ctn.find('.event-details-chosen-tickets-outer-ctn');
        var listCtn = ctn.find('.event-details-chosen-tickets-ctn');
        var oneEvent = ctn.find('.event-details-one-chosen-ticket.hide').clone();

        var par = ctn.closest(".virtual-cash-ticket-ctn");
        var id = par.attr("data-id");
        var doorPrice = par.attr("data-doorPrice") === 'true';
        var other = $(".virtual-cash-ticket-ctn[data-id = '" + id + "'][data-doorPrice = '" + !doorPrice + "']");
        var selectTicketsText2 = other.find('.get-package-tickets-list.multiple:not(.icon)');
        var listOuterCtn2 = other.find('.event-details-chosen-tickets-outer-ctn');
        var listCtn2 = other.find('.event-details-chosen-tickets-ctn');

        if (type === 'add') {
            oneEvent.html(name);
            oneEvent.attr('data-id', id);
            listCtn.append(oneEvent.removeClass('hide'));
            if (listOuterCtn.css('display') !== 'block') {
                selectTicketsText.slideUp(function () {
                    listOuterCtn.slideDown();
                });
            }
            if (par.length !== 0) {
                var oneEvent2 = oneEvent.clone();
                if ($(".virtual-cash-ticket-ctn[data-id = '" + id + "']").length > 1) {
                    listCtn2.append(oneEvent2.removeClass('hide'));
                    if (listOuterCtn2.css('display') !== 'block') {
                        selectTicketsText2.slideUp(function () {
                            listOuterCtn2.slideDown();
                        });
                    }
                }
            }
        } else {
            listCtn.find('.event-details-one-chosen-ticket[data-id=' + id + ']').remove();

            if (!listOuterCtn.find('.event-details-one-chosen-ticket:not(.hide)').length) {
                listOuterCtn.slideUp(function () {
                    selectTicketsText.slideDown();
                });
            }
            if (par.length !== 0) {
                if ($(".virtual-cash-ticket-ctn[data-id = '" + id + "']").length > 1) {
                    listCtn2.find('.event-details-one-chosen-ticket[data-id=' + id + ']').remove();

                    if (!listOuterCtn2.find('.event-details-one-chosen-ticket:not(.hide)').length) {
                        listOuterCtn2.slideUp(function () {
                            selectTicketsText2.slideDown();
                        });
                    }
                }
            }
        }
    };

    var displaySelectedPic = function displaySelectedPic() {
        var t = $(this);
        var ctn = t.closest('.one-product-available-pictures');
        var activePicCtn = t.closest('.one-product-popup-pictures-ctn').find('.one-product-active-picture');
        var imgUrl = t.css('background-image');

        ctn.find(picPreview).removeClass('active');
        t.addClass('active');
        activePicCtn.fadeOut(300, function () {
            $(this).css('background-image', imgUrl);
            $(this).fadeIn(300);
        });
    };

    var scrollTopAllProducts = function scrollTopAllProducts() {
        if ($(window).scrollTop() > $('.tabs-content').offset().top - 70 && respDetectionSmScreen.css('visibility') !== 'visible') {
            var pos = $('.tabs-content').offset().top - 70;
            pageScrlTo(pos);
        }
    };

    var getMaxAllowed = function getMaxAllowed(option) {
        var available = option.data('available');
        var max = option.data('max');

        var maxAvailable = available > max ? max : available;

        return maxAvailable;
    };

    var adjustAvailableProdQty = function adjustAvailableProdQty(select) {
        var t = $(this).length > 0 ? $(this) : select;
        var option = t.find('option[value=' + t.val() + ']');
        var product = t.closest('.profile-one-product-ctn');
        var plusBtn = product.find('.change-qty-btn.plus');
        var productQtySelect = product.find('.event-product-select');

        var maxAllowed = getMaxAllowed(option);
        var count = 0;

        plusBtn.data('max-qty', maxAllowed);

        if (productQtySelect.val() > maxAllowed) {
            productQtySelect.val(maxAllowed);
        } else if (productQtySelect.val() < maxAllowed) {
            plusBtn.removeClass('disabled');
        }

        product.find('.event-product-select').find('option').each(function () {
            $(this).val() > maxAllowed ? $(this).addClass('hide') : $(this).removeClass('hide');
        });
    };

    var getCookieValue = function getCookieValue(name) {
        var nameEQ = name + "=";
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1, cookie.length);
            }
            if (cookie.indexOf(nameEQ) === 0) {
                return cookie.substring(nameEQ.length, cookie.length);
            }
        }
        return null;
    };

    var init = function init(page) {

        // check if cookie enabled in browser
        var isCookieEnabled = navigator.cookieEnabled;
        if (!isCookieEnabled) {
            $(".please-enable-cookie").trigger("click");
        }

        currPage = page || $(".page");
        eventTicketsCtn = $(".event-tickets-ctn");
        ticketQtySel = $(".event-ticket-select");
        //Fix an issue with safari on ipad by adding blur event on <select>
        ticketQtySel.on("change" + (isSafari && isPhod ? " blur" : ""), sumCart);
        addCartBtn = $(".add-to-cart-btn");
        addCartBtn.on("click", addCart);
        addCartProductBtn = $(".product-add-to-cart-btn");
        addCartProductBtn.on("click", addCartProduct);
        prevSelectedTickets = $('input[name="prev-selected-tickets"]');
        openProductPopupBtn = $('.profile-one-product-details-btn');
        respDetectionSmScreen = $('.responsive-detector-sm');
        productOptionSelect = $('.product-option-select');

        getPackageTicketsListBtn = $('.get-package-tickets-list');
        getPackageTicketsListBtn.click(getTicketsList);

        tabsBar = $(".tabs-bar.profile");
        tabsCtn = tabsBar.find(".tabs-bar-items-ctn");
        if (tabsCtn.length > 0) {
            // setTabsBarHeight();
            // $(g).on("resize", setTabsBarHeight);
            initStickyTabs();
        }

        cartCtn = $('.products-cart-ctn');
        if (cartCtn.length > 0) {
            initStickyCart();
        }

        picPreview = $('.one-product-preview-pic');
        picPreview.click(displaySelectedPic);

        checkUrlContact();

        $(".event-details-description-table-contact-btn").on("click", popContactForm);
        $("#event-details-contact-form").on("submit", sendContact);

        prevSelectedTickets.each(function () {
            $(this).closest('.standard-package-tickets-list').find('.get-package-tickets-list:not(.icon)').trigger('click');
        });

        openProductPopupBtn.click(scrollTopAllProducts);
        productOptionSelect.click(adjustAvailableProdQty);

        removeFromCart = $('.payment-process-delete-item-btn-ajax');
        removeFromCart.click(removeItem);

        var eventId = $(".event-one-ticket-select-qty").data("event-id");
        if (eventId === 6942) {
            //ERIC LAPOINTE EN FORMULE SOUPER SPECTACLE
            console.log('calling facebook function ............... ERIC LAPOINTE EN FORMULE SOUPER SPECTACLE');
            fbq('init', '438706678514426');
            fbq('track', 'PageView');
        }
        if (eventId === 7165) {
            //OBSKUR #004 - Kill The Noise & Friends
            console.log('calling facebook function ............... OBSKUR #004 - Kill The Noise & Friends');
            fbq('init', '943675224110997');
            fbq('track', 'PageView');
        }
        if (eventId === 7325) {
            //Thuwan_Test_2_Event_1
            console.log('calling facebook function ............... Thuwan_Test_2_Event_1');
            fbq('init', '266548857543903');
            fbq('trackCustom', 'EpassliveTestPageView');
        }
        if (eventId === 7362) {
            //Thuwan_Test_2_Event_2
            console.log('calling facebook function ............... Thuwan_Test_2_Event_2');
            fbq('init', '1722681941873874');
            fbq('trackCustom', 'EpassliveTestPageView');
        }
    };

    $(g).on("load", function () {
        init();
    });
})(jQuery, document, window);
(function ($, undefined) {

	'use strict';

	var slider;
	var sliderNextBtn;
	var sliderPrevBtn;

	var nextSlide = function nextSlide() {
		slider.slick('slickNext');
	};

	var prevSlide = function prevSlide() {
		slider.slick('slickPrev');
	};

	var init = function init() {
		slider = $('.home-slider');
		slider.slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 5000,
			speed: 500,
			arrows: false,
			cssEase: 'cubic-bezier(.58,.24,.52,.93)',
			fade: true
		});
		slider.css("visibility", "visible");

		sliderNextBtn = $(".slick-next");
		sliderPrevBtn = $(".slick-prev");
		sliderNextBtn.on("click", nextSlide);
		sliderPrevBtn.on("click", prevSlide);
	};

	init();
})(jQuery);
(function ($, undefined) {
    'use strict';

    var openEventDetailsIframeBtn;

    var openEventDetailsIframe = function openEventDetailsIframe(e) {
        var t = $(this);
        var src = t.attr('data-iframe');
        var iframe = t.find('.event-details-iframe-popup-inner');
        var popup = t.closest('.popup-outer-ctn').find('.popup');
        var target = $(e.target);

        if (!target.closest('.popup-inner-close').length) {
            if (iframe.attr('src') === undefined) {
                iframe.attr('src', src);

                setTimeout(function () {
                    popup.addClass('open processing-loader is-processing');
                    $('.overlay', 'body').addClass('active');
                }, 300);
            } else {
                popup.addClass('open');
                $('.overlay', 'body').addClass('active');
            }
        }
    };

    var init = function init() {
        openEventDetailsIframeBtn = $('.open-event-details-popup');
        openEventDetailsIframeBtn.click(openEventDetailsIframe);
    };

    $(window).on('load', function () {
        init();
    });
})(jQuery);

var displayedFeaturedEvents = [];

(function ($, undefined) {

    'use strict';

    var currPage;
    var searchEventsInput;
    var searchEventsBtn;
    var searchInputAndDropDownCtn;
    var searchDropDown;
    var searchDropDownChoiceOuterCtn;
    var searchDropDownChoiceInnerCtn;
    var searchEventsSliderBtn;
    var featureBtn;
    var removeChosenFeaturedBtn;
    var sendLostTicketsBtn;
    var lang = $('html').attr('lang');

    var displayedEvents = [];

    var searchEvents = function searchEvents() {
        var t = $(this);
        var searchVal = encodeInputText(t.closest(".input-and-inner-btn-ctn").find(searchEventsInput).val());
        var parentCtn = searchEventsInput.closest(".lost-tickets-option-content");
        $(".search-events-lost-tickets input").val(searchVal);
        $(".input-form-lost-tickets-search").val(searchVal);
        var dropDownDisplayedEvents = parentCtn.find(searchDropDownChoiceInnerCtn).find('.search-drop-down-one-item');
        if (searchVal !== '') {
            parentCtn.find(searchDropDown).slideDown(300);
            ajax('/action/epSearchEvents?q=' + searchVal + '&count=99999999&ajax=true', function (response) {
                var json = JSON.parse(response);
                var newResults = [];

                if (json.length > 0) {
                    $.each(json, function (k, v) {
                        var id = json[k].id;
                        newResults.push(id);

                        if ($.inArray(id, displayedEvents) === -1) {
                            populateDropDown(parentCtn, json[k], false, false);
                        }
                    });

                    removeUnrelatedProfilesFromDropDown(parentCtn, displayedEvents, newResults);
                    displayedEvents = newResults;

                    parentCtn.find(searchDropDownChoiceOuterCtn).slideDown(300);
                } else {
                    parentCtn.find(searchDropDownChoiceOuterCtn).slideUp(300);
                    emptyDropDown(dropDownDisplayedEvents);
                }
            }, true);
        } else {
            parentCtn.find(searchDropDown).slideUp(300);
            emptyDropDown(dropDownDisplayedEvents);
        }
    };

    var searchEventsSlider = function searchEventsSlider() {
        var t = $(this);
        var searchVal = encodeInputText(t.closest(".input-and-inner-btn-ctn").find(searchEventsInput).val());
        var parentCtn = t.closest(".lost-tickets-option-content");
        $(".search-events-lost-tickets input").val(searchVal);
        $(".input-form-lost-tickets-search").val(searchVal);
        var dropDownDisplayedEvents = parentCtn.find(searchDropDownChoiceInnerCtn).find('.search-drop-down-one-item');

        if (searchVal !== '') {
            parentCtn.find(searchDropDown).slideDown(300);
            ajax('/action/epSearchEvents?q=' + searchVal, function (response) {
                var json = JSON.parse(response);
                var newResults = [];
                if (json.length > 0) {
                    $.each(json, function (k, v) {
                        var id = json[k].id;
                        newResults.push(id);

                        if ($.inArray(id, displayedEvents) === -1) {
                            populateDropDown(parentCtn, json[k], true, false);
                        }
                    });

                    removeUnrelatedProfilesFromDropDown(parentCtn, displayedEvents, newResults);
                    displayedEvents = newResults;

                    parentCtn.find(searchDropDownChoiceOuterCtn).slideDown(300);
                } else {
                    parentCtn.find(searchDropDownChoiceOuterCtn).slideUp(300);
                    emptyDropDown(dropDownDisplayedEvents);
                }
            }, true);
        } else {
            parentCtn.find(searchDropDown).slideUp(300);
            emptyDropDown(dropDownDisplayedEvents);
        }
    };

    var removeUnrelatedProfilesFromDropDown = function removeUnrelatedProfilesFromDropDown(parentCtn, displayedProfiles, newResults) {
        if (displayedProfiles.length > 0 && newResults.length > 0) {
            for (var i = 0; i < displayedProfiles.length; i++) {
                if ($.inArray(displayedProfiles[i], newResults) === -1) {
                    parentCtn.find('.search-drop-down-one-item#' + displayedProfiles[i]).slideUp(300, function () {
                        $(this).remove();
                    });
                }
            }
        }
    };
    var emptyDropDown = function emptyDropDown(events) {
        displayedEvents = [];
        displayedFeaturedEvents = [];
        events.slideUp(300, function () {
            $(this).remove();
        });
    };

    var populateDropDown = function populateDropDown(parentCtn, obj, slider, feature) {
        var id = obj.id;
        var name = encodeText(obj.name);
        var friendlyUrl = parentCtn.attr("data-detail-page") + "/" + obj.friendlyUrl + '?contact=true';
        var date = encodeText(obj.startDate);
        date += obj.startDate !== obj.endDate ? " " : ", ";
        if (obj.startDate === obj.endDate) {
            date += obj.startTime;

            if (obj.displayEndTime === 'true') {
                date += lang === 'fr' ? " \xE0 " : " to ";
                date += obj.endTime;
            }
        }
        if (obj.startDate !== obj.endDate) {
            date += lang === 'fr' ? " au " : " to ";
            date += encodeText(obj.endDate) + " ";
        }
        var image = obj.profileMediaId !== 0 ? obj.profileMediaId : 0;
        var address = encodeText(obj.address) + ', ' + encodeText(obj.city);
        var dropDownItemCtn = parentCtn.find('.search-drop-down-one-item#clone').clone();
        var mediaId = obj.profileMediaId;
        styleAndAppendClone(dropDownItemCtn, parentCtn.find('.search-drop-down-choices-inner-ctn'), id, name, image, address, friendlyUrl, date, slider, feature, mediaId);
    };

    var styleAndAppendClone = function styleAndAppendClone(clone, container, id, name, image, address, friendlyUrl, date, slider, feature, mediaId) {
        if (!slider && !feature) {
            clone.on("click", function () {
                window.location = friendlyUrl;
            });
        }
        clone.find('.search-drop-down-one-item-name').html(name);

        if (date !== '') {
            clone.find('.search-drop-down-one-item-datetime-ctn p').html(date);
        }
        if (image !== "0") {
            clone.find('.bg-pic').css('background-image', 'url(/static/uploaded/EventProfile/' + image + '-profile.jpg)');
        }

        if (address !== '') {
            clone.find('.search-drop-down-one-item-location').html(address);
        }

        if (clone.hasClass('search-drop-down-one-item')) {
            clone.attr('id', id);
        } else {
            clone.find('.search-drop-down-one-item').attr('id', id);
        }
        if (slider) {
            clone.on("click", function () {
                chooseEvent($(this), container.closest(".lost-tickets-option-content"));
            });
        }
        if (feature) {
            clone.attr("data-media-id", mediaId);
            clone.on("click", function () {
                selectAsFeature($(this), container.closest(".lost-tickets-option-content"));
            });
        }
        clone.hide().removeClass('clone');
        container.append(clone);
        clone.slideDown(300);
    };

    var chooseEvent = function chooseEvent(event, parentCtn) {
        var cl = event.clone();
        parentCtn.next(".slider-box-theme-ctn").find(".slide-event-selected-ctn").html(cl);
        event.closest(searchDropDown).slideUp();
        parentCtn.next(".slider-box-theme-ctn").find(".event-id-selected").attr("value", cl.attr("id"));
        parentCtn.next(".slider-box-theme-ctn").slideDown();
        parentCtn.next(".slider-box-theme-ctn").next(".event-slide-btns").slideDown();
    };
    var selectAsFeature = function selectAsFeature(event, parentCtn) {
        var cl = event.clone();
        cl.find(".removable-item-btn").on("click", removeChosenFeature);
        parentCtn.next(".box-theme-ctn").find(".slide-event-selected-ctn").html(cl);
        event.closest('.search-drop-down').slideUp();
        parentCtn.next(".box-theme-ctn").slideDown();
        parentCtn.next(".box-theme-ctn").next(".event-slide-btns").slideDown();
    };

    var removeChosenFeature = function removeChosenFeature() {
        var t = $(this);
        t.closest(".box-theme-ctn").next(".event-slide-btns").slideUp();
        t.closest(".search-drop-down-one-item").slideUp(function () {
            $(this).remove();
        });
        t.closest(".event-select-box").slideUp();
    };

    function encodeText(name) {
        if (name !== undefined) {
            name = name.replace(/\\xE0/g, '\xE0');
            name = name.replace(/\\xE2/g, '\xE2');
            name = name.replace(/\\xE3/g, '\xE3');
            name = name.replace(/\\xE4/g, '\xE4');
            name = name.replace(/\\xE5/g, '\xE5');
            name = name.replace(/\\xE7/g, '\xE7');
            name = name.replace(/\\xE9/g, '\xE9');
            name = name.replace(/\\xE8/g, '\xE8');
            name = name.replace(/\\xEA/g, '\xEA');
            name = name.replace(/\\xEB/g, '\xEB');
            name = name.replace(/\\xEE/g, '\xEE');
            name = name.replace(/\\xEF/g, '\xEF');
            name = name.replace(/\\xF1/g, '\xF1');
            name = name.replace(/\\xF2/g, '\xF2');
            name = name.replace(/\\xF3/g, '\xF3');
            name = name.replace(/\\xF4/g, '\xF4');
            name = name.replace(/\\xF6/g, '\xF6');
            name = name.replace(/\\xF9/g, '\xF9');
            name = name.replace(/\\xFB/g, '\xFB');
            name = name.replace(/\\xC0/g, '\xC0');
            name = name.replace(/\\xC2/g, '\xC2');
            name = name.replace(/\\xC7/g, '\xC7');
            name = name.replace(/\\xC8/g, '\xC8');
            name = name.replace(/\\xC9/g, '\xC9');
            name = name.replace(/\\xCA/g, '\xCA');
            name = name.replace(/\\xCB/g, '\xCB');
            name = name.replace(/\\xCE/g, '\xCE');
            name = name.replace(/\\xCF/g, '\xCF');
            name = name.replace(/\\xD1/g, '\xD1');
            name = name.replace(/\\xD4/g, '\xD4');
            name = name.replace(/\\xD9/g, '\xD9');
            name = name.replace(/\\xDB/g, '\xDB');
        } else {
            name = "";
        }
        return name;
    }

    function encodeInputText(name) {
        if (name !== undefined) {
            name = name.replace('à', '\xE0');
            name = name.replace('â', '\xE2');
            name = name.replace('ã', '\xE3');
            name = name.replace('ä', '\xE4');
            name = name.replace('å', '\xE5');
            name = name.replace('ç', '\xE7');
            name = name.replace('é', '\xE9');
            name = name.replace('è', '\xE8');
            name = name.replace('ê', '\xEA');
            name = name.replace('ë', '\xEB');
            name = name.replace('î', '\xEE');
            name = name.replace('ï', '\xEF');
            name = name.replace('ñ', '\xF1');
            name = name.replace('ò', '\xF2');
            name = name.replace('ó', '\xF3');
            name = name.replace('ô', '\xF4');
            name = name.replace('ö', '\xF6');
            name = name.replace('ù', '\xF9');
            name = name.replace('û', '\xFB');
            name = name.replace('À', '\xC0');
            name = name.replace('Â', '\xC2');
            name = name.replace('Ç', '\xC7');
            name = name.replace('È', '\xC8');
            name = name.replace('É', '\xC9');
            name = name.replace('Ê', '\xCA');
            name = name.replace('Ë', '\xCB');
            name = name.replace('Î', '\xCE');
            name = name.replace('�?', '\xCF');
            name = name.replace('Ò', '\xD1');
            name = name.replace('Ô', '\xD4');
            name = name.replace('Ù', '\xD9');
            name = name.replace('Û', '\xDB');
        } else {
            name = "";
        }
        return name;
    }
    var checkOutClick = function checkOutClick(event) {
        if (!$(event.target).closest('.search-input-and-drop-down-ctn ').length) {
            if ($('.search-drop-down-choices-outer-ctn').is(":visible")) {
                $('.search-drop-down').slideUp(300);
            }
        }
    };

    var searchFeatureEvents = function searchFeatureEvents() {
        var t = $(this);
        var searchVal = encodeInputText(t.closest(".input-and-inner-btn-ctn").find(".lost-tickets-search").val());
        var parentCtn = t.closest(".lost-tickets-option-content");
        var dropDownDisplayedEvents = parentCtn.find('.search-drop-down-choices-inner-ctn').find('.search-drop-down-one-item');
        if (searchVal !== '') {
            parentCtn.find('.search-drop-down').slideDown(300);
            ajax('/action/epSearchEvents?q=' + searchVal, function (response) {
                var json = JSON.parse(response);
                var newResults = [];

                if (json.length > 0) {
                    $.each(json, function (k, v) {
                        var id = json[k].id;
                        newResults.push(id);
                        if ($.inArray(id, displayedFeaturedEvents) === -1) {
                            populateDropDown(parentCtn, json[k], false, true);
                        }
                    });

                    removeUnrelatedProfilesFromDropDown(parentCtn, displayedFeaturedEvents, newResults);
                    displayedFeaturedEvents = newResults;

                    parentCtn.find('.search-drop-down-choices-outer-ctn').slideDown(300);
                } else {
                    parentCtn.find('.search-drop-down-choices-outer-ctn').slideUp(300);
                    emptyDropDown(dropDownDisplayedEvents);
                }
            }, true);
        } else {
            parentCtn.find('.search-drop-down').slideUp(300);
            emptyDropDown(dropDownDisplayedEvents);
        }
    };

    var sendLostTickets = function sendLostTickets() {
        var t = $(this);
        var email = $(".lost-tickets-form").find("input[name=email]").val();
        if (email !== '') {
            t.addClass('disabled');
            var url = "/action/epLostTickets?ajax=true";
            url += "&email=" + email;

            ajax(url, function (response) {
                $(".lost-tickets-no-payments").slideUp();
                $(".lost-tickets-no-tickets").slideUp();
                $(".lost-tickets-sent").slideUp();
                if (response.indexOf("success") !== -1) {
                    $(".lost-tickets-form-inner-ctn").slideUp();
                    $(".lost-tickets-sent").slideDown();
                }
                if (response.indexOf("fail") !== -1) {
                    $(".lost-tickets-no-payments").slideDown();
                }
                if (response.indexOf("no-tickets") !== -1) {
                    $(".lost-tickets-no-tickets").slideDown();
                }
                t.removeClass('disabled');
            }, true);
        }
    };

    var init = function init(page) {
        currPage = $(page);
        searchEventsInput = $('.lost-tickets-search');
        searchEventsBtn = $('.lost-tickets-search-btn');
        searchInputAndDropDownCtn = $('.search-input-and-drop-down-ctn');
        searchDropDown = $('.search-drop-down');
        searchDropDownChoiceOuterCtn = $('.search-drop-down-choices-outer-ctn');
        searchDropDownChoiceInnerCtn = $('.search-drop-down-choices-inner-ctn');
        searchEventsBtn.click(searchEvents);
        searchEventsSliderBtn = $('.slider-list-event-btn');
        searchEventsSliderBtn.click(searchEventsSlider);

        featureBtn = $(".feature-event-btn");
        featureBtn.on("click", searchFeatureEvents);

        sendLostTicketsBtn = $(".send-lost-tickets-btn");
        sendLostTicketsBtn.on("click", sendLostTickets);

        $(document).on('click', checkOutClick);
    };

    $(window).on("load", function () {
        init();
    });
})(jQuery);
(function ($, d, g) {

    'use strict';

    var lang = d.documentElement.lang;

    var currPage;
    var meTable;
    var deleteBtn;
    var cancelBtn;
    var deleteInvitationBtn;
    var refundAllTicketsBtn;
    var confirmForm;
    var eventRow;
    var attendeesBtn;

    var confirmAction = function confirmAction(e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        if (confirmForm) {
            ajaxBlackout(true);
            confirmForm.submit();
        }
    };

    var deleteEvent = function deleteEvent(e) {
        confirmForm = $(this).closest("form")[0];
        $("#manage_events_prompt_delete .popup-inner-content-btn .btn")
        // .css("position", "absolute") // looks weird
        .click(confirmAction);
        openWindow("manage_events_prompt_delete", true);
    };

    var cancelEvent = function cancelEvent(e) {
        confirmForm = $(this).closest("form")[0];
        $("#manage_events_prompt_cancel .popup-inner-content-btn .btn")
        // .css("position", "absolute")
        .click(confirmAction);
        openWindow("manage_events_prompt_cancel", true);
    };

    var deleteInvitation = function deleteInvitation(e) {
        confirmForm = $(this).closest("form")[0];
        $("#manage_events_prompt_delete_invitation .popup-inner-content-btn .btn").click(confirmAction);
        openWindow("manage_events_prompt_delete_invitation", true);
    };

    var refundAll = function refundAll(e) {
        var t = $(this);
        openWindow("manage_events_prompt_confirm_refund_all_request", true);
        confirmForm = t.closest("form")[0];

        var checksP = $('#manage_events_prompt_confirm_refund_all_request').find('.check-sum-refund');
        var consigneP = $('#manage_events_prompt_confirm_refund_all_request').find('.consigne-sum-refund');
        var ticketAmountSpan = $('#manage_events_prompt_confirm_refund_all_request').find('.refund-all-tickets-amount');
        var ticketNumSpan = $('#manage_events_prompt_confirm_refund_all_request').find('.refund-all-tickets-num');
        var ticketAmountCheckSpan = $('#manage_events_prompt_confirm_refund_all_request').find('.refund-all-tickets-amount-check');
        var ticketNumCheckSpan = $('#manage_events_prompt_confirm_refund_all_request').find('.refund-all-tickets-num-check');
        var ticketAmountConsigneSpan = $('#manage_events_prompt_confirm_refund_all_request').find('.refund-all-tickets-num-consigne');

        var url = '/action/epRefund';
        url += '?eventId=' + $(confirmForm).find('input[name=eventId]').val();
        url += '&data=true';
        url += '&ajax=true';

        ajax(url, function (response) {
            var resp = response.split('~');
            try {
                ticketAmountSpan.html(parseFloat(resp[0]).toFixed(2));
                ticketNumSpan.html(resp[1]);
                if (parseFloat(resp[2]) !== 0) {
                    checksP.removeClass("hide");
                    ticketAmountCheckSpan.html(parseFloat(resp[2]).toFixed(2));
                    ticketNumCheckSpan.html(resp[3]);
                } else {
                    checksP.addClass("hide");
                }
                if (parseFloat(resp[4]) !== 0) {
                    consigneP.removeClass("hide");
                    ticketAmountConsigneSpan.html(resp[4]);
                } else {
                    consigneP.addClass("hide");
                }
            } catch (e) {
                console.log(e);
            }
        }, true);
        $("#manage_events_prompt_confirm_refund_all_request .popup-inner-content-btn .btn").unbind();
        $("#manage_events_prompt_confirm_refund_all_request .popup-inner-content-btn .btn").one('click', function () {
            $(this).closest('.popup').find('.popup-inner-close').trigger('click');

            var url = '/action/epRefund';
            url += '?eventId=' + $(confirmForm).find('input[name=eventId]').val();
            url += '&org=true';
            url += '&ajax=true';

            ajax(url, function (response) {
                if (response.indexOf('success') !== -1) {
                    t.closest('tr').find('.event-infos-td p').html(t.attr('data-info'));
                    t.addClass('disabled');
                }
            }, true);
        });
    };

    var getEventTicketsInfos = function getEventTicketsInfos() {
        var btn = $(this);
        var t = btn.closest(".one-event-row");
        var eventCode = t.data('code');
        var perPage = 30;

        if (!eventCode) {
            return;
        }

        t.find('.popup').addClass('processing');
        t.find('.participants-list-table .one-participant-row:not(.clone)').remove();

        var data = {
            validate: eventCode,
            download: true,
            count: perPage,
            page: t.data('curr'),
            version: 4
        };

        if (t.find('.form-input[name=q]').length > 0 && t.find('.form-input[name=q]').val().length > 0) {
            data.q = t.find('.form-input[name=q]').val();
        }

        $.ajax({
            url: '/action/epQR',
            cache: false,
            data: data,
            success: function success(response) {
                if (response.indexOf('validityStartDate') !== -1) {
                    var data = JSON.parse(response);
                    var count = t.data('curr') > 1 ? (t.data('curr') - 1) * perPage : 0;

                    handlePager(t, data);

                    $.each(data, function (k, tickets) {
                        if (isNaN(k.substring(0, 3))) {
                            return;
                        }

                        $.each(tickets, function (k1, v) {
                            count++;
                            t.find(attendeesBtn).removeClass('hide');

                            var ticketNumber = count;
                            var buyerName = v.buyer;
                            var ticketType = '';
                            var isFr = lang === "fr";
                            switch (v.type) {
                                case "0":
                                    ticketType = isFr ? "Billet" : "Ticket";
                                    break;
                                case "1":
                                    ticketType = isFr ? "Billet en palier" : "Level ticket";
                                    break;
                                case "2":
                                    if (v.ticketType == 'pass') {
                                        ticketType = isFr ? "Billet via passe" : "Ticket in pass";
                                    } else {
                                        ticketType = isFr ? "Billet via forfait" : "Ticket in package";
                                    }
                                    break;
                                case "3":
                                    ticketType = isFr ? "Billet de consigne" : "Physical ticket";
                                    break;
                                case "4":
                                    ticketType = isFr ? "Billet de faveur" : "Free ticket";
                                    break;
                            }
                            var ticketName = v.ticketName;
                            var ticketCode = k;
                            var ticketScannedStatus = returnScannedStatus(v.scannedIn, v.inside);
                            var buyerEmail = v.email;
                            var ticketActive = v.active;
                            var ticketScanned = v.scannedIn;
                            var buyerInside = v.inside;
                            var refunded = v.refunded;
                            var participant = v.hasOwnProperty("participant") && v.hasOwnProperty("firstName") ? v.participant : "";
                            var buyingMode = v.buyingMode; //0 : online ; 1 : Virtual cashier
                            if (buyerName.trim() === '' && buyingMode === '1') {
                                buyerName = isFr ? "Caisse Virtuelle" : "Virtual Cashier";
                            }
                            addNewAttendeeRow(t, ticketNumber, buyerName, ticketType, ticketName, ticketCode, ticketScannedStatus, buyerEmail, ticketActive, ticketScanned, buyerInside, refunded, participant);
                        });
                    });
                }
                t.find('.popup').removeClass('processing');
            }
        });
    };

    var handlePager = function handlePager(t, data) {
        var totalPages = data.page;
        if (totalPages > 1) {
            var currPage = t.data('curr');

            t.data('total', totalPages);

            currPage > 1 ? t.find('.pager-arrow.previous-page').fadeIn() : t.find('.pager-arrow.previous-page').fadeOut();
            currPage < totalPages ? t.find('.pager-arrow.next-page').fadeIn() : t.find('.pager-arrow.next-page').fadeOut();
            t.find('.participants-pager-total-count').html('Page ' + currPage + ' / ' + totalPages + ' - ' + 'Total: ' + data.counter + ' participants');
        } else {
            t.find('.pager-arrow.previous-page').fadeOut();
            t.find('.pager-arrow.next-page').fadeOut();
            t.find('.participants-pager-total-count').html('Page ' + totalPages + ' - ' + 'Total: ' + data.counter + ' participants');
        }
    };

    var addNewAttendeeRow = function addNewAttendeeRow(t, ticketNumber, buyerName, ticketType, ticketName, ticketCode, ticketScannedStatus, buyerEmail, ticketActive, ticketScanned, buyerInside, refunded, participant) {
        var rowCopy = t.find('.table-action-btns-ctn:not(.responsive)').find('.one-participant-row.clone').clone();

        rowCopy.find('.ticket-number').html(ticketNumber);
        if (participant.trim() !== '') {
            rowCopy.find('.ticket-participant-name').html(participant);
            //            t.find('.table-action-btns-ctn:not(.responsive)').find(".table-participants-list-participant-name").css("display","block");
        } else {
            rowCopy.find('.ticket-participant-name').html(buyerName);
            //            rowCopy.find('.ticket-participant-name').parent("td").css("display", "none");
            //            t.find('.table-action-btns-ctn:not(.responsive)').find(".table-participants-list-participant-name").css("display","none");
        }
        //        rowCopy.find('.ticket-buyer-name').html(buyerName);
        rowCopy.find('.ticket-type').html(ticketType);
        rowCopy.find('.ticket-cat-name').html(ticketName);
        rowCopy.find('.ticket-code').html(ticketCode);
        rowCopy.find('.ticket-scanned-status').html(ticketScannedStatus);
        rowCopy.find('.ticket-buyer-email').html(buyerEmail);
        rowCopy.find('.table-toggle-ticket-scan-action').data('qr', ticketCode);
        rowCopy.find('.table-toggle-ticket-scan-action').data('inside', !buyerInside);
        rowCopy.find('.table-toggle-ticket-scan-action').addClass('' + !buyerInside + '').click(toggleTicketScan);
        if (ticketActive === false) {
            rowCopy.find('.table-toggle-ticket-scan-action').addClass('disabled');
        }
        rowCopy.find('.table-toggle-ticket-active-action').data('qr', ticketCode);
        rowCopy.find('.table-toggle-ticket-active-action').data('activate', !ticketActive);
        rowCopy.find('.table-toggle-ticket-active-action').addClass('' + !ticketActive + '').click(toggleTicketActive);

        if (refunded === true) {
            var refundedText = '<p>';
            if (lang = 'fr') {
                refundedText += 'Billet remboursé';
            } else {
                refundedText += 'Refunded ticket';
            }
            refundedText += '</p>';
            rowCopy.find('.table-actions-inner-ctn').remove();
            rowCopy.find('.table-action').append(refundedText);
        }

        rowCopy.removeClass('clone').removeClass('hide');
        t.find('.participants-list-table').append(rowCopy);
    };

    var toggleTicketScan = function toggleTicketScan() {
        var t = $(this);
        var eventCode = t.closest('.one-event-row').data('code');
        var qr = t.data('qr');
        var inside = t.data('inside');

        var url = '/action/epQR';
        url += '?qr=' + qr;
        url += '&validate=' + eventCode;
        url += '&scanIn=' + inside;

        ajax(url, function (response) {
            if (response.indexOf('already scanned in is out') !== -1 || response.indexOf('already scanned out is in') !== -1 || response.indexOf('valid') !== -1) {
                t.removeClass('' + inside + '').addClass('' + !inside + '');
                t.data('inside', !inside);
                t.closest('tr').find('.ticket-scanned-status').html(returnScannedStatus(true, inside));
            }
        }, true);
    };

    var toggleTicketActive = function toggleTicketActive() {
        var t = $(this);
        var eventId = t.closest('.one-event-row').data('id');
        var qr = t.data('qr');
        var activate = t.data('activate');

        var url = '/action/epQR';
        url += '?qr=' + qr;
        url += '&validate=' + eventId;
        url += '&activate=' + activate;

        ajax(url, function (response) {
            if (response.indexOf('success') !== -1) {
                t.removeClass('' + activate + '').addClass('' + !activate + '');
                t.data('activate', !activate);

                if (activate === false) {
                    t.closest('td').find('.table-toggle-ticket-scan-action').addClass('disabled');
                } else {
                    t.closest('td').find('.table-toggle-ticket-scan-action').removeClass('disabled');
                }
            }
        }, true);
    };

    var returnScannedStatus = function returnScannedStatus(scanned, inside) {
        var status;

        if (scanned) {
            if (lang === 'fr') {
                status = 'Scanné ';
            } else {
                status = 'Scanned ';
            }

            if (inside) {
                status += 'in';
            } else {
                status += 'out';
            }
        } else {
            if (lang === 'fr') {
                status = 'Non scanné';
            } else {
                status = 'Not scanned';
            }
        }

        return status;
    };

    var updateAllPopupInputs = function updateAllPopupInputs() {
        // to have the same query in both popups...meh
        var t = $(this);
        var val = t.val();
        var popupId = t.closest('.popup').attr('id');

        $('.popup[id=' + popupId + ']').find('.search-participants-input').val(val).closest('.input-ctn').addClass('focused');
    };

    var changeParticipantsPage = function changeParticipantsPage() {
        var t = $(this);
        var row = t.closest('.one-event-row');

        if (t.hasClass('next-page')) {
            row.data('curr', row.data('curr') + 1);
        } else if (t.hasClass('previous-page')) {
            row.data('curr', row.data('curr') - 1);
        }

        t.closest('.popup').find('.search-participants-btn').trigger('click');
    };

    var closePopupAndOpenAppCode = function closePopupAndOpenAppCode() {
        var t = $(this);
        t.closest('.popup').find('.popup-inner-close').trigger('click');
        t.closest('.table-action-btns-ctn').find('.table-app-code-action').trigger('click');
    };

    var init = function init() {
        currPage = $(".page");
        meTable = $(".manage-events-table", currPage);
        deleteBtn = $(".table-delete-action", meTable);
        deleteBtn.click(deleteEvent);
        cancelBtn = $(".table-cancel-action", meTable);
        cancelBtn.click(cancelEvent);
        deleteInvitationBtn = $(".table-delete-invitation", meTable);
        deleteInvitationBtn.click(deleteInvitation);
        refundAllTicketsBtn = $(".table-refund-all-tickets-action", meTable);
        refundAllTicketsBtn.click(refundAll);
        eventRow = $('.one-event-row', meTable);
        attendeesBtn = $('.table-participants-list-action');
        attendeesBtn.on("click", getEventTicketsInfos);
        $('.search-participants-btn').on("click", getEventTicketsInfos);
        $('.search-participants-input').keyup(updateAllPopupInputs);
        $('.participants-page-btn').click(changeParticipantsPage);
        $('.app-code-instructions-btn').on("click", closePopupAndOpenAppCode);
        $('.table-app-update-action').show();
        $('.table-app-code-action').hide();
    };

    $(g).on("load", function () {
        init();
    });

    var manageEvents = Fw.component.export('manageEvents', {
        init: init,
        confirmAction: confirmAction
    });
})(jQuery, document, window);
(function ($, undefined) {
    'use strict';

    var manageMerchsPath = "/action/epManageProducts";
    var picture;
    var pictureFile;
    var delPicture;
    var activateOptions;
    var addOptionBtn;
    var addOptionDelBtn;
    var optionEditQty;
    var originalInventory;
    var pauseProductBtn;
    var archiveProductBtn;
    var confirmArchivePopupBtn;
    var confirmArchiveBtn;
    var duplicateProductBtn;
    var linkEventProductBtn;
    var linkEventProductDeleteBtn;
    var linkEventProductVisibilityBtn;
    var merchId;
    var submitCreateProductBtn;
    var statusChangeBtn;
    var doNotBuyTicketCheckbox;
    var availableQtyInput;

    var triggerFileSelection = function triggerFileSelection(e) {
        var t = $(this);
        var f = t.next();
        f.click();
    };

    var getThumbnail = function getThumbnail(e) {
        var file = this.files[0];
        var reader = new FileReader();
        var ctn = $(this).prev();
        var preview = ctn.find(".home-event-bg-pic");

        reader.onloadend = function (e) {
            ctn.removeClass("empty");
            preview.removeClass("home-event-bg-pic-hide");
            if (ctn.find(".featured-event-delete").hasClass("rotate")) {
                deleteImage(e, ctn.find(".featured-event-delete"));
            }
            preview.css("backgroundImage", "url(" + reader.result + ")");
        };

        if (file) {
            reader.readAsDataURL(file);
        } else {
            preview.css("");
        }
    };

    var deleteImage = function deleteImage(e, th) {
        e.stopPropagation();
        var t = th !== undefined ? th : $(this);
        var inp = t.find(".delete-pic");
        var img = t.parent().find(".home-event-bg-pic");
        if (t.hasClass("rotate")) {
            t.removeClass("rotate");
            inp.attr("name", "");
            img.removeClass("to-be-deleted");
        } else {
            t.addClass("rotate");
            inp.attr("name", inp.attr("data-name"));
            img.addClass("to-be-deleted");
        }
    };

    var deleteMerch = function deleteMerch() {
        var btnDel = $(this),
            data = { item: btnDel.closest("tr") },
            btnYes = $("#deleteMerchConfirmPopup .popup-btn-confirm"),
            btnNo = $("#deleteMerchConfirmPopup .popup-btn-cancel");
        btnYes.one("click", data, function (e) {
            confirmDeleteMerch(e);
        });
        btnNo.one("click", function (e) {
            btnYes.off("click", confirmDeleteMerch);
            closeWindow("deleteMerchConfirmPopup");
        });
        $("#deleteMerchConfirmPopup").css("position", "absolute");
        openWindow("deleteMerchConfirmPopup", true);
    };

    var confirmDeleteMerch = function confirmDeleteMerch(e) {
        e.stopImmediatePropagation();
        var item = e.data.item,
            merchid = item.attr("data-merchid");

        var data = new FormData();
        data.append("productId", merchid);
        data.append("delete", "true");
        data.append("ajax", "true");

        $.ajax({
            url: manageMerchsPath,
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            type: 'POST',
            success: function success(response) {
                if (response.trim() !== "fail") {
                    item.remove();
                }
            }
        });
        closeWindow("deleteMerchConfirmPopup");
    };

    var addOption = function addOption() {
        var ctn = $(".add-option-form");
        var name = ctn.find("input[name='optionName']").val();
        var qty = ctn.find("input[name='optionQty']").val();

        if (name !== '' && qty !== '') {
            var count = parseInt($(".create-product-all-custom-quantities input[name='optionCounter']").val()) + 1;

            var clone = $("#product-options-clone").children().clone();
            clone.find("input.product-custom-name").val(name);
            clone.find("input.product-custom-name").attr("name", "optionName" + count);
            clone.find(".create-product-custom-qty-name").text(name);
            clone.find("input.product-custom-qty").val(qty);
            clone.find("input.product-custom-qty").attr("name", "optionQty" + count);
            clone.find(".remove-product-custom-qty-btn").on("click", function (e) {
                removeOption(e, this);
            });

            $(".options-ctn").append(clone);
            $(".create-product-all-custom-quantities input[name='optionCounter']").val(count);
            ctn.find("input[name='optionName']").val("").closest('.input-ctn').removeClass('focused');
            ctn.find("input[name='optionQty']").val("").closest('.input-ctn').removeClass('focused');
            $(".create-product-options-ctn").find('.derequired').removeClass('required');
            updateMerchQty();
        }
    };

    var removeOption = function removeOption(e, th) {
        var t = th === undefined ? $(this) : $(th);
        var ctn = t.closest('.create-product-options-ctn');
        if (t.closest(".create-product-custom-qty-ctn").find(".product-custom-remove").length !== 0) {
            var inp = t.closest(".create-product-custom-qty-ctn").find(".product-custom-remove");
            inp.attr("name", inp.attr("data-name"));
            t.closest(".create-product-custom-qty-ctn").addClass("hide");
        } else {
            t.closest(".create-product-custom-qty-ctn").remove();
        }
        if (ctn.find('.options-ctn').find('.create-product-custom-qty-ctn.filled:not(.hide)').length === 0) {
            ctn.find('.derequired').addClass('required');
        }
        updateMerchQty();
    };

    var handleOptions = function handleOptions(e) {
        var check = $(this).is(":checked");
        var optionsCtn = $(".create-product-options-ctn");
        var inventoryInput = $(".add-product-form input[name = 'inventory']");
        var optionInventoryInput = $(".add-product-form  .available-options-qty");

        if (check) {
            optionsCtn.slideDown();
            inventoryInput.parent().addClass("disabled-ctn");
            inventoryInput.addClass("disabled");
            inventoryInput.attr("disabled", "disabled");
            originalInventory = inventoryInput.val();
            if (optionsCtn.find('.options-ctn').find('.create-product-custom-qty-ctn.filled:not(.hide)').length === 0) {
                optionsCtn.find('.derequired').addClass('required');
            }
            optionInventoryInput.attr("name", optionInventoryInput.attr("data-name"));
            updateMerchQty();
        } else {
            optionsCtn.slideUp();
            inventoryInput.parent().removeClass("disabled-ctn");
            inventoryInput.removeAttr("disabled");
            inventoryInput.removeClass("disabled");
            optionsCtn.find('.derequired').removeClass('required').removeClass('error');
            inventoryInput.val(originalInventory);
            optionInventoryInput.attr("name", "");
        }
    };

    var updateMerchQty = function updateMerchQty(e) {
        var optionInventoryInput = $(".add-product-form  .available-options-qty");
        var inventory = $(".add-product-form input[name = 'inventory']");
        var total = 0;

        $(".create-product-custom-qty-ctn:not(.hide) .product-custom-qty").each(function () {
            total += parseInt($(this).val());
        });

        inventory.val(total);
        optionInventoryInput.val(total);
    };

    var pauseProduct = function pauseProduct() {
        var t = $(this);
        var row = t.closest('tr');
        var id = t.attr("data-id");
        var active = !t.hasClass("active");

        var data = new FormData();
        data.append("productId", id);
        data.append("active", active);
        data.append("ajax", "true");

        var url = "/action/epManageProducts";

        $.ajax({
            url: url,
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            type: 'POST',
            success: function success(response) {
                var actionBtns = row.find('.table-suspend-product-sale-action');
                if (active) {
                    actionBtns.addClass("active");
                    actionBtns.find("p").text(t.find("p").attr("data-active"));
                } else {
                    actionBtns.removeClass("active");
                    actionBtns.find("p").text(t.find("p").attr("data-inactive"));
                }
            }
        });
    };

    var archiveProduct = function archiveProduct(btn) {
        var t = $(this).length > 0 ? $(this) : btn;
        var id = t.attr("data-id");
        var archive = !t.hasClass("archived");
        var forward = t.attr("data-url");

        var data = new FormData();
        data.append("productId", id);
        data.append("archive", archive);
        data.append("ajax", "true");

        var url = "/action/epManageProducts";

        $.ajax({
            url: url,
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            type: 'POST',
            success: function success(response) {
                window.location = forward;
                //                if (archive) {
                //                    t.addClass("archived");
                //                    t.find("p").text(t.find("p").attr("data-unarchive"));
                //                } else {
                //                    t.removeClass("archived");
                //                    t.find("p").text(t.find("p").attr("data-archive"));
                //                }
            }
        });
    };

    var confirmArchivePopup = function confirmArchivePopup() {
        merchId = $(this).closest('tr').attr('data-merchid');
        openWindow("archive-product-warning-popup", true);
    };

    var archiveAfterConfirm = function archiveAfterConfirm() {
        var archiveBtn = $('tr[data-merchid=' + merchId + ']').find('.product-archive-action');
        archiveProduct(archiveBtn);
    };

    var duplicateProduct = function duplicateProduct() {
        var t = $(this);
        var id = t.attr("data-id");
        var forward = t.attr("data-url");

        var data = new FormData();
        data.append("productId", id);
        data.append("duplicate", "true");
        data.append("ajax", "true");

        var url = "/action/epManageProducts";

        $.ajax({
            url: url,
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            type: 'POST',
            success: function success(response) {
                if (response.indexOf("success") !== -1) {
                    var id = response.trim().substring(8);
                    window.location = forward + "?productId=" + id;
                }
            }
        });
    };

    var linkEventProduct = function linkEventProduct() {
        var ctn = $(".create-event-product-link-form");
        var eventId = ctn.find("input[name='link-event-product-eventId']").val();
        var productId = ctn.find("select[name='product-selection']").val();
        var doNotBuyTicket = ctn.find("input[name='event-product-purchase-condition']").is(":checked");
        if (productId !== '') {
            var url = "/action/epManageEventProducts";
            url += "?productId=" + productId;
            url += "&eventId=" + eventId;
            url += "&buyTicket=" + !doNotBuyTicket;
            ajax(url, function (response) {
                if (response.indexOf("success") !== -1) {
                    var id = response.trim().substring(8);
                    var clone = $(".event-form-products-table-bank .event-product-" + productId);
                    $(".event-form-products-table-bank .event-product-" + productId);
                    var counter = parseInt($(".event-product-position-counter").val()) + 1;
                    clone.find(".event-product-position").text(counter);
                    $(".event-product-position-counter").val(counter);

                    clone.find(".event-product-delete-link").attr("data-id", id);
                    clone.find(".event-product-delete-link").attr("data-buyticket", !doNotBuyTicket);
                    clone.attr("data-linkid", id);
                    if (doNotBuyTicket) {
                        clone.find(".table-product-qr-icon-ctn").addClass("hide");
                    } else {
                        clone.find(".table-product-qr-icon-ctn").removeClass("hide");
                    }

                    $(".event-form-products-table").append(clone);
                    $(".link-products-choice-" + productId).addClass("hide");
                    ctn.find("select[name='product-selection']").val("");
                    ctn.find("input[name='event-product-purchase-condition']").prop("checked", false);
                }
            }, true);
        }
    };

    var closeClonePopup = function closeClonePopup(ctn) {
        var rowActionButtons = ctn.find('.table-action-popup-btn');
        var actionsPopup = ctn.find('.table-actions-ctn');
        rowActionButtons.removeClass('active');
        ctn.find('.table-cell-overlay').removeClass('active');
        ctn.find('.table-cell-overlay').attr("style", "display: none;");
        actionsPopup.removeClass('open');

        var parent = ctn.find('.table-action-btns-ctn');
        if (!parent.is('div')) {
            $('.overlay', 'body').removeClass('active-responsive');
        }
    };

    var linkEventProductDelete = function linkEventProductDelete() {
        var t = $(this);
        var ctn = $(".create-event-product-link-form");
        var eventId = ctn.find("input[name='link-event-product-eventId']").val();
        var productId = t.attr("data-productid");
        var linkId = t.attr("data-id");
        var table = t.closest('tbody');
        if (linkId !== '') {
            var url = "/action/epManageEventProducts";
            url += "?linkId=" + linkId;
            url += "&productId=" + productId;
            url += "&eventId=" + eventId;
            url += "&delete=true";
            ajax(url, function (response) {
                if (response.indexOf("success") !== -1) {
                    var clone = t.closest("tr");
                    var counter = parseInt($(".event-product-position-counter").val()) - 1;
                    $(".event-product-position-counter").val(counter);
                    $(".event-form-products-table-bank").append(clone);
                    $(".link-products-choice-" + productId).removeClass("hide");
                    closeClonePopup(clone);
                    updatePositionMerch();
                    if (table.find('.event-product-delete-link[data-buyticket=false]').length === 0) {
                        $('.postal-delivery-checkbox-ctn').removeClass('fade no-pointer');
                    }
                }
            }, true);
        }
    };

    var updatePositionMerch = function updatePositionMerch() {
        $(".event-form-products-table tr").each(function (index) {
            $(this).find(".event-product-position").text(index);
        });
    };

    var toggleEventProductVisibility = function toggleEventProductVisibility() {
        var t = $(this);
        var ctn = $(".create-event-product-link-form");
        var eventId = ctn.find("input[name='link-event-product-eventId']").val();
        var productId = t.attr("data-productid");
        var linkId = t.attr("data-id");
        var visible = !t.hasClass("active");
        if (linkId !== '') {
            var url = "/action/epManageEventProducts";
            url += "?linkId=" + linkId;
            url += "&productId=" + productId;
            url += "&eventId=" + eventId;
            url += "&visible=" + visible;
            ajax(url, function (response) {
                if (response.indexOf("success") !== -1) {
                    if (visible) {
                        t.addClass("active");
                        t.find("p").text(t.find("p").attr("data-visible"));
                    } else {
                        t.removeClass("active");
                        t.find("p").text(t.find("p").attr("data-invisible"));
                    }
                }
            }, true);
        }
    };

    var validateProductForm = function validateProductForm(e) {
        var btn = $(this);
        var form = $(this).closest('form');
        var mainImgCtn = $('.create-product-img-ctn.main');
        var error = $('.js-form-error-message.image');

        e.preventDefault();
        formValidator.validateForm(form);

        if (mainImgCtn.hasClass('empty') || mainImgCtn.find('.home-event-bg-pic').hasClass('to-be-deleted')) {
            form.addClass('error-img');
            mainImgCtn.addClass('error');
            error.slideDown();
        } else {
            form.removeClass('error-img');
            mainImgCtn.removeClass('error');
            error.slideUp();
        }

        if (!form.hasClass('has-error') && !form.hasClass('error-img')) {
            btn.addClass('disabled');
            form.submit();
        }
    };

    var changePaymentStatus = function changePaymentStatus() {
        var t = $(this);
        var ctn = t.closest(".product-sales-status-popup");
        var id = t.attr("data-id");
        var radio = ctn.find("input[name = 'product-status-" + id + "']:checked");
        var status = radio.val();
        var mode = radio.attr("data-extra");

        var url = "/action/epManageTransactions";
        url += "?paymentId=" + id;
        url += "&shippingMode=" + mode;
        url += "&status=" + status;
        ajax(url, function (response) {
            if (response.indexOf("success") !== -1) {
                $(".merch-payments-" + id).find(".table-status-text").text(radio.parent().find(".radio-input-text").text());
                var colorBar = $(".merch-payments-" + id).find(".table-status-colorbar");
                if (status === '2' || status === '3' || status === '4') {
                    colorBar.removeClass("yellow");
                    colorBar.removeClass("orange");
                    colorBar.addClass("green");
                } else if (status === '1') {
                    colorBar.removeClass("green");
                    colorBar.removeClass("orange");
                    colorBar.addClass("yellow");
                } else {
                    colorBar.removeClass("yellow");
                    colorBar.removeClass("green");
                    colorBar.addClass("orange");
                }
            }
        }, true);
    };

    var toggleShippingCheckbox = function toggleShippingCheckbox() {
        var t = $(this);
        var postalDelivery = $('input[name=postalDelivery]');

        if (t.is(':checked')) {
            if (!postalDelivery.is(':checked')) {
                postalDelivery.trigger('click');
            }
            $('.postal-delivery-checkbox-ctn').addClass('fade no-pointer');
        } else {
            if ($('.event-form-products-table').find('.event-product-delete-link[data-buyticket=false]').length === 0) {
                $('.postal-delivery-checkbox-ctn').removeClass('fade no-pointer');
            }
        }
    };

    var checkInventoryVsAvailable = function checkInventoryVsAvailable() {
        var t = $(this);

        if (t.val() < t.data('misc')) {
            t.val(t.data('misc'));
        }
    };

    var maxProductPrice = function maxProductPrice() {
        var t = $(this);
        if (parseInt(t.val()) > 10000) {
            t.val(10000);
        }
    };

    var init = function init() {
        originalInventory = $(".add-product-form input[name = 'inventory']").val();

        delPicture = $(".create-product-img-ctn .featured-event-delete");
        delPicture.on("click", deleteImage);

        picture = $(".create-product-img-ctn");
        picture.on("click", triggerFileSelection);

        pictureFile = $(".select-picture");
        pictureFile.on("change", getThumbnail);

        $(".merch-table .table-delete-btn").click(deleteMerch);

        activateOptions = $(".add-product-form input[name = 'optionsActive']");
        activateOptions.on("click", handleOptions);

        addOptionBtn = $(".create-product-add-option-btn");
        addOptionBtn.on("click", addOption);

        addOptionDelBtn = $(".remove-product-custom-qty-btn");
        addOptionDelBtn.on("click", removeOption);

        optionEditQty = $(".product-custom-qty");
        optionEditQty.on("change", updateMerchQty);

        pauseProductBtn = $(".table-suspend-product-sale-action");
        pauseProductBtn.on("click", pauseProduct);

        archiveProductBtn = $(".product-archive-action:not(.has-linked-events)");
        archiveProductBtn.on("click", archiveProduct);

        confirmArchivePopupBtn = $(".product-archive-action.has-linked-events");
        confirmArchivePopupBtn.on("click", confirmArchivePopup);

        confirmArchiveBtn = $(".confirm-archive-btn");
        confirmArchiveBtn.on("click", archiveAfterConfirm);

        duplicateProductBtn = $(".product-duplicate-btn");
        duplicateProductBtn.on("click", duplicateProduct);

        linkEventProductBtn = $(".add-product-choice-btn");
        linkEventProductBtn.on("click", linkEventProduct);

        linkEventProductDeleteBtn = $(".event-product-delete-link");
        linkEventProductDeleteBtn.on("click", linkEventProductDelete);

        linkEventProductVisibilityBtn = $(".event-product-visibility-btn");
        linkEventProductVisibilityBtn.on("click", toggleEventProductVisibility);

        submitCreateProductBtn = $('.submit-create-product-btn');
        submitCreateProductBtn.click(validateProductForm);

        statusChangeBtn = $('.status-payment-change-btn');
        statusChangeBtn.click(changePaymentStatus);

        doNotBuyTicketCheckbox = $("input[name='event-product-purchase-condition']");
        doNotBuyTicketCheckbox.click(toggleShippingCheckbox);

        availableQtyInput = $('.merch-available-qty');
        availableQtyInput.keyup(checkInventoryVsAvailable);

        $('.product-price-input').keyup(maxProductPrice);
    };

    $(window).on('load', function () {
        init();
    });
})(jQuery);
(function ($, undefined) {

	'use strict';

	var formValidator;
	var updateElem;
	var initMapBtn;
	var geolocalisationInput;
	var appLocationDetailsForm;
	var clearLocationFormBtn;
	var mapId;
	var mapCtn;
	var repArtistsCtn;
	var filesInfos = '';
	var tools;

	var saveAppParams = function saveAppParams() {
		var btn = $(this);
		var form = btn.closest('form');
		var sitePlanFrInput = form.find('.file-upload-input[name=plan-fr]');
		var sitePlanFr = sitePlanFrInput[0].files[0];
		var sitePlanEnInput = form.find('.file-upload-input[name=plan-en]');
		var sitePlanEn = sitePlanEnInput[0].files[0];
		var sitePlanErrorMsg = $('.js-form-error-message.plan-size');
		var fileTypeErrorMsg = $('.js-form-error-message.file-type');

		if (!sitePlanFr) {
			sitePlanFr = form.find('.file-upload-input[name=plan-en]')[0].files[0];
		}
		if (!sitePlanEn) {
			sitePlanEn = form.find('.file-upload-input[name=plan-fr]')[0].files[0];
		}

		$('.file-ctn').removeClass('error');
		sitePlanErrorMsg.slideUp();
		fileTypeErrorMsg.slideUp();
		form.removeClass('error-plan-file-size');
		form.removeClass('error-file-type');

		formValidator.validateForm(form);
		validateFileExtensions(form);
		validatePlanSize(sitePlanFrInput, form);
		validatePlanSize(sitePlanEnInput, form);

		if (!form.hasClass('has-error') && !form.hasClass('error-file-type') && !form.hasClass('error-plan-file-size')) {
			btn.addClass('disabled');

			var appId = form.find('input[name=app-id]').val();
			var social = {
				hashtag: form.find('input[name=hashtag]').val(),
				facebook: form.find('input[name=facebook]').val(),
				instagram: form.find('input[name=instagram]').val(),
				twitter: form.find('input[name=twitter]').val(),
				linkedin: form.find('input[name=linkedin]').val(),
				website: form.find('input[name=website]').val()
			};
			var bannerText = {
				fr: {
					h1: form.find('input[name=banner-h1-fr]').val().length > 0 ? form.find('input[name=banner-h1-fr]').val() : form.find('input[name=banner-h1-en]').val(),
					h2: form.find('input[name=banner-h2-fr]').val().length > 0 ? form.find('input[name=banner-h2-fr]').val() : form.find('input[name=banner-h2-en]').val(),
					link: form.find('input[name=banner-link-fr]').val().length > 0 ? form.find('input[name=banner-link-fr]').val() : form.find('input[name=banner-link-en]').val()
				},
				en: {
					h1: form.find('input[name=banner-h1-en]').val().length > 0 ? form.find('input[name=banner-h1-en]').val() : form.find('input[name=banner-h1-fr]').val(),
					h2: form.find('input[name=banner-h2-en]').val().length > 0 ? form.find('input[name=banner-h2-en]').val() : form.find('input[name=banner-h2-fr]').val(),
					link: form.find('input[name=banner-link-en]').val().length > 0 ? form.find('input[name=banner-link-en]').val() : form.find('input[name=banner-link-fr]').val()
				}
			};
			var colors = {
				splash: form.find('input[name=logo-background-color]').val(),
				main: form.find('input[name=main-color]').val(),
				text: form.find('input[name=app-text-color]:checked').val(),
				map: form.find('input[name=app-map-style]:checked').val()
			};
			var disabledPages = {
				artists: form.find('input[name=disable-artists-page]').prop('checked'),
				program: form.find('input[name=disable-program-page]').prop('checked'),
				tickets: form.find('input[name=disable-tickets-page]').prop('checked'),
				location: form.find('input[name=disable-location-page]').prop('checked'),
				merch: form.find('input[name=disable-merch-page]').prop('checked'),
				hashtag: form.find('input[name=disable-hashtag-page]').prop('checked')
			};

			var imageHomepageFr = form.find('.file-upload-input[name=homepage-fr]')[0].files[0];
			if (!imageHomepageFr) {
				imageHomepageFr = form.find('.file-upload-input[name=homepage-en]')[0].files[0];
			}

			var imageHomepageEn = form.find('.file-upload-input[name=homepage-en]')[0].files[0];
			if (!imageHomepageEn) {
				imageHomepageEn = form.find('.file-upload-input[name=homepage-fr]')[0].files[0];
			}

			var data = {
				id: appId,
				field1: 'app',
				field3: form.find('input[name=profile-id]').val(),
				field4: form.find('input[name=account-id]').val(),
				field6: JSON.stringify(getTextareaContent(form, 'app-description')),
				field7: JSON.stringify(getTextareaContent(form, 'practical-infos')),
				field8: JSON.stringify(getTextareaContent(form, 'terms-conditions')),
				field9: JSON.stringify(social),
				field10: JSON.stringify(colors),
				field11: JSON.stringify(bannerText),
				field12: JSON.stringify(disabledPages),
				ajax: true
			};

			if (appId === '') {
				data.field2 = 0;
			}

			if (!btn.hasClass('valid')) {
				data.field5 = form.find('input[name=app-name]').val();
			}

			var _updateData = function _updateData(data) {
				// console.log(data);

				$.ajax({
					url: '/action/manageGenData',
					cache: false,
					data: data,
					method: 'POST',
					success: function success(response) {
						// console.log('app new/edit : ' + response);
						if (response.indexOf('success') !== -1) {
							window.location.reload();
						} else {
							btn.removeClass('disabled');
						}
					},
					error: function error(xhr, textStatus) {
						// console.error(textStatus);

						btn.removeClass('disabled');
					}
				});
			};

			uploadFile(form.find('.file-upload-input[name=logo]')[0].files[0], 'AppLogo', '-image.jpg', function () {
				if (filesInfos !== '' && !btn.hasClass('valid')) {
					data.field13 = JSON.stringify(Object.assign({}, filesInfos.split(',')));
				}
				filesInfos = '';

				uploadMultipleSizeImage(form.find('.file-upload-input[name=logo-menu]')[0].files[0], 'AppMenuLogoBase', 'AppMenuLogoBase2x', 'AppMenuLogoBase3x', '-image.jpg', function () {
					if (filesInfos !== '') {
						data.field16 = JSON.stringify(Object.assign({}, filesInfos.split(',')));
					}
					filesInfos = '';

					uploadMultipleSizeImage(form.find('.file-upload-input[name=menu]')[0].files[0], 'AppMenuBase', 'AppMenuBase2x', 'AppMenuBase3x', '-image.jpg', function () {
						if (filesInfos !== '') {
							data.field17 = JSON.stringify(Object.assign({}, filesInfos.split(',')));
						}
						filesInfos = '';

						uploadMultipleSizeImage(imageHomepageFr, 'AppBannerBase', 'AppBannerBase2x', 'AppBannerBase3x', '-image.jpg', function () {
							if (filesInfos !== '') {
								data.field14 = JSON.stringify(Object.assign({}, filesInfos.split(',')));
							}
							filesInfos = '';

							uploadMultipleSizeImage(imageHomepageEn, 'AppBannerBase', 'AppBannerBase2x', 'AppBannerBase3x', '-image.jpg', function () {
								if (filesInfos !== '') {
									data.field15 = JSON.stringify(Object.assign({}, filesInfos.split(',')));
								}
								filesInfos = '';

								uploadFile(sitePlanFr, 'AppPlan', '-Default.jpg', function () {
									if (filesInfos !== '') {
										data.field18 = filesInfos;
									}
									filesInfos = '';

									uploadFile(sitePlanEn, 'AppPlan', '-Default.jpg', function () {
										if (filesInfos !== '') {
											data.field19 = filesInfos;
										}
										filesInfos = '';

										_updateData(data);
									}, false, 'Default');
								}, false, 'Default');
							});
						});
					});
				});
			});
		}

		if (form.hasClass('error-plan-file-size')) {
			sitePlanErrorMsg.slideDown();
		}

		if (form.hasClass('error-file-type')) {
			fileTypeErrorMsg.slideDown();
		}
	};

	var validatePlanSize = function validatePlanSize(fileInput, form) {
		var maxSize = 1048576; // 1MB

		if (fileInput[0].files[0] !== undefined && fileInput[0].files[0].size > maxSize) {
			fileInput.closest('.input-ctn').addClass('error');
			form.addClass('error-plan-file-size');
		}
	};

	var validateFileExtensions = function validateFileExtensions(form) {
		form.find('.file-upload-input').each(function () {
			if ($(this)[0].files[0] !== undefined) {
				var re = /(?:\.([^.]+))?$/;
				var ext = re.exec($(this)[0].files[0].name)[1];
				// console.log(ext);

				if (ext.toLowerCase() !== 'jpg' && ext.toLowerCase() !== 'jpeg' && ext.toLowerCase() !== 'png') {
					$(this).closest('.input-ctn').addClass('error');
					form.addClass('error-file-type');
				}
			}
		});
	};

	var uploadSquareImage = function uploadSquareImage(image, callback) {
		var ext = '-image.jpg';

		uploadMultipleSizeImage(image, 'AppImgBase', 'AppImgBase2x', 'AppImgBase3x', ext, callback);
	};

	var uploadMultipleSizeImage = function uploadMultipleSizeImage(image, dir1, dir2, dir3, ext, callback) {
		if (image) {
			uploadFile(image, dir1, ext, function () {
				uploadFile(image, dir2, ext, function () {
					uploadFile(image, dir3, ext, function () {
						if (callback) {
							callback();
						}
					});
				});
			});
		} else if (callback) {
			callback();
		}
	};

	var createFileFormData = function createFileFormData(file, dir, noCrop) {
		var fd = new FormData();
		fd.append('image', file);
		fd.append('directory', dir);
		if (noCrop) {
			fd.append('noCrop', noCrop);
		}
		fd.append('ajax', 'true');
		fd.append('center', true);
		fd.append('scaleRatio', 0.001);

		return fd;
	};

	var uploadFile = function uploadFile(file, dir, ext, callback, noCrop, saveDir) {
		if (!saveDir) {
			saveDir = dir;
		}
		if (file) {
			$.ajax({
				url: '/action/uploadCroppedImage',
				cache: false,
				contentType: false,
				processData: false,
				method: 'POST',
				data: createFileFormData(file, dir, noCrop),
				success: function success(response) {
					console.log('uploadFile: ', response);

					if (filesInfos.length > 0) {
						filesInfos += ',';
					}
					filesInfos += saveDir + '/' + $.trim(response.split('mediaId=')[1]) + ext;

					callback();
				},
				error: function error(xhr, textStatus) {
					// console.error(textStatus);

					callback();
				}
			});
		} else if (callback) {
			callback();
		}
	};

	var getUpdateElem = function getUpdateElem() {
		var t = $(this);
		updateElem = t.attr('data-update');

		MG2.ColorPicker.setColor(t.closest('.color-picker-icon-ctn').find('.form-input').val());
	};

	var changeColor = function changeColor() {
		var color = MG2.ColorPicker.getColor();
		var elem = $(updateElem);

		elem.css('background-color', color);
		elem.val(color);
		lightOrDark(elem);
	};

	// https://gist.github.com/larryfox/1636338
	var lightOrDark = function lightOrDark(t) {
		var r,
		    b,
		    g,
		    hsp,
		    a = t.css('background-color');

		if (a.match(/^rgb/)) {
			a = a.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
			r = a[1];
			g = a[2];
			b = a[3];
		} else {
			a = +("0x" + a.slice(1).replace( // thanks to jed : http://gist.github.com/983661
			a.length < 5 && /./g, '$&$&'));
			r = a >> 16;
			g = a >> 8 & 255;
			b = a & 255;
		}
		hsp = Math.sqrt( // HSP equation from http://alienryderflex.com/hsp.html
		0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
		if (hsp > 127.5) {
			t.addClass('dark').removeClass('light');
		} else {
			t.addClass('light').removeClass('dark');
		}
	};

	var saveAppArtist = function saveAppArtist() {
		var btn = $(this);
		var form = btn.closest('form');

		formValidator.validateForm(form);

		if (!form.hasClass('has-error')) {
			btn.addClass('disabled');

			var social = {
				"facebook": form.find('input[name=facebook]').val(),
				"instagram": form.find('input[name=instagram]').val(),
				"spotify": form.find('input[name=spotify]').val(),
				"youtube": form.find('input[name=youtube]').val()
			};

			var artistDescription = {
				"fr": form.find('textarea[name=artist-description-fr]').val(),
				"en": form.find('textarea[name=artist-description-en]').val()
			};

			var data = {
				id: form.find('input[name=artist-id]').val(),
				field1: 'artist',
				field2: form.find('input[name=app-id]').val(),
				field3: form.find('input[name=profile-id]').val(),
				field4: form.find('input[name=account-id]').val(),
				field5: form.find('input[name=artist-name]').val(),
				field6: JSON.stringify(artistDescription),
				field7: JSON.stringify(social),
				ajax: true
			};

			// console.log(JSON.stringify(data));

			uploadSquareImage(form.find('.file-upload-input[name=artist]')[0].files[0], function () {
				if (filesInfos !== '') {
					data.field8 = JSON.stringify(Object.assign({}, filesInfos.split(',')));
					filesInfos = '';
				}

				$.ajax({
					url: '/action/manageGenData',
					cache: false,
					data: data,
					method: 'POST',
					success: function success(response) {
						// console.log('artist new/edit : ' + response);

						if (response.indexOf('success') !== -1) {
							window.location.reload();
						} else {
							btn.removeClass('disabled');
						}
					}
				});
			});
		}
	};

	var deleteGenData = function deleteGenData(btn, deleteConfirmed) {
		if (btn.length === undefined) {
			btn = $(this);
		}

		if (deleteConfirmed) {
			btn.addClass('disabled');
			var data = {
				id: btn.attr('data-id'),
				delete: true,
				ajax: true
			};

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				data: data,
				method: 'POST',
				success: function success(response) {
					// console.log('delete GenData : ' + response);
					if (btn.hasClass('remove-artist-from-representation')) {
						deleteArtistFromRep(btn);
					} else {
						if (response.indexOf('success') !== -1) {
							window.location.reload();
						} else {
							btn.removeClass('disabled');
						}
					}
				}
			});
		} else {
			confirmDelete(btn);
		}
	};

	var confirmDelete = function confirmDelete(btn, isOrg) {
		var popup = $('#app-admin-confirm-delete-popup');
		var overlay = $('.overlay', 'body');

		popup.addClass('open');
		overlay.addClass('active');

		popup.find('.confirm-delete-btn').click(function () {
			popup.find('.confirm-delete-btn').off('click');
			popup.removeClass('open');
			overlay.removeClass('active');

			if (isOrg) {
				deleteOrganization(btn, true);
			} else {
				deleteGenData(btn, true);
			}
		});

		popup.find('.popup-inner-close').one('click', function () {
			popup.find('.confirm-delete-btn').off('click');
		});
	};

	var deleteArtistFromRep = function deleteArtistFromRep(btn) {
		var id = btn.attr('data-id');
		var repsToEdit = $('.representation-to-edit-' + id);
		var total = repsToEdit.length;
		var count = 0;

		repsToEdit.each(function () {
			var rep = $(this);
			var data = {
				id: rep.attr('data-id'),
				field8: rep.attr('data-artists'),
				ajax: true
			};

			count++;

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				data: data,
				method: 'POST',
				success: function success(response) {
					// console.log('edit representation GenData : ' + response);

					if (count >= total) {
						if (response.indexOf('success') !== -1) {
							window.location.reload();
						} else {
							btn.removeClass('disabled');
						}
					}
				}
			});
		});
	};

	var filterAppArtists = function filterAppArtists() {
		var input = $(this);
		var q = input.val().toLowerCase();
		var ctn = input.closest('.box-theme-ctn');
		var notFound = $('.app-admin-artists-not-found');

		if (q === '') {
			$('.app-artist').removeClass('hide-search');
			notFound.slideUp();
			return false;
		}

		$('.app-admin-list .app-artist').each(function () {
			var t = $(this);
			var name = t.find('.app-artist-name').html().toLowerCase();
			var isOk = false;

			if (name.indexOf(q) !== -1) {
				isOk = true;
			}

			isOk ? t.removeClass('hide-search') : t.addClass('hide-search');
		});

		$('.app-admin-list .app-artist:not(.hide-search)').length === 0 ? notFound.slideDown() : notFound.slideUp();
	};

	var saveAppLocation = function saveAppLocation() {
		var btn = $(this);
		var form = btn.closest('form');
		var addr = form.find('input[name="geolocalisation"]').val();
		var hiddenLat = form.find('input[name="hiddenLat"]').val();
		var city = form.find('input[name=city]').val();
		var province = form.find('input[name=province]').val();
		var country = form.find('input[name=country]').val();
		var postalCode = form.find('input[name=postalCode]').val();

		if (addr.length && city.length && province.length && country.length && postalCode.length && !hiddenLat.length) {

			btn.addClass('disabled');

			fetchLocation(addr, city, province, country, postalCode, function (lat, lng) {
				if (lat && lng) {
					form.find('input[name="hiddenLat"]').val(lat);
					form.find('input[name="hiddenLng"]').val(lng);
				}
				btn.removeClass('disabled');
				completeFormValidation(form, btn);
			});

			return;
		}

		completeFormValidation(form, btn);
	};

	var fetchLocation = function fetchLocation(addr, city, province, country, postalCode, callback) {
		var geocoder = new google.maps.Geocoder();
		var coorUrl = [addr, city, province, country, postalCode].join(', ');

		geocoder.geocode({ 'address': coorUrl }, function (results, status) {
			var lat, lng;
			if (status === google.maps.GeocoderStatus.OK) {
				var lat = results[0].geometry.location.lat();
				var lng = results[0].geometry.location.lng();
			}

			if (typeof callback === 'function') {
				callback(lat, lng);
			}
		});
	};

	var completeFormValidation = function completeFormValidation(form, btn) {
		formValidator.validateForm(form);

		if (form.hasClass('has-error')) {
			var hiddenLat = form.find(':not(.disabled) input[name="hiddenLat"].error');
			console.log('invalid address');
			if (hiddenLat.length) {
				form.find('.invalid-address').show();
				form.find('input[name="geolocalisation"]').removeClass('success').addClass('error');
			} else {
				form.find('.invalid-address').hide();
			}
		} else if (!form.hasClass('has-error')) {
			btn.addClass('disabled');

			var data = {
				id: form.find('input[name=location-id]').val(),
				field1: false,
				field2: form.find('input[name=app-id]').val(),
				field3: form.find('input[name=profile-id]').val(),
				field4: form.find('input[name=account-id]').val(),
				name: form.find('input[name=location-name]').val(),
				ajax: true
			};

			if (form.find('input[name=geolocalisation]').val().length > 0) {
				data.address = form.find('input[name=geolocalisation]').val();
				data.city = form.find('input[name=city]').val();
				data.province = form.find('input[name=province]').val();
				data.country = form.find('input[name=country]').val();
				data.postalCode = form.find('input[name=postalCode]').val();
				if (form.find('input[name=hiddenLat]').val().length > 0) {
					data.lat = form.find('input[name=hiddenLat]').val();
					data.lng = form.find('input[name=hiddenLng]').val();
				}
			} else if (form.find('input[name=latitude]').val().length > 0) {
				data.lat = form.find('input[name=latitude]').val();
				data.lng = form.find('input[name=longitude]').val();
			} else if (form.find('input[name=latMap]').val().length > 0) {
				data.field1 = true;
				data.lat = form.find('input[name=latMap]').val();
				data.lng = form.find('input[name=lngMap]').val();
			}

			// console.log(JSON.stringify(data));

			$.ajax({
				url: '/action/addOrganization',
				cache: false,
				data: data,
				method: 'POST',
				success: function success(response) {
					// console.log('location new/edit : ' + response);

					if (response.indexOf('success') !== -1) {
						window.location.reload();
					} else {
						btn.removeClass('disabled');
					}
				}
			});
		}
	};

	var handleLocationInputs = function handleLocationInputs(t, forceHasVal) {
		if (t.length === undefined) {
			t = $(this);
		}
		var ctn = t.closest(appLocationDetailsForm);
		var hasVal;

		ctn.find('.form-input').each(function () {
			if ($(this).val().length > 0) {
				hasVal = true;
				return;
			}
		});

		if (hasVal || forceHasVal) {
			ctn.find('.clear-addr-btn').slideDown();
			appLocationDetailsForm.each(function () {
				if ($(this).attr('class') !== ctn.attr('class')) {
					$(this).find('input').removeClass('required error');
					$(this).addClass('disabled');
				}
			});
		} else {
			ctn.find('.clear-addr-btn').slideUp();
			$('.app-location-details-form input').addClass('required');
			appLocationDetailsForm.removeClass('disabled');
		}
	};

	var clearLocationForm = function clearLocationForm() {
		clearLocationFormBtn.slideUp();
		appLocationDetailsForm.removeClass('disabled');
		appLocationDetailsForm.find('input').val('').removeClass('error success place-found').addClass('required').closest('.input-ctn').removeClass('focused');
	};

	var deleteOrganization = function deleteOrganization(btn, deleteConfirmed) {
		if (btn.length === undefined) {
			btn = $(this);
		}

		if (deleteConfirmed) {
			btn.addClass('disabled');

			$.ajax({
				url: '/action/deleteOrganization',
				cache: false,
				data: {
					id: btn.attr('data-id'),
					ajax: true
				},
				method: 'POST',
				success: function success(response) {
					// console.log('location delete : ' + response);

					if (response.indexOf('success') !== -1) {
						window.location.reload();
					} else {
						btn.removeClass('disabled');
					}
				}
			});
		} else {
			confirmDelete(btn, true);
		}
	};

	var initLocationMap = function initLocationMap() {
		var btn = $('.init-location-map-btn');
		var ctn = btn.closest('.app-location-details-form');
		var lat;
		var lng;

		$('input[name=latMap]').val() === '' ? lat = mapCtn.attr('data-defaultlat') : lat = $('input[name=latMap]').val();
		$('input[name=lngMap]').val() === '' ? lng = mapCtn.attr('data-defaultlng') : lng = $('input[name=lngMap]').val();

		var myLatlng = new google.maps.LatLng(lat, lng);
		var mapOptions = {
			zoom: 10,
			center: myLatlng,
			streetViewControl: false,
			fullscreenControl: false
		};

		var map = new google.maps.Map(document.getElementById(mapId), mapOptions);
		var marker = new google.maps.Marker({
			position: myLatlng,
			map: map,
			title: name,
			draggable: true,
			icon: '/static/assets/img/pin.png'
		});

		$('#' + mapId).addClass('activated');
		handleLocationInputs(btn, true);
		btn.slideUp();

		map.addListener('click', function (event) {
			updateMarkerLocation(event.latLng.lat(), event.latLng.lng(), marker);
		});

		marker.addListener('dragend', function () {
			updateMarkerLocation(marker.getPosition().lat(), marker.getPosition().lng(), marker);
		});
	};

	var updateMarkerLocation = function updateMarkerLocation(lat, lng, marker) {
		var ctn = $('.app-location-details-form.map-click');

		marker.setPosition(new google.maps.LatLng(lat, lng));
		ctn.find('input[name=latMap]').val(lat);
		ctn.find('input[name=lngMap]').val(lng);
		// console.log(lat + ', ' + lng);
	};

	var clearMap = function clearMap() {
		mapCtn.empty().removeClass('activated');
		initMapBtn.slideDown();

		$('input[name=latMap]').val(mapCtn.attr('data-defaultlat'));
		$('input[name=lngMap]').val(mapCtn.attr('data-defaultlng'));
	};

	var setEditLocationPopup = function setEditLocationPopup() {
		var btn = $(this);
		var popup = $('.' + btn.attr('data-id'));

		clearMap();
		clearLocationForm();
		popup.find('.js-form-error-message').slideUp();

		popup.find('input[name=location-id]').val(btn.attr('data-locationid'));
		popup.find('input[name=location-name]').val(btn.attr('data-name'));

		if (btn.attr('data-address').length !== 0) {
			popup.find('input[name=geolocalisation]').val(btn.attr('data-address'));
			popup.find('input[name=city]').val(btn.attr('data-city'));
			popup.find('input[name=province]').val(btn.attr('data-province'));
			popup.find('input[name=country]').val(btn.attr('data-country'));
			popup.find('input[name=postalCode]').val(btn.attr('data-postalCode'));
			popup.find('input[name=hiddenLat]').val(btn.attr('data-lat'));
			popup.find('input[name=hiddenLng]').val(btn.attr('data-lng'));
			handleLocationInputs(popup.find('input[name=geolocalisation]'));
		} else if (btn.data('map')) {
			popup.find('input[name=latMap]').val(btn.attr('data-lat'));
			popup.find('input[name=lngMap]').val(btn.attr('data-lng'));
			initLocationMap();
		} else if (btn.attr('data-lat').length !== 0) {
			popup.find('input[name=latitude]').val(btn.attr('data-lat'));
			popup.find('input[name=longitude]').val(btn.attr('data-lng'));
			handleLocationInputs(popup.find('input[name=latitude]'));
		}

		popup.find('input').each(function () {
			if ($(this).val().length > 0) {
				$(this).removeClass('error').closest('.input-ctn').addClass('focused');
			} else {
				$(this).removeClass('error success').closest('.input-ctn').removeClass('focused');
			}
		});
	};

	var filterAppLocations = function filterAppLocations() {
		var input = $(this);
		var q = input.val().toLowerCase();
		var ctn = input.closest('.box-theme-ctn');
		var notFound = $('.app-admin-locations-not-found');

		if (q === '') {
			$('.app-location').removeClass('hide-search');
			notFound.slideUp();
			return false;
		}

		$('.app-admin-list .app-location').each(function () {
			var t = $(this);
			var name = t.find('.app-location-name').html().toLowerCase();
			var address = t.find('.app-location-address').html() !== undefined ? t.find('.app-location-address').html().toLowerCase() : '';
			var isOk = false;

			if (name.indexOf(q) !== -1 || address.indexOf(q) !== -1) {
				isOk = true;
			}

			isOk ? t.removeClass('hide-search') : t.addClass('hide-search');
		});

		$('.app-admin-list .app-location:not(.hide-search)').length === 0 ? notFound.slideDown() : notFound.slideUp();
	};

	var updateRepresentationArtistsList = function updateRepresentationArtistsList() {
		var btn = $(this);

		repArtistsCtn.find('.app-representation-artist-img-ctn:not(.popup-btn)').remove();

		$('.representation-artist-check:checked').each(function () {
			var clone = $('.app-representation-artist-img-ctn[data-artist=clone]').clone();
			var imgCtn = clone.find('.representation-artist-img');
			var infos = $(this).closest('.form-checkbox-ctn').find('.representation-artist-info');

			if (infos.attr('data-img').length > 0) {
				imgCtn.attr('style', imgCtn.attr('data-prefix') + infos.attr('data-img') + imgCtn.attr('data-suffix'));
			}

			clone.find('.featured-event-add-event-text').html(infos.html());
			clone.attr('data-artist', infos.attr('data-id'));
			clone.removeClass('clone');

			repArtistsCtn.append(clone);
			clone.fadeIn();
		});

		repArtistsCtn.find('.app-representation-artist-img-ctn.popup-btn').detach().appendTo(repArtistsCtn);
		btn.closest('.popup').find('.popup-inner-close').trigger('click');

		updateListInput();
	};

	var updateListInput = function updateListInput() {
		var artists = [];

		repArtistsCtn.find('.app-representation-artist-img-ctn:not(.popup-btn)').each(function () {
			artists.push($(this).attr('data-artist'));
		});

		$('input[name=artists-list]').val(artists.join());
	};

	var removeRepresentationArtist = function removeRepresentationArtist() {
		var id = $(this).closest('.app-representation-artist-img-ctn').attr('data-artist');
		// console.log(id);

		$(this).closest('.app-representation-artist-img-ctn').fadeOut(function () {
			$(this).remove();
			$('.app-representation-add-artist-popup').find('.representation-artist-check[value=' + id + ']').prop('checked', false);
			updateListInput();
		});
	};

	var saveRepresentation = function saveRepresentation() {
		var btn = $(this);
		var form = btn.closest('form');

		formValidator.validateForm(form);

		if (!form.hasClass('has-error')) {
			btn.addClass('disabled');
			var artists = '';
			var tickets = [];

			if (form.find('input[name="no-artists"]:checked').length === 0) {
				artists = form.find('input[name=artists-list]').val();
			}

			if ($('.app-event-tickets-ctn.open').length > 0) {
				$('.app-event-tickets-ctn.open').find('input[name="ticket-check"]:checked').each(function () {
					tickets.push($(this).val());
				});
			}

			var data = {
				id: form.find('input[name=representation-id]').val(),
				field1: 'representation',
				field2: form.find('input[name=app-id]').val(),
				field3: form.find('input[name=profile-id]').val(),
				field4: form.find('input[name=account-id]').val(),
				field5: form.find('input[name=name]').val(),
				field6: form.find('textarea[name=description]').val(),
				field7: form.find('select[name=representation-location]').val(),
				field8: artists,
				field9: form.find('input[name="show-rep-homepage"]').prop('checked'),
				field10: form.find('select[name=representation-event]').val(),
				field12: form.find('input[name=hide-doors]').prop('checked'),
				dateField1Year: form.find('input[name=startDateYear]').val(),
				dateField1Month: form.find('input[name=startDateMonth]').val(),
				dateField1Day: form.find('input[name=startDateDay]').val(),
				dateField1Hour: form.find('input[name=startDateHour]').val(),
				dateField1Minute: form.find('input[name=startDateMinute]').val(),
				dateField2Year: form.find('input[name=endDateYear]').val(),
				dateField2Month: form.find('input[name=endDateMonth]').val(),
				dateField2Day: form.find('input[name=endDateDay]').val(),
				dateField2Hour: form.find('input[name=endDateHour]').val(),
				dateField2Minute: form.find('input[name=endDateMinute]').val(),
				dateField3Year: form.find('input[name=startDateYear]').val(),
				dateField3Month: form.find('input[name=startDateMonth]').val(),
				dateField3Day: form.find('input[name=startDateDay]').val(),
				dateField3Hour: form.find('input[name=doorDateHour]').val(),
				dateField3Minute: form.find('input[name=doorDateMinute]').val(),
				field13: tickets.join(),
				ajax: true
			};

			// console.log(JSON.stringify(data));

			uploadSquareImage(form.find('.file-upload-input[name=representation]')[0].files[0], function () {
				if (filesInfos !== '') {
					data.field11 = JSON.stringify(Object.assign({}, filesInfos.split(',')));
					filesInfos = '';
				}

				$.ajax({
					url: '/action/manageGenData',
					cache: false,
					data: data,
					method: 'POST',
					success: function success(response) {
						// console.log('representation new/edit : ' + response);

						if (response.indexOf('success') !== -1) {
							window.location.href = btn.attr('data-forward');
						} else {
							btn.removeClass('disabled');
						}
					}
				});
			});
		}
	};

	var showAssociatedTickets = function showAssociatedTickets() {
		var eventId = $(this).val();

		$('.app-event-tickets-ctn').each(function () {
			if ($(this).attr('data-event') != eventId) {
				$(this).removeClass('open').slideUp();
			}
		});

		if (eventId !== '' && $('.app-event-tickets-ctn[data-event=' + eventId + ']').length > 0) {
			$('.app-event-tickets-ctn[data-event=' + eventId + ']').addClass('open').slideDown();
			$('.representation-tickets-box').slideDown();
		} else {
			$('.representation-tickets-box').slideUp();
		}
	};

	var submitAppForApproval = function submitAppForApproval() {
		var btn = $(this);
		var form = btn.closest('form');

		formValidator.validateForm(form);

		if (!form.hasClass('has-error')) {
			btn.addClass('disabled');

			var newDate = new Date();

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				data: {
					id: btn.attr('data-id'),
					field2: 1,
					dateField1Year: newDate.getFullYear(),
					dateField1Month: newDate.getMonth(),
					dateField1Day: newDate.getDate(),
					dateField1Hour: newDate.getHours(),
					dateField1Minute: newDate.getMinutes(),
					dateField1Second: newDate.getSeconds(),
					ajax: true
				},
				method: 'POST',
				success: function success(response) {
					// console.log('submit app : ' + response);
					if (response.indexOf('success') !== -1) {
						var id = response.substring(8);
						ajax("/action/epAddAlert?ajax=true&type=10&field1=" + id, function (response) {
							window.location.reload();
						}, true);
					} else {
						btn.removeClass('disabled');
					}
				}
			});
		}
	};

	var saveAppStatus = function saveAppStatus() {
		var btn = $(this);
		var form = btn.closest('form');

		formValidator.validateForm(form);

		if (!form.hasClass('has-error')) {
			btn.addClass('disabled');
			var email = btn.attr("data-email");
			var lang = $("html").attr('lang');
			var status = $('select[name=change-app-status]').val();
			var currStatus = btn.parent().attr("data-status");

			var data = {
				id: btn.attr('data-id'),
				field2: status,
				ajax: true
			};

			if (status === '2') {
				var newDate = new Date();
				data.dateField2Year = newDate.getFullYear();
				data.dateField2Month = newDate.getMonth();
				data.dateField2Day = newDate.getDate();
				data.dateField2Hour = newDate.getHours();
				data.dateField2Minute = newDate.getMinutes();
				data.dateField2Second = newDate.getSeconds();
			}

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				data: data,
				method: 'POST',
				success: function success(response) {
					//					console.log('app status change: ' + response);
					if (response.indexOf('success') !== -1) {
						if ((status === '2' || status === '3') && currStatus !== status) {
							var subject = status === '2' ? lang === "fr" ? "Votre demande pour une application mobile a été acceptée!" : "Your request for a mobile app has been approved!" : lang === "fr" ? "Votre demande pour une application mobile a été refusée" : "Your request for a mobile app has been denied";
							var file = status === '2' ? "app-approved-" + lang : "app-refused-" + lang;
							tools.sendEmail(email, subject, null, file, null, function (response) {
								window.location.reload();
							});
						} else {
							window.location.reload();
						}
					} else {
						btn.removeClass('disabled');
					}
				}
			});
		}
	};

	var getTextareaContent = function getTextareaContent(form, name) {
		var contentFr = tinymce.get($('.form-input[name="' + name + '-fr"]', form).attr('id')).getContent() !== '' ? tinymce.get($('.form-input[name="' + name + '-fr"]', form).attr('id')).getContent() : tinymce.get($('.form-input[name="' + name + '-en"]', form).attr('id')).getContent();
		var contentEn = tinymce.get($('.form-input[name="' + name + '-en"]', form).attr('id')).getContent() !== '' ? tinymce.get($('.form-input[name="' + name + '-en"]', form).attr('id')).getContent() : tinymce.get($('.form-input[name="' + name + '-fr"]', form).attr('id')).getContent();

		return { fr: contentFr, en: contentEn };
	};

	var saveAppAlert = function saveAppAlert() {
		var btn = $(this);
		var form = btn.closest('form');
		var alertNameFr = form.find('input[name=title-fr]').val().length > 0 ? form.find('input[name=title-fr]').val() : form.find('input[name=title-en]').val();
		var alertNameEn = form.find('input[name=title-en]').val().length > 0 ? form.find('input[name=title-en]').val() : form.find('input[name=title-fr]').val();

		formValidator.validateForm(form);

		if (!form.hasClass('has-error')) {
			btn.addClass('disabled');

			var data = {
				id: form.find('input[name=alert-id]').val(),
				field1: 'alert',
				field2: form.find('input[name=app-id]').val(),
				field3: form.find('input[name=profile-id]').val(),
				field4: form.find('input[name=account-id]').val(),
				field5: JSON.stringify({ fr: alertNameFr, en: alertNameEn }),
				field6: JSON.stringify(getTextareaContent(form, 'alert-description')),
				dateField1Year: form.find('input[name=startDateYear]').val(),
				dateField1Month: form.find('input[name=startDateMonth]').val(),
				dateField1Day: form.find('input[name=startDateDay]').val(),
				dateField1Hour: form.find('input[name=startDateHour]').val(),
				dateField1Minute: form.find('input[name=startDateMinute]').val(),
				ajax: true
			};

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				data: data,
				method: 'POST',
				success: function success(response) {
					// console.log('alert new/edit : ' + response);

					if (response.indexOf('success') !== -1) {
						window.location.reload();
					} else {
						btn.removeClass('disabled');
					}
				}
			});
		}
	};

	var openAppPreviewMenu = function openAppPreviewMenu() {
		$('.mobile-app-preview-screen').addClass('pushed');
	};

	var closeAppPreviewMenu = function closeAppPreviewMenu() {
		$('.mobile-app-preview-screen').removeClass('pushed');
	};

	var fadeOutSplashscreen = function fadeOutSplashscreen() {
		var splashscreen = $('.mobile-app-preview-splashscreen');

		if (splashscreen.length > 0) {
			setTimeout(function () {
				splashscreen.fadeOut();
			}, 3000);
		}
	};

	var deleteGenDataImage = function deleteGenDataImage() {
		var btn = $(this);
		var data = {
			id: btn.attr('data-id'),
			ajax: true
		};

		data[btn.attr('data-field')] = '';

		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: data,
			method: 'POST',
			success: function success(response) {
				// console.log('delete iamge: ' + response);

				window.location.reload();
			}
		});
	};

	var init = function init() {
		tools = Fw.component.models().tools;
		formValidator = Fw.component.models().form;
		geolocalisationInput = $('input[name=geolocalisation]');
		appLocationDetailsForm = $('.app-location-details-form');
		initMapBtn = $('.init-location-map-btn');
		mapId = 'app-location-click-map-ctn';
		mapCtn = $('#' + mapId);
		clearLocationFormBtn = $('.clear-addr-btn');
		repArtistsCtn = $('.representation-artists-ctn');

		$('.lang-input-toggle-ctn').removeClass('disabled');
		fadeOutSplashscreen();

		if (geolocalisationInput.length > 0) {
			profile.activateGlgAutocomplete();
			profile.checkAddress();

			setTimeout(function () {
				geolocalisationInput.removeAttr("placeholder");
			}, 200);
		}

		$('.color-picker-input').each(function () {
			lightOrDark($(this));
		});

		$('.save-app-params-btn').click(saveAppParams);
		$('.color-picker-input-ctn .color-picker-icon.popup-btn').click(getUpdateElem);
		$('.color-picker-input-popup .mg2-color-current, .color-picker-input-popup .popup-inner-close').click(changeColor);
		$('.save-app-artist-btn').click(saveAppArtist);
		$('.delete-gendata-btn').click(deleteGenData);
		$('input[name=search-artists]').keyup(filterAppArtists);
		$('.save-app-location-btn').click(saveAppLocation);
		$('.app-location-details-form .form-input').keyup(handleLocationInputs);
		clearLocationFormBtn.click(clearLocationForm);
		$('.app-location-details-form.map-click .clear-addr-btn').click(clearMap);
		$('.delete-organization-btn').click(deleteOrganization);
		initMapBtn.click(initLocationMap);
		$('.app-edit-location-btn').click(setEditLocationPopup);
		$('input[name=search-locations]').keyup(filterAppLocations);
		$('.update-representation-artists-list-btn').click(updateRepresentationArtistsList);
		$('.save-representation-btn').click(saveRepresentation);
		$('.representation-event').change(showAssociatedTickets);
		$('.delete-representation-btn').click(deleteGenData);
		$('.submit-app-btn').click(submitAppForApproval);
		$('.save-app-status-btn').click(saveAppStatus);
		$('.save-app-alert-btn').click(saveAppAlert);
		$('.delete-alert-btn').click(deleteGenData);
		$('.app-img-delete-btn-js').click(deleteGenDataImage);
		if ($('.remove-representation-artist-btn').length > 0) {
			$('body').on('click', '.remove-representation-artist-btn', removeRepresentationArtist);
		}
		if ($('.open-app-preview-menu-btn').length > 0) {
			$('body').on('click', '.mobile-app-preview-screen:not(.pushed) .open-app-preview-menu-btn', openAppPreviewMenu);
		}
		if ($('.mobile-app-preview-main').length > 0) {
			$('body').on('click', '.mobile-app-preview-screen.pushed .mobile-app-preview-main', closeAppPreviewMenu);
		}
	};

	$(window).on('load', function () {
		init();
	});
})(jQuery);
(function ($, undefined) {

    'use strict';

    var currPage;
    var createMessageBtn;
    var setDeleteMessageBtn;
    var deleteMessageBtn;
    var toggleMessageBtn;
    var pickerWin;
    var pickerIcon;
    var addEventBoxBtn;
    var deleteEmptyEventBoxBtn;
    var addLinkBtn;
    var editEventBoxBtn;
    var addFeaturedBtn;

    var updatePickerInput = function updatePickerInput() {
        var t = $(this);
        var inp = t.closest(".color-picker-icon-ctn").find("input");
        var name = inp.attr("name");

        pickerWin.find(".mg2-color-current").attr("data-inp", name);
    };

    var toggleCreateForm = function toggleCreateForm() {
        var t = $(this);
        if (t.hasClass("logged-nav-item-active")) {
            t.removeClass("logged-nav-item-active");
            $(".create-message-box").slideUp();
        } else {
            t.addClass("logged-nav-item-active");
            $(".create-message-box").slideDown();
        }
    };

    var editId;
    var setDeleteInfos = function setDeleteInfos() {
        var t = $(this);

        editId = t.attr("data-editId");
    };

    var deleteMessage = function deleteMessage() {

        var url = "/action/messages";
        url += "?delete=true";
        url += "&ajax=true";
        url += "&editId=" + editId;

        ajax(url, function () {
            $("#message" + editId).slideUp();
        }, true);
    };

    var toggleMessage = function toggleMessage() {
        var t = $(this);
        var id = t.attr("data-editId");
        var active = t.hasClass("active");

        var url = "/action/messages";
        url += "?active=" + !active;
        url += "&ajax=true";
        url += "&editId=" + id;

        ajax(url, function () {
            if (active) {
                t.removeClass("active");
            } else {
                t.addClass("active");
            }
        }, true);
    };

    var toggleEventBox = function toggleEventBox(e) {
        var t = $(this);
        var target = $(e.target);
        var delBtn = t.find(".featured-event-delete");
        if (delBtn.has(e.target).length === 0 && !target.hasClass("featured-event-delete")) {
            if (t.attr("data-empty") !== undefined && t.attr("data-empty") === "false") {
                t = $(this).closest(".featured-event-ctn");
            }
            if (!t.hasClass("selected")) {
                var inUse = $(".featured-event-ctn.selected");
                var ctn = t.nextAll(".select-featured-ctn:eq(0)");
                if (inUse.length !== 0) {
                    if (ctn.find(".create-slider-event-feature").length === 0) {
                        $(".pointer").remove();
                        $(".create-slider-event-feature").slideUp(400, function () {
                            $.when($(this).siblings('div').stop().slideUp()).then(function () {
                                inUse.removeClass("selected");
                                slideBox(t, ctn);
                            });
                        });
                    } else {
                        getBoxPos(t, ctn);
                        inUse.removeClass("selected");
                        t.addClass("selected");
                    }
                } else {
                    slideBox(t, ctn);
                }
            } else {
                $(".pointer").remove();
                $(".create-slider-event-feature").slideUp(400, function () {
                    t.removeClass("selected");
                });
            }
        } else {
            $(".pointer").remove();
            if (t.hasClass("selected")) {
                $(".create-slider-event-feature").slideUp(400, function () {});
            }
        }
    };

    var slideBox = function slideBox(t, ctn) {
        t.addClass("selected");
        var clone = $(".create-slider-event-feature").clone(true);
        $(".create-slider-event-feature").remove();
        ctn.html(clone);
        addPointer(ctn);
        getBoxPos(t, ctn);
        displayedFeaturedEvents = [];
        $(".search-drop-down-choices-inner-ctn").empty();
        $(".lost-tickets-search").val("");
        $(".lost-tickets-search").parent().removeClass("focused");
        $(".create-slider-event-feature").slideDown();
    };

    var deleteEmptyBox = function deleteEmptyBox() {
        var t = $(this);
        var ctn = t.parent();
        var id = ctn.attr("data-id");
        var eventId = ctn.attr("data-eventId");
        var deleteLink = false;

        var url = "/action/epManageFeatured";
        url += "?ajax=true";
        if (eventId !== "" && eventId !== "-1" && eventId !== undefined) {
            url += "&featureId=" + id;
            url += "&deleteLink=true";
            deleteLink = true;
        } else {
            url += "&featureId=" + id;
            url += "&delete=true";
        }

        ajax(url, function () {
            if (deleteLink) {
                ctn.addClass("empty");
                ctn.removeClass("featured-event-ctn-expired");
                ctn.removeAttr("data-eventId");
                ctn.find(".home-event-bg-pic").addClass("home-event-bg-pic-hide");
                ctn.find(".pic-placeholder").addClass("pic-placeholder-hide");
                ctn.find(".home-event-pic-overlay").addClass("home-event-pic-overlay-hide");
                ctn.on("click", toggleEventBox);
                ctn.find(".featured-event-name").empty();
                ctn.find(".featured-event-location").empty();
                ctn.find(".featured-event-date").empty();
                ctn.find(".featured-event-expired").remove();
            } else {
                ctn.slideUp(400, function () {
                    ctn.remove();
                    initFeatured();
                });
            }
        }, true);
    };

    var addLinkFeatured = function addLinkFeatured() {
        var f = $(".featured-event-ctn.selected");
        var t = $(this);
        var event = t.closest(".add-slide-ctn").find(".slide-event-selected-ctn .select-profile-from-drop-down[id != 'clone']");
        var eventId = event.attr("id");
        var mediaId = event.attr("data-media-id");
        var id = f.attr("data-id");

        var url = "/action/epManageFeatured";
        url += "?ajax=true";
        url += "&featureId=" + id;
        url += "&eventId=" + eventId;

        ajax(url, function () {
            var elmt = t.closest(".add-slide-ctn").find(".slide-event-selected-ctn .select-profile-from-drop-down[id != 'clone']");
            f.removeClass("empty");
            f.removeClass("featured-event-ctn-expired");
            f.attr("data-eventId", eventId);
            t.parent().slideUp();
            t.closest(".add-slide-ctn").find(".lost-tickets-search").val("");
            t.closest(".add-slide-ctn").find(".input-ctn").removeClass("focused");
            elmt.slideUp(function () {
                $(this).remove();
            });
            t.closest(".add-slide-ctn").find(".event-select-box").slideUp();
            f.unbind();
            f.find(".home-event-bg-pic").addClass("home-event-bg-pic-hide");
            f.find(".pic-placeholder").addClass("pic-placeholder-hide");
            f.find(".home-event-pic-overlay").removeClass("home-event-pic-overlay-hide");
            if (mediaId !== '0') {
                f.find(".home-event-bg-pic").css("background-image", "url('/static/uploaded/EventProfile/" + mediaId + "-profile.jpg')");
                f.find(".home-event-bg-pic").removeClass("home-event-bg-pic-hide");
            } else {
                f.find(".pic-placeholder").removeClass("pic-placeholder-hide");
            }
            var name = elmt.find(".search-drop-down-one-item-name").html();
            var location = elmt.find(".search-drop-down-one-item-location").html();
            var date = elmt.find(".search-drop-down-one-item-datetime-ctn p").html();

            f.find(".featured-event-name").html(name);
            f.find(".featured-event-location").html(location);
            f.find(".featured-event-date").html(date);
            f.find(".featured-event-expired").remove();
        }, true);
    };

    var addFeatured = function addFeatured() {
        var url = "/action/epManageFeatured";
        url += "?ajax=true";
        url += "&create=true";

        ajax(url, function (response) {
            var clone = $("#featured-clone").children().clone(true);
            clone.attr("data-id", response.substring(response.indexOf("- ") + 2).trim());
            var qty = $(".featured-main-ctn .featured-event-ctn").length;

            $(".featured-main-ctn").append(clone);
            initFeatured();
        }, true);
    };

    var initFeatured = function initFeatured() {
        var l = $(".featured-main-ctn .featured-event-ctn").length;
        var clone = $(".create-slider-event-feature").clone(true);
        clone.removeAttr("style");
        $(".featured-select-copy").html(clone);
        $(".select-featured-ctn").remove();
        $(".featured-event-ctn").removeClass("selected");
        var index = 1;
        $(".featured-main-ctn .featured-event-ctn").each(function () {
            if ((index % 4 === 0 || index === l) && index !== 1) {
                var div = document.createElement("div");
                div.className = "select-featured-ctn";
                $(div).insertAfter($(this));
            }
            index++;
        });
    };

    var addPointer = function addPointer(ctn) {
        var div = document.createElement("div");
        div.className = "pointer";

        ctn.append(div);
    };

    var getBoxPos = function getBoxPos(box, ctn) {
        var ctnPos = getPosition($(".featured-main-ctn")[0]);
        var pos = getPosition(box[0]);
        var l = pos.x - ctnPos.x - 25;
        var w = box.outerWidth();
        ctn.parent().find(".pointer").css("left", l + w / 2 + "px");
    };

    var init = function init(page) {
        currPage = $(page);

        createMessageBtn = $(".create-message-btn");
        createMessageBtn.on("click", toggleCreateForm);
        setDeleteMessageBtn = $(".message-delete");
        setDeleteMessageBtn.on("click", setDeleteInfos);
        deleteMessageBtn = $(".delete-message-btn");
        deleteMessageBtn.on("click", deleteMessage);

        toggleMessageBtn = $(".message-power");
        toggleMessageBtn.on("click", toggleMessage);

        MG2.ColorPicker.init();
        pickerWin = $("#color-picker-window");

        pickerIcon = $(".color-picker-icon");
        pickerIcon.on("click", updatePickerInput);

        addEventBoxBtn = $(".featured-event-ctn.empty");
        addEventBoxBtn.on("click", toggleEventBox);

        editEventBoxBtn = $(".featured-event-edit-btn");
        editEventBoxBtn.on("click", toggleEventBox);

        deleteEmptyEventBoxBtn = $(".featured-event-ctn .featured-event-delete");
        deleteEmptyEventBoxBtn.on("click", deleteEmptyBox);

        addLinkBtn = $(".save-featured-btn");
        addLinkBtn.on("click", addLinkFeatured);

        addFeaturedBtn = $(".add-featured-btn");
        addFeaturedBtn.on("click", addFeatured);

        initFeatured();
    };

    $(window).on("load", function () {
        init();
    });
})(jQuery);
(function ($, undefined) {

    'use strict';

    var currPage;
    var minElem;
    var secElem;
    var submitFormBtn;
    var backPurchaseBtn;
    var cancelPurchaseBtn;
    var emptyCartBtn;
    var detailFeesBtn;
    var backBtn;
    var shippingBtn;
    var paymentTypeBtn;
    var shippingModeBtn;

    var getTime = function getTime() {
        var url = "/action/epCurrentTimer";

        ajax(url, function (response) {
            if (response.indexOf('-') !== -1) {
                window.location.href = window.location.href;
            } else {
                var min = response.split(':')[0];
                var sec = response.split(':')[1];

                if (parseInt(sec) < 10) {
                    sec = "0" + sec;
                }

                minElem.html(min);
                secElem.html(sec);
                timer();
            }
        }, true);
    };

    var timer = function timer() {
        var min = parseInt(minElem.html());
        var sec = parseInt(secElem.html());
        var secStr;
        var minStr;

        if (min >= 0) {
            if (sec > 0) {
                var newSec = sec - 1;
                secStr = newSec < 10 ? "0" + newSec : newSec;
            } else if (min > 0) {
                minStr = min - 1;
                secStr = "59";
            }
        }

        minElem.html(minStr);
        secElem.html(secStr);

        if (min !== 0 || min === 0 && sec > 0) {
            window.setTimeout(timer, 1000);
        }
    };

    var submitPaymentForm = function submitPaymentForm(event) {
        $(this).addClass('disabled');
        event.preventDefault();
        var form = $(".payment-process-step");
        formValidator.validateForm(form);

        if (!form.hasClass('has-error')) {
            if (form.hasClass('payment-process-step-2')) {
                console.log('calling facebook function Purchase ...............');
                fbq('track', 'Purchase', { currency: "CAD", value: 0.00 });
            }
            form.submit();
        } else {
            $(this).removeClass('disabled');
        }
    };

    var backPurchase = function backPurchase(event) {
        $("#checkout-back-form").submit();
    };
    var cancelPurchasePopup = function cancelPurchasePopup(event) {
        event.preventDefault();
    };

    var emptyCart = function emptyCart() {
        var t = $(this);
        var url = "/action/epAddCart";
        url += "?ajax=true&clear=true";
        ajax(url, function () {
            var redirection = t.attr('data-url');
            window.location.href = redirection;
        }, true);
    };

    var toggleFees = function toggleFees() {
        var t = $(this);

        t.fadeOut();

        $(".mini-cart-fees-total").slideDown();
    };

    var goBack = function goBack() {
        event.preventDefault();
        $("#checkout-back-form").submit();
    };

    //	var updateShippingPrice = function() {
    //		var paymentProcessShippingTotal = $('.payment-process-shipping-price');
    //		var price;
    //
    //		if(this.value === '0') {
    //			price = paymentProcessShippingTotal.attr('data-free-shipping');
    //		} else {
    //			price = paymentProcessShippingTotal.attr('data-shipping');
    //		}
    //		
    //		paymentProcessShippingTotal.html(price);
    //		// @TODO: Update cart price front-end and shipping price in backend
    //	};

    var handlePaymentChoice = function handlePaymentChoice() {
        var t = $(this);
        var ccInputsCtn = $('.credit-card-inputs-ctn');

        if ($('.payment-type-choice .form-check-input:checked').val() === 'cheque') {

            ccInputsCtn.find('.required').each(function () {
                $(this).removeClass('required').addClass('derequired');
                //				ccInputsCtn.addClass('hidden');
            });
            ccInputsCtn.slideUp("fast", function () {
                $(".cheque-infos-ctn").fadeIn().addClass('visible');
            });
        } else {

            ccInputsCtn.find('.derequired').each(function () {
                $(this).removeClass('derequired').addClass('required');
                //				ccInputsCtn.removeClass('hidden');
            });
            $(".cheque-infos-ctn").removeClass('visible').fadeOut("fast", function () {
                ccInputsCtn.slideDown();
            });
        }
    };

    var pickShippingMode = function pickShippingMode() {
        var t = $(this);
        var merchAddrCtn = $(".virtual-cash-address-box-merch");
        var url = "/action/epManageShippingRules";
        url += "?shippingMode=" + t.val();
        url += "&ajax=true";
        ajax(url, function (response) {
            var j = response.trim().substring(8); //response = success-
            var json = JSON.parse(j);
            var shipping = json.shipping;
            var subtotal = json.subTotal;
            var total = json.total;

            $(".payment-process-shipping-price").text(formatMoney(shipping));
            $(".payment-process-subtotal-price").text(formatMoney(subtotal));
            $(".payment-process-step-1-amount-total-number").text(formatMoney(total));

            if (t.hasClass('pickup')) {
                $('.shipping-address:not(.element-to-toggle)').slideUp(function () {
                    $('.shipping-address').find('.required').addClass('derequired').removeClass('required').val('').removeClass('error').removeClass('success').closest('.input-ctn').removeClass('focused');
                });
                if ($('.shipping-address.element-to-toggle').length !== 0) {
                    $('.shipping-address').find('.required').addClass('derequired').removeClass('required').val('').removeClass('error').removeClass('success').closest('.input-ctn').removeClass('focused');
                }
                $(".virtual-cash-address-box-merch").addClass("hide");
            } else {
                $('.shipping-address:not(.element-to-toggle)').slideDown(function () {
                    $('.shipping-address').find('.derequired').addClass('required').removeClass('derequired');
                });
                if ($('.shipping-address.element-to-toggle').length !== 0) {
                    $('.shipping-address').find('.derequired').addClass('required').removeClass('derequired');
                }
                merchAddrCtn.removeClass("hide");
                if (merchAddrCtn.find('input[name=firstName]').val() === '' && merchAddrCtn.find('.virtual-cash-address-box-inputs-ctn').css('display') !== 'block') {
                    merchAddrCtn.find('.editable-item-btn').trigger('click');
                }
            }

            if ($(".virtual-cash-step-2-warning-1").length !== 0) {
                $(".virtual-cash-step-2-warning-1").slideUp();
                $(".js-form-error-message").slideUp();
            }
        }, true);
    };

    var init = function init(page) {
        currPage = $(page);
        minElem = $(".timer-minutes");
        secElem = $(".timer-sec");

        var eventId = $(".payment-process-event-info").data("event-id");
        if (eventId === 6942) {
            //ERIC LAPOINTE EN FORMULE SOUPER SPECTACLE
            console.log('calling facebook function ............... ERIC LAPOINTE EN FORMULE SOUPER SPECTACLE');
            fbq('init', '438706678514426');
        }
        if (eventId === 7165) {
            //OBSKUR #004 - Kill The Noise & Friends
            console.log('calling facebook function ............... OBSKUR #004 - Kill The Noise & Friends');
            fbq('init', '943675224110997');
        }
        if (eventId === 7325) {
            //Thuwan_Test_2_Event_1
            console.log('calling facebook function ............... Thuwan_Test_2_Event_1');
            fbq('init', '266548857543903');
        }
        if (eventId === 7362) {
            //Thuwan_Test_2_Event_2
            console.log('calling facebook function ............... Thuwan_Test_2_Event_2');
            fbq('init', '1722681941873874');
        }

        if ($(".timer-minutes")[0] && $(".timer-sec")[0]) {
            getTime();
        }

        submitFormBtn = $(".submit-process-payment-btn");
        submitFormBtn.on("click", submitPaymentForm);

        backPurchaseBtn = $(".back-purchase");
        backPurchaseBtn.on("click", backPurchase);

        cancelPurchaseBtn = $(".cancel-purchase-btn");
        cancelPurchaseBtn.on("click", cancelPurchasePopup);

        emptyCartBtn = $(".empty-cart-btn");
        emptyCartBtn.on("click", emptyCart);

        detailFeesBtn = $(".mini-cart-details-btn");
        detailFeesBtn.on("click", toggleFees);

        backBtn = $(".back-purchase");
        backBtn.on("click", goBack);

        //		shippingBtn = $(".payment-process-radio");
        //		shippingBtn.on("change", updateShippingPrice);

        paymentTypeBtn = $('.payment-type-choice .form-check-input');
        paymentTypeBtn.change(handlePaymentChoice);

        shippingModeBtn = $('.payment-process-radio');
        shippingModeBtn.change(pickShippingMode);

        $('.billing-country-select').change(function () {
            initChangeStates($(this));
        });
    };

    $(window).on("load", function () {
        init();
    });
})(jQuery);
(function ($) {

    'use strict';

    var permissionPageBtn;
    var permissionToggleBtn;
    var addEditCollabBtn;
    var confirmForm;

    var togglePermissionPage = function togglePermissionPage() {
        var $it = $(this);
        var $ctn = $it.closest('.popup-content-ctn');
        $it.toggleClass('disabled');
        if ($it.hasClass('create-event') && !$it.hasClass('disabled')) {
            $ctn.find('.one-dashboard-page-box.manage-events').removeClass('disabled');
            $ctn.find('.one-dashboard-page-box.manage-forfaits').removeClass('disabled');
        } else if (($it.hasClass('manage-events') || $it.hasClass('manage-forfaits')) && $it.hasClass('disabled')) {
            $ctn.find('.one-dashboard-page-box.create-event').addClass('disabled');
            $ctn.find('.one-dashboard-page-box.create-app').addClass('disabled');
        } else if (($it.hasClass('create-event') || $it.hasClass('manage-shop')) && $it.hasClass('disabled')) {
            $ctn.find('.one-dashboard-page-box.create-app').addClass('disabled');
        } else if ($it.hasClass('manage-transactions') && $it.hasClass('disabled')) {
            $ctn.find('.one-dashboard-page-box.virtual-cashier').addClass('disabled');
        } else if ($it.hasClass('create-app') && !$it.hasClass('disabled')) {
            $ctn.find('.one-dashboard-page-box.create-event').removeClass('disabled');
            $ctn.find('.one-dashboard-page-box.manage-events').removeClass('disabled');
            $ctn.find('.one-dashboard-page-box.manage-shop').removeClass('disabled');
            $ctn.find('.one-dashboard-page-box.manage-forfaits').removeClass('disabled');
        } else if ($it.hasClass('virtual-cashier') && !$it.hasClass('disabled')) {
            $ctn.find('.one-dashboard-page-box.manage-transactions').removeClass('disabled');
        }
    };

    var togglePermissionStatus = function togglePermissionStatus() {
        var t = $(this);
        var wasSuspended = t.hasClass('suspended');
        var id = t.attr('data-id');
        var colorbar = $('.ptcr' + id + ' .table-status-colorbar');
        var text = $('.ptcr' + id + ' .table-status-text');

        t.toggleClass('suspended');
        if (wasSuspended) {
            t.find('p').html(t.attr('data-deactivate'));
            colorbar.removeClass(colorbar.attr('data-deactivate')).addClass(colorbar.attr('data-activate'));
            text.text(text.attr('data-activate'));
        } else {
            t.find('p').html(t.attr('data-activate'));
            colorbar.removeClass(colorbar.attr('data-activate')).addClass(colorbar.attr('data-deactivate'));
            text.text(text.attr('data-deactivate'));
        }
        t.closest('.popup').find(".popup-inner-close").trigger("click");

        var url = '/action/epPermissions?ajax=true';
        url += '&subId=' + id;
        url += '&active=' + (wasSuspended ? "true" : "false");
        // Update field5 active
        ajax(url, function (res) {}, true);
    };

    var checkWidth = function checkWidth() {
        if ($('.responsive-detector-sm').css('visibility') === 'visible' && $('.permissions-popup.open').length) {
            $('.permissions-popup.open').each(function () {
                $(this).find('.popup-inner-close').trigger('click');
            });
        }
    };

    function submitCollabForm() {
        var btn = $(this);
        var ctn = btn.closest(".permissions-popup");
        var targ = ctn.find(".permission-email-ctn input");
        var name = targ.attr("name");
        var val = targ.val();
        var json = {};

        if (!(targ[0] && (name === "email" || name === "subId"))) {
            return;
        }

        ctn.find(".one-dashboard-page-box").each(function () {
            var moduleInfos = {};
            moduleInfos["active"] = !$(this).hasClass("disabled");

            if ($(this).find('input[type=radio]').length !== 0) {
                moduleInfos[$(this).find('input[type=radio]').attr("name")] = $(this).find('input[type=radio]:checked').val();
            }

            json["module-" + $(this).attr("data-id")] = moduleInfos;
        });
        if (val.trim() === "") {
            targ.addClass("error");
        }
        if (!targ.hasClass("error")) {
            targ.removeClass("error");

            var url = "/action/epPermissions?ajax=true";
            url += "&" + name + "=" + encodeURIComponent(val);
            url += "&json=" + encodeURIComponent(JSON.stringify(json));

            ajax(url, function (res) {
                if (btn.attr("class").match("add")) {
                    if (res.indexOf("success") !== -1) {
                        ctn.find(".js-form-error-message").slideUp(300);
                        window.location.reload();
                    } else {
                        ctn.find(".js-form-error-message").slideDown(300);
                    }
                } else {
                    ctn.find(".js-form-error-message").slideUp(300);
                    ctn.find(".popup-inner-close").trigger("click");

                    ctn.find(".one-dashboard-page-box").each(function () {
                        var row = ctn.closest(".permissions-table-row");
                        if (!$(this).hasClass("disabled")) {
                            row.find(".permission-allowed[data-id = '" + $(this).attr("data-id") + "']").remove();
                            var sub = $(this).find(".permission-radio") !== undefined && $(this).find(".permission-radio").length !== 0 ? " (" + $(this).find(".permission-radio input:checked").parent('label').find("span").text() + ")" : "";

                            row.find(".permissions-allowed-ctn").append('<div class="permission-allowed semibold fs12" data-id="' + $(this).attr("data-id") + '">' + $(this).find(".one-dashboard-page-header").text() + sub + '</div>');
                        } else {
                            row.find(".permission-allowed[data-id = '" + $(this).attr("data-id") + "']").remove();
                        }
                    });
                }
            }, true);
        } else {
            console.error("An error occurred.");
        }
    }

    function promptDelete(e) {
        e.preventDefault();
        confirmForm = $(this).closest("form")[0];
        openWindow("permission_profile_prompt_delete", true);
    }
    function confirmAction(e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        closeWindow("permission_profile_prompt_delete");
        if (confirmForm) {
            ajaxBlackout(true);
            confirmForm.submit();
            confirmForm = null;
        }
    }

    var init = function init() {
        permissionPageBtn = $('.permissions-popup .one-dashboard-page-box');
        permissionToggleBtn = $('.toggle-profile-permission-btn');

        permissionPageBtn.click(togglePermissionPage);
        permissionToggleBtn.click(togglePermissionStatus);

        addEditCollabBtn = $('.add-collaborator-btn, .edit-collaborator-btn');
        addEditCollabBtn.click(submitCollabForm);

        $('#permission_profile_prompt_delete .popup-inner-content-btn .btn').click(confirmAction);
        $('.permissions-table .table-delete-btn').on('click', promptDelete);
        $('.permission-radio').on('click', function (e) {
            e.stopPropagation();
        }); // Prevent click on parent button when choosing one of the radio button

        $(window).resize(checkWidth);
    };

    $(window).on('load', init);
})(jQuery);
(function ($, undefined) {

	'use strict';

	var currPage;
	var calendarDay;

	var handleCalendarTouch = function handleCalendarTouch(t) {
		$(t).closest('.calendar-display-day').find('.show-more-calendar-events-btn').trigger('click');
	};

	var init = function init(page) {
		currPage = $(page);
		loadTouchEvents($);

		calendarDay = $('.calendar-display-day');
		calendarDay.tap(function (e) {
			e.preventDefault();
			handleCalendarTouch(e.target);
		});
	};

	$(window).on("load", function () {
		init();
	});
})(jQuery);
(function ($, undefined) {
	'use strict';

	var directoryScrollCtn;
	var directoryInnerScrollCtn;
	var directoryProfilesSectionCtn;
	var directoryLettersCtn;
	var directoryScrollLetterBtn;
	var tapHoldLetterDisplayCtn;
	var reverseScroll = false;
	var letterPositionsArrayOri = [];
	var letterPositionsArray;

	var getFirstDisplayedLetter = function getFirstDisplayedLetter() {
		var firstDisplayedLetter = directoryProfilesSectionCtn.first().attr('data-letter');
		$('.directory-scroll-letter-btn[data-letter="' + firstDisplayedLetter + '"]').addClass('selected');
	};

	var scrollToLetterSection = function scrollToLetterSection(t, isTapHold) {
		var chosenLetter = t.attr('data-letter');
		var chosenLetterProfilesSection = $('.directory-profiles-inner-ctn[data-letter="' + chosenLetter + '"]');
		var ctnPosition;
		var speed;

		if (isTapHold === true) {
			speed = 50;
		} else {
			speed = 300;
		}

		if (chosenLetterProfilesSection.length === 0) {
			// if there is no profile for the chosen section, try the next letter. 
			// If it's the last letter and there are still no sections found, start scrolling backwards
			if (isTapHold !== true) {
				if (t.is(':last-child') || reverseScroll === true) {
					reverseScroll = true;
					t.prev().trigger('click');
				} else {
					t.next().trigger('click');
				}
			}
		} else {
			reverseScroll = false;
			changeSelectedLetterBtn(t);

			if (directoryInnerScrollCtn.position().top < 0) {
				ctnPosition = -directoryInnerScrollCtn.position().top;
			} else {
				ctnPosition = directoryInnerScrollCtn.position().top;
			}

			directoryScrollCtn.animate({
				scrollTop: ctnPosition + chosenLetterProfilesSection.position().top
			}, speed);
		}
	};

	var changeSelectedLetterBtn = function changeSelectedLetterBtn(letter) {
		$('.directory-scroll-letter-btn.selected').removeClass('selected');
		letter.addClass('selected');
	};

	// TOUCH
	var getClosestHeldLetter = function getClosestHeldLetter(offsetY) {
		letterPositionsArray = letterPositionsArrayOri.slice();
		letterPositionsArray.sort(function (a, b) {
			return Math.abs(offsetY - a) - Math.abs(offsetY - b);
		});

		var currentHeldLetterPosition = letterPositionsArray[0];
		var letterIndex = letterPositionsArrayOri.indexOf(currentHeldLetterPosition);
		var letterBtnSelector = $('.directory-scroll-letter-btn[data-tab=' + (letterIndex + 1) + ']');

		changeSelectedLetterBtn(letterBtnSelector);
		scrollToLetterSection(letterBtnSelector, true);
		changeTapHoldLetterDisplay(letterBtnSelector.attr('data-letter'), offsetY);
	};

	var changeTapHoldLetterDisplay = function changeTapHoldLetterDisplay(letter, offsetY) {
		if (!tapHoldLetterDisplayCtn.hasClass('active')) {
			tapHoldLetterDisplayCtn.addClass('active');
		}

		var halfLetterBtnHeight = directoryScrollLetterBtn.height() / 2;
		var y;

		if (offsetY > directoryLettersCtn.height() - directoryScrollLetterBtn.height()) {
			y = directoryLettersCtn.height() - directoryScrollLetterBtn.height() - halfLetterBtnHeight;
		} else if (offsetY < 0) {
			y = -halfLetterBtnHeight;
		} else {
			y = offsetY - halfLetterBtnHeight;
		}

		tapHoldLetterDisplayCtn.css('top', y + 'px');
		tapHoldLetterDisplayCtn.find('.letter').html(letter);
	};

	var init = function init(page) {
		loadTouchEvents($);

		directoryScrollCtn = $('.directory-profiles-outer-ctn.responsive');
		directoryInnerScrollCtn = $('.directory-inner-scroll');
		directoryProfilesSectionCtn = $('.directory-profiles-inner-ctn', directoryScrollCtn);
		directoryLettersCtn = $('.directory-alphabet-outer-ctn.responsive .directory-alphabet-inner-ctn');
		directoryScrollLetterBtn = $('.directory-scroll-letter-btn');
		tapHoldLetterDisplayCtn = $('.directory-alphabet-tap-hold-mobile-ctn', directoryLettersCtn);

		directoryScrollLetterBtn.click(function () {
			scrollToLetterSection($(this));
		});

		// TOUCH PHONE CONTACTS EFFECT
		// https://www.npmjs.com/package/jquery-touch-events
		directoryScrollLetterBtn.on('tapstart', function (e) {
			$('body, html').addClass('no-scroll');
		});

		directoryScrollLetterBtn.on('tapend', function (e) {
			$('body, html').removeClass('no-scroll');
			tapHoldLetterDisplayCtn.removeClass('active');
		});

		directoryScrollLetterBtn.each(function () {
			letterPositionsArrayOri.push($(this).position().top);
		});

		directoryLettersCtn.on('tapmove', function (e, touch) {
			if (touch.offset.x >= 0) {
				getClosestHeldLetter(touch.offset.y);
			}
		});

		getFirstDisplayedLetter();
	};

	$(window).on("load", function () {
		init();
	});
})(jQuery);
(function ($, undefined) {

	'use strict';

	var promotionsAllActionsBtn;
	var promotionsActionBtn;
	var outerCtn;
	var buttonChoiceBtn;
	var buttonSizeRangeBtn;
	var colorPickerBtn;
	var buttonTextInput;
	var backToButtonChoicesBtn;
	var addFavorTicketsBtn;
	var addFavorTicketsRecipientBtn;
	var delFavorTicketsRecipientBtn;
	var eventDisplayBtn;
	var eventTypeBtn;

	var blackoutPromotionsEvents = function blackoutPromotionsEvents() {
		var t = $(this);
		var parentEvent = t.closest('.promotions-one-event-outer-ctn');

		parentEvent.removeClass('one-action-open');
		parentEvent.find('.promotions-action-ctn.open').removeClass('open').slideUp(300);

		if (!$('.promotions-one-event-outer-ctn').hasClass('actions-open')) {
			$('.promotions-one-event-outer-ctn').addClass('actions-open');
		} else {
			$('.promotions-one-event-outer-ctn').removeClass('actions-open');
		}
	};

	var closePromotionsActionPopup = function closePromotionsActionPopup(t) {
		$('.promotions-one-event-outer-ctn').removeClass('actions-open');
		t.closest('.table-actions-ctn').removeClass('open');
		t.closest('.table-action-btns-ctn').find('.table-action-popup-btn').removeClass('active');
	};

	var showActionRelatedContent = function showActionRelatedContent() {
		var t = $(this);
		var action = t.attr('data-id');
		var parentEvent = t.closest('.promotions-one-event-outer-ctn');

		parentEvent.addClass('one-action-open');
		parentEvent.find('.promotions-action-ctn.' + action).slideDown(300, function () {
			$(this).addClass('open');
		});
		closePromotionsActionPopup(t);
	};

	// CUSTOMIZE BUTTON FUNCTIONS

	var getButtonChoice = function getButtonChoice() {
		var t = $(this);
		var parent = t.closest(outerCtn);
		var choice = t.val();
		var button = t.closest('.button-style-choice-option-outer-ctn').find('.epasslive-button');
		var height = button.outerHeight();
		var width = button.outerWidth();

		$('.customize-button-text.shape-choice', parent).fadeOut(300, function () {
			$('.customize-button-text.personalize', parent).fadeIn(300);
		});

		$('.button-style-choice-option-outer-ctn:not(.' + choice + ')', parent).fadeOut(300, function () {
			$(this).addClass('hide');
			$('.promotions-button-all-options-ctn', parent).addClass('flex-justify-center');
		});

		$('.promotions-disabled-button-customisation-overlay', parent).fadeOut(300, function () {
			$('.custom-btn-range-input.height', parent).val(height).attr('min', button.attr('data-min-height'));
			$('.custom-btn-range-input.width', parent).val(width).attr('min', button.attr('data-min-width'));
			changeButtonSizeText(parent, button.outerHeight(), button.outerWidth());

			if (choice === 'a' || choice === 'b') {
				$('.custom-btn-range-input', parent).addClass('square');
			}
		});
		$('.promotions-custom-button-back-to-choices-btn', parent).fadeIn(300);

		$('.promotions-button-code-step-outer-ctn', parent).slideDown(300, function () {
			updateButtonCode(button);
		});
	};

	var changeButtonSize = function changeButtonSize() {
		var t = $(this);
		var size = t.val();
		var parent = t.closest(outerCtn);
		var chosenButton = parent.find('.button-style-choice-option-outer-ctn:not(.hide)').find('.epasslive-button');
		var height = null;
		var width = null;

		if (t.hasClass('square')) {
			height = size;
			width = size;

			parent.find(buttonSizeRangeBtn).val(size);
		} else {
			if (t.hasClass('width')) {
				width = size;
			}
			if (t.hasClass('height')) {
				height = size;
			}
		}

		if (height !== null) {
			chosenButton.css('height', height + 'px');
		}

		if (width !== null) {
			chosenButton.css('width', width + 'px');
		}

		changeButtonSizeText(parent, height, width);
		updateButtonCode(chosenButton);
	};

	var changeButtonSizeText = function changeButtonSizeText(parent, height, width) {
		if (height) {
			$('.custom-button-size.height', parent).html('(' + parseInt(height) + 'px)');
		}

		if (width) {
			$('.custom-button-size.width', parent).html('(' + parseInt(width) + 'px)');
		}
	};

	var changeButtonColor = function changeButtonColor() {
		var t = $(this);
		var color = MG2.ColorPicker.getColor();
		var id = t.attr('data-inp').split('color-')[1];
		var parent = t.closest('.box-theme-content').find('.promotions-one-event-outer-ctn[data-id=' + id + ']');
		var chosenButton = parent.find('.button-style-choice-option-outer-ctn:not(.hide)').find('.epasslive-button');
		var button = parent.find('.button-style-choice-option-outer-ctn').find('.epasslive-button');
		var modifType = t.attr('data-inp').split('-' + id)[0];

		t.closest('.popup-ctn').find('.popup-inner-close').trigger('click');
		if (modifType.indexOf('text') !== -1) {
			button.find('.epasslive-button-text').css('color', color);
			button.find('svg').css('fill', color);
		} else {
			button.css(modifType, color);
		}

		updateButtonCode(chosenButton);
	};

	var changeButtonText = function changeButtonText() {
		var t = $(this);
		var parent = t.closest(outerCtn);
		var button = parent.find('.button-style-choice-option-outer-ctn').find('.epasslive-button');
		var chosenButton = parent.find('.button-style-choice-option-outer-ctn:not(.hide)').find('.epasslive-button');

		button.find('.epasslive-button-text').text(t.val());

		updateButtonCode(chosenButton);
	};

	var updateButtonCode = function updateButtonCode(button) {
		var codeCtn = button.closest(outerCtn).find('.promotions-generate-btn-step-ctn.button-code-ctn');
		var eventUrl = codeCtn.attr('data-url');
		var style = '';
		var classNames = button.attr('class').split(' ');

		classNames.forEach(function (e) {
			var eStyles = getStyle('.' + e);

			if (eStyles !== undefined) {
				style += eStyles;
			}
		});

		if (button.attr('style') !== undefined) {
			style += button.attr('style');
		}

		codeCtn.find('textarea').val('<a href="' + eventUrl + '" target="_blank" style="text-decoration:none;margin:20px;display:inline-block;"><div style="height:' + button.attr('data-min-height') + 'px;width:' + button.attr('data-min-width') + 'px;' + style + '">' + button.html() + '</div></a>');
	};

	// keeps color choices and text (applied to all buttons), resets other elements
	var showAllButtonChoices = function showAllButtonChoices() {
		var parent = $(this).closest(outerCtn);

		$('.button-style-choice-btn', parent).prop('checked', false);

		$('.customize-button-text.personalize', parent).fadeOut(300, function () {
			$('.customize-button-text.shape-choice', parent).fadeIn(300);
		});

		$('.promotions-button-all-options-ctn', parent).removeClass('flex-justify-center');
		$('.button-style-choice-option-outer-ctn', parent).fadeIn(300, function () {
			$(this).removeClass('hide');
		});
		$('.promotions-disabled-button-customisation-overlay', parent).fadeIn(300);
		$('.custom-btn-range-input', parent).removeClass('square');
		$('.custom-button-size', parent).html('');

		$('.promotions-custom-button-back-to-choices-btn', parent).fadeOut(300);

		$('.promotions-button-code-step-outer-ctn', parent).slideUp(300, function () {
			$('.button-code-ctn', parent).find('textarea').val('');
		});
	};

	var addFavorTickets = function addFavorTickets() {
		var t = $(this);
		var eventId = t.attr("data-id");
		var ctn = t.closest(".popup-content-ctn");
		var form = t.closest('.js-form');
		var valid = true;

		var ticketIds = "";
		var qtys = "";
		var links = "";
		var names = "";
		var emails = "";

		// if (ctn.find(".page-promotions-tickets-warning input").is(":checked")) {

		// } else {
		// 	form.addClass('error-checkbox');
		// }

		formValidator.validateForm(form);

		ctn.find(".promotions-send-free-tickets-form-inputs-outer-ctn .free-ticket-promotion-line").each(function () {
			var qty = $(this).find(".qty-input-with-buttons input").val();
			var tId = $(this).find(".promotions-free-tickets-category-select").val();
			var linked = $(this).find(".promotions-free-tickets-category-select").find(":selected").attr("data-tickets");
			var name = $(this).find(".promotions-free-tickets-name input").val();
			var email = $(this).find(".promotions-free-tickets-email input").val();
			if (qty !== "0" && qty !== undefined && qty !== "" && tId !== "" && name !== "" && email !== "") {
				$(this).find(".qty-input-with-buttons").removeClass("error");
				ticketIds += tId + ",";
				qtys += qty + ",";
				links += linked === undefined ? "X," : linked + ",";
				names += encodeURIComponent(name) + ",";
				emails += encodeURIComponent(email) + ",";
			} else {
				valid = false;
				if (!(qty !== "0" && qty !== undefined && qty !== "")) {
					$(this).find(".qty-input-with-buttons").addClass("error");
				} else {
					$(this).find(".qty-input-with-buttons").removeClass("error");
				}
			}
		});

		if (valid && !form.hasClass('has-error')) {
			t.addClass('disabled');

			var url = "/action/epFavorTickets";
			url += "?eventId=" + eventId;
			url += "&ticketIds=" + ticketIds;
			url += "&qtys=" + qtys;
			url += "&linkedTicketIds=" + links;
			url += "&names=" + names;
			url += "&emails=" + emails;
			ajax(url, function (response) {
				ctn.find(".page-promotions-tickets-warning input").prop("checked", false);
				ctn.find(".free-ticket-form-success").slideDown();
				ctn.find(".free-ticket-form-ctn").slideUp();
				ctn.find(".free-ticket-promotion-line:gt(0)").each(function (index) {
					if (index === 0) {
						$(this).find(".promotions-free-tickets-category-select-ctn").removeClass('focused').find('select').removeClass('success').val("");
						$(this).find(".qty-input-with-buttons").removeClass('focused').find('input').val("");
						$(this).find(".promotions-free-tickets-name").removeClass('focused').find('input').removeClass('success').val("");
						$(this).find(".promotions-free-tickets-email").removeClass('focused').find('input').removeClass('success').val("");
					} else {
						$(this).slideUp("fast", function () {
							$(this).remove();
						});
					}
				});

				window.setTimeout(function () {
					ctn.find(".free-ticket-form-success").slideUp();
					ctn.find(".free-ticket-form-ctn").slideDown();
					t.removeClass('disabled');
				}, 3000);
			}, true);
		}
	};

	var addFavorTicketsRecipient = function addFavorTicketsRecipient() {
		var t = $(this);
		var ctn = t.closest(".popup-content-ctn");

		var model = ctn.find(".promotions-free-tickets-model").children().clone(true);
		model.addClass("clone");
		model.find('.form-input:not(.numbers-only)').addClass('required').blur(function () {
			formValidator.formItemsBlur($(this));
		});
		ctn.find(".promotions-send-free-tickets-form-inputs-outer-ctn").append(model);
		model.removeClass("clone");
	};

	var delFavorTicketsRecipient = function delFavorTicketsRecipient() {
		var t = $(this);
		t.closest(".free-ticket-promotion-line").slideUp("fast", function () {
			$(this).remove();
		});
	};

	var changeEventDisplayStyle = function changeEventDisplayStyle() {
		var t = $(this);
		var ctn = t.closest('.box-theme-ctn');
		var initCode = ctn.find('textarea').html();
		var codeCtn = ctn.find('.code-promotions');
		var code = codeCtn.attr('data-prefix');

		if (t.hasClass('promotions-profile-events-style-btn')) {
			$('.promotions-profile-events-style-btn').removeClass('selected');
			t.addClass('selected');
		}

		if (t.hasClass('change-display') && t.hasClass('calendar') || !t.hasClass('change-display') && initCode.indexOf('calendar') !== -1) {
			code += codeCtn.attr('data-calendar');
		}
		if (t.hasClass('change-type') && t.hasClass('dynamic') || !t.hasClass('change-type') && initCode.indexOf('dynamic') !== -1) {
			code += codeCtn.attr('data-dynamic');
		}
		code += codeCtn.attr('data-suffix');

		ctn.find('textarea').html(code);
	};

	var init = function init() {
		MG2.ColorPicker.init();
		promotionsAllActionsBtn = $('.promotions-one-event-outer-ctn .table-action-popup-btn');
		promotionsActionBtn = $('.table-promotions-action-btn');
		outerCtn = $('.promotions-action-ctn.generate-buy-btn');
		buttonChoiceBtn = $('.button-style-choice-btn');
		buttonSizeRangeBtn = $('.custom-btn-range-input');
		colorPickerBtn = $('.promotions .mg2-color-current');
		buttonTextInput = $('.promotions-custom-button-text-input');
		backToButtonChoicesBtn = $('.promotions-custom-button-back-to-choices-btn');
		eventDisplayBtn = $('.promotions-profile-events-style-btn');
		eventTypeBtn = $('.change-type');

		promotionsAllActionsBtn.click(blackoutPromotionsEvents);
		promotionsActionBtn.click(showActionRelatedContent);
		buttonChoiceBtn.click(getButtonChoice);
		buttonSizeRangeBtn.on('input', changeButtonSize);
		buttonSizeRangeBtn.on('change', changeButtonSize); // IE
		colorPickerBtn.click(changeButtonColor);
		buttonTextInput.keyup(changeButtonText);
		backToButtonChoicesBtn.click(showAllButtonChoices);
		eventTypeBtn.change(changeEventDisplayStyle);
		eventDisplayBtn.click(changeEventDisplayStyle);

		addFavorTicketsBtn = $(".add-favor-tickets");
		addFavorTicketsBtn.on("click", addFavorTickets);

		addFavorTicketsRecipientBtn = $(".promotions-tickets-add-recipient-btn");
		addFavorTicketsRecipientBtn.on("click", addFavorTicketsRecipient);

		delFavorTicketsRecipientBtn = $(".del-free-ticket-line");
		delFavorTicketsRecipientBtn.on("click", delFavorTicketsRecipient);
	};

	$(window).on('load', function () {
		init();
	});
})(jQuery);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function ($, undefined) {

    'use strict';

    var recaptchaKey = "6LcB2hUqAAAAAJKM4KosE-a9hR2_wtrYoUXDxLrs"; // Production

    var renderCaptcha = function renderCaptcha() {
        var $render = $(".account_creation_recaptcha");
        if ($render.length && (typeof grecaptcha === "undefined" ? "undefined" : _typeof(grecaptcha)) === "object") {
            grecaptcha.ready(function () {
                $render.each(function () {
                    var _ = this;
                    var createForm = $(_).closest(".create-account-form");
                    var widgetId = grecaptcha.render(_, {
                        'sitekey': recaptchaKey,
                        'size': 'invisible',
                        'badge': 'bottomleft',
                        'callback': function callback(response) {
                            var email = createForm.find('input[name="email"]').val();
                            var fName = createForm.find('input[name="firstName"]').val();
                            var lName = createForm.find('input[name="lastName"]').val();
                            createForm.find('.account_creation_recatpcha_token').val(response);
                            session.save("regEmail", email, function () {
                                session.save("regFName", fName, function () {
                                    session.save("regLName", lName, function () {
                                        createForm.submit();
                                    });
                                });
                            });
                        }
                    });
                    createForm.attr("data-widget-id", widgetId);
                });
            });
        }
    };

    var createAccount = function createAccount(e) {
        e.preventDefault();
        var createForm = $(e.currentTarget).closest(".create-account-form");
        formValidator.validateForm(createForm);
        if (!createForm.hasClass('has-error')) {
            grecaptcha.execute(createForm.attr("data-widget-id"));
        } else {
            return false;
        }
    };

    var init = function init() {
        renderCaptcha();
        $(".create-account-form .register-btn").on("click", createAccount);
    };

    $(window).on("load", init);
})(jQuery);
(function ($, undefined) {
    'use strict';

    var responsiveDetectorSm;
    var slickSm;
    var desktopActive = true;
    var sendEventDetailsBtn;
    var deleteEventSubscriberBtn;

    var checkWidth = function checkWidth() {
        if (responsiveDetectorSm.css('visibility') === 'hidden') {
            if (desktopActive === false) {
                slickSm.slick('unslick');
                desktopActive = true;
            }
        } else {
            if (desktopActive === true) {
                slickInitSm();
                desktopActive = false;
            }
        }
    };

    var slickInitSm = function slickInitSm() {
        $('.slick-sm').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            slide: '.stat-box-slide-outer-ctn:not(.phase-2)'
        });
    };

    var init = function init() {
        responsiveDetectorSm = $('.responsive-detector-sm');
        sendEventDetailsBtn = $('.send-event-details-btn');
        sendEventDetailsBtn.click(sendEventDetailsByEmail);
        deleteEventSubscriberBtn = $('.delete-event-subscriber-btn');
        deleteEventSubscriberBtn.click(updateSubscribersList);
        slickSm = $('.slick-sm');

        checkWidth();
        $(window).resize(function () {
            checkWidth();
        });
    };

    $(window).on('load', function () {
        init();
    });

    function sendEventDetailsByEmail() {
        var t = $(this);
        var form = t.closest('form');
        var email = encodeURIComponent(form.find('input[name="email"]').val());
        var eventId = form.find('input[name="event_id"]').val();
        var type = form.find('select[name="types"]').val();
        console.log(email);
        console.log(eventId);
        console.log(type);
        if (email != null && email.length !== 0) {
            if (type == "immediately") {
                $.ajax({
                    url: '/action/epSendEventStats?sendEventReportWhenSubmittingEmail=true&eventId=' + eventId + '&receiver=' + email,
                    cache: false,
                    data: {
                        ajax: true
                    },
                    success: function success(response) {
                        alert("succès");
                    },
                    error: function error(xhr, textStatus) {
                        alert("échoué");
                    }
                });
            } else if (type == "daily") {
                var url = '/action/manageGenData';
                url += '?field1=ep-event-report-emails';
                url += '&field2=' + eventId;
                url += '&field3=' + email;
                url += '&ajax=true';
                console.log(url);
                $.ajax({
                    url: url,
                    cache: false,
                    data: {
                        ajax: true
                    },
                    success: function success(response) {
                        if (response === "success-0") {
                            alert("l'email existe déjà");
                        } else {
                            alert("succès");
                        }
                        // window.location.reload();
                    },
                    error: function error(xhr, textStatus) {
                        alert("échoué");
                    }
                });
            } else {
                var url = '/action/manageGenData';
                url += '?field1=ep-event-report-emails-weekly';
                url += '&field2=' + eventId;
                url += '&field3=' + email;
                url += '&ajax=true';
                console.log(url);
                $.ajax({
                    url: url,
                    cache: false,
                    data: {
                        ajax: true
                    },
                    success: function success(response) {
                        if (response === "success-0") {
                            alert("l'email existe déjà");
                        } else {
                            alert("succès");
                        }
                        // window.location.reload();
                    },
                    error: function error(xhr, textStatus) {
                        alert("échoué");
                    }
                });
            }
        } else {
            alert("Email cannot be empty!");
        }
    }

    function updateSubscribersList() {
        if (confirm('Êtes-vous sûr de vouloir supprimer cet abonné?')) {
            // Delete it!
            var t = $(this);
            var form = t.closest('form');
            var id = t.attr("id");
            var eventId = form.find('input[name="event_id_' + id + '"]').val();
            var email = form.find('input[name="subscriber_' + id + '"]').val();
            var epEventReportEmails = form.find('input[name="ep-event-report-emails_' + id + '"]').val();
            var data = {
                id: id,
                field1: epEventReportEmails == "true" ? 'ep-event-report-emails-deleted' : "ep-event-report-emails-weekly-deleted",
                field2: eventId,
                field3: email,
                ajax: true
            };
            $.ajax({
                url: '/action/manageGenData',
                cache: false,
                data: data,
                method: 'POST',
                success: function success(response) {
                    alert("succès");
                    window.location.reload();
                },
                error: function error(xhr, textStatus) {
                    alert("échoué");
                }
            });
        } else {
            // Don't delete!
        }
    }
})(jQuery);
(function ($, undefined) {

    'use strict';

    var currPage;
    var sendBillsBackBtn;
    var refundBtn;
    var refundCheck;
    var refundConfirmBtn;
    var refundCancelBtn;
    var refundActionCancelBtn;
    var refundActionAcceptBtn;
    var editTicketsNames;
    var chequeBtn;
    var cancelPaymentBtn;
    var resendBillsToggleBtn;
    var resendBillsBtn;

    /* Sends the bill and all tickets back to buyer */
    var sendBillsBack = function sendBillsBack() {
        var t = $(this);
        var ctn = t.closest(".send-bills-form");
        var id = t.attr("data-id");
        var email = ctn.find("input[name=email]").val();
        var firstName = ctn.find("input[name=fname]").val();
        var lastName = ctn.find("input[name=lname]").val();
        var overwrite = ctn.find("input[name=overwrite]").is(':checked');

        var url = "/action/epManageTransactions?sendAgain=true";
        url += "&paymentId=" + id;
        url += "&email=" + email;
        url += "&firstName=" + firstName;
        url += "&lastName=" + lastName;
        url += "&overwrite=" + overwrite;

        t.addClass("disabled");
        ajax(url, function () {
            ctn.find(".success-msg").slideDown();
            window.setTimeout(function () {
                ctn.find(".success-msg").slideUp();
                t.removeClass("disabled");
            }, 3000);
            if ($(".vc-confirm-step-btn.email").length !== 0) {
                // virtual cashier, step 5
                $(".vc-confirm-step-btn.email").addClass("checked");
            }
        }, true);
    };

    /* Organizer side : creates a request to admin (alert & payment) to proceed to a refund */
    var refundAmt = function refundAmt() {
        var t = $(this);
        var id = t.attr("data-id");
        var tickets_selected = t.closest(".refund-form").find(".purchase-payment-list-ctn tr.selected");
        var tickets_all = t.closest(".refund-form").find(".purchase-payment-list-ctn tr");
        var amount = trimAmount(t.closest(".refund-form").find(".refund-amount-ctn input[name='amount']").val());
        var allCheck = t.closest(".refund-form").find(".refund-amount-ctn input[name='refund-all-admin']");
        var all = allCheck.length !== 0 && allCheck.is(":checked");
        if (amount !== "" && amount > 0 || tickets_selected.length !== 0 || all) {
            t.addClass("disabled");
            var tickets = all ? getSelectedTickets(tickets_all) : getSelectedTickets(tickets_selected);
            var url = "/action/epRefund?ajax=true&org=true";
            url += "&amount=" + amount;
            url += "&paymentId=" + id;
            url += "&all=" + all;
            url += "&selectedTickets=" + tickets;

            ajax(url, function (response) {
                if (response.indexOf("success") !== -1) {
                    t.closest(".refund-form").find(".error-funds-message").slideUp();
                    window.location = window.location.href.split("?")[0];
                } else {
                    t.removeClass("disabled");
                    t.closest(".refund-form").find(".error-funds-message").slideDown();
                }
            }, true);
        }
    };

    var getSelectedTickets = function getSelectedTickets(elmts) {
        var ids = "";

        elmts.each(function () {
            var id = $(this).attr("data-id");
            if (typeof id !== "undefined") {
                ids += $(this).attr("data-id") + ",";
            }
        });

        return ids;
    };

    var trimAmount = function trimAmount(amt) {
        if (amt.indexOf(",") !== -1) {
            amt = amt.replace(",", ".");
        }
        if (amt.indexOf("$") !== -1) {
            amt = amt.replace("$", "");
        }
        amt = amt.trim();
        return amt;
    };

    var toggleCheckLine = function toggleCheckLine() {
        var t = $(this);
        var price = parseFloat(t.closest("td").attr("data-price"));
        var totalInput = t.closest(".refund-form").find("input[name='amount']");
        var total = totalInput.val();
        var s = total.trim() === "" ? parseFloat(0) : parseFloat(total.trim());

        if (t.is(":checked")) {
            t.closest("tr").addClass("selected");
            totalInput.val((s + price).toFixed(2));
        } else {
            t.closest("tr").removeClass("selected");
            var sum = s - price < 0 ? 0 : s - price;
            totalInput.val(sum.toFixed(2));
        }
    };

    /* Confirmation from organizer before he actually creates a request for a refund to Admin */
    var confirmRefund = function confirmRefund() {
        var t = $(this);
        var amount = trimAmount(t.closest(".refund-form").find(".refund-amount-ctn input[name='amount']").val());
        var tickets = t.closest(".refund-form").find(".purchase-payment-list-ctn tr.selected td");
        var allCheck = t.closest(".refund-form").find(".refund-amount-ctn input[name='refund-all-admin']");
        var all = allCheck.length !== 0 && allCheck.is(":checked");
        if (amount !== "" && amount > 0 || tickets.length !== 0 || all) {
            t.addClass("disabled");
            t.closest(".refund-form").find(".form-overlay").addClass("visible");
            t.closest(".refund-form").find(".confirm-message-refund").slideDown();
            t.closest(".refund-form").find(".purchase-payment-list-ctn tr:not(.selected) td").slideUp();
        }
    };

    var cancelRefund = function cancelRefund() {
        var t = $(this);
        refundConfirmBtn.removeClass("disabled");
        t.closest(".refund-form").find(".form-overlay").removeClass("visible");
        t.closest(".refund-form").find(".confirm-message-refund").slideUp();
        t.closest(".refund-form").find(".error-funds-message").slideUp();
        t.closest(".refund-form").find(".purchase-payment-list-ctn tr:not(.selected) td").slideDown();
    };

    /* Request for refund already created : this cancels it. */
    var cancelRefundPayment = function cancelRefundPayment() {
        var t = $(this);
        t.addClass("disabled");
        var id = t.attr("data-id");

        var url = "/action/epRefund?ajax=true";
        url += "&paymentId=" + id;
        url += "&cancel=true";
        url += "&organizer=true";

        ajax(url, function (response) {
            var ctn = t.closest("tr");
            var text = ctn.find(".payment-status").attr("data-canceled");
            ctn.find(".payment-status-text").html(text);
            t.remove();
            t.closest(".table-action-btns-ctn").find(".table-accept-refund-action").remove();
        }, true);
    };

    /* Request for refund already created : accept it. */
    var acceptRefundPayment = function acceptRefundPayment() {
        var t = $(this);
        t.addClass("disabled");
        var id = t.attr("data-id");

        var url = "/action/epRefund?ajax=true";
        url += "&paymentId=" + id;

        ajax(url, function (response) {
            var ctn = t.closest("tr");
            var text = ctn.find(".payment-status").attr("data-refunded");
            ctn.find(".payment-status-text").html(text);
            t.remove();
            t.closest(".table-action-btns-ctn").find(".table-cancel-refund-action").remove();
        }, true);
    };

    var editInfos = function editInfos() {
        var mainCtn = $(this).closest(".ticket-owner-ctn");
        var ctn = $(this).closest(".ticket-owner-name-form");
        var id = ctn.attr("data-id");
        var fName = ctn.find("input[name=firstName]").val();
        var lName = ctn.find("input[name=lastName]").val();
        var email = ctn.find("input[name=email]").val();
        var company = ctn.find("input[name=company]").val();

        var url = "/action/epQR?ticketPaymentId=" + id;
        url += "&firstName=" + fName;
        url += "&lastName=" + lName;
        url += "&email=" + email;
        url += "&company=" + company;

        ajax(url, function (response) {
            var t = fName + " " + lName + " (" + email;
            if (company !== "") {
                t += " - " + company;
            }
            t += ")";
            mainCtn.find(".ticket-names").text(t);
        }, true);
    };

    var updateCheckPayment = function updateCheckPayment() {
        var t = $(this);
        var id = t.attr("data-id");
        var btn = $(".cheque-popup-btn-" + id);
        var paid = t.hasClass("hijacker") ? !btn.hasClass("active") : true;
        var tr = t.closest("tr");

        var url = "/action/epManageTransactions?paymentId=" + id;
        url += "&paid=" + paid;

        t.addClass("disabled");
        ajax(url, function (response) {
            if (t.hasClass("hijacker")) {
                btn.toggleClass("active");
                var ctn = t.closest(".popup-inner-content");
                if (paid) {
                    ctn.find(".message-check-paid").css("display", "none");
                    ctn.find(".message-check-not-paid").css("display", "");
                } else {
                    ctn.find(".message-check-paid").css("display", "");
                    ctn.find(".message-check-not-paid").css("display", "none");
                }
            } else {
                btn.addClass("active");
                btn.removeClass("popup-btn");
                btn.unbind();
            }
            var text = tr.find(".payment-status").attr("data-paid");
            if (!paid) {
                text = tr.find(".payment-status").attr("data-not-paid");
            }
            tr.find(".payment-status-text").text(text);
            tr.find(".popup-status").text(text);
            tr.find(".table-cancel-action").remove();
            tr.find(".table-send-bills-action").remove();
            t.removeClass("disabled");
        }, true);
    };

    var cancelCheckPayment = function cancelCheckPayment() {
        var t = $(this);
        var id = t.attr("data-id");
        var tr = t.closest("tr");

        var url = "/action/epManageTransactions?paymentId=" + id;
        url += "&cancel=true";

        t.addClass("disabled");
        ajax(url, function (response) {
            var text = tr.find(".payment-status").attr("data-canceled");
            tr.find(".payment-status-text").text(text);
            tr.find(".popup-status").text(text);
            tr.find(".table-send-bills-action").addClass("disabled");
            tr.find(".cheque-received-popup").addClass("disabled");
            tr.find(".table-cancel-action").addClass("disabled");
        }, true);
    };

    function resendBillsToggle() {
        $(".form-send-bills-by-date").toggleClass("hide");
    }

    function resendBillsByDate() {
        var form = $(".form-send-bills-by-date");
        formValidator.validateForm(form);
        if (!form.hasClass("has-error")) {
            var t = $(this);
            var startDay = $("input[name = 'startDateDay']", form).val();
            var startMonth = $("input[name = 'startDateMonth']", form).val();
            var startYear = $("input[name = 'startDateYear']", form).val();
            var startHour = $("input[name = 'startDateHour']", form).val();
            var startMinute = $("input[name = 'startDateMinute']", form).val();
            var endDay = $("input[name = 'endDateDay']", form).val();
            var endMonth = $("input[name = 'endDateMonth']", form).val();
            var endYear = $("input[name = 'endDateYear']", form).val();
            var endHour = $("input[name = 'endDateHour']", form).val();
            var endMinute = $("input[name = 'endDateMinute']", form).val();

            var message = tinymce.get("message").getContent();

            var url = "/action/epManageTransactions?sendAgainFromDate=true";
            url += "&startDay=" + startDay;
            url += "&startMonth=" + startMonth;
            url += "&startYear=" + startYear;
            url += "&startHour=" + startHour;
            url += "&startMinute=" + startMinute;
            url += "&endDay=" + endDay;
            url += "&endMonth=" + endMonth;
            url += "&endYear=" + endYear;
            url += "&endHour=" + endHour;
            url += "&endMinute=" + endMinute;
            url += "&message=" + encodeURIComponent(message);

            t.addClass("disabled");
            ajax(url, function () {

                t.removeClass("disabled");
            }, true);
        }
    }

    var init = function init(page) {
        currPage = $(page);

        sendBillsBackBtn = $(".send-bills-back-btn");
        sendBillsBackBtn.on("click", sendBillsBack);

        refundCheck = $(".refund-checkbox input[type='checkbox']");
        refundCheck.on("click", toggleCheckLine);

        refundConfirmBtn = $(".refund-confirm-btn");
        refundConfirmBtn.on("click", confirmRefund);

        refundCancelBtn = $(".refund-cancel-btn");
        refundCancelBtn.on("click", cancelRefund);

        refundBtn = $(".refund-btn");
        refundBtn.on("click", refundAmt);

        refundActionCancelBtn = $(".table-cancel-refund-action");
        refundActionCancelBtn.on("click", cancelRefundPayment);

        refundActionAcceptBtn = $(".table-accept-refund-action");
        refundActionAcceptBtn.on("click", acceptRefundPayment);

        editTicketsNames = $(".edit-tickets-names");
        editTicketsNames.on("click", editInfos);

        chequeBtn = $(".cheque-received");
        chequeBtn.on("click", updateCheckPayment);

        cancelPaymentBtn = $(".cancel-cheque-payment");
        cancelPaymentBtn.on("click", cancelCheckPayment);

        resendBillsToggleBtn = $(".resend-bills-by-date");
        resendBillsToggleBtn.on("click", resendBillsToggle);

        resendBillsBtn = $(".send-bills-by-date-btn");
        resendBillsBtn.on("click", resendBillsByDate);
    };

    $(window).on("load", function () {
        init();
    });
})(jQuery);
(function ($, undefined) {

    'use strict';

    var stickyFooter;
    var stickyFooterMargin;
    var cancelTransactionBtn;
    var eventSelect;
    var directEntranceCheck;
    var sendEmailCheck;
    var continueStep2Btn;
    var continueStep3Btn;
    var saveNewDeliveryBtn;
    var saveNewSendByEmailBtn;
    var submitStepPaymentBtn;
    var toggleDirectEntranceBtn;
    var error = false;

    var sessionDirectEntrance = "virtualCashierDirectEntrance";
    var sessionSendByEmail = "virtualCashierSendByEmail";
    var sessionDeliveryProducts = "virtualCashierDeliveryProducts";

    var setFooterMargin = function setFooterMargin() {
        stickyFooterMargin.css('margin-top', stickyFooter.height() + 20);
    };

    var cancelTransaction = function cancelTransaction() {
        var t = $(this);

        ajax('/action/epAddCart?clear=true&ajax=true', function (response) {
            window.location.href = t.attr('data-forward');
        }, true);
    };

    var saveDirectEntrance = function saveDirectEntrance() {
        var t = $(this);
        session.save(sessionDirectEntrance, t.is(":checked"), function () {});
    };
    var saveSendByEmail = function saveSendByEmail() {
        var t = $(this);
        session.save(sessionSendByEmail, t.is(":checked"), function () {});
        if (!t.is(":checked")) {
            $(".js-form-error-message.fields").slideUp();
            $(".virtual-cash-resp-wrap .form-input.required").each(function () {
                session.save(sessionSendByEmail + $(this).attr("name"), null, function () {});
            });
        }
    };

    var validateStep1 = function validateStep1(e) {
        e.preventDefault();
        var t = $(this);
        t.addClass("disabled");
        var products = t.attr("data-products");
        var onlyProductsLinked = t.attr("data-onlyLinkedProducts");
        var ticketsInCart = 0;
        error = false;

        // count tickets in cart for iframe
        $('.virtual-cash-ticket-ctn .event-one-ticket-ctn > .event-one-ticket-select-qty').each(function () {
            var val = parseInt($(this).find('.event-ticket-select').val());
            ticketsInCart = ticketsInCart + val;
        });

        if (products === 'false' || onlyProductsLinked === 'true') {
            // cannot skip step1 if no products
            var counter = 0;
            $(".virtual-cash-ticket-ctn").each(function () {
                if ($(this).find(".event-ticket-select").length !== 0) {
                    counter += parseInt($(this).find(".event-ticket-select").val());
                }
            });
            if (counter === 0) {
                error = true;
                $(".virtual-cash-step-1-warning-1").slideDown();

                if ($(".virtual-cash-step-1-warning-1").length > 0) {
                    $('html, body').animate({
                        scrollTop: $(".virtual-cash-step-1-warning-1").offset().top
                    }, 2000);
                }
                //Select at least one ticket
            } else {
                $(".virtual-cash-step-1-warning-1").slideUp();
            }
        }
        if (sendEmailCheck.is(":checked") || t.closest('.iframe-wrapper:not(.products-iframe)').length > 0 && (products === 'false' || onlyProductsLinked === 'true' || ticketsInCart !== 0)) {
            var req = false;
            var l = $(".virtual-cash-resp-wrap .form-input.required").length;
            var counter = 0;
            $(".virtual-cash-resp-wrap .form-input.required").each(function () {
                if ($(this).val().trim() === '' || $(this).hasClass("error")) {
                    $(this).addClass("error");
                    error = true;
                    req = true;
                    $(".js-form-error-message.fields").slideDown();
                    t.removeClass("disabled");
                } else {
                    if (t.closest('.iframe-wrapper').length > 0) {
                        session.save(sessionSendByEmail, true, function () {});
                    }
                    session.save(sessionSendByEmail + $(this).attr("name"), encodeURIComponent($(this).val()), function () {
                        counter++;
                        if (counter === l && !error) {
                            window.location = t.attr("href");
                        }
                    });
                }
            });
            if (!req) {
                $(".js-form-error-message.fields").slideUp();
            } else if ($(".error:eq(0)").length > 0) {
                $('html, body').animate({
                    scrollTop: $(".error:eq(0)").offset().top - 90
                }, 2000);
            }
        } else {
            $(".js-form-error-message.fields").slideUp();
            if (!error) {
                window.location = t.attr("href");
            } else {
                t.removeClass("disabled");
            }
        }
    };

    var validateStep2 = function validateStep2(e) {
        e.preventDefault();
        var t = $(this);
        var table = $(".payment-process-table");
        var products = !(table.find(".payment-process-table-row:not(.template)").length === 1);
        var ticketsInCart = t.attr("data-ticketsInCart");
        var delivery;
        var pickup1;
        var pickup2;
        t.addClass("disabled");
        error = false;

        if (products) {
            delivery = $(".payment-process-radio[value = '0']").is(":checked");
            pickup1 = $(".payment-process-radio[value = '1']").is(":checked");
            pickup2 = $(".payment-process-radio[value = '2']").is(":checked");

            if ($('.iframe-wrapper').hasClass('products-iframe') || $('.iframe-wrapper').find('input[name=email]').length > 0) {
                if ($('.iframe-wrapper').hasClass('products-iframe')) {
                    delivery = true;
                }
                session.save(sessionSendByEmail, true, function () {});
                session.save(sessionSendByEmail + 'email', encodeURIComponent($('.iframe-wrapper').find('input[name=email]').val()), function () {});
            }

            if (delivery) {
                var req = false;
                var l = $(".virtual-cash-inputs-ctn .form-input:not(select:not([name = 'country'])), .virtual-cash-inputs-ctn .selected-province").length;
                var counter = 0;
                $(".virtual-cash-inputs-ctn .form-input:not(select:not([name = 'country'])), .virtual-cash-inputs-ctn .selected-province").each(function () {
                    if ($(this).attr("name") !== undefined) {
                        if ($(this).hasClass("required") && $(this).val().trim() === '') {
                            $(this).addClass("error");
                            error = true;
                            req = true;
                            $(".js-form-error-message.fields").slideDown();
                            t.removeClass("disabled");
                        } else {
                            $(this).removeClass("error");
                            session.save(sessionDeliveryProducts + $(this).attr("name"), encodeURIComponent($(this).val()), function () {
                                counter++;
                                if (counter === l && !error) {
                                    window.location = t.attr("href");
                                }
                            });
                        }
                    }
                });
                if (!req) {
                    $(".js-form-error-message.fields").slideUp();
                } else if ($(".error:eq(0)").length > 0) {
                    $('html, body').animate({
                        scrollTop: $(".error:eq(0)").offset().top - 90
                    }, 2000);
                }
            } else if (!pickup1 && !pickup2 && !delivery) {
                $(".virtual-cash-step-2-warning-1").slideDown();
                error = true;
                t.removeClass("disabled");
                if ($(".virtual-cash-step-2-warning-1").length > 0) {
                    $('html, body').animate({
                        scrollTop: $(".virtual-cash-step-2-warning-1").offset().top
                    }, 2000);
                }
            }
        }
        if (!products && ticketsInCart === '0') {
            error = true;
            $(".virtual-cash-step-2-warning-2").slideDown();
            if ($(".virtual-cash-step-2-warning-2").length > 0) {
                $('html, body').animate({
                    scrollTop: $(".virtual-cash-step-2-warning-2").offset().top
                }, 2000);
            }
            t.removeClass("disabled");
        } else {
            $(".virtual-cash-step-2-warning-2").slideUp();

            if (!error && (!products || products && (pickup1 || pickup2 || delivery))) {
                window.location = t.attr("href");
            }
        }
    };

    var saveNewDeliveryAddr = function saveNewDeliveryAddr() {
        var req = false;
        var n = "";
        var addr1 = "";
        var addr2 = "";
        var country = "";
        var fn = "";
        var ln = "";
        var street = "";
        var street2 = "";
        var city = "";
        var province = "";
        var zip = "";
        var ctn = $(this).closest(".virtual-cash-address-box-inputs-ctn");
        ctn.find(".form-input, .selected-province").each(function () {
            var name = $(this).attr("name");
            var val = $(this).val().trim();
            if (name !== undefined) {
                if (name != 'street2' && $(this).hasClass("required") && val === '') {
                    $(this).addClass("error");
                    req = true;
                    error = true;
                    $(".js-form-error-message.fields").slideDown();
                } else {
                    $(this).removeClass("error");
                    session.save(sessionDeliveryProducts + name, encodeURIComponent(val), function () {});
                    if (name === 'firstName') {
                        n = val;
                        fn = val;
                    }
                    if (name === 'lastName') {
                        n += " " + val;
                        ln = val;
                    }
                    if (name === 'street') {
                        addr1 = val;
                        street = val;
                    }
                    if (name === 'street2' && val !== '') {
                        addr1 += ", " + val;
                        street2 = val;
                    }
                    if (name === 'city') {
                        addr2 = val;
                        city = val;
                    }
                    if (name === 'province') {
                        addr2 += ", " + val;
                        province = val;
                    }
                    if (name === 'zip') {
                        addr2 += " " + val;
                        zip = val;
                    }
                    if (name === 'country') {
                        country = val;
                    }
                }
            }
        });
        if (error && $(".error:eq(0)").length > 0) {
            $('html, body').animate({
                scrollTop: $(".error:eq(0)").offset().top - 90
            }, 2000);
        }
        if (!req) {
            $(".js-form-error-message.fields").slideUp();
            $(".virtual-cash-address-ctn").find(".virtual-cash-address-name").text(n);
            $(".virtual-cash-address-ctn").find(".virtual-cash-address-addr1").text(addr1);
            $(".virtual-cash-address-ctn").find(".virtual-cash-address-addr2").text(addr2);
            $(".virtual-cash-address-ctn").find(".virtual-cash-address-country").text(country);

            $(".form-virtual-cashier-del-fn").val(fn);
            $(".form-virtual-cashier-del-ln").val(ln);
            $(".form-virtual-cashier-del-street").val(street);
            $(".form-virtual-cashier-del-street2").val(street2);
            $(".form-virtual-cashier-del-city").val(city);
            $(".form-virtual-cashier-del-province").val(province);
            $(".form-virtual-cashier-del-zip").val(zip);
            $(".form-virtual-cashier-del-country").val(country);
        }
    };

    var saveNewSendByEmail = function saveNewSendByEmail() {
        var req = false;
        var n = "";
        var email = "";
        var fn = "";
        var ln = "";
        var ctn = $(this).closest(".virtual-cash-address-box-inputs-ctn");
        ctn.find(".form-input[name != ''], .selected-province").each(function () {
            var name = $(this).attr("name");
            var val = $(this).val().trim();
            if (name !== undefined) {
                if ($(this).hasClass("required") && val === '') {
                    $(this).addClass("error");
                    req = true;
                    $(".js-form-error-message.fields").slideDown();
                } else {
                    $(this).removeClass("error");
                    session.save(sessionSendByEmail + name, encodeURIComponent(val), function () {});
                    if (name === 'buyerFirstName') {
                        n = val;
                        fn = val;
                    }
                    if (name === 'buyerLastName') {
                        n += " " + val;
                        ln = val;
                    }
                    if (name === 'email') {
                        email = val;
                    }
                }
            }
        });
        if (!req) {
            $(".js-form-error-message.fields").slideUp();
            $(".virtual-cash-send-by-email-ctn").find(".virtual-cash-send-by-email-name").text(n);
            $(".virtual-cash-send-by-email-ctn").find(".virtual-cash-send-by-email-email").text(email);
            $(".form-virtual-cashier-email").val(email);
            $(".form-virtual-cashier-fn").val(fn);
            $(".form-virtual-cashier-ln").val(ln);
        } else if ($(".error:eq(0)").length > 0) {
            $('html, body').animate({
                scrollTop: $(".error:eq(0)").offset().top - 90
            }, 2000);
        }
    };

    var submitPaymentForm = function submitPaymentForm() {
        var t = $(this);
        error = false;
        t.addClass("disabled");
        if ($(".vc-payment-box-inputs-ctn").length !== 0) {
            $(".vc-payment-box-inputs-ctn .form-input.required").each(function () {
                var val = $(this).val().trim();
                if (val === '') {
                    error = true;
                    $(this).addClass("error");
                    t.removeClass("disabled");
                }
            });
        }
        // if step 3 delivery chosen, validate/save address
        if ($('.virtual-cash-address-box-merch:not(.hide)').length > 0 && ($('.virtual-cash-address-box-merch').find('.virtual-cash-address-box-inputs-ctn').css('display') === 'block' || $('.virtual-cash-address-box-merch').find('.form-input.required[val=""]').length > 0)) {
            saveNewDeliveryBtn.trigger('click');
            t.removeClass("disabled");
        }
        if (!error) {
            t.addClass("disabled");
            $(".virtual-cash-form").submit();
        } else if ($(".error:eq(0)").length > 0) {
            $('html, body').animate({
                scrollTop: $(".error:eq(0)").offset().top - 90
            }, 2000);
            $(".js-form-error-message.fields").slideDown();
        }
    };

    var toggleDirectEntrance = function toggleDirectEntrance() {
        var t = $(this);
        var url = "/action/epQR";
        url += "?validate=" + t.attr("data-1");
        url += "&paymentToken=" + t.attr("data-2");
        url += "&scan=" + (t.attr("data-3") !== "true");

        ajax(url, function (response) {
            if (response.indexOf("success") !== -1) {
                t.toggleClass("checked");
                t.attr("data-3", t.attr("data-3") !== "true");
            }
        }, true);
    };

    var init = function init() {
        stickyFooter = $('.virtual-cash-steps-outer-ctn');
        stickyFooterMargin = $('.virtual-cash-steps-margin');
        cancelTransactionBtn = $('.virtual-cash-cancel-btn');
        eventSelect = $('.virtual-cash-select-event');
        directEntranceCheck = $('.check-direct-entrance input[name="directEntrance"]');
        sendEmailCheck = $('.check-send-by-email input[name="sendByEmail"]');
        continueStep2Btn = $('.virtual-cashier-continue-step2');
        continueStep3Btn = $('.virtual-cashier-continue-step3');
        saveNewDeliveryBtn = $('.save-new-delivery-address-btn');
        saveNewSendByEmailBtn = $('.save-new-send-by-email-btn');
        submitStepPaymentBtn = $('.virtual-cashier-submit-form');
        toggleDirectEntranceBtn = $('.vc-confirm-step-btn.entrance');

        cancelTransactionBtn.click(cancelTransaction);
        eventSelect.click(cancelTransaction);
        directEntranceCheck.click(saveDirectEntrance);
        sendEmailCheck.click(saveSendByEmail);
        continueStep2Btn.click(validateStep1);
        continueStep3Btn.click(validateStep2);
        saveNewDeliveryBtn.click(saveNewDeliveryAddr);
        saveNewSendByEmailBtn.click(saveNewSendByEmail);
        submitStepPaymentBtn.click(submitPaymentForm);
        toggleDirectEntranceBtn.click(toggleDirectEntrance);
        setFooterMargin();
        $(window).resize(function () {
            setFooterMargin();
        });
        if (window.location.href.indexOf("fail") > -1) {
            $(".vc-payment-box-inputs-fail").slideDown();
        }
    };

    $(window).on("load", function () {
        init();
    });
})(jQuery);
var MIME_IMAGE = {
    ".gif"  : "image/gif",
    ".jpeg" : "image/jpeg",
    ".jpg"  : "image/jpeg",
    ".png"  : "image/png"
};

function cropImageEdit(id) {
    var editor = document.getElementById(id),
        ctrler = editor.querySelector(".imed-ctrl"),
        sizer = editor.querySelector(".imed-res"),
        img1 = editor.querySelector(".iei1"),
        img2 = editor.querySelector(".iei2"),
        scaler = editor.querySelector(".imed-sca"),
        moving = false,
        uploadName = editor.querySelector(".file-upload-title"),
        uploadFile = editor.querySelector(".file-upload-input"),
        inputEditing = editor.querySelector(".imed-ie"),
        inputDeleting = null;

    var oe = {
        mouseX: 0,
        mouseY: 0,
        imgX: 0,
        imgY: 0,
        baseW: 8,
        baseH: 8,
        cropW: sizer.clientWidth,
        cropH: sizer.clientHeight,
        ratio: sizer.clientWidth / sizer.clientHeight,
        scaleratio: 1,
        scaleby: "width",
        limit: {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            minWidth: 8,
            maxWidth: 4000,
            minHeight: 8,
            maxHeight: 4000,
            minScale: 5,
            maxScale: 180
        },
        mediaId: editor.querySelector(".imed-mi").value,
        curSrc: editor.querySelector(".imed-cur").src,
        defSrc: img1.src
    };
    
    function checkFile(e, el) {
        var file = el.files[0],
            ext = file.name.substr(file.name.lastIndexOf(".")).toLowerCase(),
            lang = document.documentElement.lang;
    
        if (!(ext in MIME_IMAGE)) {
            uploadName.value = lang === "fr" ? "Fichier invalid" : "Invalid file";
            return false;
        }
        if (file.size < 160 || file.size > 10485760) {
            uploadName.value = lang === "fr" ? "Fichier est trop large ou trop petit" 
                    : "File is too large or too small";
            return false;
        }
        return true;
    }
    function loadFile(e) {
        if (!checkFile(e, this)) {
            this.value = "";
            $(uploadName).addClass("error");
            return false;
        } else {
            $(uploadName).removeClass("error");
        }
        
        var newImg1 = document.createElement("IMG"),
            newImg2 = document.createElement("IMG");
    
        newImg1.src = newImg2.src = window.URL.createObjectURL(e.target.files[0]);
        newImg1.className = img1.className;
        newImg2.className = img2.className;
        newImg1.onload = function() {
            editor.querySelector(".imed-pho").replaceChild(newImg1, img1);
            sizer.replaceChild(newImg2, img2);
            img1 = newImg1;
            img2 = newImg2;
            toggleMedia(true);
            start();
        };
    }
    
    function start() {
        checkCropArea();
        initImage();
        setScaleLimit();
    }
    function checkCropArea() {
        var zoneW = editor.querySelector(".imed-zo1-inner").clientWidth;
        if (oe.cropW > zoneW) {
            var area = editor.querySelector(".imed-pho");
            area.style.width = zoneW + "px";
            area.style.height = Math.round(zoneW / oe.ratio) + "px";
            oe.scaleratio = zoneW / oe.cropW;
            oe.cropW = zoneW;
            oe.cropH = area.clientHeight;
            scaler.setAttribute("data-min-width", oe.cropW);
            scaler.setAttribute("data-min-height", oe.cropH);
        }
    }
    function initImage() {
        oe.baseW = Math.round(img1.naturalWidth * oe.scaleratio);
        oe.baseH = Math.round(img1.naturalHeight * oe.scaleratio);
        if (oe.baseW / oe.baseH > oe.ratio) {
            oe.scaleby = "height";
            istyle("height", Math.max(oe.baseH, oe.cropH) + "px");
            istyle("width", "");
        } else {
            oe.scaleby = "width";
            istyle("width", Math.max(oe.baseW, oe.cropW) + "px");
            istyle("height", "");
        }
        setPositionLimit();
        imove((oe.cropW - img1.width) / 2, (oe.cropH - img1.height) / 2);
        setPosition();
    }
    
    function setPositionLimit() {
        oe.limit.right = oe.cropW - img1.width;
        oe.limit.bottom = oe.cropH - img1.height;
    }
    function setScaleLimit() {
        var data = $(scaler).data();
        if (!parseInt(data.maxWidth)) data.maxWidth = 4000;
        if (!parseInt(data.maxHeight)) data.maxHeight = 4000;
        
        data.minScale = Math.max(oe.cropW / oe.baseW, oe.cropH / oe.baseH, 0.05) * 100;
        data.minScale = data.minScale.toFixed(4);
        data.maxScale = Math.max(data.minScale, 100) + 80;
        scaler.setAttribute("max", data.maxScale);
        scaler.setAttribute("min", data.minScale);
        scaler.value = Math.max(data.minScale, 100);
        
        Object.assign(oe.limit, data);
    }
    function setPosition() {
        oe.imgX = img1.offsetLeft;
        oe.imgY = img1.offsetTop;
    }
    
    function mdown(e) {
        e.preventDefault();
        e.stopPropagation();
        moving = true;
        var orEv = e.originalEvent || e;
        oe.mouseX = e.pageX || e.clientX || orEv.touches[0].clientX;
        oe.mouseY = e.pageY || e.clientY || orEv.touches[0].clientY;
    }
    function mmove(e) {
        e.preventDefault();
        if (moving) {
            var orEv = e.originalEvent || e;
            var x = e.pageX || e.clientX || orEv.touches[0].clientX;
            var y = e.pageY || e.clientY || orEv.touches[0].clientY;
            imove(oe.imgX + x - oe.mouseX, oe.imgY + y - oe.mouseY);
        }
    }
    function mup(e) {
        e.preventDefault();
        moving = false;
        setPosition();
        iput();
    }
    
    function imove(x, y) {
        if (img1.width >= oe.cropW) {
            istyle("left", within(x, oe.limit.right, oe.limit.left) + "px");
        } else {
            istyle("left", within(x, oe.limit.left, oe.limit.right) + "px");
        }
        if (img1.height >= oe.cropH) {
            istyle("top", within(y, oe.limit.bottom, oe.limit.top) + "px");
        } else {
            istyle("top", within(y, oe.limit.top, oe.limit.bottom) + "px");
        }
    }
    function iresize(e) {
        var w = img1.width,
            h = img1.height,
            nw = within(Math.round(oe.baseW * (scaler.value / 100)), oe.limit.minWidth, oe.limit.maxWidth),
            nh = within(Math.round(oe.baseH * (scaler.value / 100)), oe.limit.minHeight, oe.limit.maxHeight);
        
        if (oe.scaleby === "width") {
            istyle("width", nw + "px");
            istyle("height", "");
        } else {
            istyle("width", "");
            istyle("height", nh + "px");
        }
        setPositionLimit();
        imove(oe.imgX - (nw - w) / 2, oe.imgY - (nh - h) / 2);
        setPosition();
    }
    function istyle(prop, val) {
        img1.style[prop] = img2.style[prop] = val;
    }
    function within(value, min, max) {
        return value < min ? min : value > max ? max : value;
    }
    function iput() {
        editor.querySelector(".imed-ox").value = Math.round(-oe.imgX / oe.scaleratio);
        editor.querySelector(".imed-oy").value = Math.round(-oe.imgY / oe.scaleratio);
        editor.querySelector(".imed-sr").value = scaler.value / 100;
    }
    
    function toggleMedia(active) {
        if (active) {
            $(editor).removeClass("nosrc").removeClass("hascrop");
            inputEditing.value = "true";
        } else {
            $(editor).addClass("nosrc");
            inputEditing.value = "";
            $(uploadFile).val("").change();
            $(uploadName).val("").removeClass("error");
            if (oe.mediaId !== "" && parseInt(oe.mediaId) > 0 && oe.curSrc.length > 1) {
                $(editor).addClass("hascrop");
                $(uploadName).parent().removeClass("error");
            }
        }
    }
    function toggleDelete(active) {
        if (active) {
            inputDeleting = document.createElement("INPUT");
            inputDeleting.type = "hidden";
            inputDeleting.name = "delProfilePic";
            inputDeleting.value = "true";
            editor.appendChild(inputDeleting);
            $(editor).addClass("removal");
        } else {
            if (inputDeleting) {
                editor.removeChild(inputDeleting);
                inputDeleting = null;
            }
            $(editor).removeClass("removal");
        }
    }
    function cancel(e) {
        toggleMedia(false);
    }
    function edit(e) {
        img1.src = img2.src = oe.defSrc;
        setTimeout(function() {
            toggleDelete(false);
            toggleMedia(true);
            start();
        }, 100);
    }
    function remove(e) {
        toggleDelete(!$(editor).hasClass("removal"));
    }
    // In case the container is not displayed, try to reinitiate until the 
    // crop's dimension is calculated.
    function checkSizer() {
        if (sizer.clientHeight > 0 && oe.cropH <= 0 && !oe.ratio) {
            oe.cropW = sizer.clientWidth;
            oe.cropH = sizer.clientHeight;
            oe.ratio = sizer.clientWidth / sizer.clientHeight;
            start();
        } else {
            setTimeout(checkSizer, 1000);
        }
    }
    
    /* Initiate */
    if (img1.width > 0 && img2.width > 0 && oe.cropH > 0 && oe.ratio) {
        start();
    }
    checkSizer();
    
    ctrler.addEventListener("mousedown", mdown);
    ctrler.addEventListener("mousemove", mmove);
    ctrler.addEventListener("mouseup", mup);
    ctrler.addEventListener("mouseout", mup);
    ctrler.addEventListener("touchstart", mdown);
    ctrler.addEventListener("touchmove", mmove);
    ctrler.addEventListener("touchend", mup);
    ctrler.addEventListener("touchcancel", mup);
    scaler.addEventListener("input", iresize);
    scaler.addEventListener("change", iresize); //For IE11
    scaler.addEventListener("change", mup);
    
    uploadFile.addEventListener("change", loadFile);
    
    editor.querySelector(".imed-can").addEventListener("click", cancel);
    editor.querySelector(".imed-mod").addEventListener("click", edit);
    try {
        editor.querySelector(".imed-del").addEventListener("click", remove);
    } catch (ex) {
    }
}


if (window.location.protocol == 'file:') {
    alert('To test this demo properly please use a local server such as XAMPP or WAMP. See README.md for more details.');
}

var resizeableImage = function (image_target_sel, fileInput) {
    // Some variable and settings
    var $container,
            orig_src = new Image(),
            image_target = $(image_target_sel).get(0),
            event_state = {},
            constrain = false,
            min_width = 60, // Change as required
            min_height = 60,
            max_width = 800, // Change as required
            max_height = 900,
            file_input = fileInput,
            resize_canvas = document.createElement('canvas');

    var init = function () {

        // When resizing, we will always use this copy of the original as the base
        orig_src.src = image_target.src;

        // Wrap the image with the container and add resize handles
        $(image_target).wrap('<div class="resize-container"></div>')
                .before('<span class="resize-handle resize-handle-nw"></span>')
                .before('<span class="resize-handle resize-handle-ne"></span>')
                .after('<span class="resize-handle resize-handle-se"></span>')
                .after('<span class="resize-handle resize-handle-sw"></span>');

        // Assign the container to a variable
        $container = $(image_target).parent('.resize-container');

        // Add events
        $container.on('mousedown touchstart', '.resize-handle', startResize);
        $container.on('mousedown touchstart', 'img', startMoving);
        $('.js-crop').on('click', crop);
    };

    startResize = function (e) {
        e.preventDefault();
        e.stopPropagation();
        saveEventState(e);
        $(document).on('mousemove touchmove', resizing);
        $(document).on('mouseup touchend', endResize);
    };

    endResize = function (e) {
        e.preventDefault();
        $(document).off('mouseup touchend', endResize);
        $(document).off('mousemove touchmove', resizing);
    };

    saveEventState = function (e) {
        // Save the initial event details and container state
        event_state.container_width = $container.width();
        event_state.container_height = $container.height();
        event_state.container_left = $container.offset().left;
        event_state.container_top = $container.offset().top;
        event_state.mouse_x = (e.clientX || e.pageX || e.originalEvent.touches[0].clientX) + $(window).scrollLeft();
        event_state.mouse_y = (e.clientY || e.pageY || e.originalEvent.touches[0].clientY) + $(window).scrollTop();

        // This is a fix for mobile safari
        // For some reason it does not allow a direct copy of the touches property
        if (typeof e.originalEvent.touches !== 'undefined') {
            event_state.touches = [];
            $.each(e.originalEvent.touches, function (i, ob) {
                event_state.touches[i] = {};
                event_state.touches[i].clientX = 0 + ob.clientX;
                event_state.touches[i].clientY = 0 + ob.clientY;
            });
        }
        event_state.evnt = e;
    };

    resizing = function (e) {
        var mouse = {}, width, height, left, top, offset = $container.offset();
        mouse.x = (e.clientX || e.pageX || e.originalEvent.touches[0].clientX) + $(window).scrollLeft();
        mouse.y = (e.clientY || e.pageY || e.originalEvent.touches[0].clientY) + $(window).scrollTop();

        // Position image differently depending on the corner dragged and constraints
        if ($(event_state.evnt.target).hasClass('resize-handle-se')) {
            width = mouse.x - event_state.container_left;
            height = mouse.y - event_state.container_top;
            left = event_state.container_left;
            top = event_state.container_top;
        } else if ($(event_state.evnt.target).hasClass('resize-handle-sw')) {
            width = event_state.container_width - (mouse.x - event_state.container_left);
            height = mouse.y - event_state.container_top;
            left = mouse.x;
            top = event_state.container_top;
        } else if ($(event_state.evnt.target).hasClass('resize-handle-nw')) {
            width = event_state.container_width - (mouse.x - event_state.container_left);
            height = event_state.container_height - (mouse.y - event_state.container_top);
            left = mouse.x;
            top = mouse.y;
            if (constrain || e.shiftKey) {
                top = mouse.y - ((width / orig_src.width * orig_src.height) - height);
            }
        } else if ($(event_state.evnt.target).hasClass('resize-handle-ne')) {
            width = mouse.x - event_state.container_left;
            height = event_state.container_height - (mouse.y - event_state.container_top);
            left = event_state.container_left;
            top = mouse.y;
            if (constrain || e.shiftKey) {
                top = mouse.y - ((width / orig_src.width * orig_src.height) - height);
            }
        }

        // Optionally maintain aspect ratio
        if (constrain || e.shiftKey) {
            height = width / orig_src.width * orig_src.height;
        }

        if (width > min_width && height > min_height && width < max_width && height < max_height) {
            // To improve performance you might limit how often resizeImage() is called
            resizeImage(width, height);
            // Without this Firefox will not re-calculate the the image dimensions until drag end
            $container.offset({'left': left, 'top': top});
        }
    };

    resizeImage = function (width, height) {
        resize_canvas.width = width;
        resize_canvas.height = height;
        resize_canvas.getContext('2d').drawImage(orig_src, 0, 0, width, height);
        $(image_target).attr('src', resize_canvas.toDataURL("image/png"));
        file_input.attr("value", orig_src.src);
    };

    startMoving = function (e) {
        e.preventDefault();
        e.stopPropagation();
        saveEventState(e);
        $(document).on('mousemove touchmove', moving);
        $(document).on('mouseup touchend', endMoving);
    };

    endMoving = function (e) {
        e.preventDefault();
        $(document).off('mouseup touchend', endMoving);
        $(document).off('mousemove touchmove', moving);
    };

    moving = function (e) {
        var mouse = {}, touches;
        e.preventDefault();
        e.stopPropagation();

        touches = e.originalEvent.touches;

        mouse.x = (e.clientX || e.pageX || touches[0].clientX) + $(window).scrollLeft();
        mouse.y = (e.clientY || e.pageY || touches[0].clientY) + $(window).scrollTop();
        $container.offset({
            'left': mouse.x - (event_state.mouse_x - event_state.container_left),
            'top': mouse.y - (event_state.mouse_y - event_state.container_top)
        });
        // Watch for pinch zoom gesture while moving
        if (event_state.touches && event_state.touches.length > 1 && touches.length > 1) {
            var width = event_state.container_width, height = event_state.container_height;
            var a = event_state.touches[0].clientX - event_state.touches[1].clientX;
            a = a * a;
            var b = event_state.touches[0].clientY - event_state.touches[1].clientY;
            b = b * b;
            var dist1 = Math.sqrt(a + b);

            a = e.originalEvent.touches[0].clientX - touches[1].clientX;
            a = a * a;
            b = e.originalEvent.touches[0].clientY - touches[1].clientY;
            b = b * b;
            var dist2 = Math.sqrt(a + b);

            var ratio = dist2 / dist1;

            width = width * ratio;
            height = height * ratio;
            // To improve performance you might limit how often resizeImage() is called
            resizeImage(width, height);
        }
    };

    crop = function () {
        //Find the part of the image that is inside the crop box
        var crop_canvas,
                left = $('.overlay-crop').offset().left - $container.offset().left,
                top = $('.overlay-crop').offset().top - $container.offset().top,
                width = $('.overlay-crop').width(),
                height = $('.overlay-crop').height();

        crop_canvas = document.createElement('canvas');
        crop_canvas.width = width;
        crop_canvas.height = height;

        crop_canvas.getContext('2d').drawImage(image_target, left, top, width, height, 0, 0, width, height);
        $(image_target).attr("src", crop_canvas.toDataURL("image/png"));
        left = $('.overlay-crop').offset().left - $container.offset().left;
        top = $('.overlay-crop').offset().top - $container.offset().top;
        $container.css("top", top);
        $container.css("left", left);
        orig_src.src = crop_canvas.toDataURL("image/png");
        file_input.attr("value", orig_src);
    };

    init();
};

// Kick everything off with the target image
//resizeableImage($('.resize-image'));
/**
 * Gets styles by a classname
 * 
 * @notice The className must be 1:1 the same as in the CSS
 * @param string className_
 */
function getStyle(className_) {

    var styleSheets = document.styleSheets;
    var styleSheetsLength = styleSheets.length;
    for(var i = 0; i < styleSheetsLength; i++){
        try {
            var classes = styleSheets[i].rules || styleSheets[i].cssRules;
            if (classes !== null) {
                var classesLength = classes.length;
                for (var x = 0; x < classesLength; x++) {
                    if (classes[x].selectorText == className_) {
                        var ret = classes[x].style.cssText;
                        return ret;
                    }
                }
            } else {
                return ' ';
            }
        }
        catch (e) {
        }
    }

}
/*!
 * jQuery Mobile Events
 * By: Sam Delgado (https://rizerapp.com), Ben Major (http://www.ben-major.co.uk), and hachigoro (https://github.com/hachigoro)
 *
 * Copyright 2011-2015, Ben Major - Copyright 2016, Sam Delgado
 * Licensed under the MIT License:
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *
 */

function loadTouchEvents($) {

  $.attrFn = $.attrFn || {};

  // navigator.userAgent.toLowerCase() isn't reliable for Chrome installs
  // on mobile devices. As such, we will create a boolean isChromeDesktop
  // The reason that we need to do this is because Chrome annoyingly
  // purports support for touch events even if the underlying hardware
  // does not!
  var agent = navigator.userAgent.toLowerCase(),
      isChromeDesktop = (agent.indexOf('chrome') > -1 && ((agent.indexOf('windows') > -1) || (agent.indexOf('macintosh') > -1) || (agent.indexOf('linux') > -1)) && agent.indexOf('mobile') < 0 && agent.indexOf('android') < 0),

      settings = {
          tap_pixel_range: 5,
          swipe_h_threshold: 50,
          swipe_v_threshold: 50,
          taphold_threshold: 750,
          doubletap_int: 500,

          touch_capable: ('ontouchstart' in window && !isChromeDesktop),
          orientation_support: ('orientation' in window && 'onorientationchange' in window),

          // startevent:  (('ontouchstart' in window && !isChromeDesktop) ? 'touchstart' : 'mousedown'),
          // endevent:    (('ontouchstart' in window && !isChromeDesktop) ? 'touchend' : 'mouseup'),
          // moveevent:   (('ontouchstart' in window && !isChromeDesktop) ? 'touchmove' : 'mousemove'),
       	  startevent:  'touchstart',
          endevent:    'touchend',
          moveevent:   'touchmove',
          tapevent:    ('ontouchstart' in window && !isChromeDesktop) ? 'tap' : 'click',
          scrollevent: ('ontouchstart' in window && !isChromeDesktop) ? 'touchmove' : 'scroll',

          hold_timer: null,
          tap_timer: null
      };

  // Convenience functions:
  $.isTouchCapable = function() { return settings.touch_capable; };
  $.getStartEvent  = function() { return settings.startevent;    };
  $.getEndEvent    = function() { return settings.endevent;      };
  $.getMoveEvent   = function() { return settings.moveevent;     };
  $.getTapEvent    = function() { return settings.tapevent;      };
  $.getScrollEvent = function() { return settings.scrollevent;   };

  // Add Event shortcuts:
  $.each(['tapstart', 'tapend', 'tapmove', 'tap', 'tap2', 'tap3', 'tap4', 'singletap', 'doubletap', 'taphold', 'swipe', 'swipeup', 'swiperight', 'swipedown', 'swipeleft', 'swipeend', 'scrollstart', 'scrollend', 'orientationchange'], function (i, name) {
      $.fn[name] = function (fn) {
          return fn ? this.on(name, fn) : this.trigger(name);
      };

      $.attrFn[name] = true;
  });

  // tapstart Event:
  $.event.special.tapstart = {
      setup: function () {

          var thisObject = this,
              $this = $(thisObject);

          $this.on(settings.startevent, function tapStartFunc(e) {

              $this.data('callee', tapStartFunc);
              if (e.which && e.which !== 1) {
                  return false;
              }

              var origEvent = e.originalEvent,
                  touchData = {
                      'position': {
                          'x': ((settings.touch_capable) ? origEvent.touches[0].screenX : e.screenX),
                          'y': (settings.touch_capable) ? origEvent.touches[0].screenY : e.screenY
                      },
                      'offset': {
                          'x': (settings.touch_capable) ? Math.round(origEvent.changedTouches[0].pageX - ($this.offset() ? $this.offset().left : 0)) : Math.round(e.pageX - ($this.offset() ? $this.offset().left : 0)),
                          'y': (settings.touch_capable) ? Math.round(origEvent.changedTouches[0].pageY - ($this.offset() ? $this.offset().top : 0)) : Math.round(e.pageY - ($this.offset() ? $this.offset().top : 0))
                      },
                      'time': Date.now(),
                      'target': e.target
                  };

              triggerCustomEvent(thisObject, 'tapstart', e, touchData);
              return true;
          });
      },

      remove: function () {
          $(this).off(settings.startevent, $(this).data.callee);
      }
  };

  // tapmove Event:
  $.event.special.tapmove = {
  	setup: function() {
          var thisObject = this,
          $this = $(thisObject);

          $this.on(settings.moveevent, function tapMoveFunc(e) {
              $this.data('callee', tapMoveFunc);

              var origEvent = e.originalEvent,
                  touchData = {
                      'position': {
                          'x': ((settings.touch_capable) ? origEvent.touches[0].screenX : e.screenX),
                          'y': (settings.touch_capable) ? origEvent.touches[0].screenY : e.screenY
                      },
                      'offset': {
                          'x': (settings.touch_capable) ? Math.round(origEvent.changedTouches[0].pageX - ($this.offset() ? $this.offset().left : 0)) : Math.round(e.pageX - ($this.offset() ? $this.offset().left : 0)),
  					'y': (settings.touch_capable) ? Math.round(origEvent.changedTouches[0].pageY - ($this.offset() ? $this.offset().top : 0)) : Math.round(e.pageY - ($this.offset() ? $this.offset().top : 0))
                      },
                      'time': Date.now(),
                      'target': e.target
                  };

              triggerCustomEvent(thisObject, 'tapmove', e, touchData);
              return true;
          });
      },
      remove: function() {
          $(this).off(settings.moveevent, $(this).data.callee);
      }
  };

  // tapend Event:
  $.event.special.tapend = {
      setup: function () {
          var thisObject = this,
              $this = $(thisObject);

          $this.on(settings.endevent, function tapEndFunc(e) {
              // Touch event data:
              $this.data('callee', tapEndFunc);

              var origEvent = e.originalEvent;
              var touchData = {
                  'position': {
                      'x': (settings.touch_capable) ? origEvent.changedTouches[0].screenX : e.screenX,
                      'y': (settings.touch_capable) ? origEvent.changedTouches[0].screenY : e.screenY
                  },
                  'offset': {
                      'x': (settings.touch_capable) ? Math.round(origEvent.changedTouches[0].pageX - ($this.offset() ? $this.offset().left : 0)) : Math.round(e.pageX - ($this.offset() ? $this.offset().left : 0)),
                      'y': (settings.touch_capable) ? Math.round(origEvent.changedTouches[0].pageY - ($this.offset() ? $this.offset().top : 0)) : Math.round(e.pageY - ($this.offset() ? $this.offset().top : 0))
                  },
                  'time': Date.now(),
                  'target': e.target
              };
              triggerCustomEvent(thisObject, 'tapend', e, touchData);
              return true;
          });
      },
      remove: function () {
          $(this).off(settings.endevent, $(this).data.callee);
      }
  };

  // taphold Event:
  $.event.special.taphold = {
      setup: function () {
          var thisObject = this,
              $this = $(thisObject),
              origTarget,
              start_pos = {
                  x: 0,
                  y: 0
              },
              end_x = 0,
              end_y = 0;

          $this.on(settings.startevent, function tapHoldFunc1(e) {
              if (e.which && e.which !== 1) {
                  return false;
              } else {
                  $this.data('tapheld', false);
                  origTarget = e.target;

                  var origEvent = e.originalEvent;
                  var start_time = Date.now(),
                      startPosition = {
                          'x': (settings.touch_capable) ? origEvent.touches[0].screenX : e.screenX,
                          'y': (settings.touch_capable) ? origEvent.touches[0].screenY : e.screenY
                      },
                      startOffset = {
                          'x': (settings.touch_capable) ? origEvent.touches[0].pageX - origEvent.touches[0].target.offsetLeft : e.offsetX,
                          'y': (settings.touch_capable) ? origEvent.touches[0].pageY - origEvent.touches[0].target.offsetTop : e.offsetY
                      };

                  start_pos.x = (e.originalEvent.targetTouches) ? e.originalEvent.targetTouches[0].pageX : e.pageX;
                  start_pos.y = (e.originalEvent.targetTouches) ? e.originalEvent.targetTouches[0].pageY : e.pageY;

                  end_x = start_pos.x;
                  end_y = start_pos.y;

                  settings.hold_timer = window.setTimeout(function () {

                      var diff_x = (start_pos.x - end_x),
                          diff_y = (start_pos.y - end_y);

                      if (e.target == origTarget && ((start_pos.x == end_x && start_pos.y == end_y) || (diff_x >= -(settings.tap_pixel_range) && diff_x <= settings.tap_pixel_range && diff_y >= -(settings.tap_pixel_range) && diff_y <= settings.tap_pixel_range))) {
                          $this.data('tapheld', true);

                          var end_time = Date.now(),
                              endPosition = {
                                  'x': (settings.touch_capable) ? origEvent.touches[0].screenX : e.screenX,
                                  'y': (settings.touch_capable) ? origEvent.touches[0].screenY : e.screenY
                              },
                              endOffset = {
                                  'x': (settings.touch_capable) ? Math.round(origEvent.changedTouches[0].pageX - ($this.offset() ? $this.offset().left : 0)) : Math.round(e.pageX - ($this.offset() ? $this.offset().left : 0)),
  							'y': (settings.touch_capable) ? Math.round(origEvent.changedTouches[0].pageY - ($this.offset() ? $this.offset().top : 0)) : Math.round(e.pageY - ($this.offset() ? $this.offset().top : 0))
                              };
                          var duration = end_time - start_time;

                          // Build the touch data:
                          var touchData = {
                              'startTime': start_time,
                              'endTime': end_time,
                              'startPosition': startPosition,
                              'startOffset': startOffset,
                              'endPosition': endPosition,
                              'endOffset': endOffset,
                              'duration': duration,
                              'target': e.target
                          };
                          $this.data('callee1', tapHoldFunc1);
                          triggerCustomEvent(thisObject, 'taphold', e, touchData);
                      }
                  }, settings.taphold_threshold);

                  return true;
              }
          }).on(settings.endevent, function tapHoldFunc2() {
              $this.data('callee2', tapHoldFunc2);
              $this.data('tapheld', false);
              window.clearTimeout(settings.hold_timer);
          })
          .on(settings.moveevent, function tapHoldFunc3(e) {
              $this.data('callee3', tapHoldFunc3);

              end_x = (e.originalEvent.targetTouches) ? e.originalEvent.targetTouches[0].pageX : e.pageX;
              end_y = (e.originalEvent.targetTouches) ? e.originalEvent.targetTouches[0].pageY : e.pageY;
          });
      },

      remove: function () {
          $(this).off(settings.startevent, $(this).data.callee1).off(settings.endevent, $(this).data.callee2).off(settings.moveevent, $(this).data.callee3);
      }
  };

  // doubletap Event:
  $.event.special.doubletap = {
      setup: function () {
          var thisObject = this,
              $this = $(thisObject),
              origTarget,
              action,
              firstTap = null,
              origEvent,
  		cooloff,
  		cooling = false;

          $this.on(settings.startevent, function doubleTapFunc1(e) {
              if (e.which && e.which !== 1) {
                  return false;
              }
              $this.data('doubletapped', false);
              origTarget = e.target;
              $this.data('callee1', doubleTapFunc1);

              origEvent = e.originalEvent;
              if (!firstTap) {
                  firstTap = {
                      'position': {
                          'x': (settings.touch_capable) ? origEvent.touches[0].screenX : e.screenX,
                          'y': (settings.touch_capable) ? origEvent.touches[0].screenY : e.screenY
                      },
                      'offset': {
                          'x': (settings.touch_capable) ? Math.round(origEvent.changedTouches[0].pageX - ($this.offset() ? $this.offset().left : 0)) : Math.round(e.pageX - ($this.offset() ? $this.offset().left : 0)),
                          'y': (settings.touch_capable) ? Math.round(origEvent.changedTouches[0].pageY - ($this.offset() ? $this.offset().top : 0)) : Math.round(e.pageY - ($this.offset() ? $this.offset().top : 0))
                      },
                      'time': Date.now(),
                      'target': e.target
                  };
              }

              return true;
          }).on(settings.endevent, function doubleTapFunc2(e) {

              var now = Date.now();
              var lastTouch = $this.data('lastTouch') || now + 1;
              var delta = now - lastTouch;
              window.clearTimeout(action);
              $this.data('callee2', doubleTapFunc2);

              if (delta < settings.doubletap_int && (e.target == origTarget) && delta > 100) {
                  $this.data('doubletapped', true);
                  window.clearTimeout(settings.tap_timer);

                  // Now get the current event:
                  var lastTap = {
                      'position': {
                          'x': (settings.touch_capable) ? e.originalEvent.changedTouches[0].screenX : e.screenX,
                          'y': (settings.touch_capable) ? e.originalEvent.changedTouches[0].screenY : e.screenY
                      },
                      'offset': {
                          'x': (settings.touch_capable) ? Math.round(origEvent.changedTouches[0].pageX - ($this.offset() ? $this.offset().left : 0)) : Math.round(e.pageX - ($this.offset() ? $this.offset().left : 0)),
                          'y': (settings.touch_capable) ? Math.round(origEvent.changedTouches[0].pageY - ($this.offset() ? $this.offset().top : 0)) : Math.round(e.pageY - ($this.offset() ? $this.offset().top : 0))
                      },
                      'time': Date.now(),
                      'target': e.target
                  };

                  var touchData = {
                      'firstTap': firstTap,
                      'secondTap': lastTap,
                      'interval': lastTap.time - firstTap.time
                  };

                  if (!cooling) {
                  	triggerCustomEvent(thisObject, 'doubletap', e, touchData);
                      firstTap = null;
                  }

                  cooling = true;

                  cooloff = window.setTimeout(function () {
                  	cooling = false;
                  }, settings.doubletap_int);

              } else {
                  $this.data('lastTouch', now);
                  action = window.setTimeout(function () {
                      firstTap = null;
                      window.clearTimeout(action);
                  }, settings.doubletap_int, [e]);
              }
              $this.data('lastTouch', now);
          });
      },
      remove: function () {
          $(this).off(settings.startevent, $(this).data.callee1).off(settings.endevent, $(this).data.callee2);
      }
  };

  // singletap Event:
  // This is used in conjuction with doubletap when both events are needed on the same element
  $.event.special.singletap = {
      setup: function () {
          var thisObject = this,
              $this = $(thisObject),
              origTarget = null,
              startTime = null,
              start_pos = {
                  x: 0,
                  y: 0
              };

          $this.on(settings.startevent, function singleTapFunc1(e) {
              if (e.which && e.which !== 1) {
                  return false;
              } else {
                  startTime = Date.now();
                  origTarget = e.target;
                  $this.data('callee1', singleTapFunc1);

                  // Get the start x and y position:
                  start_pos.x = (e.originalEvent.targetTouches) ? e.originalEvent.targetTouches[0].pageX : e.pageX;
                  start_pos.y = (e.originalEvent.targetTouches) ? e.originalEvent.targetTouches[0].pageY : e.pageY;

                  return true;
              }
          }).on(settings.endevent, function singleTapFunc2(e) {
              $this.data('callee2', singleTapFunc2);
              if (e.target == origTarget) {

                  // Get the end point:
                  var end_pos_x = (e.originalEvent.changedTouches) ? e.originalEvent.changedTouches[0].pageX : e.pageX,
                      end_pos_y = (e.originalEvent.changedTouches) ? e.originalEvent.changedTouches[0].pageY : e.pageY;

                  // We need to check if it was a taphold:

                  settings.tap_timer = window.setTimeout(function () {

                      var diff_x = (start_pos.x - end_pos_x), diff_y = (start_pos.y - end_pos_y);

                      if(!$this.data('doubletapped') && !$this.data('tapheld') && (((start_pos.x == end_pos_x) && (start_pos.y == end_pos_y)) || (diff_x >= -(settings.tap_pixel_range) && diff_x <= settings.tap_pixel_range && diff_y >= -(settings.tap_pixel_range) && diff_y <= settings.tap_pixel_range))) {

                          var origEvent = e.originalEvent;
                          var touchData = {
                              'position': {
                                  'x': (settings.touch_capable) ? origEvent.changedTouches[0].screenX : e.screenX,
                                  'y': (settings.touch_capable) ? origEvent.changedTouches[0].screenY : e.screenY
                              },
                              'offset': {
                                  'x': (settings.touch_capable) ? Math.round(origEvent.changedTouches[0].pageX - ($this.offset() ? $this.offset().left : 0)) : Math.round(e.pageX - ($this.offset() ? $this.offset().left : 0)),
  							'y': (settings.touch_capable) ? Math.round(origEvent.changedTouches[0].pageY - ($this.offset() ? $this.offset().top : 0)) : Math.round(e.pageY - ($this.offset() ? $this.offset().top : 0))
                              },
                              'time': Date.now(),
                              'target': e.target
                          };

                          // Was it a taphold?
                          if((touchData.time - startTime) < settings.taphold_threshold)
                          {
                              triggerCustomEvent(thisObject, 'singletap', e, touchData);
                          }
                      }
                  }, settings.doubletap_int);
              }
          });
      },

      remove: function () {
          $(this).off(settings.startevent, $(this).data.callee1).off(settings.endevent, $(this).data.callee2);
      }
  };

  // tap Event:
  $.event.special.tap = {
      setup: function () {
          var thisObject = this,
              $this = $(thisObject),
              started = false,
              origTarget = null,
              start_time,
              start_pos = {
                  x: 0,
                  y: 0
              },
              touches;

          $this.on(settings.startevent, function tapFunc1(e) {
              $this.data('callee1', tapFunc1);

              if( e.which && e.which !== 1 )
  		{
                  return false;
              }
  		else
  		{
                  started = true;
                  start_pos.x = (e.originalEvent.targetTouches) ? e.originalEvent.targetTouches[0].pageX : e.pageX;
                  start_pos.y = (e.originalEvent.targetTouches) ? e.originalEvent.targetTouches[0].pageY : e.pageY;
                  start_time = Date.now();
                  origTarget = e.target;

                  touches = (e.originalEvent.targetTouches) ? e.originalEvent.targetTouches : [ e ];
                  return true;
              }
          }).on(settings.endevent, function tapFunc2(e) {
              $this.data('callee2', tapFunc2);

              // Only trigger if they've started, and the target matches:
              var end_x = (e.originalEvent.targetTouches) ? e.originalEvent.changedTouches[0].pageX : e.pageX,
                  end_y = (e.originalEvent.targetTouches) ? e.originalEvent.changedTouches[0].pageY : e.pageY,
                  diff_x = (start_pos.x - end_x),
                  diff_y = (start_pos.y - end_y),
                  eventName;

              if (origTarget == e.target && started && ((Date.now() - start_time) < settings.taphold_threshold) && ((start_pos.x == end_x && start_pos.y == end_y) || (diff_x >= -(settings.tap_pixel_range) && diff_x <= settings.tap_pixel_range && diff_y >= -(settings.tap_pixel_range) && diff_y <= settings.tap_pixel_range))) {
                  var origEvent = e.originalEvent;
                  var touchData = [ ];

                  for( var i = 0; i < touches.length; i++)
                  {
                      var touch = {
                          'position': {
                              'x': (settings.touch_capable) ? origEvent.changedTouches[i].screenX : e.screenX,
                              'y': (settings.touch_capable) ? origEvent.changedTouches[i].screenY : e.screenY
                          },
                          'offset': {
                              'x': (settings.touch_capable) ? Math.round(origEvent.changedTouches[i].pageX - ($this.offset() ? $this.offset().left : 0)) : Math.round(e.pageX - ($this.offset() ? $this.offset().left : 0)),
                              'y': (settings.touch_capable) ? Math.round(origEvent.changedTouches[i].pageY - ($this.offset() ? $this.offset().top : 0)) : Math.round(e.pageY - ($this.offset() ? $this.offset().top : 0))
                          },
                          'time': Date.now(),
                          'target': e.target
                      };

                      touchData.push( touch );
                  }

                  triggerCustomEvent(thisObject, 'tap', e, touchData);
              }
          });
      },

      remove: function () {
          $(this).off(settings.startevent, $(this).data.callee1).off(settings.endevent, $(this).data.callee2);
      }
  };

  // swipe Event (also handles swipeup, swiperight, swipedown and swipeleft):
  $.event.special.swipe = {
      setup: function () {
          var thisObject = this,
              $this = $(thisObject),
              started = false,
              hasSwiped = false,
              originalCoord = {
                  x: 0,
                  y: 0
              },
              finalCoord = {
                  x: 0,
                  y: 0
              },
              startEvnt;

          // Screen touched, store the original coordinate

          function touchStart(e) {
              $this = $(e.currentTarget);
              $this.data('callee1', touchStart);
              originalCoord.x = (e.originalEvent.targetTouches) ? e.originalEvent.targetTouches[0].pageX : e.pageX;
              originalCoord.y = (e.originalEvent.targetTouches) ? e.originalEvent.targetTouches[0].pageY : e.pageY;
              finalCoord.x = originalCoord.x;
              finalCoord.y = originalCoord.y;
              started = true;
              var origEvent = e.originalEvent;
              // Read event data into our startEvt:
              startEvnt = {
                  'position': {
                      'x': (settings.touch_capable) ? origEvent.touches[0].screenX : e.screenX,
                      'y': (settings.touch_capable) ? origEvent.touches[0].screenY : e.screenY
                  },
                  'offset': {
                      'x': (settings.touch_capable) ? Math.round(origEvent.changedTouches[0].pageX - ($this.offset() ? $this.offset().left : 0)) : Math.round(e.pageX - ($this.offset() ? $this.offset().left : 0)),
                      'y': (settings.touch_capable) ? Math.round(origEvent.changedTouches[0].pageY - ($this.offset() ? $this.offset().top : 0)) : Math.round(e.pageY - ($this.offset() ? $this.offset().top : 0))
                  },
                  'time': Date.now(),
                  'target': e.target
              };
          }

          // Store coordinates as finger is swiping

          function touchMove(e) {
              $this = $(e.currentTarget);
              $this.data('callee2', touchMove);
              finalCoord.x = (e.originalEvent.targetTouches) ? e.originalEvent.targetTouches[0].pageX : e.pageX;
              finalCoord.y = (e.originalEvent.targetTouches) ? e.originalEvent.targetTouches[0].pageY : e.pageY;

              var swipedir;

              // We need to check if the element to which the event was bound contains a data-xthreshold | data-vthreshold:
              var ele_x_threshold = ($this.parent().data('xthreshold')) ? $this.parent().data('xthreshold') : $this.data('xthreshold'),
                  ele_y_threshold = ($this.parent().data('ythreshold')) ? $this.parent().data('ythreshold') : $this.data('ythreshold'),
                  h_threshold = (typeof ele_x_threshold !== 'undefined' && ele_x_threshold !== false && parseInt(ele_x_threshold)) ? parseInt(ele_x_threshold) : settings.swipe_h_threshold,
                  v_threshold = (typeof ele_y_threshold !== 'undefined' && ele_y_threshold !== false && parseInt(ele_y_threshold)) ? parseInt(ele_y_threshold) : settings.swipe_v_threshold;

              if (originalCoord.y > finalCoord.y && (originalCoord.y - finalCoord.y > v_threshold)) {
                  swipedir = 'swipeup';
              }
              if (originalCoord.x < finalCoord.x && (finalCoord.x - originalCoord.x > h_threshold)) {
                  swipedir = 'swiperight';
              }
              if (originalCoord.y < finalCoord.y && (finalCoord.y - originalCoord.y > v_threshold)) {
                  swipedir = 'swipedown';
              }
              if (originalCoord.x > finalCoord.x && (originalCoord.x - finalCoord.x > h_threshold)) {
                  swipedir = 'swipeleft';
              }
              if (swipedir !== undefined && started) {
                  originalCoord.x = 0;
                  originalCoord.y = 0;
                  finalCoord.x = 0;
                  finalCoord.y = 0;
                  started = false;

                  // Read event data into our endEvnt:
                  var origEvent = e.originalEvent;
                  var endEvnt = {
                      'position': {
                          'x': (settings.touch_capable) ? origEvent.touches[0].screenX : e.screenX,
                          'y': (settings.touch_capable) ? origEvent.touches[0].screenY : e.screenY
                      },
                      'offset': {
                          'x': (settings.touch_capable) ? Math.round(origEvent.changedTouches[0].pageX - ($this.offset() ? $this.offset().left : 0)) : Math.round(e.pageX - ($this.offset() ? $this.offset().left : 0)),
                          'y': (settings.touch_capable) ? Math.round(origEvent.changedTouches[0].pageY - ($this.offset() ? $this.offset().top : 0)) : Math.round(e.pageY - ($this.offset() ? $this.offset().top : 0))
                      },
                      'time': Date.now(),
                      'target': e.target
                  };

                  // Calculate the swipe amount (normalized):
                  var xAmount = Math.abs(startEvnt.position.x - endEvnt.position.x),
                      yAmount = Math.abs(startEvnt.position.y - endEvnt.position.y);

                  var touchData = {
                      'startEvnt': startEvnt,
                      'endEvnt': endEvnt,
                      'direction': swipedir.replace('swipe', ''),
                      'xAmount': xAmount,
                      'yAmount': yAmount,
                      'duration': endEvnt.time - startEvnt.time
                  };
                  hasSwiped = true;
                  $this.trigger('swipe', touchData).trigger(swipedir, touchData);
              }
          }

          function touchEnd(e) {
              $this = $(e.currentTarget);
              var swipedir = "";
              $this.data('callee3', touchEnd);
              if (hasSwiped) {
                  // We need to check if the element to which the event was bound contains a data-xthreshold | data-vthreshold:
                  var ele_x_threshold = $this.data('xthreshold'),
                      ele_y_threshold = $this.data('ythreshold'),
                      h_threshold = (typeof ele_x_threshold !== 'undefined' && ele_x_threshold !== false && parseInt(ele_x_threshold)) ? parseInt(ele_x_threshold) : settings.swipe_h_threshold,
                      v_threshold = (typeof ele_y_threshold !== 'undefined' && ele_y_threshold !== false && parseInt(ele_y_threshold)) ? parseInt(ele_y_threshold) : settings.swipe_v_threshold;

                  var origEvent = e.originalEvent;
                  var endEvnt = {
                      'position': {
                          'x': (settings.touch_capable) ? origEvent.changedTouches[0].screenX : e.screenX,
                          'y': (settings.touch_capable) ? origEvent.changedTouches[0].screenY : e.screenY
                      },
                      'offset': {
                          'x': (settings.touch_capable) ? Math.round(origEvent.changedTouches[0].pageX - ($this.offset() ? $this.offset().left : 0)) : Math.round(e.pageX - ($this.offset() ? $this.offset().left : 0)),
                          'y': (settings.touch_capable) ? Math.round(origEvent.changedTouches[0].pageY - ($this.offset() ? $this.offset().top : 0)) : Math.round(e.pageY - ($this.offset() ? $this.offset().top : 0))
                      },
                      'time': Date.now(),
                      'target': e.target
                  };

                  // Read event data into our endEvnt:
                  if (startEvnt.position.y > endEvnt.position.y && (startEvnt.position.y - endEvnt.position.y > v_threshold)) {
                      swipedir = 'swipeup';
                  }
                  if (startEvnt.position.x < endEvnt.position.x && (endEvnt.position.x - startEvnt.position.x > h_threshold)) {
                      swipedir = 'swiperight';
                  }
                  if (startEvnt.position.y < endEvnt.position.y && (endEvnt.position.y - startEvnt.position.y > v_threshold)) {
                      swipedir = 'swipedown';
                  }
                  if (startEvnt.position.x > endEvnt.position.x && (startEvnt.position.x - endEvnt.position.x > h_threshold)) {
                      swipedir = 'swipeleft';
                  }

                  // Calculate the swipe amount (normalized):
                  var xAmount = Math.abs(startEvnt.position.x - endEvnt.position.x),
                      yAmount = Math.abs(startEvnt.position.y - endEvnt.position.y);

                  var touchData = {
                      'startEvnt': startEvnt,
                      'endEvnt': endEvnt,
                      'direction': swipedir.replace('swipe', ''),
                      'xAmount': xAmount,
                      'yAmount': yAmount,
                      'duration': endEvnt.time - startEvnt.time
                  };
                  $this.trigger('swipeend', touchData);
              }

              started = false;
              hasSwiped = false;
          }

          $this.on(settings.startevent, touchStart);
          $this.on(settings.moveevent, touchMove);
          $this.on(settings.endevent, touchEnd);
      },

      remove: function () {
          $(this).off(settings.startevent, $(this).data.callee1).off(settings.moveevent, $(this).data.callee2).off(settings.endevent, $(this).data.callee3);
      }
  };

  // scrollstart Event (also handles scrollend):
  $.event.special.scrollstart = {
      setup: function () {
          var thisObject = this,
              $this = $(thisObject),
              scrolling,
              timer;

          function trigger(event, state) {
              scrolling = state;
              triggerCustomEvent(thisObject, scrolling ? 'scrollstart' : 'scrollend', event);
          }

          // iPhone triggers scroll after a small delay; use touchmove instead
          $this.on(settings.scrollevent, function scrollFunc(event) {
              $this.data('callee', scrollFunc);

              if (!scrolling) {
                  trigger(event, true);
              }

              clearTimeout(timer);
              timer = setTimeout(function () {
                  trigger(event, false);
              }, 50);
          });
      },

      remove: function () {
          $(this).off(settings.scrollevent, $(this).data.callee);
      }
  };

  // This is the orientation change (largely borrowed from jQuery Mobile):
  var win = $(window),
      special_event,
      get_orientation,
      last_orientation,
      initial_orientation_is_landscape,
      initial_orientation_is_default,
      portrait_map = {
          '0': true,
          '180': true
      };

  if (settings.orientation_support) {
      var ww = window.innerWidth || win.width(),
          wh = window.innerHeight || win.height(),
          landscape_threshold = 50;

      initial_orientation_is_landscape = ww > wh && (ww - wh) > landscape_threshold;
      initial_orientation_is_default = portrait_map[window.orientation];

      if ((initial_orientation_is_landscape && initial_orientation_is_default) || (!initial_orientation_is_landscape && !initial_orientation_is_default)) {
          portrait_map = {
              '-90': true,
              '90': true
          };
      }
  }

  $.event.special.orientationchange = special_event = {
      setup: function () {
          // If the event is supported natively, return false so that jQuery
          // will on to the event using DOM methods.
          if (settings.orientation_support) {
              return false;
          }

          // Get the current orientation to avoid initial double-triggering.
          last_orientation = get_orientation();

          win.on('throttledresize', handler);
          return true;
      },
      teardown: function () {
          if (settings.orientation_support) {
              return false;
          }

          win.off('throttledresize', handler);
          return true;
      },
      add: function (handleObj) {
          // Save a reference to the bound event handler.
          var old_handler = handleObj.handler;

          handleObj.handler = function (event) {
              event.orientation = get_orientation();
              return old_handler.apply(this, arguments);
          };
      }
  };

  // If the event is not supported natively, this handler will be bound to
  // the window resize event to simulate the orientationchange event.

  function handler() {
      // Get the current orientation.
      var orientation = get_orientation();

      if (orientation !== last_orientation) {
          // The orientation has changed, so trigger the orientationchange event.
          last_orientation = orientation;
          win.trigger("orientationchange");
      }
  }

  $.event.special.orientationchange.orientation = get_orientation = function () {
      var isPortrait = true,
          elem = document.documentElement;

      if (settings.orientation_support) {
          isPortrait = portrait_map[window.orientation];
      } else {
          isPortrait = elem && elem.clientWidth / elem.clientHeight < 1.1;
      }

      return isPortrait ? 'portrait' : 'landscape';
  };

  // throttle Handler:
  $.event.special.throttledresize = {
      setup: function () {
          $(this).on('resize', throttle_handler);
      },
      teardown: function () {
          $(this).off('resize', throttle_handler);
      }
  };

  var throttle = 250,
      throttle_handler = function () {
          curr = Date.now();
          diff = curr - lastCall;

          if (diff >= throttle) {
              lastCall = curr;
              $(this).trigger('throttledresize');

          } else {
              if (heldCall) {
                  window.clearTimeout(heldCall);
              }

              // Promise a held call will still execute
              heldCall = window.setTimeout(handler, throttle - diff);
          }
      },
      lastCall = 0,
      heldCall,
      curr,
      diff;

  // Trigger a custom event:

  function triggerCustomEvent(obj, eventType, event, touchData) {
      var originalType = event.type;
      event.type = eventType;

      $.event.dispatch.call(obj, event, touchData);
      event.type = originalType;
  }

  // Correctly on anything we've overloaded:
  $.each({
      scrollend: 'scrollstart',
      swipeup: 'swipe',
      swiperight: 'swipe',
      swipedown: 'swipe',
      swipeleft: 'swipe',
      swipeend: 'swipe',
      tap2: 'tap'
  }, function (e, srcE) {
      $.event.special[e] = {
          setup: function () {
              $(this).on(srcE, $.noop);
          }
      };
  });

  return;

}
(function ($, undefined) {

    'use strict';

    var setLanguageCookie = function setLanguageCookie(language) {
        var days = 30; // The number of days the cookie will be valid
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000); // Set the expiration date
        var expires = "expires=" + date.toUTCString();
        document.cookie = "USERLANG=" + language + ";" + expires + ";path=/";
    };
    var getLanguageCookie = function getLanguageCookie() {
        var name = "USERLANG=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var cookies = decodedCookie.split(';');

        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].trim();
            if (cookie.indexOf(name) === 0) {
                return cookie.substring(name.length, cookie.length);
            }
        }
        return null; // Return null if the cookie is not found
    };
    var setItemWithExpiry = function setItemWithExpiry(key, value, expiryInMinutes) {
        var now = new Date();
        var expiryTime = now.getTime() + expiryInMinutes * 60 * 1000;

        var item = {
            value: value,
            expiry: expiryTime
        };

        localStorage.setItem(key, JSON.stringify(item));
    };
    var getItemWithExpiry = function getItemWithExpiry(key) {
        var itemStr = localStorage.getItem(key);

        // If the item doesn't exist, return null
        if (!itemStr) {
            return null;
        }

        var item = JSON.parse(itemStr);
        var now = new Date();

        // Compare the expiry time of the item with the current time
        if (now.getTime() > item.expiry) {
            // If the item is expired, remove it from storage and return null
            localStorage.removeItem(key);
            return null;
        }

        return item.value;
    };

    var init = function init() {

        // User Language
        var preferredLang = getItemWithExpiry('language');
        if (!preferredLang) {
            var userLang = navigator.language || navigator.userLanguage;
            userLang = userLang.split('-')[0]; // Extract the language code (e.g., 'en' from 'en-US')

            var currentPath = window.location.pathname; // Get the current URL path
            var redirectPath = '';
            var redirectURL = '';

            if (!currentPath.startsWith('/en/')) {
                // Check if the path includes '/en/' slug
                if (userLang == 'en') {
                    redirectPath = $(".site-lang-btn").attr("href");
                    // redirectURL = window.location.protocol + '//' + window.location.host + redirectPath + window.location.search + window.location.hash;
                    redirectURL = window.location.protocol + '//' + window.location.host + redirectPath;
                    console.log(redirectURL);
                    window.location.href = redirectURL;
                }
            } else {
                if (userLang == 'fr') {
                    redirectPath = $(".site-lang-btn").attr("href");
                    redirectURL = window.location.protocol + '//' + window.location.host + redirectPath;
                    console.log(redirectURL);
                    window.location.href = redirectURL;
                }
            }
        }

        // Click event for language change
        $(".site-lang-btn").click(function (e) {
            e.preventDefault();
            var selectedLang = $(this).data("lang");
            setItemWithExpiry('language', selectedLang, 30 * 24 * 60); // 30 days
            redirectPath = $(this).attr("href");
            redirectURL = window.location.protocol + '//' + window.location.host + redirectPath;
            window.location.href = redirectURL;
        });
    };

    init();
})(jQuery);